import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  JSON: { input: unknown; output: unknown };
  Long: { input: number; output: number };
};

export type AbTestData = {
  flag?: Maybe<FlagsAdminV1FlagResult>;
  rollout?: Maybe<WorkflowV1WorkflowInstanceResult>;
  treatments?: Maybe<Array<AbTestDataTreatment>>;
};

export type AbTestDataInput = {
  flag?: InputMaybe<Scalars['String']['input']>;
  rollout?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<Array<AbTestDataInputTreatmentInput>>;
};

export type AbTestDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variant: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type AbTestDataTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  variant: FlagsAdminV1FlagVariantResult;
  weight: Scalars['Long']['output'];
};

export type ActionsV1TypesAction = {
  executeFunctionAction?: Maybe<ActionsV1TypesExecuteFunctionAction>;
  pagerdutyAction?: Maybe<ActionsV1TypesPagerDutyAction>;
  transitionAction?: Maybe<ActionsV1TypesTransitionWorkflowAction>;
};

export type ActionsV1TypesActionInput = {
  executeFunctionAction?: InputMaybe<ActionsV1TypesExecuteFunctionActionInput>;
  pagerdutyAction?: InputMaybe<ActionsV1TypesPagerDutyActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  transitionAction?: InputMaybe<ActionsV1TypesTransitionWorkflowActionInput>;
};

export type ActionsV1TypesActivityTrigger = {
  kind?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
};

export type ActionsV1TypesActivityTriggerInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type ActionsV1TypesAutomatedAction = {
  action?: Maybe<ActionsV1TypesAction>;
  trigger?: Maybe<ActionsV1TypesTrigger>;
};

export type ActionsV1TypesAutomatedActionInput = {
  action?: InputMaybe<ActionsV1TypesActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<ActionsV1TypesTriggerInput>;
};

export type ActionsV1TypesExecuteFunctionAction = {
  function?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type ActionsV1TypesExecuteFunctionActionInput = {
  function?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActionsV1TypesPagerDutyAction = {
  description?: Maybe<Scalars['String']['output']>;
  pdKey: Scalars['String']['output'];
  severity: ActionsV1TypesSeverity;
  title?: Maybe<Scalars['String']['output']>;
};

export type ActionsV1TypesPagerDutyActionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  pdKey: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  severity: ActionsV1TypesSeverity;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ActionsV1TypesSeverity {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

export type ActionsV1TypesStateTrigger = {
  resource?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ActionsV1TypesStateTriggerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ActionsV1TypesTransitionWorkflowAction = {
  action?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type ActionsV1TypesTransitionWorkflowActionInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActionsV1TypesTrigger = {
  activityTrigger?: Maybe<ActionsV1TypesActivityTrigger>;
  stateTrigger?: Maybe<ActionsV1TypesStateTrigger>;
};

export type ActionsV1TypesTriggerInput = {
  activityTrigger?: InputMaybe<ActionsV1TypesActivityTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stateTrigger?: InputMaybe<ActionsV1TypesStateTriggerInput>;
};

export type ActivityV1Activity = {
  activityTime: Scalars['String']['output'];
  actor: IamV1IdentityResult;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  body: Scalars['String']['output'];
  changeSet?: Maybe<ActivityV1ResourceChangeSet>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  data?: Maybe<Scalars['JSON']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ActivityV1ActivityLabelsEntry>;
  name: Scalars['String']['output'];
  primaryResource: Scalars['String']['output'];
  priority: ActivityV1ActivityPriority;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  relatedResources: Array<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  title: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ActivityV1ActivityAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1ActivityCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1ActivityQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum ActivityV1ActivityPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type ActivityV1ActivityResult = ActivityV1Activity | Error;

export type ActivityV1ActivityType = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  deletedTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  global: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  primaryResourceType: ActivityV1ResourceType;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
};

export type ActivityV1ActivityTypeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityTypeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1ActivityTypeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1ActivityTypeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1ActivityTypeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTypeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTypeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTypeReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1ActivityTypeResult = ActivityV1ActivityType | Error;

export type ActivityV1EventsActivityCreated = {
  activity?: Maybe<ActivityV1Activity>;
};

export type ActivityV1Feed = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  channels: Array<ActivityV1FeedChannelConfig>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  feedEntries?: Maybe<ActivityV1ListFeedEntriesResponseResult>;
  feedSubscriptions?: Maybe<ActivityV1ListFeedSubscriptionsResponseResult>;
  labels: Array<ActivityV1FeedLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ActivityV1FeedAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1FeedCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1FeedFeedEntriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedFeedSubscriptionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedChannelConfig = {
  activityTypes: Array<ActivityV1ActivityTypeResult>;
  batchingConfig?: Maybe<ActivityV1FeedChannelConfigBatchingConfig>;
  digestConfig?: Maybe<ActivityV1FeedChannelConfigDigestConfig>;
  disabled: Scalars['Boolean']['output'];
  email?: Maybe<ActivityV1FeedChannelConfigEmail>;
  lastError?: Maybe<ActivityV1FeedChannelConfigError>;
  priority?: Maybe<ActivityV1ActivityPriority>;
  slack?: Maybe<ActivityV1FeedChannelConfigSlack>;
  webhook?: Maybe<ActivityV1FeedChannelConfigWebhook>;
};

export type ActivityV1FeedChannelConfigBatchingConfig = {
  priority?: Maybe<ActivityV1ActivityPriority>;
  window: Scalars['String']['output'];
};

export type ActivityV1FeedChannelConfigBatchingConfigInput = {
  priority?: InputMaybe<ActivityV1ActivityPriority>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  window: Scalars['String']['input'];
};

export type ActivityV1FeedChannelConfigDigestConfig = {
  interval: ActivityV1FeedChannelConfigDigestConfigDigestInterval;
  nextDueTime?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
};

export enum ActivityV1FeedChannelConfigDigestConfigDigestInterval {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
}

export type ActivityV1FeedChannelConfigDigestConfigInput = {
  interval: ActivityV1FeedChannelConfigDigestConfigDigestInterval;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type ActivityV1FeedChannelConfigEmail = {
  address: Scalars['String']['output'];
};

export type ActivityV1FeedChannelConfigEmailInput = {
  address: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedChannelConfigError = {
  errorTime: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ActivityV1FeedChannelConfigErrorInput = {
  errorTime: Scalars['String']['input'];
  message: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedChannelConfigInput = {
  activityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  batchingConfig?: InputMaybe<ActivityV1FeedChannelConfigBatchingConfigInput>;
  digestConfig?: InputMaybe<ActivityV1FeedChannelConfigDigestConfigInput>;
  disabled: Scalars['Boolean']['input'];
  email?: InputMaybe<ActivityV1FeedChannelConfigEmailInput>;
  priority?: InputMaybe<ActivityV1ActivityPriority>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slack?: InputMaybe<ActivityV1FeedChannelConfigSlackInput>;
  webhook?: InputMaybe<ActivityV1FeedChannelConfigWebhookInput>;
};

export type ActivityV1FeedChannelConfigSlack = {
  channel?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1FeedChannelConfigSlackInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedChannelConfigWebhook = {
  id?: Maybe<Scalars['String']['output']>;
  uri: Scalars['String']['output'];
};

export type ActivityV1FeedChannelConfigWebhookInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};

export type ActivityV1FeedEntry = {
  activity: ActivityV1Activity;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  channelDeliveryStatuses: Array<ActivityV1FeedEntryChannelDeliveryStatus>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  entryTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ActivityV1FeedEntryLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  read: Scalars['Boolean']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ActivityV1FeedEntryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedEntryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1FeedEntryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedEntryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1FeedEntryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedEntryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedEntryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedEntryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedEntryChannelDeliveryStatus = {
  channel: Scalars['String']['output'];
  failedAttempts: Scalars['Int']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ActivityV1FeedEntryChannelDeliveryStatusDeliveryState>;
};

export enum ActivityV1FeedEntryChannelDeliveryStatusDeliveryState {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PendingDigest = 'PENDING_DIGEST',
  Skipped = 'SKIPPED',
}

export type ActivityV1FeedEntryLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1FeedEntryResult = ActivityV1FeedEntry | Error;

export type ActivityV1FeedInput = {
  channels?: InputMaybe<Array<ActivityV1FeedChannelConfigInput>>;
  labels?: InputMaybe<Array<ActivityV1FeedLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1FeedLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedResult = ActivityV1Feed | Error;

export type ActivityV1FeedSubscription = {
  activityTypes: Array<ActivityV1ActivityTypeResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  resourceType?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
};

export type ActivityV1FeedSubscriptionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedSubscriptionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ActivityV1FeedSubscriptionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityV1FeedSubscriptionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ActivityV1FeedSubscriptionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedSubscriptionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedSubscriptionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedSubscriptionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1FeedSubscriptionResult =
  | ActivityV1FeedSubscription
  | Error;

export type ActivityV1ListActivitiesResponse = {
  activities: Array<ActivityV1Activity>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListActivitiesResponseResult =
  | ActivityV1ListActivitiesResponse
  | Error;

export type ActivityV1ListActivityTypesResponse = {
  activityTypes: Array<ActivityV1ActivityType>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListActivityTypesResponseResult =
  | ActivityV1ListActivityTypesResponse
  | Error;

export type ActivityV1ListFeedEntriesResponse = {
  feedEntries: Array<ActivityV1FeedEntry>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListFeedEntriesResponseResult =
  | ActivityV1ListFeedEntriesResponse
  | Error;

export type ActivityV1ListFeedSubscriptionsResponse = {
  feedSubscriptions: Array<ActivityV1FeedSubscription>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListFeedSubscriptionsResponseResult =
  | ActivityV1ListFeedSubscriptionsResponse
  | Error;

export type ActivityV1ListFeedsResponse = {
  feeds: Array<ActivityV1Feed>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1ListFeedsResponseResult =
  | ActivityV1ListFeedsResponse
  | Error;

export type ActivityV1MarkFeedEntriesAsReadRequestFeedEntriesInput = {
  entryNames: Array<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1MarkFeedEntriesAsReadRequestMarkReadTimeInput = {
  feed?: InputMaybe<Scalars['String']['input']>;
  markReadTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityV1QueryActivityTypesResponse = {
  activityTypes: Array<ActivityV1ActivityType>;
};

export type ActivityV1QueryActivityTypesResponseResult =
  | ActivityV1QueryActivityTypesResponse
  | Error;

export type ActivityV1QueryIsFollowingResourceResponse = {
  isFollowing?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivityV1QueryIsFollowingResourceResponseResult =
  | ActivityV1QueryIsFollowingResourceResponse
  | Error;

export type ActivityV1ResourceChangeSet = {
  changes: Array<ActivityV1ResourceChangeSetFieldChange>;
};

export type ActivityV1ResourceChangeSetFieldChange = {
  changeType: ActivityV1ResourceChangeSetFieldChangeChangeType;
  description?: Maybe<Scalars['String']['output']>;
  fieldPath: Scalars['String']['output'];
  fieldType?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  reorderDetails?: Maybe<ActivityV1ResourceChangeSetFieldChangeReorderDetails>;
};

export enum ActivityV1ResourceChangeSetFieldChangeChangeType {
  Add = 'ADD',
  Remove = 'REMOVE',
  Reorder = 'REORDER',
  Update = 'UPDATE',
}

export type ActivityV1ResourceChangeSetFieldChangeReorderDetails = {
  moves: Array<ActivityV1ResourceChangeSetFieldChangeReorderDetailsReorderMove>;
};

export type ActivityV1ResourceChangeSetFieldChangeReorderDetailsReorderMove = {
  item: Scalars['String']['output'];
  itemDisplayName?: Maybe<Scalars['String']['output']>;
  newPosition: Scalars['Int']['output'];
  oldPosition: Scalars['Int']['output'];
};

export enum ActivityV1ResourceType {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  CollaborativeDocument = 'COLLABORATIVE_DOCUMENT',
  Comment = 'COMMENT',
  CommentReply = 'COMMENT_REPLY',
  DashboardAlert = 'DASHBOARD_ALERT',
  DimensionTable = 'DIMENSION_TABLE',
  EventDefinition = 'EVENT_DEFINITION',
  FactTable = 'FACT_TABLE',
  Flag = 'FLAG',
  Initiative = 'INITIATIVE',
  Measurement = 'MEASUREMENT',
  Metric = 'METRIC',
  Segment = 'SEGMENT',
  Surface = 'SURFACE',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
}

export type ActivityV1SlackAdminConfig = {
  state?: Maybe<ActivityV1SlackAdminConfigState>;
  teamId?: Maybe<Scalars['String']['output']>;
};

export type ActivityV1SlackAdminConfigResult =
  | ActivityV1SlackAdminConfig
  | Error;

export enum ActivityV1SlackAdminConfigState {
  NotConfigured = 'NOT_CONFIGURED',
  Ok = 'OK',
}

export type ActivityV1TestWebhookResponse = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  responseDuration?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivityV1TestWebhookResponseResult =
  | ActivityV1TestWebhookResponse
  | Error;

export type AdminLabelsV1Label = {
  allowedValues: Array<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<AdminLabelsV1LabelLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  resourceTypes: Array<AdminLabelsV1LabelResourceType>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AdminLabelsV1LabelAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminLabelsV1LabelCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AdminLabelsV1LabelCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminLabelsV1LabelExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AdminLabelsV1LabelQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLabelsV1LabelReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLabelsV1LabelResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLabelsV1LabelReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AdminLabelsV1LabelInput = {
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<AdminLabelsV1LabelLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resourceTypes: Array<AdminLabelsV1LabelResourceType>;
};

export type AdminLabelsV1LabelLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AdminLabelsV1LabelLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum AdminLabelsV1LabelResourceType {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  DimensionTable = 'DIMENSION_TABLE',
  EventDefinition = 'EVENT_DEFINITION',
  FactTable = 'FACT_TABLE',
  Flag = 'FLAG',
  Initiative = 'INITIATIVE',
  Measurement = 'MEASUREMENT',
  Metric = 'METRIC',
  Segment = 'SEGMENT',
  Surface = 'SURFACE',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
}

export type AdminLabelsV1LabelResult = AdminLabelsV1Label | Error;

export type AdminLabelsV1ListLabelsResponse = {
  labels: Array<AdminLabelsV1Label>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AdminLabelsV1ListLabelsResponseResult =
  | AdminLabelsV1ListLabelsResponse
  | Error;

export type AdminV1AccountInfo = {
  admin?: Maybe<IamV1IdentityResult>;
  allowedLoginEmailDomains: Array<Scalars['String']['output']>;
  authConnections: Array<AdminV1AccountInfoAuthConnection>;
  blockReason?: Maybe<Scalars['String']['output']>;
  blockTime?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  createTime: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  loginId: Scalars['String']['output'];
  mode?: Maybe<AdminV1AccountMode>;
  name: Scalars['String']['output'];
  /** @deprecated No longer supported */
  planState?: Maybe<AdminV1PlanState>;
  /** @deprecated No longer supported */
  planType?: Maybe<AdminV1PlanType>;
  /** @deprecated No longer supported */
  planValidUntilTime?: Maybe<Scalars['String']['output']>;
  quotas?: Maybe<AdminV1Quotas>;
  region: AdminV1Region;
  serviceTier?: Maybe<AdminV1ServiceTier>;
  totalConfidenceAccountInfo?: Maybe<AdminV1AccountInfoTotalConfidenceAccountStatus>;
  updateTime: Scalars['String']['output'];
};

export type AdminV1AccountInfoAuthConnection = {
  autoJoin?: Maybe<Scalars['Boolean']['output']>;
  googleAuthConnection?: Maybe<AdminV1AccountInfoAuthConnectionGoogleAuthConnection>;
  passwordAuthConnection?: Maybe<AdminV1AccountInfoAuthConnectionPasswordAuthConnection>;
};

export type AdminV1AccountInfoAuthConnectionGoogleAuthConnection = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AdminV1AccountInfoAuthConnectionPasswordAuthConnection = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AdminV1AccountInfoResult = AdminV1AccountInfo | Error;

export type AdminV1AccountInfoTotalConfidenceAccountStatus = {
  accountInfo?: Maybe<AdminV1AccountInfoTotalConfidenceAccountStatusTotalConfidenceAccountInfo>;
  creationStartTime: Scalars['String']['output'];
  state?: Maybe<AdminV1AccountInfoTotalConfidenceAccountStatusState>;
};

export enum AdminV1AccountInfoTotalConfidenceAccountStatusState {
  Active = 'ACTIVE',
  Creating = 'CREATING',
  Deleted = 'DELETED',
}

export type AdminV1AccountInfoTotalConfidenceAccountStatusTotalConfidenceAccountInfo =
  {
    createDuration: Scalars['String']['output'];
    createTime: Scalars['String']['output'];
    gcpProjectId: Scalars['String']['output'];
  };

export enum AdminV1AccountMode {
  TotalConfidence = 'TOTAL_CONFIDENCE',
  WarehouseNative = 'WAREHOUSE_NATIVE',
}

export type AdminV1CreditBalance = {
  consumed?: Maybe<Scalars['Long']['output']>;
  granted?: Maybe<Scalars['Long']['output']>;
  snapshotTime: Scalars['String']['output'];
};

export type AdminV1EntitlementValue = {
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  integerValue?: Maybe<Scalars['Long']['output']>;
  unlimited?: Maybe<AdminV1EntitlementValueUnlimited>;
};

export type AdminV1EntitlementValueUnlimited = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export enum AdminV1PlanState {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
}

export enum AdminV1PlanType {
  Paid = 'PAID',
  Trial = 'TRIAL',
}

export type AdminV1Quotas = {
  limits: Array<AdminV1QuotasLimitsEntry>;
};

export type AdminV1QuotasLimits = {
  hardLimit?: Maybe<Scalars['Long']['output']>;
  softLimit?: Maybe<Scalars['Long']['output']>;
};

export type AdminV1QuotasLimitsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<AdminV1QuotasLimits>;
};

export enum AdminV1Region {
  RegionEu = 'REGION_EU',
  RegionUs = 'REGION_US',
}

export type AdminV1ServiceTier = {
  credits?: Maybe<AdminV1CreditBalance>;
  entitlements: Array<AdminV1ServiceTierEntitlementsEntry>;
  subscription?: Maybe<AdminV1SubscriptionSnapshot>;
  tier: AdminV1ServiceTierTier;
};

export type AdminV1ServiceTierEntitlementsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<AdminV1EntitlementValue>;
};

export enum AdminV1ServiceTierTier {
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Growth = 'GROWTH',
}

export type AdminV1SubscriptionSnapshot = {
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  currentPeriodEndTime?: Maybe<Scalars['String']['output']>;
  state: AdminV1SubscriptionSnapshotState;
  trialEndTime?: Maybe<Scalars['String']['output']>;
};

export enum AdminV1SubscriptionSnapshotState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
}

export type AiworkflowsV1AccountTokenUsage = {
  sessionCount?: Maybe<Scalars['Int']['output']>;
  usage?: Maybe<AiworkflowsV1TokenUsage>;
};

export type AiworkflowsV1AccountTokenUsageResult =
  | AiworkflowsV1AccountTokenUsage
  | Error;

export type AiworkflowsV1Action = {
  executeFunctionAction?: Maybe<AiworkflowsV1ExecuteFunctionAction>;
  notifyFeedAction?: Maybe<AiworkflowsV1NotifyFeedAction>;
  runPromptAction?: Maybe<AiworkflowsV1RunPromptAction>;
  transitionWorkflowAction?: Maybe<AiworkflowsV1TransitionWorkflowAction>;
};

export type AiworkflowsV1ActionInput = {
  executeFunctionAction?: InputMaybe<AiworkflowsV1ExecuteFunctionActionInput>;
  notifyFeedAction?: InputMaybe<AiworkflowsV1NotifyFeedActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  runPromptAction?: InputMaybe<AiworkflowsV1RunPromptActionInput>;
  transitionWorkflowAction?: InputMaybe<AiworkflowsV1TransitionWorkflowActionInput>;
};

export type AiworkflowsV1ActivityTrigger = {
  kind: Scalars['String']['output'];
  resource?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ActivityTriggerInput = {
  kind: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export enum AiworkflowsV1ActorType {
  ClaudeAgentsActor = 'CLAUDE_AGENTS_ACTOR',
  ClaudeAgentsManagedActor = 'CLAUDE_AGENTS_MANAGED_ACTOR',
  ConfidenceActor = 'CONFIDENCE_ACTOR',
  CursorAgentActor = 'CURSOR_AGENT_ACTOR',
  CustomAgentActor = 'CUSTOM_AGENT_ACTOR',
}

export type AiworkflowsV1AiWorkflowInstance = {
  actorType: AiworkflowsV1ActorType;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<AiworkflowsV1AiWorkflowInstanceLabelsEntry>;
  mode?: Maybe<AiworkflowsV1Mode>;
  name: Scalars['String']['output'];
  outcomeType?: Maybe<AiworkflowsV1OutcomeType>;
  owner: IamV1IdentityResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  state?: Maybe<AiworkflowsV1State>;
  taskType: AiworkflowsV1TaskType;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AiworkflowsV1AiWorkflowInstanceAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AiworkflowsV1AiWorkflowInstanceCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AiworkflowsV1AiWorkflowInstanceQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceInput = {
  actorType: AiworkflowsV1ActorType;
  labels?: InputMaybe<Array<AiworkflowsV1AiWorkflowInstanceLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  outcomeType?: InputMaybe<AiworkflowsV1OutcomeType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  taskType: AiworkflowsV1TaskType;
};

export type AiworkflowsV1AiWorkflowInstanceLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1AiWorkflowInstanceLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowInstanceResult =
  | AiworkflowsV1AiWorkflowInstance
  | Error;

export type AiworkflowsV1AiWorkflowSchedule = {
  actorType: AiworkflowsV1ActorType;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  executedCount?: Maybe<Scalars['Int']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  intervalMinutes: Scalars['Int']['output'];
  labels: Array<AiworkflowsV1AiWorkflowScheduleLabelsEntry>;
  lastRunTime?: Maybe<Scalars['String']['output']>;
  latestInstance?: Maybe<AiworkflowsV1AiWorkflowInstanceResult>;
  name: Scalars['String']['output'];
  nextRunTime?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<AiworkflowsV1OutcomeType>;
  owner: IamV1IdentityResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleState?: Maybe<AiworkflowsV1ScheduleState>;
  taskType: AiworkflowsV1TaskType;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AiworkflowsV1AiWorkflowScheduleAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AiworkflowsV1AiWorkflowScheduleCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AiworkflowsV1AiWorkflowScheduleQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleInput = {
  actorType: AiworkflowsV1ActorType;
  intervalMinutes: Scalars['Int']['input'];
  labels?: InputMaybe<Array<AiworkflowsV1AiWorkflowScheduleLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  outcomeType?: InputMaybe<AiworkflowsV1OutcomeType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  taskType: AiworkflowsV1TaskType;
};

export type AiworkflowsV1AiWorkflowScheduleLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1AiWorkflowScheduleLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowScheduleResult =
  | AiworkflowsV1AiWorkflowSchedule
  | Error;

export type AiworkflowsV1AiWorkflowTrigger = {
  action: AiworkflowsV1Action;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  filterName: Scalars['String']['output'];
  filterType: Scalars['String']['output'];
  labels: Array<AiworkflowsV1AiWorkflowTriggerLabelsEntry>;
  name: Scalars['String']['output'];
  owner: IamV1IdentityResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  trigger: AiworkflowsV1Trigger;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AiworkflowsV1AiWorkflowTriggerAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AiworkflowsV1AiWorkflowTriggerCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AiworkflowsV1AiWorkflowTriggerQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerInput = {
  action: AiworkflowsV1ActionInput;
  filterName: Scalars['String']['input'];
  filterType: Scalars['String']['input'];
  labels?: InputMaybe<Array<AiworkflowsV1AiWorkflowTriggerLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  trigger: AiworkflowsV1TriggerInput;
};

export type AiworkflowsV1AiWorkflowTriggerLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1AiWorkflowTriggerLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1AiWorkflowTriggerResult =
  | AiworkflowsV1AiWorkflowTrigger
  | Error;

export enum AiworkflowsV1AlertSeverity {
  AlertSeverityCritical = 'ALERT_SEVERITY_CRITICAL',
  AlertSeverityHigh = 'ALERT_SEVERITY_HIGH',
  AlertSeverityLow = 'ALERT_SEVERITY_LOW',
  AlertSeverityMedium = 'ALERT_SEVERITY_MEDIUM',
}

export enum AiworkflowsV1AlertState {
  AlertActive = 'ALERT_ACTIVE',
  AlertFiring = 'ALERT_FIRING',
  AlertPaused = 'ALERT_PAUSED',
}

export type AiworkflowsV1ArchiveManagedWorkspaceResponse = {
  archivedWorkspaceId?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ArchiveManagedWorkspaceResponseResult =
  | AiworkflowsV1ArchiveManagedWorkspaceResponse
  | Error;

export type AiworkflowsV1ClaudeAgentsIntegrationConfigDisplay = {
  agentId?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1CleanupTargetInput = {
  flagName: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  repositoryUri: Scalars['String']['input'];
};

export enum AiworkflowsV1Comparator {
  Above = 'ABOVE',
  Below = 'BELOW',
}

export type AiworkflowsV1CreateClaudeAgentsIntegrationDetails = {
  agentId?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1CreateClaudeAgentsIntegrationDetailsInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1CreateCursorIntegrationDetails = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1CreateCursorIntegrationDetailsInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1CreateIntercomIntegrationDetails = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1CreateIntercomIntegrationDetailsInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1DashboardAlertTrigger = {
  alertState?: Maybe<AiworkflowsV1AlertState>;
  condition: AiworkflowsV1ThresholdCondition;
  graphType: Scalars['String']['output'];
  labelFilters: Array<AiworkflowsV1DashboardAlertTriggerLabelFiltersEntry>;
  lastChecked?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1DashboardAlertTriggerInput = {
  condition: AiworkflowsV1ThresholdConditionInput;
  graphType: Scalars['String']['input'];
  labelFilters?: InputMaybe<
    Array<AiworkflowsV1DashboardAlertTriggerLabelFiltersEntryInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1DashboardAlertTriggerLabelFiltersEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1DashboardAlertTriggerLabelFiltersEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExecuteFunctionAction = {
  function: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type AiworkflowsV1ExecuteFunctionActionInput = {
  function: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegration = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  claudeAgents?: Maybe<AiworkflowsV1CreateClaudeAgentsIntegrationDetails>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  cursor?: Maybe<AiworkflowsV1CreateCursorIntegrationDetails>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  github?: Maybe<AiworkflowsV1GithubIntegrationDetails>;
  integrationType?: Maybe<Scalars['String']['output']>;
  intercom?: Maybe<AiworkflowsV1CreateIntercomIntegrationDetails>;
  labels: Array<AiworkflowsV1ExternalIntegrationLabelsEntry>;
  name: Scalars['String']['output'];
  owner: IamV1IdentityResult;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type AiworkflowsV1ExternalIntegrationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1ExternalIntegrationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type AiworkflowsV1ExternalIntegrationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiworkflowsV1ExternalIntegrationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type AiworkflowsV1ExternalIntegrationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationInput = {
  claudeAgents?: InputMaybe<AiworkflowsV1CreateClaudeAgentsIntegrationDetailsInput>;
  cursor?: InputMaybe<AiworkflowsV1CreateCursorIntegrationDetailsInput>;
  github?: InputMaybe<AiworkflowsV1GithubIntegrationDetailsInput>;
  intercom?: InputMaybe<AiworkflowsV1CreateIntercomIntegrationDetailsInput>;
  labels?: InputMaybe<Array<AiworkflowsV1ExternalIntegrationLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ExternalIntegrationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1ExternalIntegrationResult =
  | AiworkflowsV1ExternalIntegration
  | Error;

export enum AiworkflowsV1ExternalIntegrationType {
  ClaudeAgents = 'CLAUDE_AGENTS',
  Cursor = 'CURSOR',
  Github = 'GITHUB',
  Intercom = 'INTERCOM',
}

export type AiworkflowsV1GithubIntegrationDetails = {
  appId: Scalars['Long']['output'];
  installationId: Scalars['Long']['output'];
};

export type AiworkflowsV1GithubIntegrationDetailsInput = {
  appId: Scalars['Long']['input'];
  installationId: Scalars['Long']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1HasExternalIntegrationResponse = {
  claudeAgentsConfig?: Maybe<AiworkflowsV1ClaudeAgentsIntegrationConfigDisplay>;
  exists: Scalars['Boolean']['output'];
  integrationName?: Maybe<Scalars['String']['output']>;
  working?: Maybe<Scalars['Boolean']['output']>;
};

export type AiworkflowsV1HasExternalIntegrationResponseResult =
  | AiworkflowsV1HasExternalIntegrationResponse
  | Error;

export type AiworkflowsV1InstantiateGithubInstallationResponse = {
  installationUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1InstantiateGithubInstallationResponseResult =
  | AiworkflowsV1InstantiateGithubInstallationResponse
  | Error;

export type AiworkflowsV1InstantiateIntercomInstallationResponse = {
  authorizationUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1InstantiateIntercomInstallationResponseResult =
  | AiworkflowsV1InstantiateIntercomInstallationResponse
  | Error;

export type AiworkflowsV1ListAiWorkflowInstancesResponse = {
  aiWorkflowInstances: Array<AiworkflowsV1AiWorkflowInstance>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ListAiWorkflowInstancesResponseResult =
  | AiworkflowsV1ListAiWorkflowInstancesResponse
  | Error;

export type AiworkflowsV1ListAiWorkflowSchedulesResponse = {
  aiWorkflowSchedules: Array<AiworkflowsV1AiWorkflowSchedule>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ListAiWorkflowSchedulesResponseResult =
  | AiworkflowsV1ListAiWorkflowSchedulesResponse
  | Error;

export type AiworkflowsV1ListAiWorkflowTriggersResponse = {
  aiWorkflowTriggers: Array<AiworkflowsV1AiWorkflowTrigger>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ListAiWorkflowTriggersResponseResult =
  | AiworkflowsV1ListAiWorkflowTriggersResponse
  | Error;

export type AiworkflowsV1ListExternalIntegrationsResponse = {
  externalIntegrations: Array<AiworkflowsV1ExternalIntegration>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ListExternalIntegrationsResponseResult =
  | AiworkflowsV1ListExternalIntegrationsResponse
  | Error;

export type AiworkflowsV1ListManagedSessionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  sessions: Array<AiworkflowsV1ManagedCodingSession>;
};

export type AiworkflowsV1ListManagedSessionsResponseResult =
  | AiworkflowsV1ListManagedSessionsResponse
  | Error;

export type AiworkflowsV1ManagedAgentSettings = {
  available?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AiworkflowsV1ManagedAgentSettingsResult =
  | AiworkflowsV1ManagedAgentSettings
  | Error;

export type AiworkflowsV1ManagedCodingSession = {
  branch?: Maybe<Scalars['String']['output']>;
  chatName?: Maybe<Scalars['String']['output']>;
  prUrl?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  repository?: Maybe<Scalars['String']['output']>;
  runtimeMillis?: Maybe<Scalars['Long']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<AiworkflowsV1TokenUsage>;
};

export type AiworkflowsV1ManagedWorkspace = {
  agentId?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  federationRuleId?: Maybe<Scalars['String']['output']>;
  serviceAccountId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type AiworkflowsV1ManagedWorkspaceResult =
  | AiworkflowsV1ManagedWorkspace
  | Error;

export enum AiworkflowsV1Mode {
  Interval = 'INTERVAL',
  Oneoff = 'ONEOFF',
}

export type AiworkflowsV1NotifyFeedAction = {
  activityType: Scalars['String']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  severity: AiworkflowsV1AlertSeverity;
};

export type AiworkflowsV1NotifyFeedActionInput = {
  activityType: Scalars['String']['input'];
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  severity: AiworkflowsV1AlertSeverity;
};

export enum AiworkflowsV1OutcomeType {
  GithubIssue = 'GITHUB_ISSUE',
  PullRequest = 'PULL_REQUEST',
  SlackDm = 'SLACK_DM',
}

export type AiworkflowsV1RunPromptAction = {
  actorType: AiworkflowsV1ActorType;
  prompt: Scalars['String']['output'];
  taskType?: Maybe<AiworkflowsV1TaskType>;
};

export type AiworkflowsV1RunPromptActionInput = {
  actorType: AiworkflowsV1ActorType;
  prompt: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<AiworkflowsV1TaskType>;
};

export enum AiworkflowsV1ScheduleState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Paused = 'PAUSED',
}

export enum AiworkflowsV1State {
  Created = 'CREATED',
  Done = 'DONE',
  Error = 'ERROR',
  Running = 'RUNNING',
  RunningCodemod = 'RUNNING_CODEMOD',
}

export type AiworkflowsV1StateTrigger = {
  state: Scalars['String']['output'];
};

export type AiworkflowsV1StateTriggerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export enum AiworkflowsV1TaskType {
  StaleFlags = 'STALE_FLAGS',
}

export type AiworkflowsV1ThresholdCondition = {
  comparator: AiworkflowsV1Comparator;
  thresholdValue: Scalars['Float']['output'];
};

export type AiworkflowsV1ThresholdConditionInput = {
  comparator: AiworkflowsV1Comparator;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  thresholdValue: Scalars['Float']['input'];
};

export type AiworkflowsV1TokenUsage = {
  cacheCreationInputTokens?: Maybe<Scalars['Long']['output']>;
  cacheReadInputTokens?: Maybe<Scalars['Long']['output']>;
  inputTokens?: Maybe<Scalars['Long']['output']>;
  outputTokens?: Maybe<Scalars['Long']['output']>;
  totalInputTokens?: Maybe<Scalars['Long']['output']>;
  totalTokens?: Maybe<Scalars['Long']['output']>;
};

export type AiworkflowsV1TransitionWorkflowAction = {
  action: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type AiworkflowsV1TransitionWorkflowActionInput = {
  action: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type AiworkflowsV1Trigger = {
  activityTrigger?: Maybe<AiworkflowsV1ActivityTrigger>;
  dashboardAlertTrigger?: Maybe<AiworkflowsV1DashboardAlertTrigger>;
  stateTrigger?: Maybe<AiworkflowsV1StateTrigger>;
};

export type AiworkflowsV1TriggerInput = {
  activityTrigger?: InputMaybe<AiworkflowsV1ActivityTriggerInput>;
  dashboardAlertTrigger?: InputMaybe<AiworkflowsV1DashboardAlertTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stateTrigger?: InputMaybe<AiworkflowsV1StateTriggerInput>;
};

export type AnalysisData = {
  endTime?: Maybe<Scalars['String']['output']>;
  exposureKey?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<Array<AnalysisDataTreatment>>;
};

export type AnalysisDataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<Array<AnalysisDataInputTreatmentInput>>;
};

export type AnalysisDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variantKey: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type AnalysisDataTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  variantKey: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

export type AudiencesData = {
  audiences?: Maybe<Array<AudiencesDataAudience>>;
};

export type AudiencesDataAudience = {
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  segment?: Maybe<FlagsAdminV1SegmentResult>;
};

export type AudiencesDataInput = {
  audiences?: InputMaybe<Array<AudiencesDataInputAudienceInput>>;
};

export type AudiencesDataInputAudienceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type BackgroundData = {
  text?: Maybe<Scalars['String']['output']>;
};

export type BackgroundDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1BillingOverview = {
  customerPortalUri?: Maybe<Scalars['String']['output']>;
  meters: Array<BillingV1MeterBalance>;
  renewalTime?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<BillingV1SubscriptionInfo>;
};

export type BillingV1BillingOverviewResult = BillingV1BillingOverview | Error;

export type BillingV1BillingPortalSession = {
  redirectUri: Scalars['String']['output'];
};

export type BillingV1BillingPortalSessionResult =
  | BillingV1BillingPortalSession
  | Error;

export type BillingV1CheckoutSession = {
  checkoutUri?: Maybe<Scalars['String']['output']>;
};

export type BillingV1CheckoutSessionResult = BillingV1CheckoutSession | Error;

export type BillingV1ConvertSubscriptionResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type BillingV1ConvertSubscriptionResponseResult =
  | BillingV1ConvertSubscriptionResponse
  | Error;

export type BillingV1EventsStripeCustomerCreated = {
  stripeCustomer: BillingV1StripeCustomer;
};

export type BillingV1EventsStripeCustomerUpdated = {
  stripeCustomer: BillingV1StripeCustomer;
};

export type BillingV1ListSkusResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  skus: Array<BillingV1Sku>;
};

export type BillingV1ListSkusResponseResult = BillingV1ListSkusResponse | Error;

export type BillingV1MeterBalance = {
  displayName?: Maybe<Scalars['String']['output']>;
  included?: Maybe<Scalars['Long']['output']>;
  meterSlug?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Long']['output']>;
};

export type BillingV1QueryTrialUsageInfoResponse = {
  trialUsageInfo: Array<BillingV1TrialUsageInfo>;
};

export type BillingV1QueryTrialUsageInfoResponseResult =
  | BillingV1QueryTrialUsageInfoResponse
  | Error;

export enum BillingV1ReportResolution {
  Days = 'DAYS',
  Hours = 'HOURS',
}

export type BillingV1Sku = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  service?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<GoogleTypeDecimal>;
  unitSize?: Maybe<Scalars['Long']['output']>;
};

export type BillingV1SkuAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1SkuCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type BillingV1SkuCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1SkuExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type BillingV1SkuQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1SkuReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1SkuResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1SkuReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1SkuResult = BillingV1Sku | Error;

export type BillingV1StripeCustomer = {
  address: BillingV1StripeCustomerAddress;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  environment?: Maybe<BillingV1StripeEnvironment>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  paymentMethod?: Maybe<BillingV1StripeCustomerPaymentMethod>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  region?: Maybe<BillingV1StripeRegion>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  stripeId?: Maybe<Scalars['String']['output']>;
  subscriptions: Array<BillingV1StripeCustomerSubscription>;
  taxInfo: BillingV1StripeCustomerTaxInfo;
};

export type BillingV1StripeCustomerAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1StripeCustomerCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type BillingV1StripeCustomerCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1StripeCustomerExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type BillingV1StripeCustomerQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1StripeCustomerReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1StripeCustomerResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1StripeCustomerReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1StripeCustomerAddress = {
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: BillingV1StripeCustomerAddressStatus;
};

export enum BillingV1StripeCustomerAddressStatus {
  Invalid = 'INVALID',
  Valid = 'VALID',
}

export type BillingV1StripeCustomerPaymentMethod = {
  cardInfo?: Maybe<BillingV1StripeCustomerPaymentMethodCardInfo>;
  createTime: Scalars['String']['output'];
  paymentMethodId?: Maybe<Scalars['String']['output']>;
};

export type BillingV1StripeCustomerPaymentMethodCardInfo = {
  brand?: Maybe<Scalars['String']['output']>;
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  expirationYear?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type BillingV1StripeCustomerResult = BillingV1StripeCustomer | Error;

export type BillingV1StripeCustomerSubscription = {
  items: Array<BillingV1StripeCustomerSubscriptionItem>;
  state?: Maybe<BillingV1SubscriptionState>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  trialEndTime?: Maybe<Scalars['String']['output']>;
  trialStartTime?: Maybe<Scalars['String']['output']>;
};

export type BillingV1StripeCustomerSubscriptionItem = {
  sku: BillingV1SkuResult;
  stripeSubscriptionItemId: Scalars['String']['output'];
};

export type BillingV1StripeCustomerTaxInfo = {
  state: BillingV1StripeCustomerTaxInfoState;
  taxId: Scalars['String']['output'];
  taxType: BillingV1TaxType;
};

export enum BillingV1StripeCustomerTaxInfoState {
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Valid = 'VALID',
}

export enum BillingV1StripeEnvironment {
  Prod = 'PROD',
  Test = 'TEST',
}

export enum BillingV1StripeRegion {
  Eu = 'EU',
  Us = 'US',
}

export type BillingV1SubscriptionInfo = {
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<BillingV1SubscriptionStatus>;
  tier?: Maybe<Scalars['String']['output']>;
  trialEndTime?: Maybe<Scalars['String']['output']>;
};

export enum BillingV1SubscriptionState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID',
}

export enum BillingV1SubscriptionStatus {
  SubscriptionStatusActive = 'SUBSCRIPTION_STATUS_ACTIVE',
  SubscriptionStatusCanceled = 'SUBSCRIPTION_STATUS_CANCELED',
  SubscriptionStatusNone = 'SUBSCRIPTION_STATUS_NONE',
  SubscriptionStatusPastDue = 'SUBSCRIPTION_STATUS_PAST_DUE',
  SubscriptionStatusTrialing = 'SUBSCRIPTION_STATUS_TRIALING',
}

export enum BillingV1TaxType {
  AdNrt = 'AD_NRT',
  ArCuit = 'AR_CUIT',
  BoTin = 'BO_TIN',
  BrCnpj = 'BR_CNPJ',
  BrCpf = 'BR_CPF',
  CaBn = 'CA_BN',
  CaGstHst = 'CA_GST_HST',
  CaPstBc = 'CA_PST_BC',
  CaPstMb = 'CA_PST_MB',
  CaPstSk = 'CA_PST_SK',
  CaQst = 'CA_QST',
  ChVat = 'CH_VAT',
  ClTin = 'CL_TIN',
  CoNit = 'CO_NIT',
  EuVat = 'EU_VAT',
  GbVat = 'GB_VAT',
  IdNpwp = 'ID_NPWP',
  IlVat = 'IL_VAT',
  IsVat = 'IS_VAT',
  JpCn = 'JP_CN',
  JpRn = 'JP_RN',
  JpTrn = 'JP_TRN',
  KrBrn = 'KR_BRN',
  MxRfc = 'MX_RFC',
  MyFrp = 'MY_FRP',
  MyItn = 'MY_ITN',
  MySst = 'MY_SST',
  NoVat = 'NO_VAT',
  PeRuc = 'PE_RUC',
  PhTin = 'PH_TIN',
  RsPib = 'RS_PIB',
  SgGst = 'SG_GST',
  SgUen = 'SG_UEN',
  ThVat = 'TH_VAT',
  TrTin = 'TR_TIN',
  TwVat = 'TW_VAT',
  UaVat = 'UA_VAT',
  UsEin = 'US_EIN',
  UyRuc = 'UY_RUC',
  VeRif = 'VE_RIF',
  VnTin = 'VN_TIN',
}

export type BillingV1TrialUsageInfo = {
  currentUsage: Scalars['Int']['output'];
  includedInTrial: Scalars['Int']['output'];
  usagePeriodEndTime: Scalars['String']['output'];
  usagePeriodStartTime: Scalars['String']['output'];
};

export type BillingV1UsageReport = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  endTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  generateUsageReport?: Maybe<BillingV1UsageReportResult>;
  lines: Array<BillingV1UsageReportUsageLine>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resolution?: Maybe<BillingV1ReportResolution>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  startTime?: Maybe<Scalars['String']['output']>;
  total?: Maybe<GoogleTypeDecimal>;
};

export type BillingV1UsageReportAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1UsageReportCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type BillingV1UsageReportCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingV1UsageReportExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type BillingV1UsageReportGenerateUsageReportArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<BillingV1ReportResolution>;
  startTime: Scalars['String']['input'];
};

export type BillingV1UsageReportQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1UsageReportReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1UsageReportResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1UsageReportReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type BillingV1UsageReportResult = BillingV1UsageReport | Error;

export type BillingV1UsageReportUsageLine = {
  amount?: Maybe<Scalars['Long']['output']>;
  billedAmount?: Maybe<GoogleTypeDecimal>;
  sku?: Maybe<BillingV1SkuResult>;
  usageTime?: Maybe<Scalars['String']['output']>;
};

export type C4sAbTest = {
  primaryUnit?: Maybe<Scalars['String']['output']>;
  rampUpDuration?: Maybe<C4sAbTestRampUpDuration>;
  treatments?: Maybe<Array<C4sAbTestTreatment>>;
};

export type C4sAbTestInput = {
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  rampUpDuration?: InputMaybe<C4sAbTestInputRampUpDuration>;
  treatments?: InputMaybe<Array<C4sAbTestInputTreatmentInput>>;
};

export enum C4sAbTestInputRampUpDuration {
  None = 'NONE',
  OneDay = 'ONE_DAY',
  OneWeek = 'ONE_WEEK',
}

export type C4sAbTestInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Long']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overrideGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyAssignments?: InputMaybe<
    Array<C4sAbTestInputTreatmentInputPropertyAssignmentInput>
  >;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type C4sAbTestInputTreatmentInputPropertyAssignmentInput = {
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum C4sAbTestRampUpDuration {
  None = 'NONE',
  OneDay = 'ONE_DAY',
  OneWeek = 'ONE_WEEK',
}

export type C4sAbTestTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['Long']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overrideGroupId?: Maybe<Scalars['Long']['output']>;
  overrideUserIds?: Maybe<Array<Scalars['String']['output']>>;
  propertyAssignments?: Maybe<Array<C4sAbTestTreatmentPropertyAssignment>>;
  weight?: Maybe<Scalars['Long']['output']>;
};

export type C4sAbTestTreatmentPropertyAssignment = {
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type C4sRollout = {
  description?: Maybe<Scalars['String']['output']>;
  monitoringDisabled?: Maybe<Scalars['Boolean']['output']>;
  monitoringDisabledAt?: Maybe<Scalars['String']['output']>;
  primaryUnit?: Maybe<Scalars['String']['output']>;
  reach?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<C4sRolloutSchedule>;
  treatmentGroupProportion?: Maybe<Array<Scalars['Long']['output']>>;
  treatments?: Maybe<Array<C4sRolloutTreatment>>;
};

export type C4sRolloutInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  monitoringDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  monitoringDisabledAt?: InputMaybe<Scalars['String']['input']>;
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<C4sRolloutInputScheduleInput>;
  treatmentGroupProportion?: InputMaybe<Array<Scalars['Long']['input']>>;
  treatments?: InputMaybe<Array<C4sRolloutInputTreatmentInput>>;
};

export type C4sRolloutInputScheduleInput = {
  state?: InputMaybe<C4sRolloutInputScheduleInputState>;
  stateReason?: InputMaybe<C4sRolloutInputScheduleInputScheduleStateReasonInput>;
  steps: Array<C4sRolloutInputScheduleInputScheduleStepsInput>;
};

export type C4sRolloutInputScheduleInputScheduleStateReasonInput = {
  failed?: InputMaybe<C4sRolloutInputScheduleInputScheduleStateReasonInputFailed>;
};

export enum C4sRolloutInputScheduleInputScheduleStateReasonInputFailed {
  FailedCheck = 'FAILED_CHECK',
  MissingLaunchTime = 'MISSING_LAUNCH_TIME',
  NoSpace = 'NO_SPACE',
}

export type C4sRolloutInputScheduleInputScheduleStepsInput = {
  durationSincePreviousStep: Scalars['String']['input'];
  reach: Scalars['String']['input'];
  status?: InputMaybe<C4sRolloutInputScheduleInputScheduleStepsInputStatus>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export enum C4sRolloutInputScheduleInputScheduleStepsInputStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum C4sRolloutInputScheduleInputState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Ended = 'ENDED',
  Failed = 'FAILED',
}

export type C4sRolloutInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Long']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overrideGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyAssignments?: InputMaybe<
    Array<C4sRolloutInputTreatmentInputPropertyAssignmentInput>
  >;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type C4sRolloutInputTreatmentInputPropertyAssignmentInput = {
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type C4sRolloutSchedule = {
  state?: Maybe<C4sRolloutScheduleState>;
  stateReason?: Maybe<C4sRolloutScheduleScheduleStateReason>;
  steps: Array<C4sRolloutScheduleScheduleSteps>;
};

export type C4sRolloutScheduleScheduleStateReason = {
  failed?: Maybe<C4sRolloutScheduleScheduleStateReasonFailed>;
};

export enum C4sRolloutScheduleScheduleStateReasonFailed {
  FailedCheck = 'FAILED_CHECK',
  MissingLaunchTime = 'MISSING_LAUNCH_TIME',
  NoSpace = 'NO_SPACE',
}

export type C4sRolloutScheduleScheduleSteps = {
  durationSincePreviousStep: Scalars['String']['output'];
  reach: Scalars['String']['output'];
  status?: Maybe<C4sRolloutScheduleScheduleStepsStatus>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export enum C4sRolloutScheduleScheduleStepsStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum C4sRolloutScheduleState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Ended = 'ENDED',
  Failed = 'FAILED',
}

export type C4sRolloutTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id?: Maybe<Scalars['Long']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overrideGroupId?: Maybe<Scalars['Long']['output']>;
  overrideUserIds?: Maybe<Array<Scalars['String']['output']>>;
  propertyAssignments?: Maybe<Array<C4sRolloutTreatmentPropertyAssignment>>;
  weight?: Maybe<Scalars['Long']['output']>;
};

export type C4sRolloutTreatmentPropertyAssignment = {
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CollaborationV1AgentReviewPreview = {
  agent: IamV1AgentResult;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comment?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  outcome?: Maybe<CollaborationV1AgentReviewPreviewReviewOutcome>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sections: Array<CollaborationV1AgentReviewSection>;
  state: CollaborationV1AgentReviewPreviewState;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1AgentReviewPreviewAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AgentReviewPreviewCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1AgentReviewPreviewCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AgentReviewPreviewExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1AgentReviewPreviewQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AgentReviewPreviewReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AgentReviewPreviewResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AgentReviewPreviewReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AgentReviewPreviewInput = {
  agent: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type CollaborationV1AgentReviewPreviewResult =
  | CollaborationV1AgentReviewPreview
  | Error;

export enum CollaborationV1AgentReviewPreviewReviewOutcome {
  Approve = 'APPROVE',
  Reject = 'REJECT',
}

export enum CollaborationV1AgentReviewPreviewState {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
}

export type CollaborationV1AgentReviewSection = {
  comment?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

export type CollaborationV1AgentReviewSectionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};

export type CollaborationV1Anchor = {
  document?: Maybe<CollaborationV1AnchorDocumentAnchor>;
  zone?: Maybe<CollaborationV1AnchorZoneAnchor>;
};

export type CollaborationV1AnchorDocumentAnchor = {
  document: Scalars['String']['output'];
  endNode: Scalars['String']['output'];
  endOffset: Scalars['Int']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  startNode: Scalars['String']['output'];
  startOffset: Scalars['Int']['output'];
};

export type CollaborationV1AnchorDocumentAnchorInput = {
  document: Scalars['String']['input'];
  endNode: Scalars['String']['input'];
  endOffset: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  startNode: Scalars['String']['input'];
  startOffset: Scalars['Int']['input'];
};

export type CollaborationV1AnchorInput = {
  document?: InputMaybe<CollaborationV1AnchorDocumentAnchorInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<CollaborationV1AnchorZoneAnchorInput>;
};

export type CollaborationV1AnchorZoneAnchor = {
  zone: Scalars['String']['output'];
};

export type CollaborationV1AnchorZoneAnchorInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['String']['input'];
};

export type CollaborationV1ArchiveReviewResponse = {
  review: CollaborationV1Review;
};

export type CollaborationV1ArchiveReviewResponseResult =
  | CollaborationV1ArchiveReviewResponse
  | Error;

export type CollaborationV1Attachment = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1AttachmentLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  summary?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  uri: Scalars['String']['output'];
};

export type CollaborationV1AttachmentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AttachmentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1AttachmentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1AttachmentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1AttachmentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<CollaborationV1AttachmentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  uri: Scalars['String']['input'];
};

export type CollaborationV1AttachmentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1AttachmentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1AttachmentResult = CollaborationV1Attachment | Error;

export type CollaborationV1BackfillPromptHooksResponse = {
  createdCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
};

export type CollaborationV1BackfillPromptHooksResponseResult =
  | CollaborationV1BackfillPromptHooksResponse
  | Error;

export type CollaborationV1CollaborativeDocument = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  content?: Maybe<Scalars['JSON']['output']>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  getTiptapToken?: Maybe<CollaborationV1GetTiptapTokenResponseResult>;
  labels: Array<CollaborationV1CollaborativeDocumentLabelsEntry>;
  markdown?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  pendingOperation?: Maybe<CollaborationV1CollaborativeDocumentPendingOperation>;
  publishTime?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  realtimeEditing?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: CollaborationV1CollaborativeDocumentState;
  title?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type CollaborationV1CollaborativeDocumentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CollaborativeDocumentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1CollaborativeDocumentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CollaborativeDocumentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1CollaborativeDocumentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<CollaborationV1CollaborativeDocumentLabelsEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  realtimeEditing?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1CollaborativeDocumentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CollaborativeDocumentPendingOperation = {
  type: CollaborationV1CollaborativeDocumentPendingOperationType;
};

export type CollaborationV1CollaborativeDocumentPendingOperationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  type: CollaborationV1CollaborativeDocumentPendingOperationType;
};

export enum CollaborationV1CollaborativeDocumentPendingOperationType {
  AiGeneration = 'AI_GENERATION',
}

export type CollaborationV1CollaborativeDocumentResult =
  | CollaborationV1CollaborativeDocument
  | Error;

export enum CollaborationV1CollaborativeDocumentState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum CollaborationV1CollaborativeDocumentView {
  CollaborativeDocumentViewBasic = 'COLLABORATIVE_DOCUMENT_VIEW_BASIC',
  CollaborativeDocumentViewFull = 'COLLABORATIVE_DOCUMENT_VIEW_FULL',
}

export type CollaborationV1Comment = {
  anchor?: Maybe<CollaborationV1Anchor>;
  assignee?: Maybe<IamV1IdentityResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  author: IamV1IdentityResult;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  commentReplies?: Maybe<CollaborationV1ListCommentRepliesResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  content: Scalars['String']['output'];
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1CommentLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1CommentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1CommentCommentRepliesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1CommentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentInput = {
  anchor?: InputMaybe<CollaborationV1AnchorInput>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  labels?: InputMaybe<Array<CollaborationV1CommentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type CollaborationV1CommentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1CommentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReply = {
  action?: Maybe<CollaborationV1CommentReplyAction>;
  assignee?: Maybe<IamV1IdentityResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  author: IamV1IdentityResult;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1CommentReplyLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1CommentReplyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentReplyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1CommentReplyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1CommentReplyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1CommentReplyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export enum CollaborationV1CommentReplyAction {
  Assign = 'ASSIGN',
  Reopen = 'REOPEN',
  Resolve = 'RESOLVE',
}

export type CollaborationV1CommentReplyInput = {
  action?: InputMaybe<CollaborationV1CommentReplyAction>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<CollaborationV1CommentReplyLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1CommentReplyLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1CommentReplyResult =
  | CollaborationV1CommentReply
  | Error;

export type CollaborationV1CommentResult = CollaborationV1Comment | Error;

export type CollaborationV1EventsAgentReviewPreviewCreated = {
  agentReviewPreview?: Maybe<CollaborationV1AgentReviewPreview>;
};

export type CollaborationV1EventsAgentReviewPreviewUpdated = {
  agentReviewPreview?: Maybe<CollaborationV1AgentReviewPreview>;
};

export type CollaborationV1EventsAttachmentCreated = {
  attachment?: Maybe<CollaborationV1Attachment>;
};

export type CollaborationV1EventsAttachmentDeleted = {
  attachment?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsAttachmentUpdated = {
  attachment?: Maybe<CollaborationV1Attachment>;
};

export type CollaborationV1EventsCollaborativeDocumentUpdated = {
  collaborativeDocument?: Maybe<CollaborationV1CollaborativeDocument>;
};

export type CollaborationV1EventsCommentCreated = {
  comment?: Maybe<CollaborationV1Comment>;
};

export type CollaborationV1EventsCommentDeleted = {
  comment?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsCommentReplyCreated = {
  reply?: Maybe<CollaborationV1CommentReply>;
};

export type CollaborationV1EventsCommentReplyDeleted = {
  reply?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsCommentReplyUpdated = {
  reply?: Maybe<CollaborationV1CommentReply>;
};

export type CollaborationV1EventsCommentUpdated = {
  comment?: Maybe<CollaborationV1Comment>;
};

export type CollaborationV1EventsPresenceCreated = {
  presence?: Maybe<CollaborationV1Presence>;
};

export type CollaborationV1EventsPresenceDeleted = {
  presence?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsPresenceUpdated = {
  presence?: Maybe<CollaborationV1Presence>;
};

export type CollaborationV1EventsProjectCreated = {
  project?: Maybe<CollaborationV1Project>;
};

export type CollaborationV1EventsProjectDeleted = {
  project?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsProjectUpdated = {
  project?: Maybe<CollaborationV1Project>;
};

export type CollaborationV1EventsReactionCreated = {
  reaction?: Maybe<CollaborationV1Reaction>;
};

export type CollaborationV1EventsReactionDeleted = {
  reaction?: Maybe<CollaborationV1Reaction>;
};

export type CollaborationV1EventsReactionSummaryCreated = {
  reactionSummary?: Maybe<CollaborationV1ReactionSummary>;
};

export type CollaborationV1EventsReactionSummaryUpdated = {
  reactionSummary?: Maybe<CollaborationV1ReactionSummary>;
};

export type CollaborationV1EventsReviewCreated = {
  review?: Maybe<CollaborationV1Review>;
};

export type CollaborationV1EventsReviewDeleted = {
  review?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsReviewResponseCreated = {
  response?: Maybe<CollaborationV1ReviewResponse>;
};

export type CollaborationV1EventsReviewResponseDeleted = {
  response?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsReviewResponseRequested = {
  requester?: Maybe<Scalars['String']['output']>;
  responses: Array<CollaborationV1ReviewResponse>;
};

export type CollaborationV1EventsReviewResponseSubmitted = {
  response?: Maybe<CollaborationV1ReviewResponse>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1EventsReviewResponseUpdated = {
  response?: Maybe<CollaborationV1ReviewResponse>;
};

export type CollaborationV1EventsReviewUpdated = {
  review?: Maybe<CollaborationV1Review>;
};

export type CollaborationV1ExternalDocument = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1ExternalDocumentLabelsEntry>;
  markdown?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source: CollaborationV1ExternalDocumentSource;
  title?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type CollaborationV1ExternalDocumentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ExternalDocumentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ExternalDocumentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ExternalDocumentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ExternalDocumentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentInput = {
  labels?: InputMaybe<Array<CollaborationV1ExternalDocumentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  source: CollaborationV1ExternalDocumentSourceInput;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ExternalDocumentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ExternalDocumentResult =
  | CollaborationV1ExternalDocument
  | Error;

export type CollaborationV1ExternalDocumentSource = {
  sourceId: Scalars['String']['output'];
  type: CollaborationV1ExternalDocumentSourceType;
  uri?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ExternalDocumentSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
  type: CollaborationV1ExternalDocumentSourceType;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export enum CollaborationV1ExternalDocumentSourceType {
  GoogleDocs = 'GOOGLE_DOCS',
  Notion = 'NOTION',
}

export enum CollaborationV1ExternalDocumentView {
  ExternalDocumentViewBasic = 'EXTERNAL_DOCUMENT_VIEW_BASIC',
  ExternalDocumentViewFull = 'EXTERNAL_DOCUMENT_VIEW_FULL',
}

export type CollaborationV1GetTiptapTokenResponse = {
  appId: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  readWrite?: Maybe<Scalars['Boolean']['output']>;
  tiptapDocumentName?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type CollaborationV1GetTiptapTokenResponseResult =
  | CollaborationV1GetTiptapTokenResponse
  | Error;

export type CollaborationV1KnowledgeFragmentInput = {
  content: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceUri: Scalars['String']['input'];
};

export type CollaborationV1ListAttachmentsResponse = {
  attachments: Array<CollaborationV1Attachment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListAttachmentsResponseResult =
  | CollaborationV1ListAttachmentsResponse
  | Error;

export type CollaborationV1ListCollaborativeDocumentsResponse = {
  collaborativeDocuments: Array<CollaborationV1CollaborativeDocument>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListCollaborativeDocumentsResponseResult =
  | CollaborationV1ListCollaborativeDocumentsResponse
  | Error;

export type CollaborationV1ListCommentRepliesResponse = {
  commentReplies: Array<CollaborationV1CommentReply>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListCommentRepliesResponseResult =
  | CollaborationV1ListCommentRepliesResponse
  | Error;

export type CollaborationV1ListCommentsResponse = {
  comments: Array<CollaborationV1Comment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListCommentsResponseResult =
  | CollaborationV1ListCommentsResponse
  | Error;

export type CollaborationV1ListExternalDocumentsResponse = {
  externalDocuments: Array<CollaborationV1ExternalDocument>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ListExternalDocumentsResponseResult =
  | CollaborationV1ListExternalDocumentsResponse
  | Error;

export type CollaborationV1ListPresencesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  presences: Array<CollaborationV1Presence>;
};

export type CollaborationV1ListPresencesResponseResult =
  | CollaborationV1ListPresencesResponse
  | Error;

export type CollaborationV1ListProjectsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  projects: Array<CollaborationV1Project>;
};

export type CollaborationV1ListProjectsResponseResult =
  | CollaborationV1ListProjectsResponse
  | Error;

export type CollaborationV1ListReactionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  reactions: Array<CollaborationV1Reaction>;
};

export type CollaborationV1ListReactionsResponseResult =
  | CollaborationV1ListReactionsResponse
  | Error;

export type CollaborationV1ListReviewResponsesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  reviewResponses: Array<CollaborationV1ReviewResponse>;
};

export type CollaborationV1ListReviewResponsesResponseResult =
  | CollaborationV1ListReviewResponsesResponse
  | Error;

export type CollaborationV1ListReviewsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  reviews: Array<CollaborationV1Review>;
};

export type CollaborationV1ListReviewsResponseResult =
  | CollaborationV1ListReviewsResponse
  | Error;

export type CollaborationV1ListUserRequestedReviewResponsesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  reviewResponses: Array<CollaborationV1ReviewResponse>;
};

export type CollaborationV1ListUserRequestedReviewResponsesResponseResult =
  | CollaborationV1ListUserRequestedReviewResponsesResponse
  | Error;

export type CollaborationV1Presence = {
  actor: IamV1IdentityResult;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1PresenceAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1PresenceCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1PresenceCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1PresenceExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1PresenceQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1PresenceResult = CollaborationV1Presence | Error;

export type CollaborationV1PreviewAgentReviewResponse = {
  comment?: Maybe<Scalars['String']['output']>;
  outcome: CollaborationV1PreviewAgentReviewResponseReviewOutcome;
  sections: Array<CollaborationV1AgentReviewSection>;
};

export type CollaborationV1PreviewAgentReviewResponseResult =
  | CollaborationV1PreviewAgentReviewResponse
  | Error;

export enum CollaborationV1PreviewAgentReviewResponseReviewOutcome {
  Approve = 'APPROVE',
  Reject = 'REJECT',
}

export type CollaborationV1Project = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  initiatives: Array<WorkflowV1InitiativeResult>;
  labels: Array<CollaborationV1ProjectLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  summary?: Maybe<CollaborationV1ProjectSummary>;
  surfaces: Array<WorkflowV1SurfaceResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type CollaborationV1ProjectAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ProjectCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ProjectCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ProjectExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ProjectQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  initiatives?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<CollaborationV1ProjectLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<CollaborationV1ProjectSummaryInput>;
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CollaborationV1ProjectLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ProjectLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ProjectResult = CollaborationV1Project | Error;

export type CollaborationV1ProjectSummary = {
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ProjectSummaryInput = {
  body: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CollaborationV1ProviderDocumentPage = {
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastEditedTime?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1QueryReactionSummaryResponse = {
  summary: CollaborationV1ReactionSummary;
};

export type CollaborationV1QueryReactionSummaryResponseResult =
  | CollaborationV1QueryReactionSummaryResponse
  | Error;

export type CollaborationV1Reaction = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  author: IamV1IdentityResult;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  emoji: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1ReactionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ReactionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ReactionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionInput = {
  emoji: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type CollaborationV1ReactionResult = CollaborationV1Reaction | Error;

export type CollaborationV1ReactionSummary = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  commentCount: Scalars['Int']['output'];
  commentators: Array<IamV1IdentityResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  emojiReactions: Array<CollaborationV1ReactionSummaryEmojiReactionsEntry>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1ReactionSummaryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionSummaryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ReactionSummaryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReactionSummaryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ReactionSummaryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionSummaryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionSummaryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionSummaryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReactionSummaryEmojiReactionSummary = {
  emoji?: Maybe<Scalars['String']['output']>;
  identities: Array<IamV1IdentityResult>;
  reactionCount?: Maybe<Scalars['Int']['output']>;
};

export type CollaborationV1ReactionSummaryEmojiReactionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<CollaborationV1ReactionSummaryEmojiReactionSummary>;
};

export type CollaborationV1RequestReviewResponsesResponse = {
  review: CollaborationV1Review;
  reviewResponses: Array<CollaborationV1ReviewResponse>;
};

export type CollaborationV1RequestReviewResponsesResponseResult =
  | CollaborationV1RequestReviewResponsesResponse
  | Error;

export type CollaborationV1Review = {
  archiveTime?: Maybe<Scalars['String']['output']>;
  assignedReviewers: Array<CollaborationV1ReviewReviewers>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1ReviewLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviewResponses?: Maybe<CollaborationV1ListReviewResponsesResponseResult>;
  /** @deprecated No longer supported */
  reviewers: Array<CollaborationV1ReviewReviewer>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: CollaborationV1ReviewState;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1ReviewAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ReviewCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ReviewQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewReviewResponsesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewInput = {
  assignedReviewers?: InputMaybe<Array<CollaborationV1ReviewReviewersInput>>;
  labels?: InputMaybe<Array<CollaborationV1ReviewLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  reviewers?: InputMaybe<Array<CollaborationV1ReviewReviewerInput>>;
};

export type CollaborationV1ReviewLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ReviewLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponse = {
  action?: Maybe<CollaborationV1ReviewResponseAction>;
  archiveTime?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  author: IamV1IdentityResult;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comment?: Maybe<CollaborationV1CommentResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<CollaborationV1ReviewResponseLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviewers: Array<IamV1IdentityResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  stale?: Maybe<Scalars['Boolean']['output']>;
  updateTime: Scalars['String']['output'];
};

export type CollaborationV1ReviewResponseAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewResponseCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollaborationV1ReviewResponseCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollaborationV1ReviewResponseExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollaborationV1ReviewResponseQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponseReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponseResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationV1ReviewResponseReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export enum CollaborationV1ReviewResponseAction {
  Approve = 'APPROVE',
  Reject = 'REJECT',
  Requested = 'REQUESTED',
}

export type CollaborationV1ReviewResponseLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1ReviewResponseResult =
  | CollaborationV1ReviewResponse
  | Error;

export type CollaborationV1ReviewResult = CollaborationV1Review | Error;

export type CollaborationV1ReviewReviewer = {
  identity: IamV1IdentityResult;
  role: CollaborationV1ReviewReviewerReviewRole;
};

export type CollaborationV1ReviewReviewerInput = {
  identity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: CollaborationV1ReviewReviewerReviewRole;
};

export enum CollaborationV1ReviewReviewerReviewRole {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export type CollaborationV1ReviewReviewers = {
  identity: Array<IamV1IdentityResult>;
  role: CollaborationV1ReviewReviewersReviewRole;
};

export type CollaborationV1ReviewReviewersInput = {
  identity: Array<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: CollaborationV1ReviewReviewersReviewRole;
};

export enum CollaborationV1ReviewReviewersReviewRole {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export enum CollaborationV1ReviewState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export enum CollaborationV1SearchProvider {
  GoogleDrive = 'GOOGLE_DRIVE',
  Notion = 'NOTION',
}

export type CollaborationV1SearchProviderDocumentsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pages: Array<CollaborationV1ProviderDocumentPage>;
};

export type CollaborationV1SearchProviderDocumentsResponseResult =
  | CollaborationV1SearchProviderDocumentsResponse
  | Error;

export type CollaborationV1StaleReviewResponse = {
  review: CollaborationV1Review;
};

export type CollaborationV1StaleReviewResponseResult =
  | CollaborationV1StaleReviewResponse
  | Error;

export type CollaborationV1SubmitReviewResponseResponse = {
  review: CollaborationV1Review;
  reviewResponse: CollaborationV1ReviewResponse;
};

export type CollaborationV1SubmitReviewResponseResponseResult =
  | CollaborationV1SubmitReviewResponseResponse
  | Error;

export type CollaborationV1UndoReactionResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type CollaborationV1UndoReactionResponseResult =
  | CollaborationV1UndoReactionResponse
  | Error;

export type CollectionsV1Collection = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  collectionEntries?: Maybe<CollectionsV1ListCollectionEntriesResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<CollectionsV1CollectionLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  resourceTypes: Array<CollectionsV1ResourceType>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type CollectionsV1CollectionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollectionsV1CollectionCollectionEntriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollectionsV1CollectionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntry = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<IamV1IdentityResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<CollectionsV1CollectionEntryResourceUnion>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
};

export type CollectionsV1CollectionEntryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionEntryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type CollectionsV1CollectionEntryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionsV1CollectionEntryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type CollectionsV1CollectionEntryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionEntryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type CollectionsV1CollectionEntryResourceUnion =
  | CollaborationV1ExternalDocument
  | CollaborationV1Project
  | Error
  | FlagsAdminV1Flag
  | FlagsAdminV1Segment
  | MetricsV1AssignmentTable
  | MetricsV1DimensionTable
  | MetricsV1FactTable
  | MetricsV1Metric
  | WorkflowV1Initiative
  | WorkflowV1Surface
  | WorkflowV1WorkflowInstance;

export type CollectionsV1CollectionEntryResult =
  | CollectionsV1CollectionEntry
  | Error;

export type CollectionsV1CollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<CollectionsV1CollectionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resourceTypes?: InputMaybe<Array<CollectionsV1ResourceType>>;
};

export type CollectionsV1CollectionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CollectionsV1CollectionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsV1CollectionResult = CollectionsV1Collection | Error;

export type CollectionsV1EventsCollectionCreated = {
  collection: CollectionsV1Collection;
};

export type CollectionsV1EventsCollectionDeleted = {
  collection: Scalars['String']['output'];
};

export type CollectionsV1EventsCollectionEntryCreated = {
  collectionEntry: CollectionsV1CollectionEntry;
};

export type CollectionsV1EventsCollectionEntryDeleted = {
  collectionEntry: Scalars['String']['output'];
};

export type CollectionsV1EventsCollectionUpdated = {
  collection: CollectionsV1Collection;
};

export type CollectionsV1ListCollectionEntriesResponse = {
  collectionEntries: Array<CollectionsV1CollectionEntry>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollectionsV1ListCollectionEntriesResponseResult =
  | CollectionsV1ListCollectionEntriesResponse
  | Error;

export type CollectionsV1ListCollectionsResponse = {
  collections: Array<CollectionsV1Collection>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CollectionsV1ListCollectionsResponseResult =
  | CollectionsV1ListCollectionsResponse
  | Error;

export enum CollectionsV1ResourceType {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  DimensionTable = 'DIMENSION_TABLE',
  ExternalDocument = 'EXTERNAL_DOCUMENT',
  FactTable = 'FACT_TABLE',
  Flag = 'FLAG',
  Initiative = 'INITIATIVE',
  Metric = 'METRIC',
  Project = 'PROJECT',
  Segment = 'SEGMENT',
  Surface = 'SURFACE',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
}

export type ConclusionOneOfInput = {
  conclusion?: InputMaybe<ExploreDataInputAnalysisInputConclusionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1AwsCredentialsAuthenticationSettings = {
  accessKeyId: Scalars['String']['output'];
};

export type ConnectorsV1AwsCredentialsAuthenticationSettingsInput = {
  accessKeyId: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey: Scalars['String']['input'];
};

export enum ConnectorsV1AwsRegion {
  AfSouth_1 = 'AF_SOUTH_1',
  ApEast_1 = 'AP_EAST_1',
  ApNortheast_1 = 'AP_NORTHEAST_1',
  ApNortheast_2 = 'AP_NORTHEAST_2',
  ApNortheast_3 = 'AP_NORTHEAST_3',
  ApSoutheast_1 = 'AP_SOUTHEAST_1',
  ApSoutheast_2 = 'AP_SOUTHEAST_2',
  ApSoutheast_3 = 'AP_SOUTHEAST_3',
  ApSoutheast_4 = 'AP_SOUTHEAST_4',
  ApSouth_1 = 'AP_SOUTH_1',
  ApSouth_2 = 'AP_SOUTH_2',
  CaCentral_1 = 'CA_CENTRAL_1',
  CnNorthwest_1 = 'CN_NORTHWEST_1',
  CnNorth_1 = 'CN_NORTH_1',
  EuCentral_1 = 'EU_CENTRAL_1',
  EuCentral_2 = 'EU_CENTRAL_2',
  EuNorth_1 = 'EU_NORTH_1',
  EuSouth_1 = 'EU_SOUTH_1',
  EuSouth_2 = 'EU_SOUTH_2',
  EuWest_1 = 'EU_WEST_1',
  EuWest_2 = 'EU_WEST_2',
  EuWest_3 = 'EU_WEST_3',
  IlCentral_1 = 'IL_CENTRAL_1',
  MeCentral_1 = 'ME_CENTRAL_1',
  MeSouth_1 = 'ME_SOUTH_1',
  SaEast_1 = 'SA_EAST_1',
  UsEast_1 = 'US_EAST_1',
  UsEast_2 = 'US_EAST_2',
  UsGovEast_1 = 'US_GOV_EAST_1',
  UsGovWest_1 = 'US_GOV_WEST_1',
  UsIsoEast_1 = 'US_ISO_EAST_1',
  UsIsoWest_1 = 'US_ISO_WEST_1',
  UsWest_1 = 'US_WEST_1',
  UsWest_2 = 'US_WEST_2',
}

export type ConnectorsV1AwsWebIdentityAuthenticationSettings = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1AwsWebIdentityAuthenticationSettingsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1BatchFileConfig = {
  maxEventsPerFile: Scalars['Long']['output'];
  maxFileAge: Scalars['String']['output'];
  maxFileSize: Scalars['Long']['output'];
};

export type ConnectorsV1BatchFileConfigInput = {
  maxEventsPerFile: Scalars['Long']['input'];
  maxFileAge: Scalars['String']['input'];
  maxFileSize: Scalars['Long']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1BigQueryConfig = {
  dataset: Scalars['String']['output'];
  project: Scalars['String']['output'];
  serviceAccount: Scalars['String']['output'];
};

export type ConnectorsV1BigQueryConfigInput = {
  dataset: Scalars['String']['input'];
  project: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  serviceAccount: Scalars['String']['input'];
};

export type ConnectorsV1DatabricksConfig = {
  batchFileConfig: ConnectorsV1BatchFileConfig;
  connectionConfig: ConnectorsV1DatabricksConnectionConfig;
  s3BucketConfig?: Maybe<ConnectorsV1S3BucketConfig>;
  schema: Scalars['String']['output'];
};

export type ConnectorsV1DatabricksConfigInput = {
  batchFileConfig: ConnectorsV1BatchFileConfigInput;
  connectionConfig: ConnectorsV1DatabricksConnectionConfigInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  s3BucketConfig?: InputMaybe<ConnectorsV1S3BucketConfigInput>;
  schema: Scalars['String']['input'];
};

export type ConnectorsV1DatabricksConnectionConfig = {
  clientId: Scalars['String']['output'];
  host: Scalars['String']['output'];
  warehouseId: Scalars['String']['output'];
};

export type ConnectorsV1DatabricksConnectionConfigInput = {
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['String']['input'];
};

export type ConnectorsV1Event = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  cloudEvent?: Maybe<IoCloudeventsV1CloudEvent>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  eventType?: Maybe<ConnectorsV1EventTypeResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  pubsubMetadata?: Maybe<ConnectorsV1EventPubsubMetadata>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  resources: Array<Scalars['String']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
};

export type ConnectorsV1EventAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1EventCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1EventQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnection = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  bigQuery?: Maybe<ConnectorsV1EventConnectionBigQueryEventConnectionConfig>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  databricks?: Maybe<ConnectorsV1EventConnectionDatabricksEventConnectionConfig>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  includedDefinitions: Array<EventsAdminV1EventDefinitionResult>;
  labels: Array<ConnectorsV1EventConnectionLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  redshift?: Maybe<ConnectorsV1EventConnectionRedshiftEventConnectionConfig>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  snowflake?: Maybe<ConnectorsV1EventConnectionSnowflakeEventConnectionConfig>;
  state?: Maybe<ConnectorsV1State>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata?: Maybe<ConnectorsV1UsageMetadata>;
};

export type ConnectorsV1EventConnectionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventConnectionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1EventConnectionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventConnectionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1EventConnectionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionBigQueryEventConnectionConfig = {
  bigQueryConfig: ConnectorsV1BigQueryConfig;
  tablePrefix?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventConnectionBigQueryEventConnectionConfigInput = {
  bigQueryConfig: ConnectorsV1BigQueryConfigInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tablePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionDatabricksEventConnectionConfig = {
  databricksConfig: ConnectorsV1DatabricksConfig;
};

export type ConnectorsV1EventConnectionDatabricksEventConnectionConfigInput = {
  databricksConfig: ConnectorsV1DatabricksConfigInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionInput = {
  bigQuery?: InputMaybe<ConnectorsV1EventConnectionBigQueryEventConnectionConfigInput>;
  builtin?: InputMaybe<Scalars['Boolean']['input']>;
  databricks?: InputMaybe<ConnectorsV1EventConnectionDatabricksEventConnectionConfigInput>;
  includedDefinitions?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<ConnectorsV1EventConnectionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  redshift?: InputMaybe<ConnectorsV1EventConnectionRedshiftEventConnectionConfigInput>;
  snowflake?: InputMaybe<ConnectorsV1EventConnectionSnowflakeEventConnectionConfigInput>;
};

export type ConnectorsV1EventConnectionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventConnectionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionRedshiftEventConnectionConfig = {
  batchFileConfig: ConnectorsV1BatchFileConfig;
  redshiftConfig: ConnectorsV1RedshiftConfig;
  s3Config: ConnectorsV1S3BucketConfig;
  tablePrefix?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventConnectionRedshiftEventConnectionConfigInput = {
  batchFileConfig: ConnectorsV1BatchFileConfigInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig: ConnectorsV1RedshiftConfigInput;
  s3Config: ConnectorsV1S3BucketConfigInput;
  tablePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventConnectionResult =
  | ConnectorsV1EventConnection
  | Error;

export type ConnectorsV1EventConnectionSnowflakeEventConnectionConfig = {
  snowflakeConfig: ConnectorsV1SnowflakeConfig;
  tablePrefix?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventConnectionSnowflakeEventConnectionConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  snowflakeConfig: ConnectorsV1SnowflakeConfigInput;
  tablePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventPubsubMetadata = {
  consumeTime?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  publishTime?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1EventResult = ConnectorsV1Event | Error;

export type ConnectorsV1EventType = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  persist?: Maybe<Scalars['Boolean']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
};

export type ConnectorsV1EventTypeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventTypeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1EventTypeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1EventTypeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1EventTypeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTypeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTypeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTypeReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1EventTypeResult = ConnectorsV1EventType | Error;

export type ConnectorsV1FlagAppliedConnection = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  bigQuery?: Maybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfig>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  databricks?: Maybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfig>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  kinesis?: Maybe<ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfig>;
  labels: Array<ConnectorsV1FlagAppliedConnectionLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  pubsub?: Maybe<ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfig>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  redshift?: Maybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfig>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  snowflake?: Maybe<ConnectorsV1FlagAppliedConnectionSnowflakeFlagAppliedConnectionConfig>;
  state?: Maybe<ConnectorsV1State>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata?: Maybe<ConnectorsV1UsageMetadata>;
};

export type ConnectorsV1FlagAppliedConnectionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1FlagAppliedConnectionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1FlagAppliedConnectionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfig =
  {
    bigQueryConfig: ConnectorsV1BigQueryConfig;
    evaluationContextTable?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigMode>;
    table: Scalars['String']['output'];
  };

export type ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigInput =
  {
    bigQueryConfig: ConnectorsV1BigQueryConfigInput;
    evaluationContextTable?: InputMaybe<Scalars['String']['input']>;
    mode?: InputMaybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigMode>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    table: Scalars['String']['input'];
  };

export enum ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigMode {
  LoadJob = 'LOAD_JOB',
  Streaming = 'STREAMING',
}

export type ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfig =
  {
    databricksConfig: ConnectorsV1DatabricksConfig;
    mode?: Maybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigMode>;
    table: Scalars['String']['output'];
  };

export type ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigInput =
  {
    databricksConfig: ConnectorsV1DatabricksConfigInput;
    mode?: InputMaybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigMode>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    table: Scalars['String']['input'];
  };

export enum ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigMode {
  LoadJob = 'LOAD_JOB',
  Streaming = 'STREAMING',
}

export type ConnectorsV1FlagAppliedConnectionInput = {
  bigQuery?: InputMaybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigInput>;
  builtin?: InputMaybe<Scalars['Boolean']['input']>;
  databricks?: InputMaybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigInput>;
  kinesis?: InputMaybe<ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfigInput>;
  labels?: InputMaybe<Array<ConnectorsV1FlagAppliedConnectionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  pubsub?: InputMaybe<ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfigInput>;
  redshift?: InputMaybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigInput>;
  snowflake?: InputMaybe<ConnectorsV1FlagAppliedConnectionSnowflakeFlagAppliedConnectionConfigInput>;
};

export type ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfig =
  {
    kinesisConfig: ConnectorsV1KinesisConfig;
  };

export type ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfigInput =
  {
    kinesisConfig: ConnectorsV1KinesisConfigInput;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type ConnectorsV1FlagAppliedConnectionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1FlagAppliedConnectionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfig =
  {
    pubsubConfig: ConnectorsV1PubsubConfig;
  };

export type ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfigInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    pubsubConfig: ConnectorsV1PubsubConfigInput;
  };

export type ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfig =
  {
    batchFileConfig: ConnectorsV1BatchFileConfig;
    mode?: Maybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigMode>;
    redshiftConfig: ConnectorsV1RedshiftConfig;
    s3Config: ConnectorsV1S3BucketConfig;
    table: Scalars['String']['output'];
  };

export type ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigInput =
  {
    batchFileConfig: ConnectorsV1BatchFileConfigInput;
    mode?: InputMaybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigMode>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    redshiftConfig: ConnectorsV1RedshiftConfigInput;
    s3Config: ConnectorsV1S3BucketConfigInput;
    table: Scalars['String']['input'];
  };

export enum ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigMode {
  LoadJob = 'LOAD_JOB',
  Streaming = 'STREAMING',
}

export type ConnectorsV1FlagAppliedConnectionResult =
  | ConnectorsV1FlagAppliedConnection
  | Error;

export type ConnectorsV1FlagAppliedConnectionSnowflakeFlagAppliedConnectionConfig =
  {
    snowflakeConfig: ConnectorsV1SnowflakeConfig;
    table: Scalars['String']['output'];
  };

export type ConnectorsV1FlagAppliedConnectionSnowflakeFlagAppliedConnectionConfigInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    snowflakeConfig: ConnectorsV1SnowflakeConfigInput;
    table: Scalars['String']['input'];
  };

export enum ConnectorsV1Format {
  Json = 'JSON',
  Proto = 'PROTO',
}

export type ConnectorsV1KinesisConfig = {
  outputFormat: ConnectorsV1Format;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['output'];
  stream: Scalars['String']['output'];
};

export type ConnectorsV1KinesisConfigInput = {
  outputFormat: ConnectorsV1Format;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['input'];
  stream: Scalars['String']['input'];
};

export type ConnectorsV1ListEventConnectionsResponse = {
  eventConnections: Array<ConnectorsV1EventConnection>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1ListEventConnectionsResponseResult =
  | ConnectorsV1ListEventConnectionsResponse
  | Error;

export type ConnectorsV1ListEventTypesResponse = {
  eventTypes: Array<ConnectorsV1EventType>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1ListEventTypesResponseResult =
  | ConnectorsV1ListEventTypesResponse
  | Error;

export type ConnectorsV1ListEventsResponse = {
  events: Array<ConnectorsV1Event>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1ListEventsResponseResult =
  | ConnectorsV1ListEventsResponse
  | Error;

export type ConnectorsV1ListFlagAppliedConnectionsResponse = {
  flagAppliedConnections: Array<ConnectorsV1FlagAppliedConnection>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1ListFlagAppliedConnectionsResponseResult =
  | ConnectorsV1ListFlagAppliedConnectionsResponse
  | Error;

export type ConnectorsV1ListPlatformConnectionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  platformConnections: Array<ConnectorsV1PlatformConnection>;
};

export type ConnectorsV1ListPlatformConnectionsResponseResult =
  | ConnectorsV1ListPlatformConnectionsResponse
  | Error;

export type ConnectorsV1PartialSnowflakeConfigInput = {
  account: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  database?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type ConnectorsV1PlatformConnection = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  eventType: ConnectorsV1EventTypeResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  kinesis?: Maybe<ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfig>;
  labels: Array<ConnectorsV1PlatformConnectionLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  pubsub?: Maybe<ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfig>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state?: Maybe<ConnectorsV1State>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata?: Maybe<ConnectorsV1UsageMetadata>;
};

export type ConnectorsV1PlatformConnectionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1PlatformConnectionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConnectorsV1PlatformConnectionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectorsV1PlatformConnectionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConnectorsV1PlatformConnectionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionInput = {
  builtin?: InputMaybe<Scalars['Boolean']['input']>;
  eventType: Scalars['String']['input'];
  kinesis?: InputMaybe<ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfigInput>;
  labels?: InputMaybe<Array<ConnectorsV1PlatformConnectionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  pubsub?: InputMaybe<ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfigInput>;
};

export type ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfig = {
  kinesisConfig: ConnectorsV1KinesisConfig;
};

export type ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfigInput =
  {
    kinesisConfig: ConnectorsV1KinesisConfigInput;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type ConnectorsV1PlatformConnectionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConnectorsV1PlatformConnectionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfig = {
  pubsubConfig: ConnectorsV1PubsubConfig;
};

export type ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfigInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    pubsubConfig: ConnectorsV1PubsubConfigInput;
  };

export type ConnectorsV1PlatformConnectionResult =
  | ConnectorsV1PlatformConnection
  | Error;

export type ConnectorsV1PubsubConfig = {
  outputFormat: ConnectorsV1Format;
  project: Scalars['String']['output'];
  serviceAccount: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

export type ConnectorsV1PubsubConfigInput = {
  outputFormat: ConnectorsV1Format;
  project: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  serviceAccount: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type ConnectorsV1RedshiftConfig = {
  cluster: Scalars['String']['output'];
  credentialsSettings?: Maybe<ConnectorsV1AwsCredentialsAuthenticationSettings>;
  database: Scalars['String']['output'];
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['output'];
  schema: Scalars['String']['output'];
  webIdentitySettings?: Maybe<ConnectorsV1AwsWebIdentityAuthenticationSettings>;
};

export type ConnectorsV1RedshiftConfigInput = {
  cluster: Scalars['String']['input'];
  credentialsSettings?: InputMaybe<ConnectorsV1AwsCredentialsAuthenticationSettingsInput>;
  database: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['input'];
  schema: Scalars['String']['input'];
  webIdentitySettings?: InputMaybe<ConnectorsV1AwsWebIdentityAuthenticationSettingsInput>;
};

export type ConnectorsV1S3BucketConfig = {
  bucket: Scalars['String']['output'];
  credentialsSettings?: Maybe<ConnectorsV1AwsCredentialsAuthenticationSettings>;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['output'];
  webIdentitySettings?: Maybe<ConnectorsV1AwsWebIdentityAuthenticationSettings>;
};

export type ConnectorsV1S3BucketConfigInput = {
  bucket: Scalars['String']['input'];
  credentialsSettings?: InputMaybe<ConnectorsV1AwsCredentialsAuthenticationSettingsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region: ConnectorsV1AwsRegion;
  roleArn: Scalars['String']['input'];
  webIdentitySettings?: InputMaybe<ConnectorsV1AwsWebIdentityAuthenticationSettingsInput>;
};

export type ConnectorsV1SnowflakeConfig = {
  account: Scalars['String']['output'];
  authenticationKey: IamV1CryptoKeyResult;
  database: Scalars['String']['output'];
  role: Scalars['String']['output'];
  schema: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type ConnectorsV1SnowflakeConfigInput = {
  account: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  database: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  schema: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type ConnectorsV1SnowflakeConfigValidation = {
  databases: Array<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  schemas: Array<Scalars['String']['output']>;
};

export enum ConnectorsV1State {
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
}

export type ConnectorsV1UsageMetadata = {
  errorRate?: Maybe<ConnectorsV1UsageMetadataRates>;
  lag?: Maybe<ConnectorsV1UsageMetadataHistogram>;
  successRate?: Maybe<ConnectorsV1UsageMetadataRates>;
  successRatio?: Maybe<ConnectorsV1UsageMetadataRates>;
};

export type ConnectorsV1UsageMetadataHistogram = {
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  p75?: Maybe<Scalars['Float']['output']>;
  p95?: Maybe<Scalars['Float']['output']>;
  p99?: Maybe<Scalars['Float']['output']>;
};

export type ConnectorsV1UsageMetadataHistogramInput = {
  average?: InputMaybe<Scalars['Float']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  median?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  p75?: InputMaybe<Scalars['Float']['input']>;
  p95?: InputMaybe<Scalars['Float']['input']>;
  p99?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectorsV1UsageMetadataInput = {
  errorRate?: InputMaybe<ConnectorsV1UsageMetadataRatesInput>;
  lag?: InputMaybe<ConnectorsV1UsageMetadataHistogramInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successRate?: InputMaybe<ConnectorsV1UsageMetadataRatesInput>;
  successRatio?: InputMaybe<ConnectorsV1UsageMetadataRatesInput>;
};

export type ConnectorsV1UsageMetadataRates = {
  rate1m?: Maybe<Scalars['Float']['output']>;
  rate5m?: Maybe<Scalars['Float']['output']>;
  rate15m?: Maybe<Scalars['Float']['output']>;
};

export type ConnectorsV1UsageMetadataRatesInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rate1m?: InputMaybe<Scalars['Float']['input']>;
  rate5m?: InputMaybe<Scalars['Float']['input']>;
  rate15m?: InputMaybe<Scalars['Float']['input']>;
};

export type ConnectorsV1ValidateEventConnectionConfigResponse = {
  bigQueryConfigValidation?: Maybe<ConnectorsV1ValidateEventConnectionConfigResponseBigQueryConfigValidation>;
  databricksConfigValidation?: Maybe<ConnectorsV1ValidateEventConnectionConfigResponseDatabricksConfigValidation>;
  redshiftConfigValidation?: Maybe<ConnectorsV1ValidateEventConnectionConfigResponseRedshiftConfigValidation>;
  snowflakeConfigValidation?: Maybe<ConnectorsV1SnowflakeConfigValidation>;
};

export type ConnectorsV1ValidateEventConnectionConfigResponseBigQueryConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateEventConnectionConfigResponseDatabricksConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateEventConnectionConfigResponseRedshiftConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateEventConnectionConfigResponseResult =
  | ConnectorsV1ValidateEventConnectionConfigResponse
  | Error;

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponse = {
  bigQueryConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseBigQueryConfigValidation>;
  databricksConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseDatabricksConfigValidation>;
  kinesisConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseKinesisConfigValidation>;
  pubsubConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponsePubsubConfigValidation>;
  redshiftConfigValidation?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseRedshiftConfigValidation>;
  snowflakeConfigValidation?: Maybe<ConnectorsV1SnowflakeConfigValidation>;
};

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseBigQueryConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseDatabricksConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseKinesisConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponsePubsubConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseRedshiftConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidateFlagAppliedConnectionConfigResponseResult =
  | ConnectorsV1ValidateFlagAppliedConnectionConfigResponse
  | Error;

export type ConnectorsV1ValidatePlatformConnectionConfigResponse = {
  kinesisConfigValidation?: Maybe<ConnectorsV1ValidatePlatformConnectionConfigResponseKinesisConfigValidation>;
  pubsubConfigValidation?: Maybe<ConnectorsV1ValidatePlatformConnectionConfigResponsePubsubConfigValidation>;
};

export type ConnectorsV1ValidatePlatformConnectionConfigResponseKinesisConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidatePlatformConnectionConfigResponsePubsubConfigValidation =
  {
    dummy?: Maybe<Scalars['String']['output']>;
  };

export type ConnectorsV1ValidatePlatformConnectionConfigResponseResult =
  | ConnectorsV1ValidatePlatformConnectionConfigResponse
  | Error;

export type ConversationsV1ApprovedToolCall = {
  tool: Scalars['String']['output'];
};

export type ConversationsV1ApprovedToolCallInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV1Conversation = {
  account?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['String']['output']>;
  approvedToolCalls: Array<ConversationsV1ApprovedToolCall>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  exportConversation?: Maybe<ConversationsV1ExportConversationResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  firstUserMessage?: Maybe<Scalars['String']['output']>;
  lifecycle?: Maybe<ConversationsV1ConversationLifecycle>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  messages: Array<ConversationsV1ConversationMessage>;
  metadata?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sessionId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ConversationsV1ConversationSource>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV1ConversationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV1ConversationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConversationsV1ConversationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV1ConversationExportConversationArgs = {
  format?: InputMaybe<ConversationsV1ExportFormat>;
};

export type ConversationsV1ConversationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConversationsV1ConversationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationEvent = {
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV1ConversationEventInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  approvedToolCalls?: InputMaybe<Array<ConversationsV1ApprovedToolCallInput>>;
  lifecycle?: InputMaybe<ConversationsV1ConversationLifecycle>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ConversationsV1ConversationSource>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ConversationsV1ConversationLifecycle {
  ConversationLifecycleActive = 'CONVERSATION_LIFECYCLE_ACTIVE',
  ConversationLifecycleArchived = 'CONVERSATION_LIFECYCLE_ARCHIVED',
}

export type ConversationsV1ConversationMessage = {
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  events: Array<ConversationsV1ConversationEvent>;
  generatedKind?: Maybe<ConversationsV1GeneratedKind>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  pendingApproval?: Maybe<ConversationsV1PendingApproval>;
  role: ConversationsV1MessageRole;
  toolCalls?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV1ConversationMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  generatedKind?: InputMaybe<ConversationsV1GeneratedKind>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  pendingApproval?: InputMaybe<ConversationsV1PendingApprovalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: ConversationsV1MessageRole;
  toolCalls?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV1ConversationMessageResult =
  | ConversationsV1ConversationMessage
  | Error;

export type ConversationsV1ConversationResult =
  | ConversationsV1Conversation
  | Error;

export enum ConversationsV1ConversationSource {
  ConversationSourceApi = 'CONVERSATION_SOURCE_API',
  ConversationSourceCli = 'CONVERSATION_SOURCE_CLI',
  ConversationSourceSlack = 'CONVERSATION_SOURCE_SLACK',
  ConversationSourceWeb = 'CONVERSATION_SOURCE_WEB',
}

export enum ConversationsV1ConversationView {
  ConversationViewBasic = 'CONVERSATION_VIEW_BASIC',
  ConversationViewFull = 'CONVERSATION_VIEW_FULL',
}

export type ConversationsV1ExportConversationResponse = {
  content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type ConversationsV1ExportConversationResponseResult =
  | ConversationsV1ExportConversationResponse
  | Error;

export enum ConversationsV1ExportFormat {
  ExportFormatMarkdown = 'EXPORT_FORMAT_MARKDOWN',
}

export enum ConversationsV1GeneratedKind {
  GeneratedKindToolApproved = 'GENERATED_KIND_TOOL_APPROVED',
  GeneratedKindToolRejected = 'GENERATED_KIND_TOOL_REJECTED',
}

export type ConversationsV1ListConversationsResponse = {
  conversations: Array<ConversationsV1Conversation>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV1ListConversationsResponseResult =
  | ConversationsV1ListConversationsResponse
  | Error;

export enum ConversationsV1MessageRole {
  MessageRoleAssistant = 'MESSAGE_ROLE_ASSISTANT',
  MessageRoleUser = 'MESSAGE_ROLE_USER',
}

export type ConversationsV1PendingApproval = {
  requestId: Scalars['String']['output'];
  tool: Scalars['String']['output'];
};

export type ConversationsV1PendingApprovalInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  tool: Scalars['String']['input'];
};

export type ConversationsV2AssistantMessage = {
  content: Scalars['String']['output'];
  phase?: Maybe<ConversationsV2AssistantMessagePhase>;
};

export type ConversationsV2AssistantMessageInput = {
  content: Scalars['String']['input'];
  phase?: InputMaybe<ConversationsV2AssistantMessagePhase>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum ConversationsV2AssistantMessagePhase {
  Commentary = 'COMMENTARY',
  FinalAnswer = 'FINAL_ANSWER',
}

export type ConversationsV2Chat = {
  alwaysApprovedTools: Array<ConversationsV2ChatAlwaysApprovedTool>;
  assistantOutcome?: Maybe<ConversationsV2ChatAssistantOutcome>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  chatEvents?: Maybe<ConversationsV2ListChatEventsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ConversationsV2ChatLabelsEntry>;
  lastEvent?: Maybe<ConversationsV2ChatEventResult>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  parentChatEvent?: Maybe<ConversationsV2ChatEventResult>;
  pendingEvents: Array<ConversationsV2ChatEventResult>;
  project?: Maybe<CollaborationV1ProjectResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<ConversationsV2ChatSource>;
  state?: Maybe<ConversationsV2ChatState>;
  summary?: Maybe<ConversationsV2ChatSummary>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ConversationsV2ChatAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatChatEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConversationsV2ChatCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConversationsV2ChatQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatAlwaysApprovedTool = {
  input?: Maybe<Scalars['JSON']['output']>;
  tool: Scalars['String']['output'];
};

export type ConversationsV2ChatAlwaysApprovedToolInput = {
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2ChatAssistantOutcome = {
  askQuestion?: Maybe<ConversationsV2ChatAssistantOutcomeAskQuestion>;
  error?: Maybe<ConversationsV2ChatAssistantOutcomeError>;
  interrupted?: Maybe<ConversationsV2ChatAssistantOutcomeInterrupted>;
  outcome?: Maybe<ConversationsV2ChatAssistantOutcomeCompleted>;
  toolConfirmation?: Maybe<ConversationsV2ChatAssistantOutcomeToolConfirmation>;
};

export type ConversationsV2ChatAssistantOutcomeAskQuestion = {
  alternatives: Array<Scalars['String']['output']>;
  question: Scalars['String']['output'];
};

export type ConversationsV2ChatAssistantOutcomeAskQuestionInput = {
  alternatives?: InputMaybe<Array<Scalars['String']['input']>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type ConversationsV2ChatAssistantOutcomeCompleted = {
  response?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatAssistantOutcomeCompletedInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatAssistantOutcomeError = {
  details: Scalars['String']['output'];
};

export type ConversationsV2ChatAssistantOutcomeErrorInput = {
  details: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatAssistantOutcomeInput = {
  askQuestion?: InputMaybe<ConversationsV2ChatAssistantOutcomeAskQuestionInput>;
  error?: InputMaybe<ConversationsV2ChatAssistantOutcomeErrorInput>;
  interrupted?: InputMaybe<ConversationsV2ChatAssistantOutcomeInterruptedInput>;
  outcome?: InputMaybe<ConversationsV2ChatAssistantOutcomeCompletedInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  toolConfirmation?: InputMaybe<ConversationsV2ChatAssistantOutcomeToolConfirmationInput>;
};

export type ConversationsV2ChatAssistantOutcomeInterrupted = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatAssistantOutcomeInterruptedInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatAssistantOutcomeToolConfirmation = {
  input?: Maybe<Scalars['JSON']['output']>;
  requestEvent?: Maybe<ConversationsV2ChatEventResult>;
  tool: Scalars['String']['output'];
};

export type ConversationsV2ChatAssistantOutcomeToolConfirmationInput = {
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2ChatEvent = {
  assistantMessage?: Maybe<ConversationsV2AssistantMessage>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clear?: Maybe<ConversationsV2Clear>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  compactionResult?: Maybe<ConversationsV2CompactionResult>;
  compactionStart?: Maybe<ConversationsV2CompactionStart>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  error?: Maybe<ConversationsV2Error>;
  eventIndex?: Maybe<Scalars['Int']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ConversationsV2ChatEventLabelsEntry>;
  name: Scalars['String']['output'];
  notification?: Maybe<ConversationsV2Notification>;
  pending?: Maybe<Scalars['Boolean']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  thinking?: Maybe<ConversationsV2Thinking>;
  toolCall?: Maybe<ConversationsV2ToolCall>;
  toolConfirmationRequest?: Maybe<ConversationsV2ToolConfirmationRequest>;
  toolConfirmationResponse?: Maybe<ConversationsV2ToolConfirmationResponse>;
  toolResult?: Maybe<ConversationsV2ToolResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  userInterrupt?: Maybe<ConversationsV2UserInterrupt>;
  userMessage?: Maybe<ConversationsV2UserMessage>;
};

export type ConversationsV2ChatEventAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatEventCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConversationsV2ChatEventCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatEventExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConversationsV2ChatEventQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventInput = {
  assistantMessage?: InputMaybe<ConversationsV2AssistantMessageInput>;
  clear?: InputMaybe<ConversationsV2ClearInput>;
  compactionResult?: InputMaybe<ConversationsV2CompactionResultInput>;
  compactionStart?: InputMaybe<ConversationsV2CompactionStartInput>;
  error?: InputMaybe<ConversationsV2ErrorInput>;
  labels?: InputMaybe<Array<ConversationsV2ChatEventLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<ConversationsV2NotificationInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  thinking?: InputMaybe<ConversationsV2ThinkingInput>;
  toolCall?: InputMaybe<ConversationsV2ToolCallInput>;
  toolConfirmationRequest?: InputMaybe<ConversationsV2ToolConfirmationRequestInput>;
  toolConfirmationResponse?: InputMaybe<ConversationsV2ToolConfirmationResponseInput>;
  toolResult?: InputMaybe<ConversationsV2ToolResultInput>;
  userInterrupt?: InputMaybe<ConversationsV2UserInterruptInput>;
  userMessage?: InputMaybe<ConversationsV2UserMessageInput>;
};

export type ConversationsV2ChatEventLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatEventLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatEventResult = ConversationsV2ChatEvent | Error;

export type ConversationsV2ChatInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<ConversationsV2ChatLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ConversationsV2ChatSource>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2ChatLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChatResult = ConversationsV2Chat | Error;

export enum ConversationsV2ChatSource {
  Mcp = 'MCP',
  PromptHook = 'PROMPT_HOOK',
  Slack = 'SLACK',
  Web = 'WEB',
}

export enum ConversationsV2ChatState {
  Idle = 'IDLE',
  Running = 'RUNNING',
}

export type ConversationsV2ChatSummary = {
  body?: Maybe<Scalars['String']['output']>;
  lastSummarizedEvent?: Maybe<ConversationsV2ChatEventResult>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChatSummaryInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ChildChatStopped = {
  childChat: ConversationsV2ChatResult;
  success: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ChildChatStoppedInput = {
  childChat: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2Clear = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ClearInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2CompactionResult = {
  summary: Scalars['String']['output'];
};

export type ConversationsV2CompactionResultInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  summary: Scalars['String']['input'];
};

export type ConversationsV2CompactionStart = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2CompactionStartInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ConfirmToolResponse = {
  chatEvent?: Maybe<ConversationsV2ChatEvent>;
};

export type ConversationsV2ConfirmToolResponseResult =
  | ConversationsV2ConfirmToolResponse
  | Error;

export type ConversationsV2Error = {
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ConversationsV2ErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2EventTrigger = {
  eventType: Scalars['String']['output'];
  filter?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2EventTriggerInput = {
  eventType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2EventsChatCreated = {
  chat?: Maybe<ConversationsV2Chat>;
};

export type ConversationsV2EventsChatEventCreated = {
  chatEvent?: Maybe<ConversationsV2ChatEvent>;
};

export type ConversationsV2EventsChatEventUpdated = {
  chatEvent?: Maybe<ConversationsV2ChatEvent>;
};

export type ConversationsV2EventsChatUpdated = {
  chat?: Maybe<ConversationsV2Chat>;
};

export type ConversationsV2ListChatEventsResponse = {
  chatEvents: Array<ConversationsV2ChatEvent>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ListChatEventsResponseResult =
  | ConversationsV2ListChatEventsResponse
  | Error;

export type ConversationsV2ListChatsResponse = {
  chats: Array<ConversationsV2Chat>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ListChatsResponseResult =
  | ConversationsV2ListChatsResponse
  | Error;

export type ConversationsV2ListPromptHooksResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  promptHooks: Array<ConversationsV2PromptHook>;
};

export type ConversationsV2ListPromptHooksResponseResult =
  | ConversationsV2ListPromptHooksResponse
  | Error;

export type ConversationsV2MessagePart = {
  imageUri?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2MessagePartInput = {
  imageUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2Notification = {
  childChatStopped?: Maybe<ConversationsV2ChildChatStopped>;
};

export type ConversationsV2NotificationInput = {
  childChatStopped?: InputMaybe<ConversationsV2ChildChatStoppedInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHook = {
  agent?: Maybe<Scalars['String']['output']>;
  approvedTools: Array<ConversationsV2PromptHookApprovedTool>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ConversationsV2PromptHookLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  project?: Maybe<CollaborationV1ProjectResult>;
  promptTemplate: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  trigger: ConversationsV2PromptHookTrigger;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ConversationsV2PromptHookAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2PromptHookCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ConversationsV2PromptHookCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationsV2PromptHookExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ConversationsV2PromptHookQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookApprovedTool = {
  tool: Scalars['String']['output'];
};

export type ConversationsV2PromptHookApprovedToolInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2PromptHookInput = {
  agent?: InputMaybe<Scalars['String']['input']>;
  approvedTools?: InputMaybe<Array<ConversationsV2PromptHookApprovedToolInput>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<ConversationsV2PromptHookLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  promptTemplate: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  trigger: ConversationsV2PromptHookTriggerInput;
};

export type ConversationsV2PromptHookLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2PromptHookLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2PromptHookResult = ConversationsV2PromptHook | Error;

export type ConversationsV2PromptHookTrigger = {
  eventTrigger?: Maybe<ConversationsV2EventTrigger>;
  scheduleTrigger?: Maybe<ConversationsV2ScheduleTrigger>;
};

export type ConversationsV2PromptHookTriggerInput = {
  eventTrigger?: InputMaybe<ConversationsV2EventTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleTrigger?: InputMaybe<ConversationsV2ScheduleTriggerInput>;
};

export type ConversationsV2ScheduleTrigger = {
  cron: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2ScheduleTriggerInput = {
  cron: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2Thinking = {
  content: Scalars['String']['output'];
};

export type ConversationsV2ThinkingInput = {
  content: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2ToolCall = {
  displayName?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['JSON']['output']>;
  tool: Scalars['String']['output'];
};

export type ConversationsV2ToolCallInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2ToolConfirmationRequest = {
  displayName?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['JSON']['output']>;
  tool: Scalars['String']['output'];
};

export type ConversationsV2ToolConfirmationRequestInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type ConversationsV2ToolConfirmationResponse = {
  decision: ConversationsV2ToolConfirmationResponseDecision;
  toolRequestEvent: ConversationsV2ChatEventResult;
};

export enum ConversationsV2ToolConfirmationResponseDecision {
  Allow = 'ALLOW',
  AllowAll = 'ALLOW_ALL',
  Deny = 'DENY',
}

export type ConversationsV2ToolConfirmationResponseInput = {
  decision: ConversationsV2ToolConfirmationResponseDecision;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  toolRequestEvent: Scalars['String']['input'];
};

export type ConversationsV2ToolResult = {
  content: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  toolCallEvent?: Maybe<ConversationsV2ChatEventResult>;
};

export type ConversationsV2ToolResultInput = {
  content: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
  toolCallEvent?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2UserInterrupt = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type ConversationsV2UserInterruptInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationsV2UserMessage = {
  /** @deprecated No longer supported */
  content?: Maybe<Scalars['String']['output']>;
  parts: Array<ConversationsV2MessagePart>;
};

export type ConversationsV2UserMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<ConversationsV2MessagePartInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type DecisionRecordData = {
  conclusion?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<DecisionRecordDataOutcome>;
  treatment?: Maybe<Scalars['String']['output']>;
};

export type DecisionRecordDataInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<DecisionRecordDataInputOutcome>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};

export enum DecisionRecordDataInputOutcome {
  Abandoned = 'abandoned',
  Aborted = 'aborted',
  Restarted = 'restarted',
  Shipped = 'shipped',
}

export enum DecisionRecordDataOutcome {
  Abandoned = 'abandoned',
  Aborted = 'aborted',
  Restarted = 'restarted',
  Shipped = 'shipped',
}

export type DimensionsOneOfInput = {
  metricCalculationDimensionTableDimension?: InputMaybe<ExploreDataInputAnalysisInputMetricInputMetricCalculationDimensionTableDimensionInput>;
  metricCalculationFactTableDimension?: InputMaybe<ExploreDataInputAnalysisInputMetricInputMetricCalculationFactTableDimensionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EpTest = {
  myConfigField: Scalars['String']['output'];
};

export type EpTestInput = {
  myConfigField: Scalars['String']['input'];
};

export type Error = {
  code: ErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum ErrorCode {
  Aborted = 'ABORTED',
  AlreadyExists = 'ALREADY_EXISTS',
  Cancelled = 'CANCELLED',
  DataLoss = 'DATA_LOSS',
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  FailedPrecondition = 'FAILED_PRECONDITION',
  Internal = 'INTERNAL',
  InvalidArgument = 'INVALID_ARGUMENT',
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  OutOfRange = 'OUT_OF_RANGE',
  PermissionDenied = 'PERMISSION_DENIED',
  ResourceExhausted = 'RESOURCE_EXHAUSTED',
  Unauthenticated = 'UNAUTHENTICATED',
  Unavailable = 'UNAVAILABLE',
  Unimplemented = 'UNIMPLEMENTED',
  Unknown = 'UNKNOWN',
}

export type EventsAdminV1DraftEvent = {
  client: IamV1ClientResult;
  draftEventDefinition?: Maybe<Scalars['String']['output']>;
  eventDefinition?: Maybe<EventsAdminV1EventDefinitionResult>;
  eventTime: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  reason: EventsAdminV1DraftEventValidationErrorReason;
  schema: EventsAdminV1EventSchema;
};

export enum EventsAdminV1DraftEventValidationErrorReason {
  EventDefinitionMissing = 'EVENT_DEFINITION_MISSING',
  EventDefinitionUnknownFields = 'EVENT_DEFINITION_UNKNOWN_FIELDS',
}

export type EventsAdminV1EventDefinition = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<EventsAdminV1EventDefinitionLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schema: Array<EventsAdminV1EventDefinitionSchemaEntry>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata: EventsAdminV1EventDefinitionUsageMetadata;
};

export type EventsAdminV1EventDefinitionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventsAdminV1EventDefinitionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type EventsAdminV1EventDefinitionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventsAdminV1EventDefinitionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type EventsAdminV1EventDefinitionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionInput = {
  labels?: InputMaybe<Array<EventsAdminV1EventDefinitionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Array<EventsAdminV1EventDefinitionSchemaEntryInput>>;
};

export type EventsAdminV1EventDefinitionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1EventDefinitionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventDefinitionResult =
  | Error
  | EventsAdminV1EventDefinition;

export type EventsAdminV1EventDefinitionSchemaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<EventsAdminV1EventSchema>;
};

export type EventsAdminV1EventDefinitionSchemaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<EventsAdminV1EventSchemaInput>;
};

export type EventsAdminV1EventDefinitionUsageMetadata = {
  lastPublishTime?: Maybe<Scalars['String']['output']>;
  lastValidationFailedTime?: Maybe<Scalars['String']['output']>;
  publishCount: Scalars['Long']['output'];
  validationFailedCount: Scalars['Long']['output'];
};

export type EventsAdminV1EventDefinitionUsageMetadataInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventSchema = {
  boolSchema?: Maybe<EventsAdminV1EventSchemaBoolSchema>;
  dateSchema?: Maybe<EventsAdminV1EventSchemaDateSchema>;
  doubleSchema?: Maybe<EventsAdminV1EventSchemaDoubleSchema>;
  intSchema?: Maybe<EventsAdminV1EventSchemaIntSchema>;
  listSchema?: Maybe<EventsAdminV1EventSchemaListSchema>;
  stringSchema?: Maybe<EventsAdminV1EventSchemaStringSchema>;
  structSchema?: Maybe<EventsAdminV1EventSchemaStructSchema>;
  timestampSchema?: Maybe<EventsAdminV1EventSchemaTimestampSchema>;
};

export type EventsAdminV1EventSchemaBoolSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaBoolSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaDateSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaDateSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaDoubleSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaDoubleSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaInput = {
  boolSchema?: InputMaybe<EventsAdminV1EventSchemaBoolSchemaInput>;
  dateSchema?: InputMaybe<EventsAdminV1EventSchemaDateSchemaInput>;
  doubleSchema?: InputMaybe<EventsAdminV1EventSchemaDoubleSchemaInput>;
  intSchema?: InputMaybe<EventsAdminV1EventSchemaIntSchemaInput>;
  listSchema?: InputMaybe<EventsAdminV1EventSchemaListSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringSchema?: InputMaybe<EventsAdminV1EventSchemaStringSchemaInput>;
  structSchema?: InputMaybe<EventsAdminV1EventSchemaStructSchemaInput>;
  timestampSchema?: InputMaybe<EventsAdminV1EventSchemaTimestampSchemaInput>;
};

export type EventsAdminV1EventSchemaIntSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaIntSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaListSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  elementSchema?: Maybe<EventsAdminV1EventSchema>;
};

export type EventsAdminV1EventSchemaListSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  elementSchema?: InputMaybe<EventsAdminV1EventSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1EventSchemaStringSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaStringSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventSchemaStructSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  schema: Array<EventsAdminV1EventSchemaStructSchemaSchemaEntry>;
};

export type EventsAdminV1EventSchemaStructSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<EventsAdminV1EventSchemaStructSchemaSchemaEntryInput>
  >;
};

export type EventsAdminV1EventSchemaStructSchemaSchemaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<EventsAdminV1EventSchema>;
};

export type EventsAdminV1EventSchemaStructSchemaSchemaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<EventsAdminV1EventSchemaInput>;
};

export type EventsAdminV1EventSchemaTimestampSchema = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  semanticType?: Maybe<EventsAdminV1FieldSemanticType>;
};

export type EventsAdminV1EventSchemaTimestampSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<EventsAdminV1FieldSemanticTypeInput>;
};

export type EventsAdminV1EventUsageEntry = {
  hourTime: Scalars['String']['output'];
  publishCount: Scalars['Long']['output'];
  validationFailedCount: Scalars['Long']['output'];
};

export type EventsAdminV1EventsEventDefinitionCreated = {
  eventDefinition?: Maybe<EventsAdminV1EventDefinition>;
};

export type EventsAdminV1EventsEventDefinitionDeleted = {
  eventDefinition?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1EventsEventDefinitionUpdated = {
  eventDefinition?: Maybe<EventsAdminV1EventDefinition>;
};

export type EventsAdminV1FieldSemanticType = {
  country?: Maybe<EventsAdminV1FieldSemanticTypeCountrySemanticType>;
  entityReference?: Maybe<EventsAdminV1FieldSemanticTypeEntitySemanticType>;
  enumType?: Maybe<EventsAdminV1FieldSemanticTypeEnumSemanticType>;
};

export type EventsAdminV1FieldSemanticTypeCountrySemanticType = {
  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
};

export enum EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat {
  TwoLetterIsoCode = 'TWO_LETTER_ISO_CODE',
}

export type EventsAdminV1FieldSemanticTypeCountrySemanticTypeInput = {
  format: EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1FieldSemanticTypeEntitySemanticType = {
  entity: MetricsV1EntityResult;
};

export type EventsAdminV1FieldSemanticTypeEntitySemanticTypeInput = {
  entity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1FieldSemanticTypeEnumSemanticType = {
  values: Array<EventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValue>;
};

export type EventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValue = {
  value?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValueInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1FieldSemanticTypeEnumSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values: Array<EventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValueInput>;
};

export type EventsAdminV1FieldSemanticTypeInput = {
  country?: InputMaybe<EventsAdminV1FieldSemanticTypeCountrySemanticTypeInput>;
  entityReference?: InputMaybe<EventsAdminV1FieldSemanticTypeEntitySemanticTypeInput>;
  enumType?: InputMaybe<EventsAdminV1FieldSemanticTypeEnumSemanticTypeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type EventsAdminV1ListEventDefinitionsResponse = {
  eventDefinitions: Array<EventsAdminV1EventDefinition>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1ListEventDefinitionsResponseResult =
  | Error
  | EventsAdminV1ListEventDefinitionsResponse;

export type EventsAdminV1QueryDraftEventsResponse = {
  draftEvents: Array<EventsAdminV1DraftEvent>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type EventsAdminV1QueryDraftEventsResponseResult =
  | Error
  | EventsAdminV1QueryDraftEventsResponse;

export type EventsAdminV1QueryEventsUsageResponse = {
  usage: Array<EventsAdminV1EventUsageEntry>;
};

export type EventsAdminV1QueryEventsUsageResponseResult =
  | Error
  | EventsAdminV1QueryEventsUsageResponse;

export type ExploreData = {
  exploratoryAnalyses: Array<ExploreDataAnalysis>;
};

export type ExploreDataAnalysis = {
  analysisResults?: Maybe<Array<ExploreDataAnalysisAnalysisResult>>;
  conclusion?: Maybe<ExploreDataAnalysisConclusionUnion>;
  createTime: Scalars['String']['output'];
  createdBy?: Maybe<IamV1UserResult>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  labels?: Maybe<Array<ExploreDataAnalysisLabel>>;
  messages: Array<Scalars['String']['output']>;
  metrics: Array<ExploreDataAnalysisMetric>;
  name: Scalars['String']['output'];
  splitByExposureFilters?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state: ExploreDataAnalysisState;
  updateTime: Scalars['String']['output'];
  useCustomDateRange?: Maybe<Scalars['Boolean']['output']>;
  useScheduledCalculation?: Maybe<Scalars['Boolean']['output']>;
};

export type ExploreDataAnalysisAnalysisResult = {
  analysisResult: StatsV2AnalysisAnalysisResultResult;
  exposureFilterName?: Maybe<Scalars['String']['output']>;
};

export type ExploreDataAnalysisConclusion = {
  text: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
};

export type ExploreDataAnalysisConclusionUnion = ExploreDataAnalysisConclusion;

export type ExploreDataAnalysisLabel = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExploreDataAnalysisMetric = {
  calculation?: Maybe<MetricsV1MetricCalculationResult>;
  calculationError?: Maybe<Scalars['String']['output']>;
  dimensions: Array<ExploreDataAnalysisMetricDimensionsUnion>;
  metricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  name: MetricsV1MetricResult;
  scheduledCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
};

export type ExploreDataAnalysisMetricDimensionsUnion =
  | ExploreDataAnalysisMetricMetricCalculationDimensionTableDimension
  | ExploreDataAnalysisMetricMetricCalculationFactTableDimension;

export type ExploreDataAnalysisMetricMetricCalculationDimensionTableDimension =
  {
    column: Scalars['String']['output'];
    dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  };

export type ExploreDataAnalysisMetricMetricCalculationFactTableDimension = {
  column: Scalars['String']['output'];
  factTable: MetricsV1FactTableResult;
};

export enum ExploreDataAnalysisState {
  Calculating = 'CALCULATING',
  Done = 'DONE',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Stale = 'STALE',
}

export type ExploreDataInput = {
  exploratoryAnalyses: Array<ExploreDataInputAnalysisInput>;
};

export type ExploreDataInputAnalysisInput = {
  analysisResults?: InputMaybe<
    Array<ExploreDataInputAnalysisInputAnalysisResultInput>
  >;
  conclusion?: InputMaybe<ConclusionOneOfInput>;
  createTime: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  labels?: InputMaybe<Array<ExploreDataInputAnalysisInputLabelInput>>;
  messages: Array<Scalars['String']['input']>;
  metrics: Array<ExploreDataInputAnalysisInputMetricInput>;
  name: Scalars['String']['input'];
  splitByExposureFilters?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  state: ExploreDataInputAnalysisInputState;
  updateTime: Scalars['String']['input'];
  useCustomDateRange?: InputMaybe<Scalars['Boolean']['input']>;
  useScheduledCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExploreDataInputAnalysisInputAnalysisResultInput = {
  analysisResult: Scalars['String']['input'];
  exposureFilterName?: InputMaybe<Scalars['String']['input']>;
};

export type ExploreDataInputAnalysisInputConclusionInput = {
  text: Scalars['String']['input'];
  updateTime: Scalars['String']['input'];
};

export type ExploreDataInputAnalysisInputLabelInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ExploreDataInputAnalysisInputMetricInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  calculationError?: InputMaybe<Scalars['String']['input']>;
  dimensions: Array<DimensionsOneOfInput>;
  metricCalculation?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  scheduledCalculation?: InputMaybe<Scalars['String']['input']>;
};

export type ExploreDataInputAnalysisInputMetricInputMetricCalculationDimensionTableDimensionInput =
  {
    column: Scalars['String']['input'];
    dimensionTable?: InputMaybe<Scalars['String']['input']>;
  };

export type ExploreDataInputAnalysisInputMetricInputMetricCalculationFactTableDimensionInput =
  {
    column: Scalars['String']['input'];
    factTable: Scalars['String']['input'];
  };

export enum ExploreDataInputAnalysisInputState {
  Calculating = 'CALCULATING',
  Done = 'DONE',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Stale = 'STALE',
}

export type ExposureData = {
  exposure: Array<ExposureDataExposureEntry>;
};

export type ExposureDataExposureEntry = {
  exposureFilter?: Maybe<Scalars['String']['output']>;
  totalExposureCount: Scalars['Long']['output'];
  treatment: Scalars['String']['output'];
};

export type ExposureDataInput = {
  exposure: Array<ExposureDataInputExposureEntryInput>;
};

export type ExposureDataInputExposureEntryInput = {
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  totalExposureCount: Scalars['Long']['input'];
  treatment: Scalars['String']['input'];
};

export type ExposureOneOfInput = {
  exposureCalculation?: InputMaybe<SampleSizeDataInputExposureCalculationInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledExposureCalculation?: InputMaybe<SampleSizeDataInputScheduledExposureCalculationInput>;
};

export type ExposureSourceOneOfInput = {
  assignmentTable?: InputMaybe<SampleSizeDataInputAssignmentTableInput>;
  existingInstance?: InputMaybe<SampleSizeDataInputExistingInstanceInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1AuthCheckLog = {
  accountStateVersionTime: Scalars['String']['output'];
  allAllowed: Scalars['Boolean']['output'];
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  contextualTuples: Array<FgaV1TupleKey>;
  createTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  results: Array<FgaV1CheckResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  ttlTime: Scalars['String']['output'];
};

export type FgaV1AuthCheckLogAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1AuthCheckLogCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FgaV1AuthCheckLogCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1AuthCheckLogExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FgaV1AuthCheckLogQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1AuthCheckLogReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1AuthCheckLogResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1AuthCheckLogReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1CheckResult = {
  allowed?: Maybe<Scalars['Boolean']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<FgaV1ResourceRelation>;
};

export type FgaV1EventsAuthCheckLogCreated = {
  authCheckLog?: Maybe<FgaV1AuthCheckLog>;
};

export type FgaV1ExecuteCheckResponse = {
  allAllowed?: Maybe<Scalars['Boolean']['output']>;
  results: Array<FgaV1CheckResult>;
};

export type FgaV1ExecuteCheckResponseResult = Error | FgaV1ExecuteCheckResponse;

export type FgaV1ListResourcePermissionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  resourcePermissions: Array<FgaV1ResourcePermission>;
};

export type FgaV1ListResourcePermissionsResponseResult =
  | Error
  | FgaV1ListResourcePermissionsResponse;

export type FgaV1ListResourceRelationsResponse = {
  resourceRelations: Array<FgaV1ResourceRelation>;
};

export type FgaV1ListResourceRelationsResponseResult =
  | Error
  | FgaV1ListResourceRelationsResponse;

export enum FgaV1Permission {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER',
}

export type FgaV1ResourcePermission = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  labels: Array<FgaV1ResourcePermissionLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource: Scalars['String']['output'];
  resourcePermission: FgaV1Permission;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type FgaV1ResourcePermissionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1ResourcePermissionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FgaV1ResourcePermissionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FgaV1ResourcePermissionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FgaV1ResourcePermissionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionInput = {
  identity: Scalars['String']['input'];
  labels?: InputMaybe<Array<FgaV1ResourcePermissionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  resourcePermission: FgaV1Permission;
};

export type FgaV1ResourcePermissionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FgaV1ResourcePermissionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FgaV1ResourcePermissionResult = Error | FgaV1ResourcePermission;

export type FgaV1ResourceRelation = {
  relation: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export type FgaV1ResourceRelationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  relation: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

export type FgaV1TupleKey = {
  object: Scalars['String']['output'];
  relation: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type FgaV1WriteResourcePermissionsResponse = {
  addedPermissions: Array<FgaV1ResourcePermission>;
  removedPermissions: Array<FgaV1ResourcePermission>;
};

export type FgaV1WriteResourcePermissionsResponseResult =
  | Error
  | FgaV1WriteResourcePermissionsResponse;

export type FlagsAdminV1ClientEvaluationContextSchema = {
  client: IamV1ClientResult;
  schema?: Maybe<FlagsAdminV1EvaluationContextSchema>;
};

export type FlagsAdminV1ComputeSegmentSpaceCalendarResponse = {
  dailyAvailability: Array<FlagsAdminV1DailySpaceAvailability>;
};

export type FlagsAdminV1ComputeSegmentSpaceCalendarResponseResult =
  | Error
  | FlagsAdminV1ComputeSegmentSpaceCalendarResponse;

export type FlagsAdminV1ContextFieldSeenValuesInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type FlagsAdminV1ContextFieldSemanticType = {
  country?: Maybe<FlagsAdminV1ContextFieldSemanticTypeCountrySemanticType>;
  date?: Maybe<FlagsAdminV1ContextFieldSemanticTypeDateSemanticType>;
  entityReference?: Maybe<FlagsAdminV1ContextFieldSemanticTypeEntitySemanticType>;
  enumType?: Maybe<FlagsAdminV1ContextFieldSemanticTypeEnumSemanticType>;
  timestamp?: Maybe<FlagsAdminV1ContextFieldSemanticTypeTimestampSemanticType>;
  version?: Maybe<FlagsAdminV1ContextFieldSemanticTypeVersionSemanticType>;
};

export type FlagsAdminV1ContextFieldSemanticTypeCountrySemanticType = {
  format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
};

export enum FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat {
  TwoLetterIsoCode = 'TWO_LETTER_ISO_CODE',
}

export type FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeInput = {
  format: FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeDateSemanticType = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeDateSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeEntitySemanticType = {
  entity: MetricsV1EntityResult;
};

export type FlagsAdminV1ContextFieldSemanticTypeEntitySemanticTypeInput = {
  entity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeEnumSemanticType = {
  values: Array<FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValue>;
};

export type FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValue = {
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValueInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values: Array<FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValueInput>;
};

export type FlagsAdminV1ContextFieldSemanticTypeInput = {
  country?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeInput>;
  date?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeDateSemanticTypeInput>;
  entityReference?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeEntitySemanticTypeInput>;
  enumType?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeTimestampSemanticTypeInput>;
  version?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeVersionSemanticTypeInput>;
};

export type FlagsAdminV1ContextFieldSemanticTypeTimestampSemanticType = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeTimestampSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeVersionSemanticType = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ContextFieldSemanticTypeVersionSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DailySpaceAvailability = {
  availableSpace?: Maybe<GoogleTypeDecimal>;
  date: GoogleTypeDate;
  reclaimableSpace: Array<FlagsAdminV1DailySpaceAvailabilityReclaimableSpaceEntry>;
};

export type FlagsAdminV1DailySpaceAvailabilityReclaimableSpaceEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<GoogleTypeDecimal>;
};

export type FlagsAdminV1DeriveClientEvaluationContextSchemaResponse = {
  capped?: Maybe<Scalars['Boolean']['output']>;
  clientSchema: Array<FlagsAdminV1ClientEvaluationContextSchema>;
  mergedSchema?: Maybe<FlagsAdminV1EvaluationContextSchema>;
};

export type FlagsAdminV1DeriveClientEvaluationContextSchemaResponseResult =
  | Error
  | FlagsAdminV1DeriveClientEvaluationContextSchemaResponse;

export type FlagsAdminV1DistinctCount = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  count: Scalars['Long']['output'];
  createTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1DistinctCountLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
};

export type FlagsAdminV1DistinctCountAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1DistinctCountCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1DistinctCountCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1DistinctCountExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1DistinctCountQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DistinctCountReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DistinctCountResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1DistinctCountReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export enum FlagsAdminV1DistinctCountKind {
  Applies = 'APPLIES',
  Assigns = 'ASSIGNS',
}

export type FlagsAdminV1DistinctCountLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1DistinctCountResult = Error | FlagsAdminV1DistinctCount;

export type FlagsAdminV1Environment = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  color?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1EnvironmentLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type FlagsAdminV1EnvironmentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EnvironmentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1EnvironmentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EnvironmentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1EnvironmentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<FlagsAdminV1EnvironmentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EnvironmentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EnvironmentResult = Error | FlagsAdminV1Environment;

export type FlagsAdminV1EvaluationContextFieldOverride = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clients: Array<Scalars['String']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  field: Scalars['String']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  kind: FlagsAdminV1EvaluationContextSchemaFieldKind;
  labels: Array<FlagsAdminV1EvaluationContextFieldOverrideLabelsEntry>;
  log?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nonPii?: Maybe<Scalars['Boolean']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  semanticType?: Maybe<FlagsAdminV1ContextFieldSemanticType>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type FlagsAdminV1EvaluationContextFieldOverrideAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type FlagsAdminV1EvaluationContextFieldOverrideCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1EvaluationContextFieldOverrideReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideResourcePermissionsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1EvaluationContextFieldOverrideReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideInput = {
  clients?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  kind: FlagsAdminV1EvaluationContextSchemaFieldKind;
  labels?: InputMaybe<
    Array<FlagsAdminV1EvaluationContextFieldOverrideLabelsEntryInput>
  >;
  log?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonPii?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeInput>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1EvaluationContextFieldOverrideResult =
  | Error
  | FlagsAdminV1EvaluationContextFieldOverride;

export type FlagsAdminV1EvaluationContextSchema = {
  schema: Array<FlagsAdminV1EvaluationContextSchemaSchemaEntry>;
};

export type FlagsAdminV1EvaluationContextSchemaField = {
  displayName?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  seenValues: Array<Scalars['JSON']['output']>;
  semanticType?: Maybe<FlagsAdminV1ContextFieldSemanticType>;
  types: Array<FlagsAdminV1EvaluationContextSchemaFieldKind>;
};

export type FlagsAdminV1EvaluationContextSchemaFieldInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  seenValues?: InputMaybe<Array<Scalars['JSON']['input']>>;
  semanticType?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeInput>;
  types?: InputMaybe<Array<FlagsAdminV1EvaluationContextSchemaFieldKind>>;
};

export enum FlagsAdminV1EvaluationContextSchemaFieldKind {
  BoolKind = 'BOOL_KIND',
  NullKind = 'NULL_KIND',
  NumberKind = 'NUMBER_KIND',
  StringKind = 'STRING_KIND',
}

export type FlagsAdminV1EvaluationContextSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<FlagsAdminV1EvaluationContextSchemaSchemaEntryInput>
  >;
};

export type FlagsAdminV1EvaluationContextSchemaSchemaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<FlagsAdminV1EvaluationContextSchemaField>;
};

export type FlagsAdminV1EvaluationContextSchemaSchemaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<FlagsAdminV1EvaluationContextSchemaFieldInput>;
};

export type FlagsAdminV1EventsEnvironmentCreated = {
  environment?: Maybe<FlagsAdminV1Environment>;
};

export type FlagsAdminV1EventsEnvironmentDeleted = {
  environment?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EventsEnvironmentUpdated = {
  environment?: Maybe<FlagsAdminV1Environment>;
};

export type FlagsAdminV1EventsEvaluationContextFieldOverrideCreated = {
  evaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverride>;
};

export type FlagsAdminV1EventsEvaluationContextFieldOverrideDeleted = {
  evaluationContextFieldOverride?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EventsEvaluationContextFieldOverrideUpdated = {
  evaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverride>;
};

export type FlagsAdminV1EventsFlagArchived = {
  flag?: Maybe<FlagsAdminV1Flag>;
};

export type FlagsAdminV1EventsFlagCreated = {
  flag?: Maybe<FlagsAdminV1Flag>;
};

export type FlagsAdminV1EventsFlagUnarchived = {
  flag?: Maybe<FlagsAdminV1Flag>;
};

export type FlagsAdminV1EventsFlagUpdated = {
  flag?: Maybe<FlagsAdminV1Flag>;
  oldFlag?: Maybe<FlagsAdminV1Flag>;
};

export type FlagsAdminV1EventsMaterializedSegmentCreated = {
  materializedSegment?: Maybe<FlagsAdminV1MaterializedSegment>;
};

export type FlagsAdminV1EventsMaterializedSegmentDeleted = {
  materializedSegment?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1EventsMaterializedSegmentUpdated = {
  materializedSegment?: Maybe<FlagsAdminV1MaterializedSegment>;
};

export type FlagsAdminV1EventsSegmentAllocated = {
  segment?: Maybe<FlagsAdminV1Segment>;
};

export type FlagsAdminV1EventsSegmentArchived = {
  segment?: Maybe<FlagsAdminV1Segment>;
};

export type FlagsAdminV1EventsSegmentCreated = {
  segment?: Maybe<FlagsAdminV1Segment>;
};

export type FlagsAdminV1EventsSegmentUpdated = {
  oldSegment?: Maybe<FlagsAdminV1Segment>;
  segment?: Maybe<FlagsAdminV1Segment>;
};

export type FlagsAdminV1Flag = {
  archiveTime?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clients: Array<IamV1ClientResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1FlagLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  rules: Array<FlagsAdminV1FlagRule>;
  schema?: Maybe<FlagsTypesV1FlagSchemaStructFlagSchema>;
  state: FlagsAdminV1FlagState;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata?: Maybe<FlagsAdminV1FlagUsageMetadata>;
  variants: Array<FlagsAdminV1FlagVariant>;
};

export type FlagsAdminV1FlagAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1FlagCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1FlagQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagInput = {
  clients?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<FlagsAdminV1FlagLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<FlagsAdminV1FlagRuleInput>>;
  schema?: InputMaybe<FlagsTypesV1FlagSchemaStructFlagSchemaInput>;
  usageMetadata?: InputMaybe<FlagsAdminV1FlagUsageMetadataInput>;
  variants?: InputMaybe<Array<FlagsAdminV1FlagVariantInput>>;
};

export type FlagsAdminV1FlagLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagResult = Error | FlagsAdminV1Flag;

export type FlagsAdminV1FlagRule = {
  assignmentSpec: FlagsAdminV1FlagRuleAssignmentSpec;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  environments: Array<FlagsAdminV1EnvironmentResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1FlagRuleLabelsEntry>;
  materializationSpec?: Maybe<FlagsAdminV1FlagRuleMaterializationSpec>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  segment: FlagsAdminV1SegmentResult;
  targetingKeySelector?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  usageMetadata: FlagsAdminV1FlagRuleUsageMetadata;
};

export type FlagsAdminV1FlagRuleAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagRuleCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1FlagRuleCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagRuleExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1FlagRuleQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleAssignment = {
  assignmentId?: Maybe<Scalars['String']['output']>;
  bucketRanges: Array<FlagsAdminV1FlagRuleBucketRange>;
  clientDefault?: Maybe<FlagsAdminV1FlagRuleAssignmentClientDefaultAssignment>;
  fallthrough?: Maybe<FlagsAdminV1FlagRuleAssignmentFallthroughAssignment>;
  variant?: Maybe<FlagsAdminV1FlagRuleAssignmentVariantAssignment>;
};

export type FlagsAdminV1FlagRuleAssignmentClientDefaultAssignment = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagRuleAssignmentClientDefaultAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleAssignmentFallthroughAssignment = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagRuleAssignmentFallthroughAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleAssignmentInput = {
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  bucketRanges?: InputMaybe<Array<FlagsAdminV1FlagRuleBucketRangeInput>>;
  clientDefault?: InputMaybe<FlagsAdminV1FlagRuleAssignmentClientDefaultAssignmentInput>;
  fallthrough?: InputMaybe<FlagsAdminV1FlagRuleAssignmentFallthroughAssignmentInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<FlagsAdminV1FlagRuleAssignmentVariantAssignmentInput>;
};

export type FlagsAdminV1FlagRuleAssignmentSpec = {
  assignments: Array<FlagsAdminV1FlagRuleAssignment>;
  bucketCount?: Maybe<Scalars['Int']['output']>;
};

export type FlagsAdminV1FlagRuleAssignmentSpecInput = {
  assignments?: InputMaybe<Array<FlagsAdminV1FlagRuleAssignmentInput>>;
  bucketCount?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleAssignmentUsageMetadata = {
  applyCount?: Maybe<Scalars['Long']['output']>;
  assignmentId?: Maybe<Scalars['String']['output']>;
  emptyTargetingKeyCount?: Maybe<Scalars['Long']['output']>;
  lastApplyTime?: Maybe<Scalars['String']['output']>;
  resolveCount?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1FlagRuleAssignmentUsageMetadataInput = {
  applyCount?: InputMaybe<Scalars['Long']['input']>;
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  emptyTargetingKeyCount?: InputMaybe<Scalars['Long']['input']>;
  lastApplyTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveCount?: InputMaybe<Scalars['Long']['input']>;
};

export type FlagsAdminV1FlagRuleAssignmentVariantAssignment = {
  variant: FlagsAdminV1FlagVariantResult;
};

export type FlagsAdminV1FlagRuleAssignmentVariantAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variant: Scalars['String']['input'];
};

export type FlagsAdminV1FlagRuleBucketRange = {
  lower: Scalars['Int']['output'];
  upper: Scalars['Int']['output'];
};

export type FlagsAdminV1FlagRuleBucketRangeInput = {
  lower: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  upper: Scalars['Int']['input'];
};

export type FlagsAdminV1FlagRuleInput = {
  assignmentSpec: FlagsAdminV1FlagRuleAssignmentSpecInput;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<FlagsAdminV1FlagRuleLabelsEntryInput>>;
  materializationSpec?: InputMaybe<FlagsAdminV1FlagRuleMaterializationSpecInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment: Scalars['String']['input'];
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagRuleLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleMaterializationSpec = {
  mode?: Maybe<FlagsAdminV1FlagRuleMaterializationSpecMaterializationReadMode>;
  readMaterialization?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  writeMaterialization?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
};

export type FlagsAdminV1FlagRuleMaterializationSpecInput = {
  mode?: InputMaybe<FlagsAdminV1FlagRuleMaterializationSpecMaterializationReadModeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  readMaterialization?: InputMaybe<Scalars['String']['input']>;
  writeMaterialization?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagRuleMaterializationSpecMaterializationReadMode = {
  materializationMustMatch?: Maybe<Scalars['Boolean']['output']>;
  segmentTargetingCanBeIgnored?: Maybe<Scalars['Boolean']['output']>;
};

export type FlagsAdminV1FlagRuleMaterializationSpecMaterializationReadModeInput =
  {
    materializationMustMatch?: InputMaybe<Scalars['Boolean']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    segmentTargetingCanBeIgnored?: InputMaybe<Scalars['Boolean']['input']>;
  };

export type FlagsAdminV1FlagRuleResult = Error | FlagsAdminV1FlagRule;

export type FlagsAdminV1FlagRuleUsageMetadata = {
  applyCount?: Maybe<Scalars['Long']['output']>;
  assignmentUsageMetadata: Array<FlagsAdminV1FlagRuleAssignmentUsageMetadata>;
  lastApplyTime?: Maybe<Scalars['String']['output']>;
  lastResolveTime?: Maybe<Scalars['String']['output']>;
  resolveCount?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1FlagRuleUsageMetadataInput = {
  applyCount?: InputMaybe<Scalars['Long']['input']>;
  assignmentUsageMetadata?: InputMaybe<
    Array<FlagsAdminV1FlagRuleAssignmentUsageMetadataInput>
  >;
  lastApplyTime?: InputMaybe<Scalars['String']['input']>;
  lastResolveTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveCount?: InputMaybe<Scalars['Long']['input']>;
};

export enum FlagsAdminV1FlagState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type FlagsAdminV1FlagUsageEntry = {
  hourTime: Scalars['String']['output'];
  variants: Array<FlagsAdminV1FlagUsageEntryVariantsEntry>;
};

export type FlagsAdminV1FlagUsageEntryVariantUsage = {
  applyCount?: Maybe<Scalars['Long']['output']>;
  resolveCount?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1FlagUsageEntryVariantsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<FlagsAdminV1FlagUsageEntryVariantUsage>;
};

export type FlagsAdminV1FlagUsageMetadata = {
  lastApplyTime?: Maybe<Scalars['String']['output']>;
  lastResolveTime?: Maybe<Scalars['String']['output']>;
  resolveCount?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1FlagUsageMetadataInput = {
  lastApplyTime?: InputMaybe<Scalars['String']['input']>;
  lastResolveTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveCount?: InputMaybe<Scalars['Long']['input']>;
};

export type FlagsAdminV1FlagVariant = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  imageUri?: Maybe<Scalars['String']['output']>;
  labels: Array<FlagsAdminV1FlagVariantLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  value: Scalars['JSON']['output'];
};

export type FlagsAdminV1FlagVariantAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagVariantCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1FlagVariantCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1FlagVariantExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1FlagVariantQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<FlagsAdminV1FlagVariantLabelsEntryInput>>;
  name: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
};

export type FlagsAdminV1FlagVariantLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1FlagVariantLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1FlagVariantResult = Error | FlagsAdminV1FlagVariant;

export type FlagsAdminV1ListEnvironmentsResponse = {
  environments: Array<FlagsAdminV1Environment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ListEnvironmentsResponseResult =
  | Error
  | FlagsAdminV1ListEnvironmentsResponse;

export type FlagsAdminV1ListEvaluationContextFieldOverridesResponse = {
  evaluationContextFieldOverrides: Array<FlagsAdminV1EvaluationContextFieldOverride>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ListEvaluationContextFieldOverridesResponseResult =
  | Error
  | FlagsAdminV1ListEvaluationContextFieldOverridesResponse;

export type FlagsAdminV1ListFlagsResponse = {
  flags: Array<FlagsAdminV1Flag>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ListFlagsResponseResult =
  | Error
  | FlagsAdminV1ListFlagsResponse;

export type FlagsAdminV1ListMaterializedSegmentsResponse = {
  materializedSegments: Array<FlagsAdminV1MaterializedSegment>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1ListMaterializedSegmentsResponseResult =
  | Error
  | FlagsAdminV1ListMaterializedSegmentsResponse;

export type FlagsAdminV1ListRulesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  rules: Array<FlagsAdminV1FlagRule>;
};

export type FlagsAdminV1ListRulesResponseResult =
  | Error
  | FlagsAdminV1ListRulesResponse;

export type FlagsAdminV1ListSegmentsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  segments: Array<FlagsAdminV1Segment>;
};

export type FlagsAdminV1ListSegmentsResponseResult =
  | Error
  | FlagsAdminV1ListSegmentsResponse;

export type FlagsAdminV1ListVariantsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  variants: Array<FlagsAdminV1FlagVariant>;
};

export type FlagsAdminV1ListVariantsResponseResult =
  | Error
  | FlagsAdminV1ListVariantsResponse;

export type FlagsAdminV1MaterializedSegment = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<FlagsAdminV1MaterializedSegmentLabelsEntry>;
  materializedSegmentLoadJobs?: Maybe<MaterializerV1ListMaterializedSegmentLoadJobsResponseResult>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type FlagsAdminV1MaterializedSegmentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1MaterializedSegmentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1MaterializedSegmentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1MaterializedSegmentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1MaterializedSegmentMaterializedSegmentLoadJobsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentInput = {
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<FlagsAdminV1MaterializedSegmentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1MaterializedSegmentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1MaterializedSegmentResult =
  | Error
  | FlagsAdminV1MaterializedSegment;

export type FlagsAdminV1QueryAccountDistinctCountResponse = {
  distinctCount?: Maybe<FlagsAdminV1DistinctCount>;
};

export type FlagsAdminV1QueryAccountDistinctCountResponseResult =
  | Error
  | FlagsAdminV1QueryAccountDistinctCountResponse;

export type FlagsAdminV1QueryAssignmentDistinctCountResponse = {
  distinctCount?: Maybe<FlagsAdminV1DistinctCount>;
};

export type FlagsAdminV1QueryAssignmentDistinctCountResponseResult =
  | Error
  | FlagsAdminV1QueryAssignmentDistinctCountResponse;

export type FlagsAdminV1QueryFlagUsageResponse = {
  usage: Array<FlagsAdminV1FlagUsageEntry>;
};

export type FlagsAdminV1QueryFlagUsageResponseResult =
  | Error
  | FlagsAdminV1QueryFlagUsageResponse;

export type FlagsAdminV1QueryRuleWorkflowInstanceResponse = {
  rule: FlagsAdminV1FlagRuleResult;
  segment: FlagsAdminV1SegmentResult;
  workflowInstanceInfo?: Maybe<FlagsAdminV1WorkflowInstanceInfo>;
};

export type FlagsAdminV1QueryRuleWorkflowInstanceResponseResult =
  | Error
  | FlagsAdminV1QueryRuleWorkflowInstanceResponse;

export type FlagsAdminV1QuerySegmentReferencesResponse = {
  segmentReferences: Array<FlagsAdminV1QuerySegmentReferencesResponseSegmentReference>;
};

export type FlagsAdminV1QuerySegmentReferencesResponseResult =
  | Error
  | FlagsAdminV1QuerySegmentReferencesResponse;

export type FlagsAdminV1QuerySegmentReferencesResponseSegmentReference = {
  flag?: Maybe<FlagsAdminV1FlagResult>;
  segment: FlagsAdminV1SegmentResult;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
};

export type FlagsAdminV1Segment = {
  allocation?: Maybe<FlagsAdminV1SegmentAllocation>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  bitsetAllocation?: Maybe<FlagsAdminV1SegmentBitsetAllocation>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  flag?: Maybe<FlagsAdminV1FlagResult>;
  labels: Array<FlagsAdminV1SegmentLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  querySegmentReferences?: Maybe<FlagsAdminV1QuerySegmentReferencesResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state?: Maybe<FlagsAdminV1SegmentState>;
  targeting?: Maybe<FlagsTypesV1Targeting>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
};

export type FlagsAdminV1SegmentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1SegmentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type FlagsAdminV1SegmentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagsAdminV1SegmentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type FlagsAdminV1SegmentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentAllocation = {
  exclusiveTo: Array<Scalars['String']['output']>;
  exclusivityTags: Array<Scalars['String']['output']>;
  proportion?: Maybe<GoogleTypeDecimal>;
};

export type FlagsAdminV1SegmentAllocationInput = {
  exclusiveTo?: InputMaybe<Array<Scalars['String']['input']>>;
  exclusivityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  proportion?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentAvailableSpaceRequestQueryParamsInput = {
  exclusiveTo?: InputMaybe<Array<Scalars['String']['input']>>;
  exclusivityTags?: InputMaybe<Array<Scalars['String']['input']>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<FlagsTypesV1TargetingInput>;
};

export type FlagsAdminV1SegmentAvailableSpaceResponse = {
  availableSpace?: Maybe<GoogleTypeDecimal>;
  reclaimableSpace: Array<FlagsAdminV1SegmentAvailableSpaceResponseReclaimableSpaceEntry>;
  relatedSegments: Array<FlagsAdminV1SegmentResult>;
};

export type FlagsAdminV1SegmentAvailableSpaceResponseReclaimableSpaceEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<GoogleTypeDecimal>;
};

export type FlagsAdminV1SegmentAvailableSpaceResponseResult =
  | Error
  | FlagsAdminV1SegmentAvailableSpaceResponse;

export type FlagsAdminV1SegmentBitsetAllocation = {
  bitset?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1SegmentBitsetAllocationInput = {
  bitset?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentInput = {
  allocation?: InputMaybe<FlagsAdminV1SegmentAllocationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<FlagsAdminV1SegmentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<FlagsTypesV1TargetingInput>;
  workflowInstance?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1SegmentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsAdminV1SegmentResult = Error | FlagsAdminV1Segment;

export type FlagsAdminV1SegmentScheduleInput = {
  endDate: GoogleTypeDateInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment: Scalars['String']['input'];
  startDate: GoogleTypeDateInput;
};

export enum FlagsAdminV1SegmentState {
  Allocated = 'ALLOCATED',
  Archived = 'ARCHIVED',
  Ok = 'OK',
  Unallocated = 'UNALLOCATED',
}

export enum FlagsAdminV1SegmentView {
  Basic = 'BASIC',
  Full = 'FULL',
}

export type FlagsAdminV1WorkflowInstanceInfo = {
  workflowInstance: WorkflowV1WorkflowInstanceResult;
  workflowInstanceType: FlagsAdminV1WorkflowInstanceType;
};

export enum FlagsAdminV1WorkflowInstanceType {
  AbTest = 'AB_TEST',
  Analysis = 'ANALYSIS',
  Reanalysis = 'REANALYSIS',
  Rollout = 'ROLLOUT',
}

export type FlagsAdminV1WriteFlagAssignedResponse = {
  assignedFlags?: Maybe<Scalars['Long']['output']>;
};

export type FlagsAdminV1WriteFlagAssignedResponseResult =
  | Error
  | FlagsAdminV1WriteFlagAssignedResponse;

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    schema?: InputMaybe<
      Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSchemaEntryInput>
    >;
    seenValues?: InputMaybe<
      Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSeenValuesEntryInput>
    >;
    semanticTypes?: InputMaybe<
      Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSemanticTypesEntryInput>
    >;
  };

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSchemaEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<FlagsAdminV1EvaluationContextSchemaFieldKind>;
  };

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSeenValuesEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<FlagsAdminV1ContextFieldSeenValuesInput>;
  };

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceSemanticTypesEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeInput>;
  };

export type FlagsAdminV1WriteResolveInfoRequestClientResolveInfoInput = {
  client: Scalars['String']['input'];
  clientCredential: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoEvaluationContextSchemaInstanceInput>
  >;
};

export type FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoAssignmentResolveInfoInput =
  {
    assignmentId?: InputMaybe<Scalars['String']['input']>;
    count: Scalars['Long']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoInput = {
  flag: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ruleResolveInfo?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoRuleResolveInfoInput>
  >;
  variantResolveInfo?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoVariantResolveInfoInput>
  >;
};

export type FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoRuleResolveInfoInput =
  {
    assignmentResolveInfo?: InputMaybe<
      Array<FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoAssignmentResolveInfoInput>
    >;
    count: Scalars['Long']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    rule: Scalars['String']['input'];
  };

export type FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoVariantResolveInfoInput =
  {
    count: Scalars['Long']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    variant?: InputMaybe<Scalars['String']['input']>;
  };

export type FlagsAdminV1WriteResolveInfoResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsAdminV1WriteResolveInfoResponseResult =
  | Error
  | FlagsAdminV1WriteResolveInfoResponse;

export type FlagsData = {
  audiences?: Maybe<Array<FlagsDataAudience>>;
  flag?: Maybe<FlagsAdminV1FlagResult>;
  ignoreTargetingForSticky?: Maybe<Scalars['Boolean']['output']>;
  intakePaused?: Maybe<Scalars['Boolean']['output']>;
  materialization?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  stickyAssignments?: Maybe<Scalars['Boolean']['output']>;
  targetingKeySelector?: Maybe<Scalars['String']['output']>;
};

export type FlagsDataAudience = {
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  intakePaused?: Maybe<Scalars['Boolean']['output']>;
  launchTime?: Maybe<Scalars['String']['output']>;
  materialization?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  stopTime?: Maybe<Scalars['String']['output']>;
};

export type FlagsDataInput = {
  audiences?: InputMaybe<Array<FlagsDataInputAudienceInput>>;
  flag?: InputMaybe<Scalars['String']['input']>;
  ignoreTargetingForSticky?: InputMaybe<Scalars['Boolean']['input']>;
  intakePaused?: InputMaybe<Scalars['Boolean']['input']>;
  materialization?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  stickyAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsDataInputAudienceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  intakePaused?: InputMaybe<Scalars['Boolean']['input']>;
  launchTime?: InputMaybe<Scalars['String']['input']>;
  materialization?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  stopTime?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsResolverAdminV1ResolveFlagsVerboseResponse = {
  resolvedFlags: Array<FlagsResolverAdminV1ResolvedFlag>;
};

export type FlagsResolverAdminV1ResolveFlagsVerboseResponseResult =
  | Error
  | FlagsResolverAdminV1ResolveFlagsVerboseResponse;

export type FlagsResolverAdminV1ResolvedFlag = {
  flag?: Maybe<FlagsAdminV1FlagResult>;
  flagSchema?: Maybe<FlagsTypesV1FlagSchemaStructFlagSchema>;
  reason?: Maybe<FlagsResolverV1ResolveReason>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  ruleDetails: Array<FlagsResolverAdminV1ResolvedFlagRuleDetails>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  value?: Maybe<Scalars['JSON']['output']>;
  variant?: Maybe<FlagsAdminV1FlagVariantResult>;
};

export type FlagsResolverAdminV1ResolvedFlagRuleDetails = {
  evalContextMissingValues: Array<Scalars['String']['output']>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  ruleEvaluationReason: FlagsResolverAdminV1ResolvedFlagRuleDetailsRuleEvaluationReason;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  segmentEvaluationReason: FlagsResolverAdminV1ResolvedFlagRuleDetailsSegmentEvaluationReason;
};

export enum FlagsResolverAdminV1ResolvedFlagRuleDetailsRuleEvaluationReason {
  MaterializationAndSegmentNotMatched = 'MATERIALIZATION_AND_SEGMENT_NOT_MATCHED',
  MaterializationNotMatched = 'MATERIALIZATION_NOT_MATCHED',
  RuleEvaluatedNoVariantMatch = 'RULE_EVALUATED_NO_VARIANT_MATCH',
  RuleMatched = 'RULE_MATCHED',
  RuleMatchedFallthrough = 'RULE_MATCHED_FALLTHROUGH',
  RuleNotEnabled = 'RULE_NOT_ENABLED',
  RuleNotEnabledForEnvironment = 'RULE_NOT_ENABLED_FOR_ENVIRONMENT',
  RuleNotEvaluated = 'RULE_NOT_EVALUATED',
  SegmentNotFoundOrNotActive = 'SEGMENT_NOT_FOUND_OR_NOT_ACTIVE',
  SegmentNotMatched = 'SEGMENT_NOT_MATCHED',
}

export enum FlagsResolverAdminV1ResolvedFlagRuleDetailsSegmentEvaluationReason {
  BitsetNotMatched = 'BITSET_NOT_MATCHED',
  SegmentMatched = 'SEGMENT_MATCHED',
  SegmentNotEvaluated = 'SEGMENT_NOT_EVALUATED',
  TargetingKeyMissing = 'TARGETING_KEY_MISSING',
  TargetingNotMatched = 'TARGETING_NOT_MATCHED',
}

export type FlagsResolverV1EventsClientInfoInput = {
  client?: InputMaybe<Scalars['String']['input']>;
  clientCredential?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sdk?: InputMaybe<FlagsResolverV1SdkInput>;
};

export type FlagsResolverV1EventsFallthroughAssignmentInput = {
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  targetingKey?: InputMaybe<Scalars['String']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsResolverV1EventsFlagAssignedAppliedFlagInput = {
  applyTime?: InputMaybe<Scalars['String']['input']>;
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  assignmentInfo?: InputMaybe<FlagsResolverV1EventsFlagAssignedAssignmentInfoInput>;
  defaultAssignment?: InputMaybe<FlagsResolverV1EventsFlagAssignedDefaultAssignmentInput>;
  fallthroughAssignments?: InputMaybe<
    Array<FlagsResolverV1EventsFallthroughAssignmentInput>
  >;
  flag?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  targetingKey?: InputMaybe<Scalars['String']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsResolverV1EventsFlagAssignedAssignmentInfoInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export enum FlagsResolverV1EventsFlagAssignedDefaultAssignmentDefaultAssignmentReason {
  FlagArchived = 'FLAG_ARCHIVED',
  NoSegmentMatch = 'NO_SEGMENT_MATCH',
  NoTreatmentMatch = 'NO_TREATMENT_MATCH',
}

export type FlagsResolverV1EventsFlagAssignedDefaultAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<FlagsResolverV1EventsFlagAssignedDefaultAssignmentDefaultAssignmentReason>;
};

export type FlagsResolverV1EventsFlagAssignedInput = {
  clientInfo?: InputMaybe<FlagsResolverV1EventsClientInfoInput>;
  flags?: InputMaybe<Array<FlagsResolverV1EventsFlagAssignedAppliedFlagInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveId?: InputMaybe<Scalars['String']['input']>;
};

export enum FlagsResolverV1ResolveReason {
  ResolveReasonBundle = 'RESOLVE_REASON_BUNDLE',
  ResolveReasonError = 'RESOLVE_REASON_ERROR',
  ResolveReasonFlagArchived = 'RESOLVE_REASON_FLAG_ARCHIVED',
  ResolveReasonFlagNotFound = 'RESOLVE_REASON_FLAG_NOT_FOUND',
  ResolveReasonMatch = 'RESOLVE_REASON_MATCH',
  ResolveReasonMaterializationNotSupported = 'RESOLVE_REASON_MATERIALIZATION_NOT_SUPPORTED',
  ResolveReasonNoSegmentMatch = 'RESOLVE_REASON_NO_SEGMENT_MATCH',
  ResolveReasonNoTreatmentMatch = 'RESOLVE_REASON_NO_TREATMENT_MATCH',
  ResolveReasonTargetingKeyError = 'RESOLVE_REASON_TARGETING_KEY_ERROR',
  ResolveReasonTypeMismatch = 'RESOLVE_REASON_TYPE_MISMATCH',
  ResolveReasonUnrecognizedTargetingRule = 'RESOLVE_REASON_UNRECOGNIZED_TARGETING_RULE',
}

export enum FlagsResolverV1SdkId {
  SdkIdDotnetConfidence = 'SDK_ID_DOTNET_CONFIDENCE',
  SdkIdFlutterAndroidConfidence = 'SDK_ID_FLUTTER_ANDROID_CONFIDENCE',
  SdkIdFlutterIosConfidence = 'SDK_ID_FLUTTER_IOS_CONFIDENCE',
  SdkIdGoConfidence = 'SDK_ID_GO_CONFIDENCE',
  SdkIdGoProvider = 'SDK_ID_GO_PROVIDER',
  SdkIdJavaConfidence = 'SDK_ID_JAVA_CONFIDENCE',
  SdkIdJavaProvider = 'SDK_ID_JAVA_PROVIDER',
  SdkIdJsConfidence = 'SDK_ID_JS_CONFIDENCE',
  SdkIdJsServerProvider = 'SDK_ID_JS_SERVER_PROVIDER',
  SdkIdJsWebProvider = 'SDK_ID_JS_WEB_PROVIDER',
  SdkIdKotlinConfidence = 'SDK_ID_KOTLIN_CONFIDENCE',
  SdkIdKotlinProvider = 'SDK_ID_KOTLIN_PROVIDER',
  SdkIdPythonConfidence = 'SDK_ID_PYTHON_CONFIDENCE',
  SdkIdPythonProvider = 'SDK_ID_PYTHON_PROVIDER',
  SdkIdRubyProvider = 'SDK_ID_RUBY_PROVIDER',
  SdkIdRustConfidence = 'SDK_ID_RUST_CONFIDENCE',
  SdkIdRustProvider = 'SDK_ID_RUST_PROVIDER',
  SdkIdSwiftConfidence = 'SDK_ID_SWIFT_CONFIDENCE',
  SdkIdSwiftProvider = 'SDK_ID_SWIFT_PROVIDER',
}

export type FlagsResolverV1SdkInput = {
  customId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<FlagsResolverV1SdkId>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1Expression = {
  and?: Maybe<FlagsTypesV1ExpressionOperands>;
  not?: Maybe<FlagsTypesV1Expression>;
  or?: Maybe<FlagsTypesV1ExpressionOperands>;
  ref?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1ExpressionInput = {
  and?: InputMaybe<FlagsTypesV1ExpressionOperandsInput>;
  not?: InputMaybe<FlagsTypesV1ExpressionInput>;
  or?: InputMaybe<FlagsTypesV1ExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1ExpressionOperands = {
  operands: Array<FlagsTypesV1Expression>;
};

export type FlagsTypesV1ExpressionOperandsInput = {
  operands?: InputMaybe<Array<FlagsTypesV1ExpressionInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchema = {
  boolSchema?: Maybe<FlagsTypesV1FlagSchemaBoolFlagSchema>;
  doubleSchema?: Maybe<FlagsTypesV1FlagSchemaDoubleFlagSchema>;
  intSchema?: Maybe<FlagsTypesV1FlagSchemaIntFlagSchema>;
  listSchema?: Maybe<FlagsTypesV1FlagSchemaListFlagSchema>;
  stringSchema?: Maybe<FlagsTypesV1FlagSchemaStringFlagSchema>;
  structSchema?: Maybe<FlagsTypesV1FlagSchemaStructFlagSchema>;
};

export type FlagsTypesV1FlagSchemaBoolFlagSchema = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1FlagSchemaBoolFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaDoubleFlagSchema = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1FlagSchemaDoubleFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaInput = {
  boolSchema?: InputMaybe<FlagsTypesV1FlagSchemaBoolFlagSchemaInput>;
  doubleSchema?: InputMaybe<FlagsTypesV1FlagSchemaDoubleFlagSchemaInput>;
  intSchema?: InputMaybe<FlagsTypesV1FlagSchemaIntFlagSchemaInput>;
  listSchema?: InputMaybe<FlagsTypesV1FlagSchemaListFlagSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringSchema?: InputMaybe<FlagsTypesV1FlagSchemaStringFlagSchemaInput>;
  structSchema?: InputMaybe<FlagsTypesV1FlagSchemaStructFlagSchemaInput>;
};

export type FlagsTypesV1FlagSchemaIntFlagSchema = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1FlagSchemaIntFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaListFlagSchema = {
  elementSchema?: Maybe<FlagsTypesV1FlagSchema>;
};

export type FlagsTypesV1FlagSchemaListFlagSchemaInput = {
  elementSchema?: InputMaybe<FlagsTypesV1FlagSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaStringFlagSchema = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1FlagSchemaStringFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1FlagSchemaStructFlagSchema = {
  schema: Array<FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntry>;
};

export type FlagsTypesV1FlagSchemaStructFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntryInput>
  >;
};

export type FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<FlagsTypesV1FlagSchema>;
};

export type FlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<FlagsTypesV1FlagSchemaInput>;
};

export type FlagsTypesV1Targeting = {
  criteria: Array<FlagsTypesV1TargetingCriteriaEntry>;
  expression?: Maybe<FlagsTypesV1Expression>;
};

export type FlagsTypesV1TargetingAllRule = {
  rule?: Maybe<FlagsTypesV1TargetingInnerRule>;
};

export type FlagsTypesV1TargetingAllRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<FlagsTypesV1TargetingInnerRuleInput>;
};

export type FlagsTypesV1TargetingAnyRule = {
  rule?: Maybe<FlagsTypesV1TargetingInnerRule>;
};

export type FlagsTypesV1TargetingAnyRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<FlagsTypesV1TargetingInnerRuleInput>;
};

export type FlagsTypesV1TargetingCriteriaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<FlagsTypesV1TargetingCriterion>;
};

export type FlagsTypesV1TargetingCriteriaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<FlagsTypesV1TargetingCriterionInput>;
};

export type FlagsTypesV1TargetingCriterion = {
  attribute?: Maybe<FlagsTypesV1TargetingCriterionAttributeCriterion>;
  materializedSegment?: Maybe<FlagsTypesV1TargetingCriterionMaterializedSegmentCriterion>;
  segment?: Maybe<FlagsTypesV1TargetingCriterionSegmentCriterion>;
};

export type FlagsTypesV1TargetingCriterionAttributeCriterion = {
  allRule?: Maybe<FlagsTypesV1TargetingAllRule>;
  anyRule?: Maybe<FlagsTypesV1TargetingAnyRule>;
  attributeName?: Maybe<Scalars['String']['output']>;
  endsWithRule?: Maybe<FlagsTypesV1TargetingEndsWithRule>;
  eqRule?: Maybe<FlagsTypesV1TargetingEqRule>;
  rangeRule?: Maybe<FlagsTypesV1TargetingRangeRule>;
  setRule?: Maybe<FlagsTypesV1TargetingSetRule>;
  startsWithRule?: Maybe<FlagsTypesV1TargetingStartsWithRule>;
};

export type FlagsTypesV1TargetingCriterionAttributeCriterionInput = {
  allRule?: InputMaybe<FlagsTypesV1TargetingAllRuleInput>;
  anyRule?: InputMaybe<FlagsTypesV1TargetingAnyRuleInput>;
  attributeName?: InputMaybe<Scalars['String']['input']>;
  endsWithRule?: InputMaybe<FlagsTypesV1TargetingEndsWithRuleInput>;
  eqRule?: InputMaybe<FlagsTypesV1TargetingEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<FlagsTypesV1TargetingRangeRuleInput>;
  setRule?: InputMaybe<FlagsTypesV1TargetingSetRuleInput>;
  startsWithRule?: InputMaybe<FlagsTypesV1TargetingStartsWithRuleInput>;
};

export type FlagsTypesV1TargetingCriterionInput = {
  attribute?: InputMaybe<FlagsTypesV1TargetingCriterionAttributeCriterionInput>;
  materializedSegment?: InputMaybe<FlagsTypesV1TargetingCriterionMaterializedSegmentCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<FlagsTypesV1TargetingCriterionSegmentCriterionInput>;
};

export type FlagsTypesV1TargetingCriterionMaterializedSegmentCriterion = {
  materializedSegment?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
};

export type FlagsTypesV1TargetingCriterionMaterializedSegmentCriterionInput = {
  materializedSegment?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingCriterionSegmentCriterion = {
  segment?: Maybe<FlagsAdminV1SegmentResult>;
};

export type FlagsTypesV1TargetingCriterionSegmentCriterionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingEndsWithRule = {
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1TargetingEndsWithRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingEqRule = {
  value?: Maybe<FlagsTypesV1TargetingValue>;
};

export type FlagsTypesV1TargetingEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<FlagsTypesV1TargetingValueInput>;
};

export type FlagsTypesV1TargetingInnerRule = {
  endsWithRule?: Maybe<FlagsTypesV1TargetingEndsWithRule>;
  eqRule?: Maybe<FlagsTypesV1TargetingEqRule>;
  rangeRule?: Maybe<FlagsTypesV1TargetingRangeRule>;
  setRule?: Maybe<FlagsTypesV1TargetingSetRule>;
  startsWithRule?: Maybe<FlagsTypesV1TargetingStartsWithRule>;
};

export type FlagsTypesV1TargetingInnerRuleInput = {
  endsWithRule?: InputMaybe<FlagsTypesV1TargetingEndsWithRuleInput>;
  eqRule?: InputMaybe<FlagsTypesV1TargetingEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<FlagsTypesV1TargetingRangeRuleInput>;
  setRule?: InputMaybe<FlagsTypesV1TargetingSetRuleInput>;
  startsWithRule?: InputMaybe<FlagsTypesV1TargetingStartsWithRuleInput>;
};

export type FlagsTypesV1TargetingInput = {
  criteria?: InputMaybe<Array<FlagsTypesV1TargetingCriteriaEntryInput>>;
  expression?: InputMaybe<FlagsTypesV1ExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingListValue = {
  values: Array<FlagsTypesV1TargetingValue>;
};

export type FlagsTypesV1TargetingListValueInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<FlagsTypesV1TargetingValueInput>>;
};

export type FlagsTypesV1TargetingRangeRule = {
  endExclusive?: Maybe<FlagsTypesV1TargetingValue>;
  endInclusive?: Maybe<FlagsTypesV1TargetingValue>;
  startExclusive?: Maybe<FlagsTypesV1TargetingValue>;
  startInclusive?: Maybe<FlagsTypesV1TargetingValue>;
};

export type FlagsTypesV1TargetingRangeRuleInput = {
  endExclusive?: InputMaybe<FlagsTypesV1TargetingValueInput>;
  endInclusive?: InputMaybe<FlagsTypesV1TargetingValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<FlagsTypesV1TargetingValueInput>;
  startInclusive?: InputMaybe<FlagsTypesV1TargetingValueInput>;
};

export type FlagsTypesV1TargetingSemanticVersion = {
  version?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1TargetingSemanticVersionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingSetRule = {
  values: Array<FlagsTypesV1TargetingValue>;
};

export type FlagsTypesV1TargetingSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<FlagsTypesV1TargetingValueInput>>;
};

export type FlagsTypesV1TargetingStartsWithRule = {
  value?: Maybe<Scalars['String']['output']>;
};

export type FlagsTypesV1TargetingStartsWithRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlagsTypesV1TargetingValue = {
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  listValue?: Maybe<FlagsTypesV1TargetingListValue>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  timestampValue?: Maybe<Scalars['String']['output']>;
  versionValue?: Maybe<FlagsTypesV1TargetingSemanticVersion>;
};

export type FlagsTypesV1TargetingValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  listValue?: InputMaybe<FlagsTypesV1TargetingListValueInput>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
  versionValue?: InputMaybe<FlagsTypesV1TargetingSemanticVersionInput>;
};

export type GoogleApiHttpBody = {
  contentType?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  extensions: Array<Scalars['JSON']['output']>;
};

export type GoogleApiHttpBodyResult = Error | GoogleApiHttpBody;

export type GoogleProtobufEmpty = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type GoogleProtobufEmptyResult = Error | GoogleProtobufEmpty;

export type GoogleTypeDate = {
  day?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type GoogleTypeDateInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleTypeDecimal = {
  value?: Maybe<Scalars['String']['output']>;
};

export type GoogleTypeDecimalInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type HypothesisData = {
  text?: Maybe<Scalars['String']['output']>;
};

export type HypothesisDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AddGroupMembersResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type IamV1AddGroupMembersResponseResult =
  | Error
  | IamV1AddGroupMembersResponse;

export type IamV1Agent = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  instructions?: Maybe<Scalars['String']['output']>;
  labels: Array<IamV1AgentLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  pictureUri?: Maybe<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviewerSkill?: Maybe<IamV1AgentReviewerSkill>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1AgentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1AgentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1AgentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1AgentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1AgentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<IamV1AgentLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pictureUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewerSkill?: InputMaybe<IamV1AgentReviewerSkillInput>;
};

export type IamV1AgentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1AgentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1AgentResult = Error | IamV1Agent;

export type IamV1AgentReviewerSkill = {
  enabled: Scalars['Boolean']['output'];
  instructions: Scalars['String']['output'];
};

export type IamV1AgentReviewerSkillInput = {
  enabled: Scalars['Boolean']['input'];
  instructions: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClient = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clientId: Scalars['String']['output'];
  /** @deprecated No longer supported */
  clientSecret?: Maybe<Scalars['String']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  labels: Array<IamV1ApiClientLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1ApiClientAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ApiClientCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1ApiClientCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ApiClientExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1ApiClientQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1ApiClientLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1ApiClientLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ApiClientResult = Error | IamV1ApiClient;

export type IamV1ApiClientSecret = {
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type IamV1ApiClientSecretResult = Error | IamV1ApiClientSecret;

export type IamV1Client = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clientCredentials?: Maybe<IamV1ListClientCredentialsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<IamV1ClientLabelsEntry>;
  lastSeenTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1ClientAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientClientCredentialsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1ClientCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1ClientQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredential = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clientSecret?: Maybe<IamV1ClientCredentialClientSecret>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName: Scalars['String']['output'];
  environments: Array<FlagsAdminV1EnvironmentResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  hasEncryptionKey?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<IamV1ClientCredentialLabelsEntry>;
  lastSeenTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sdkType?: Maybe<IamV1ClientCredentialSdkType>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1ClientCredentialAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientCredentialCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1ClientCredentialCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1ClientCredentialExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1ClientCredentialQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialClientSecret = {
  secret?: Maybe<Scalars['String']['output']>;
};

export type IamV1ClientCredentialClientSecretInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialEncryptionKey = {
  encryptionKey?: Maybe<Scalars['String']['output']>;
};

export type IamV1ClientCredentialEncryptionKeyResult =
  | Error
  | IamV1ClientCredentialEncryptionKey;

export type IamV1ClientCredentialInput = {
  clientSecret?: InputMaybe<IamV1ClientCredentialClientSecretInput>;
  displayName: Scalars['String']['input'];
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<IamV1ClientCredentialLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sdkType?: InputMaybe<IamV1ClientCredentialSdkType>;
};

export type IamV1ClientCredentialLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1ClientCredentialLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientCredentialResult = Error | IamV1ClientCredential;

export enum IamV1ClientCredentialSdkType {
  Backend = 'BACKEND',
  Frontend = 'FRONTEND',
}

export type IamV1ClientInput = {
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1ClientLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1ClientLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1ClientResult = Error | IamV1Client;

export type IamV1CryptoKey = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  kind: IamV1CryptoKeyKind;
  labels: Array<IamV1CryptoKeyLabelsEntry>;
  name: Scalars['String']['output'];
  publicKey?: Maybe<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: IamV1CryptoKeyState;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1CryptoKeyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1CryptoKeyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1CryptoKeyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1CryptoKeyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1CryptoKeyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyInput = {
  kind: IamV1CryptoKeyKind;
  labels?: InputMaybe<Array<IamV1CryptoKeyLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum IamV1CryptoKeyKind {
  Snowflake = 'SNOWFLAKE',
}

export type IamV1CryptoKeyLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1CryptoKeyLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1CryptoKeyResult = Error | IamV1CryptoKey;

export enum IamV1CryptoKeyState {
  Created = 'CREATED',
  Creating = 'CREATING',
  Deleted = 'DELETED',
}

export type IamV1CurrentUser = {
  account: Scalars['String']['output'];
  accountMemberships: Array<IamV1CurrentUserAccountMembership>;
  identity: IamV1Identity;
  serviceAccountOauth2ClientId: Scalars['String']['output'];
  user?: Maybe<IamV1User>;
};

export type IamV1CurrentUserAccountMembership = {
  account: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  loginId: Scalars['String']['output'];
  portalInstanceUri?: Maybe<Scalars['String']['output']>;
  region: IamV1CurrentUserAccountMembershipRegion;
};

export enum IamV1CurrentUserAccountMembershipRegion {
  RegionEu = 'REGION_EU',
  RegionUs = 'REGION_US',
}

export type IamV1CurrentUserResult = Error | IamV1CurrentUser;

export type IamV1EventsApiClientCreated = {
  apiClient?: Maybe<IamV1ApiClient>;
};

export type IamV1EventsApiClientDeleted = {
  apiClient?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsApiClientUpdated = {
  apiClient?: Maybe<IamV1ApiClient>;
};

export type IamV1EventsClientCreated = {
  client?: Maybe<IamV1Client>;
};

export type IamV1EventsClientCredentialCreated = {
  clientCredential?: Maybe<IamV1ClientCredential>;
};

export type IamV1EventsClientCredentialDeleted = {
  clientCredential?: Maybe<IamV1ClientCredentialResult>;
  resource?: Maybe<IamV1ClientCredential>;
};

export type IamV1EventsClientCredentialUpdated = {
  clientCredential?: Maybe<IamV1ClientCredential>;
};

export type IamV1EventsClientDeleted = {
  client?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsClientUpdated = {
  client?: Maybe<IamV1Client>;
};

export type IamV1EventsGroupCreated = {
  group?: Maybe<IamV1Group>;
};

export type IamV1EventsGroupDeleted = {
  group?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsGroupUpdated = {
  group?: Maybe<IamV1Group>;
  oldGroup?: Maybe<IamV1Group>;
};

export type IamV1EventsIdentityCreated = {
  identity?: Maybe<IamV1Identity>;
};

export type IamV1EventsIdentityDeleted = {
  identity?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsIdentityUpdated = {
  identity?: Maybe<IamV1Identity>;
  oldIdentity?: Maybe<IamV1Identity>;
};

export type IamV1EventsPolicyCreated = {
  policy?: Maybe<IamV1Policy>;
};

export type IamV1EventsPolicyDeleted = {
  policy?: Maybe<Scalars['String']['output']>;
};

export type IamV1EventsPolicyUpdated = {
  policy?: Maybe<IamV1Policy>;
};

export type IamV1EventsUserCreated = {
  user?: Maybe<IamV1User>;
};

export type IamV1EventsUserUpdated = {
  user?: Maybe<IamV1User>;
};

export type IamV1GenerateClientCredentialEncryptionKeyResponse = {
  encryptionKey?: Maybe<Scalars['String']['output']>;
};

export type IamV1GenerateClientCredentialEncryptionKeyResponseResult =
  | Error
  | IamV1GenerateClientCredentialEncryptionKeyResponse;

export type IamV1Group = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  groupMembers?: Maybe<IamV1ListGroupMembersResponseResult>;
  groupType: IamV1GroupGroupType;
  identity: IamV1IdentityResult;
  labels: Array<IamV1GroupLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  slackChannel?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1GroupAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1GroupCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1GroupCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1GroupExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1GroupGroupMembersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export enum IamV1GroupGroupType {
  SystemCreated = 'SYSTEM_CREATED',
  UserCreated = 'USER_CREATED',
}

export type IamV1GroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1GroupLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slackChannel?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1GroupLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1GroupResult = Error | IamV1Group;

export type IamV1Identity = {
  agent?: Maybe<IamV1AgentResult>;
  apiClient?: Maybe<IamV1ApiClientResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  deactivated?: Maybe<Scalars['Boolean']['output']>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  everyone?: Maybe<Scalars['Boolean']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  group?: Maybe<IamV1GroupResult>;
  labels: Array<IamV1IdentityLabelsEntry>;
  name: Scalars['String']['output'];
  pictureUri?: Maybe<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  service?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  user?: Maybe<IamV1UserResult>;
};

export type IamV1IdentityAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1IdentityCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1IdentityCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1IdentityExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1IdentityQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1IdentityReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1IdentityResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1IdentityReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1IdentityLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1IdentityResult = Error | IamV1Identity;

export type IamV1ListAgentsResponse = {
  agents: Array<IamV1Agent>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListAgentsResponseResult = Error | IamV1ListAgentsResponse;

export type IamV1ListApiClientsResponse = {
  apiClients: Array<IamV1ApiClient>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListApiClientsResponseResult =
  | Error
  | IamV1ListApiClientsResponse;

export type IamV1ListClientCredentialsResponse = {
  clientCredentials: Array<IamV1ClientCredential>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListClientCredentialsResponseResult =
  | Error
  | IamV1ListClientCredentialsResponse;

export type IamV1ListClientsResponse = {
  clients: Array<IamV1Client>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListClientsResponseResult = Error | IamV1ListClientsResponse;

export type IamV1ListCryptoKeysResponse = {
  cryptoKeys: Array<IamV1CryptoKey>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListCryptoKeysResponseResult =
  | Error
  | IamV1ListCryptoKeysResponse;

export type IamV1ListGroupMembersResponse = {
  groupMembers: Array<IamV1Identity>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListGroupMembersResponseResult =
  | Error
  | IamV1ListGroupMembersResponse;

export type IamV1ListGroupsResponse = {
  groups: Array<IamV1Group>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListGroupsResponseResult = Error | IamV1ListGroupsResponse;

export type IamV1ListIdentitiesResponse = {
  identities: Array<IamV1Identity>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type IamV1ListIdentitiesResponseResult =
  | Error
  | IamV1ListIdentitiesResponse;

export type IamV1ListOAuthAppsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  oauthApps: Array<IamV1OAuthApp>;
};

export type IamV1ListOAuthAppsResponseResult =
  | Error
  | IamV1ListOAuthAppsResponse;

export type IamV1ListPermissionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  permissions: Array<IamV1Permission>;
};

export type IamV1ListPermissionsResponseResult =
  | Error
  | IamV1ListPermissionsResponse;

export type IamV1ListPoliciesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  policies: Array<IamV1Policy>;
};

export type IamV1ListPoliciesResponseResult = Error | IamV1ListPoliciesResponse;

export type IamV1ListRolesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  roles: Array<IamV1Role>;
};

export type IamV1ListRolesResponseResult = Error | IamV1ListRolesResponse;

export type IamV1ListUserGroupsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  userGroups: Array<IamV1UserGroup>;
};

export type IamV1ListUserGroupsResponseResult =
  | Error
  | IamV1ListUserGroupsResponse;

export type IamV1ListUserInvitationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  userInvitations: Array<IamV1UserInvitation>;
};

export type IamV1ListUserInvitationsResponseResult =
  | Error
  | IamV1ListUserInvitationsResponse;

export type IamV1ListUsersResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  users: Array<IamV1User>;
};

export type IamV1ListUsersResponseResult = Error | IamV1ListUsersResponse;

export type IamV1OAuthApp = {
  allowedCallbackUrls: Array<Scalars['String']['output']>;
  allowedLogoutUrls: Array<Scalars['String']['output']>;
  allowedWebOrigins: Array<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<IamV1OAuthAppLabelsEntry>;
  logoUri?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1OAuthAppAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1OAuthAppCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1OAuthAppCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1OAuthAppExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1OAuthAppQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppInput = {
  allowedCallbackUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedLogoutUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedWebOrigins?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1OAuthAppLabelsEntryInput>>;
  logoUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1OAuthAppLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1OAuthAppResult = Error | IamV1OAuthApp;

export type IamV1Permission = {
  category: IamV1PermissionCategory;
  description?: Maybe<Scalars['String']['output']>;
  type: IamV1PermissionType;
};

export enum IamV1PermissionCategory {
  Agent = 'AGENT',
  ApiClient = 'API_CLIENT',
  AssignmentTable = 'ASSIGNMENT_TABLE',
  Billing = 'BILLING',
  Chat = 'CHAT',
  Client = 'CLIENT',
  Collection = 'COLLECTION',
  DataWarehouse = 'DATA_WAREHOUSE',
  DimensionTable = 'DIMENSION_TABLE',
  Entity = 'ENTITY',
  EntityRelationTable = 'ENTITY_RELATION_TABLE',
  EvaluationContextSchema = 'EVALUATION_CONTEXT_SCHEMA',
  Event = 'EVENT',
  EventConnection = 'EVENT_CONNECTION',
  EventDefinition = 'EVENT_DEFINITION',
  ExposureCalculation = 'EXPOSURE_CALCULATION',
  ExposureTable = 'EXPOSURE_TABLE',
  ExternalDocument = 'EXTERNAL_DOCUMENT',
  ExternalIntegration = 'EXTERNAL_INTEGRATION',
  FactTable = 'FACT_TABLE',
  Feed = 'FEED',
  Flag = 'FLAG',
  FlagAppliedConnection = 'FLAG_APPLIED_CONNECTION',
  FlagAssigned = 'FLAG_ASSIGNED',
  Group = 'GROUP',
  IamPolicy = 'IAM_POLICY',
  Label = 'LABEL',
  MaterializedSegment = 'MATERIALIZED_SEGMENT',
  MaterializedSegmentLoadJob = 'MATERIALIZED_SEGMENT_LOAD_JOB',
  Metric = 'METRIC',
  MetricCalculation = 'METRIC_CALCULATION',
  OauthApp = 'OAUTH_APP',
  PlatformConnection = 'PLATFORM_CONNECTION',
  Project = 'PROJECT',
  Pulse = 'PULSE',
  ResolveInfo = 'RESOLVE_INFO',
  Role = 'ROLE',
  ScheduledExposureCalculation = 'SCHEDULED_EXPOSURE_CALCULATION',
  ScheduledMetricCalculation = 'SCHEDULED_METRIC_CALCULATION',
  Segment = 'SEGMENT',
  SqlJob = 'SQL_JOB',
  StatsApi = 'STATS_API',
  Surface = 'SURFACE',
  User = 'USER',
  UserInvitation = 'USER_INVITATION',
  Workflow = 'WORKFLOW',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
  WorkflowLog = 'WORKFLOW_LOG',
  WorkflowSecret = 'WORKFLOW_SECRET',
}

export type IamV1PermissionInput = {
  category: IamV1PermissionCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  type: IamV1PermissionType;
};

export enum IamV1PermissionType {
  Admin = 'ADMIN',
  Creator = 'CREATOR',
  Editor = 'EDITOR',
  Reader = 'READER',
}

export type IamV1Policy = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identities: Array<IamV1IdentityResult>;
  labels: Array<IamV1PolicyLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  roles: Array<IamV1RoleResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1PolicyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1PolicyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1PolicyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1PolicyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1PolicyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyInput = {
  identities: Array<Scalars['String']['input']>;
  labels?: InputMaybe<Array<IamV1PolicyLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

export type IamV1PolicyLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1PolicyLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1PolicyResult = Error | IamV1Policy;

export type IamV1RemoveGroupMembersResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type IamV1RemoveGroupMembersResponseResult =
  | Error
  | IamV1RemoveGroupMembersResponse;

export type IamV1Role = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<IamV1RoleLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  permissions: Array<IamV1Permission>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1RoleAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1RoleCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1RoleCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1RoleExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1RoleQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleInput = {
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1RoleLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  permissions: Array<IamV1PermissionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1RoleLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1RoleResult = Error | IamV1Role;

export type IamV1SlackUserInfo = {
  picture?: Maybe<Scalars['String']['output']>;
  team: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type IamV1SlackUserInfoInput = {
  picture?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  team: Scalars['String']['input'];
  user: Scalars['String']['input'];
};

export type IamV1StoreSlackUserInfoResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type IamV1StoreSlackUserInfoResponseResult =
  | Error
  | IamV1StoreSlackUserInfoResponse;

export type IamV1User = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  externalId?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  givenName?: Maybe<Scalars['String']['output']>;
  identity: IamV1IdentityResult;
  labels: Array<IamV1UserLabelsEntry>;
  lastLoginTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUri?: Maybe<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scimExternalId?: Maybe<Scalars['String']['output']>;
  slackUserInfo?: Maybe<IamV1SlackUserInfo>;
  updateTime: Scalars['String']['output'];
  userGroups?: Maybe<IamV1ListUserGroupsResponseResult>;
  username?: Maybe<Scalars['String']['output']>;
};

export type IamV1UserAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1UserCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1UserQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserUserGroupsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserGroup = {
  group?: Maybe<IamV1Group>;
};

export type IamV1UserInput = {
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<IamV1UserLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  disableInvitationEmail?: Maybe<Scalars['Boolean']['output']>;
  expirationTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  invitationToken: Scalars['String']['output'];
  invitationUri: Scalars['String']['output'];
  invitedEmail: Scalars['String']['output'];
  inviter?: Maybe<Scalars['String']['output']>;
  labels: Array<IamV1UserInvitationLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  ttl?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type IamV1UserInvitationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserInvitationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type IamV1UserInvitationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IamV1UserInvitationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type IamV1UserInvitationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationInput = {
  disableInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  invitedEmail: Scalars['String']['input'];
  labels?: InputMaybe<Array<IamV1UserInvitationLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ttl?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1UserInvitationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserInvitationResult = Error | IamV1UserInvitation;

export type IamV1UserLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type IamV1UserLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type IamV1UserResult = Error | IamV1User;

export type InsightsV1ActiveSdk = {
  resolveMode?: Maybe<InsightsV1SdkResolveMode>;
  sdkDisplayName?: Maybe<Scalars['String']['output']>;
  sdkId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ArithmeticExpression = {
  aggregate?: Maybe<InsightsV1ArithmeticExpressionAggregate>;
  divide?: Maybe<InsightsV1ArithmeticExpressionDivide>;
  field?: Maybe<Scalars['String']['output']>;
  multiply?: Maybe<InsightsV1ArithmeticExpressionOperands>;
  negate?: Maybe<InsightsV1ArithmeticExpression>;
  plus?: Maybe<InsightsV1ArithmeticExpressionOperands>;
  subtract?: Maybe<InsightsV1ArithmeticExpressionSubtract>;
  value?: Maybe<InsightsV1Value>;
};

export type InsightsV1ArithmeticExpressionAggregate = {
  average?: Maybe<InsightsV1ArithmeticExpression>;
  count?: Maybe<InsightsV1ArithmeticExpressionCount>;
  max?: Maybe<InsightsV1ArithmeticExpression>;
  min?: Maybe<InsightsV1ArithmeticExpression>;
  sum?: Maybe<InsightsV1ArithmeticExpression>;
};

export type InsightsV1ArithmeticExpressionAggregateInput = {
  average?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  count?: InputMaybe<InsightsV1ArithmeticExpressionCountInput>;
  max?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  min?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sum?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
};

export type InsightsV1ArithmeticExpressionCount = {
  distinct?: Maybe<Scalars['Boolean']['output']>;
  expression?: Maybe<InsightsV1ArithmeticExpression>;
};

export type InsightsV1ArithmeticExpressionCountInput = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1ArithmeticExpressionDivide = {
  denominator: InsightsV1ArithmeticExpression;
  numerator: InsightsV1ArithmeticExpression;
};

export type InsightsV1ArithmeticExpressionDivideInput = {
  denominator: InsightsV1ArithmeticExpressionInput;
  numerator: InsightsV1ArithmeticExpressionInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1ArithmeticExpressionInput = {
  aggregate?: InputMaybe<InsightsV1ArithmeticExpressionAggregateInput>;
  divide?: InputMaybe<InsightsV1ArithmeticExpressionDivideInput>;
  field?: InputMaybe<Scalars['String']['input']>;
  multiply?: InputMaybe<InsightsV1ArithmeticExpressionOperandsInput>;
  negate?: InputMaybe<InsightsV1ArithmeticExpressionInput>;
  plus?: InputMaybe<InsightsV1ArithmeticExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  subtract?: InputMaybe<InsightsV1ArithmeticExpressionSubtractInput>;
  value?: InputMaybe<InsightsV1ValueInput>;
};

export type InsightsV1ArithmeticExpressionOperands = {
  operands: Array<InsightsV1ArithmeticExpression>;
};

export type InsightsV1ArithmeticExpressionOperandsInput = {
  operands: Array<InsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1ArithmeticExpressionSubtract = {
  left: InsightsV1ArithmeticExpression;
  right: InsightsV1ArithmeticExpression;
};

export type InsightsV1ArithmeticExpressionSubtractInput = {
  left: InsightsV1ArithmeticExpressionInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  right: InsightsV1ArithmeticExpressionInput;
};

export type InsightsV1CheckSdkCompatibilityResponse = {
  activeSdks: Array<InsightsV1ActiveSdk>;
  featureCompatibilities: Array<InsightsV1FeatureCompatibility>;
};

export type InsightsV1CheckSdkCompatibilityResponseResult =
  | Error
  | InsightsV1CheckSdkCompatibilityResponse;

export type InsightsV1ColumnInfo = {
  column: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum InsightsV1CompatibilityStatus {
  CompatibilityStatusCompatible = 'COMPATIBILITY_STATUS_COMPATIBLE',
  CompatibilityStatusIncompatible = 'COMPATIBILITY_STATUS_INCOMPATIBLE',
  CompatibilityStatusUnknown = 'COMPATIBILITY_STATUS_UNKNOWN',
}

export type InsightsV1Dashboard = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<InsightsV1DashboardLabelsEntry>;
  metrics: Array<InsightsV1InsightsMetricResult>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type InsightsV1DashboardAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1DashboardCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1DashboardCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1DashboardExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1DashboardQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<InsightsV1DashboardLabelsEntryInput>>;
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1DashboardLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1DashboardResult = Error | InsightsV1Dashboard;

export type InsightsV1EntityMapping = {
  column: Scalars['String']['output'];
  entity: Scalars['String']['output'];
};

export type InsightsV1ExampleQuery = {
  question: Scalars['String']['output'];
  sql: Scalars['String']['output'];
};

export type InsightsV1ExampleQueryInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  sql: Scalars['String']['input'];
};

export type InsightsV1ExecuteSqlResponse = {
  columns: Array<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  rows: Array<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export type InsightsV1ExecuteSqlResponseResult =
  | Error
  | InsightsV1ExecuteSqlResponse;

export type InsightsV1FactTableContext = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  ddl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions: Array<InsightsV1ColumnInfo>;
  displayName: Scalars['String']['output'];
  entities: Array<InsightsV1EntityMapping>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  measures: Array<InsightsV1ColumnInfo>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sql?: Maybe<Scalars['String']['output']>;
  timestampColumn?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1FactTableContextAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableContextCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1FactTableContextCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableContextExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1FactTableContextQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableContextReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableContextResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableContextReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableContextResult =
  | Error
  | InsightsV1FactTableContext;

export type InsightsV1FactTableSummary = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  columnSummary?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
};

export type InsightsV1FactTableSummaryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableSummaryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1FactTableSummaryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1FactTableSummaryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1FactTableSummaryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableSummaryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableSummaryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableSummaryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FactTableSummaryResult =
  | Error
  | InsightsV1FactTableSummary;

export type InsightsV1FeatureCompatibility = {
  displayName?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  incompatibleSdks: Array<InsightsV1IncompatibleSdk>;
  status?: Maybe<InsightsV1CompatibilityStatus>;
};

export type InsightsV1Filter = {
  criteria: Array<InsightsV1FilterCriteriaEntry>;
  expression: InsightsV1FilterBooleanExpression;
};

export type InsightsV1FilterAnyRule = {
  eqRule?: Maybe<InsightsV1FilterEqRule>;
  itemAttribute: Scalars['String']['output'];
  rangeRule?: Maybe<InsightsV1FilterRangeRule>;
  setRule?: Maybe<InsightsV1FilterSetRule>;
};

export type InsightsV1FilterAnyRuleInput = {
  eqRule?: InputMaybe<InsightsV1FilterEqRuleInput>;
  itemAttribute: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<InsightsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<InsightsV1FilterSetRuleInput>;
};

export type InsightsV1FilterBooleanExpression = {
  and?: Maybe<InsightsV1FilterBooleanExpressionOperands>;
  not?: Maybe<InsightsV1FilterBooleanExpression>;
  or?: Maybe<InsightsV1FilterBooleanExpressionOperands>;
  ref?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1FilterBooleanExpressionInput = {
  and?: InputMaybe<InsightsV1FilterBooleanExpressionOperandsInput>;
  not?: InputMaybe<InsightsV1FilterBooleanExpressionInput>;
  or?: InputMaybe<InsightsV1FilterBooleanExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FilterBooleanExpressionOperands = {
  operands: Array<InsightsV1FilterBooleanExpression>;
};

export type InsightsV1FilterBooleanExpressionOperandsInput = {
  operands: Array<InsightsV1FilterBooleanExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FilterCriteriaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<InsightsV1FilterCriterion>;
};

export type InsightsV1FilterCriteriaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<InsightsV1FilterCriterionInput>;
};

export type InsightsV1FilterCriterion = {
  attribute?: Maybe<InsightsV1FilterCriterionAttributeCriterion>;
};

export type InsightsV1FilterCriterionAttributeCriterion = {
  anyRule?: Maybe<InsightsV1FilterAnyRule>;
  attribute: Scalars['String']['output'];
  eqRule?: Maybe<InsightsV1FilterEqRule>;
  rangeRule?: Maybe<InsightsV1FilterRangeRule>;
  setRule?: Maybe<InsightsV1FilterSetRule>;
};

export type InsightsV1FilterCriterionAttributeCriterionInput = {
  anyRule?: InputMaybe<InsightsV1FilterAnyRuleInput>;
  attribute: Scalars['String']['input'];
  eqRule?: InputMaybe<InsightsV1FilterEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<InsightsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<InsightsV1FilterSetRuleInput>;
};

export type InsightsV1FilterCriterionInput = {
  attribute?: InputMaybe<InsightsV1FilterCriterionAttributeCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FilterEqRule = {
  value: InsightsV1Value;
};

export type InsightsV1FilterEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value: InsightsV1ValueInput;
};

export type InsightsV1FilterInput = {
  criteria: Array<InsightsV1FilterCriteriaEntryInput>;
  expression: InsightsV1FilterBooleanExpressionInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1FilterRangeRule = {
  endExclusive?: Maybe<InsightsV1Value>;
  endInclusive?: Maybe<InsightsV1Value>;
  startExclusive?: Maybe<InsightsV1Value>;
  startInclusive?: Maybe<InsightsV1Value>;
};

export type InsightsV1FilterRangeRuleInput = {
  endExclusive?: InputMaybe<InsightsV1ValueInput>;
  endInclusive?: InputMaybe<InsightsV1ValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<InsightsV1ValueInput>;
  startInclusive?: InputMaybe<InsightsV1ValueInput>;
};

export type InsightsV1FilterSetRule = {
  values: Array<InsightsV1Value>;
};

export type InsightsV1FilterSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values: Array<InsightsV1ValueInput>;
};

export type InsightsV1GetLatestSdkVersionsResponse = {
  features: Array<InsightsV1SdkFeatureDefinition>;
  sdkLatestVersions: Array<InsightsV1SdkLatestVersion>;
};

export type InsightsV1GetLatestSdkVersionsResponseResult =
  | Error
  | InsightsV1GetLatestSdkVersionsResponse;

export enum InsightsV1GraphType {
  GraphTypeApolloResolvedFlagsByClient = 'GRAPH_TYPE_APOLLO_RESOLVED_FLAGS_BY_CLIENT',
  GraphTypeAverageResolveLatency = 'GRAPH_TYPE_AVERAGE_RESOLVE_LATENCY',
  GraphTypeCombinedErrorRate = 'GRAPH_TYPE_COMBINED_ERROR_RATE',
  GraphTypeCombinedErrorRatio = 'GRAPH_TYPE_COMBINED_ERROR_RATIO',
  GraphTypeCombinedResolveRate = 'GRAPH_TYPE_COMBINED_RESOLVE_RATE',
  GraphTypeEvaluationErrorsByStatus = 'GRAPH_TYPE_EVALUATION_ERRORS_BY_STATUS',
  GraphTypeEvaluationErrorRatio = 'GRAPH_TYPE_EVALUATION_ERROR_RATIO',
  GraphTypeMobileResolveRate = 'GRAPH_TYPE_MOBILE_RESOLVE_RATE',
  GraphTypeRemoteSdkResolveRate = 'GRAPH_TYPE_REMOTE_SDK_RESOLVE_RATE',
  GraphTypeResolveCountByPlatform = 'GRAPH_TYPE_RESOLVE_COUNT_BY_PLATFORM',
  GraphTypeResolveCountOverTime = 'GRAPH_TYPE_RESOLVE_COUNT_OVER_TIME',
  GraphTypeResolveErrorsByReason = 'GRAPH_TYPE_RESOLVE_ERRORS_BY_REASON',
  GraphTypeResolveErrorRatio = 'GRAPH_TYPE_RESOLVE_ERROR_RATIO',
  GraphTypeTotalEvaluationRate = 'GRAPH_TYPE_TOTAL_EVALUATION_RATE',
  GraphTypeTotalResolveRate = 'GRAPH_TYPE_TOTAL_RESOLVE_RATE',
}

export type InsightsV1IncompatibleSdk = {
  currentVersion?: Maybe<Scalars['String']['output']>;
  requiredVersion?: Maybe<Scalars['String']['output']>;
  sdkDisplayName?: Maybe<Scalars['String']['output']>;
};

export enum InsightsV1InsightsContextSource {
  LlmGenerated = 'LLM_GENERATED',
  Synced = 'SYNCED',
  User = 'USER',
}

export type InsightsV1InsightsDocument = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  labels: Array<InsightsV1InsightsDocumentLabelsEntry>;
  lifecycle?: Maybe<InsightsV1InsightsDocumentLifecycle>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  uri?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1InsightsDocumentAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsDocumentCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1InsightsDocumentCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsDocumentExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1InsightsDocumentQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InsightsV1InsightsDocumentLabelsEntryInput>>;
  lifecycle?: InputMaybe<InsightsV1InsightsDocumentLifecycle>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsDocumentLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1InsightsDocumentLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum InsightsV1InsightsDocumentLifecycle {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type InsightsV1InsightsDocumentResult =
  | Error
  | InsightsV1InsightsDocument;

export type InsightsV1InsightsMetric = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataSource: Scalars['String']['output'];
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  expression: InsightsV1ArithmeticExpression;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  filter?: Maybe<InsightsV1Filter>;
  groupBy: Array<Scalars['String']['output']>;
  labels: Array<InsightsV1InsightsMetricLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryInsightsMetric?: Maybe<InsightsV1QueryInsightsMetricResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  timeConfig?: Maybe<InsightsV1TimeConfig>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type InsightsV1InsightsMetricAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsMetricCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1InsightsMetricCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsMetricExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1InsightsMetricQueryInsightsMetricArgs = {
  filter?: InputMaybe<InsightsV1FilterInput>;
};

export type InsightsV1InsightsMetricQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricInput = {
  dataSource: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  expression: InsightsV1ArithmeticExpressionInput;
  filter?: InputMaybe<InsightsV1FilterInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<InsightsV1InsightsMetricLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<InsightsV1TimeConfigInput>;
};

export type InsightsV1InsightsMetricLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1InsightsMetricLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsMetricResult = Error | InsightsV1InsightsMetric;

export type InsightsV1InsightsTableContext = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  capabilitySummary?: Maybe<Scalars['String']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  contextMarkdown?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  ddl?: Maybe<Scalars['String']['output']>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  exampleQueries: Array<InsightsV1ExampleQuery>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable: MetricsV1FactTableResult;
  labels: Array<InsightsV1InsightsTableContextLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<InsightsV1InsightsContextSource>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type InsightsV1InsightsTableContextAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsTableContextCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1InsightsTableContextCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1InsightsTableContextExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1InsightsTableContextQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextInput = {
  capabilitySummary?: InputMaybe<Scalars['String']['input']>;
  contextMarkdown?: InputMaybe<Scalars['String']['input']>;
  ddl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  exampleQueries?: InputMaybe<Array<InsightsV1ExampleQueryInput>>;
  factTable: Scalars['String']['input'];
  labels?: InputMaybe<Array<InsightsV1InsightsTableContextLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsightsV1InsightsContextSource>;
};

export type InsightsV1InsightsTableContextLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1InsightsTableContextLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1InsightsTableContextResult =
  | Error
  | InsightsV1InsightsTableContext;

export type InsightsV1ListDashboardsResponse = {
  dashboards: Array<InsightsV1Dashboard>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListDashboardsResponseResult =
  | Error
  | InsightsV1ListDashboardsResponse;

export type InsightsV1ListFactTableContextsResponse = {
  factTableContexts: Array<InsightsV1FactTableContext>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListFactTableContextsResponseResult =
  | Error
  | InsightsV1ListFactTableContextsResponse;

export type InsightsV1ListFactTableSummariesResponse = {
  factTableSummaries: Array<InsightsV1FactTableSummary>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListFactTableSummariesResponseResult =
  | Error
  | InsightsV1ListFactTableSummariesResponse;

export type InsightsV1ListInsightsDocumentsResponse = {
  insightsDocuments: Array<InsightsV1InsightsDocument>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListInsightsDocumentsResponseResult =
  | Error
  | InsightsV1ListInsightsDocumentsResponse;

export type InsightsV1ListInsightsTableContextsResponse = {
  insightsTableContexts: Array<InsightsV1InsightsTableContext>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ListInsightsTableContextsResponseResult =
  | Error
  | InsightsV1ListInsightsTableContextsResponse;

export type InsightsV1ListSuggestedQuestionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  suggestedQuestions: Array<InsightsV1SuggestedQuestion>;
};

export type InsightsV1ListSuggestedQuestionsResponseResult =
  | Error
  | InsightsV1ListSuggestedQuestionsResponse;

export type InsightsV1MetricValue = {
  dimensions: Array<InsightsV1MetricValueDimensionsEntry>;
  endTime?: Maybe<Scalars['String']['output']>;
  metricValue?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1MetricValueDimensionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum InsightsV1NullValue {
  NullValue = 'NULL_VALUE',
}

export enum InsightsV1Platform {
  PlatformFlutterAndroid = 'PLATFORM_FLUTTER_ANDROID',
  PlatformFlutterIos = 'PLATFORM_FLUTTER_IOS',
  PlatformGo = 'PLATFORM_GO',
  PlatformJava = 'PLATFORM_JAVA',
  PlatformJsServer = 'PLATFORM_JS_SERVER',
  PlatformJsWeb = 'PLATFORM_JS_WEB',
  PlatformKotlin = 'PLATFORM_KOTLIN',
  PlatformPython = 'PLATFORM_PYTHON',
  PlatformRuby = 'PLATFORM_RUBY',
  PlatformRust = 'PLATFORM_RUST',
  PlatformSwift = 'PLATFORM_SWIFT',
}

export type InsightsV1PreviewInsightsMetricResponse = {
  values: Array<InsightsV1MetricValue>;
};

export type InsightsV1PreviewInsightsMetricResponseResult =
  | Error
  | InsightsV1PreviewInsightsMetricResponse;

export type InsightsV1QueryData = {
  result: Array<InsightsV1QueryResult>;
  resultType?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1QueryInsightsMetricResponse = {
  values: Array<InsightsV1MetricValue>;
};

export type InsightsV1QueryInsightsMetricResponseResult =
  | Error
  | InsightsV1QueryInsightsMetricResponse;

export type InsightsV1QueryResponse = {
  data?: Maybe<InsightsV1QueryData>;
  error?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type InsightsV1QueryResponseResult = Error | InsightsV1QueryResponse;

export type InsightsV1QueryResult = {
  metric: Array<InsightsV1QueryResultMetricEntry>;
  sdkResolveMode?: Maybe<InsightsV1SdkResolveMode>;
  values: Array<InsightsV1Sample>;
};

export type InsightsV1QueryResultMetricEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1RangeQueryRequestLabelFiltersEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1Sample = {
  timestamp?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1SdkFeatureDefinition = {
  displayName?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['String']['output']>;
  minVersions: Array<InsightsV1SdkMinVersion>;
};

export enum InsightsV1SdkId {
  SdkIdCloudflareResolver = 'SDK_ID_CLOUDFLARE_RESOLVER',
  SdkIdDotnetConfidence = 'SDK_ID_DOTNET_CONFIDENCE',
  SdkIdFlutterAndroidConfidence = 'SDK_ID_FLUTTER_ANDROID_CONFIDENCE',
  SdkIdFlutterIosConfidence = 'SDK_ID_FLUTTER_IOS_CONFIDENCE',
  SdkIdGoConfidence = 'SDK_ID_GO_CONFIDENCE',
  SdkIdGoLocalProvider = 'SDK_ID_GO_LOCAL_PROVIDER',
  SdkIdGoProvider = 'SDK_ID_GO_PROVIDER',
  SdkIdJavaConfidence = 'SDK_ID_JAVA_CONFIDENCE',
  SdkIdJavaLocalProvider = 'SDK_ID_JAVA_LOCAL_PROVIDER',
  SdkIdJavaProvider = 'SDK_ID_JAVA_PROVIDER',
  SdkIdJsConfidence = 'SDK_ID_JS_CONFIDENCE',
  SdkIdJsLocalServerProvider = 'SDK_ID_JS_LOCAL_SERVER_PROVIDER',
  SdkIdJsServerProvider = 'SDK_ID_JS_SERVER_PROVIDER',
  SdkIdJsWebProvider = 'SDK_ID_JS_WEB_PROVIDER',
  SdkIdKotlinConfidence = 'SDK_ID_KOTLIN_CONFIDENCE',
  SdkIdKotlinProvider = 'SDK_ID_KOTLIN_PROVIDER',
  SdkIdPythonConfidence = 'SDK_ID_PYTHON_CONFIDENCE',
  SdkIdPythonLocalProvider = 'SDK_ID_PYTHON_LOCAL_PROVIDER',
  SdkIdPythonProvider = 'SDK_ID_PYTHON_PROVIDER',
  SdkIdRubyProvider = 'SDK_ID_RUBY_PROVIDER',
  SdkIdRustConfidence = 'SDK_ID_RUST_CONFIDENCE',
  SdkIdRustLocalProvider = 'SDK_ID_RUST_LOCAL_PROVIDER',
  SdkIdRustProvider = 'SDK_ID_RUST_PROVIDER',
  SdkIdSwiftConfidence = 'SDK_ID_SWIFT_CONFIDENCE',
  SdkIdSwiftProvider = 'SDK_ID_SWIFT_PROVIDER',
}

export type InsightsV1SdkLatestVersion = {
  latestVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<InsightsV1Platform>;
  sdkDisplayName?: Maybe<Scalars['String']['output']>;
  sdkId?: Maybe<InsightsV1SdkId>;
};

export type InsightsV1SdkMinVersion = {
  minVersion?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<InsightsV1Platform>;
  sdkId?: Maybe<InsightsV1SdkId>;
};

export enum InsightsV1SdkResolveMode {
  SdkResolveModeCached = 'SDK_RESOLVE_MODE_CACHED',
  SdkResolveModeLocal = 'SDK_RESOLVE_MODE_LOCAL',
  SdkResolveModeRemote = 'SDK_RESOLVE_MODE_REMOTE',
}

export type InsightsV1SearchFactTableSummariesResponse = {
  factTableSummaries: Array<InsightsV1FactTableSummary>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1SearchFactTableSummariesResponseResult =
  | Error
  | InsightsV1SearchFactTableSummariesResponse;

export enum InsightsV1Statistic {
  StatisticAbTestsWithHypotheses = 'STATISTIC_AB_TESTS_WITH_HYPOTHESES',
  StatisticActiveUsers = 'STATISTIC_ACTIVE_USERS',
  StatisticApprovedReviews = 'STATISTIC_APPROVED_REVIEWS',
  StatisticApprovedReviewsPerUser = 'STATISTIC_APPROVED_REVIEWS_PER_USER',
  StatisticApprovedReviewsPerUserPosition = 'STATISTIC_APPROVED_REVIEWS_PER_USER_POSITION',
  StatisticAutomaticRolloutsUsed = 'STATISTIC_AUTOMATIC_ROLLOUTS_USED',
  StatisticCreatedExploratoryAnalyses = 'STATISTIC_CREATED_EXPLORATORY_ANALYSES',
  StatisticCreatedFlags = 'STATISTIC_CREATED_FLAGS',
  StatisticCreatedMetrics = 'STATISTIC_CREATED_METRICS',
  StatisticFlagsCreatedPerUser = 'STATISTIC_FLAGS_CREATED_PER_USER',
  StatisticFlagsCreatedPerUserPosition = 'STATISTIC_FLAGS_CREATED_PER_USER_POSITION',
  StatisticLaunchedAbTests = 'STATISTIC_LAUNCHED_AB_TESTS',
  StatisticLaunchedAbTestsPerUser = 'STATISTIC_LAUNCHED_AB_TESTS_PER_USER',
  StatisticLaunchedAbTestsPerUserPosition = 'STATISTIC_LAUNCHED_AB_TESTS_PER_USER_POSITION',
  StatisticLaunchedRollouts = 'STATISTIC_LAUNCHED_ROLLOUTS',
  StatisticReviewsCreated = 'STATISTIC_REVIEWS_CREATED',
  StatisticRolledBack = 'STATISTIC_ROLLED_BACK',
  StatisticRolledBackPerUser = 'STATISTIC_ROLLED_BACK_PER_USER',
  StatisticRolledBackPerUserPosition = 'STATISTIC_ROLLED_BACK_PER_USER_POSITION',
  StatisticRolledForward = 'STATISTIC_ROLLED_FORWARD',
  StatisticRolledForwardPerUser = 'STATISTIC_ROLLED_FORWARD_PER_USER',
  StatisticRolledForwardPerUserPosition = 'STATISTIC_ROLLED_FORWARD_PER_USER_POSITION',
  StatisticSampleSizeCalculationsUsed = 'STATISTIC_SAMPLE_SIZE_CALCULATIONS_USED',
  StatisticSurfacesUsed = 'STATISTIC_SURFACES_USED',
}

export type InsightsV1SuggestedQuestion = {
  factTable: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type InsightsV1SyncInsightsTableContextsResponse = {
  created?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  totalFactTables?: Maybe<Scalars['Int']['output']>;
};

export type InsightsV1SyncInsightsTableContextsResponseResult =
  | Error
  | InsightsV1SyncInsightsTableContextsResponse;

export type InsightsV1TimeAggregationConfig = {
  allCombinations?: Maybe<Scalars['Boolean']['output']>;
  maxLength?: Maybe<Scalars['String']['output']>;
  truncation: InsightsV1Truncation;
  until?: Maybe<InsightsV1TimeSeriesEnd>;
  window?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1TimeAggregationConfigInput = {
  allCombinations?: InputMaybe<Scalars['Boolean']['input']>;
  maxLength?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  truncation: InsightsV1Truncation;
  until?: InputMaybe<InsightsV1TimeSeriesEnd>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1TimeConfig = {
  disableDeleteTimeFilter?: Maybe<Scalars['Boolean']['output']>;
  endTimeColumn?: Maybe<Scalars['String']['output']>;
  timeAggregation?: Maybe<InsightsV1TimeAggregationConfig>;
  timeColumn: Scalars['String']['output'];
};

export type InsightsV1TimeConfigInput = {
  disableDeleteTimeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeColumn?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeAggregation?: InputMaybe<InsightsV1TimeAggregationConfigInput>;
  timeColumn: Scalars['String']['input'];
};

export enum InsightsV1TimeSeriesEnd {
  CurrentDate = 'CURRENT_DATE',
  LastDate = 'LAST_DATE',
}

export enum InsightsV1Truncation {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
}

export type InsightsV1Value = {
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  dateValue?: Maybe<Scalars['String']['output']>;
  decimalValue?: Maybe<GoogleTypeDecimal>;
  intValue?: Maybe<Scalars['Long']['output']>;
  nullValue?: Maybe<InsightsV1NullValue>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  timestampValue?: Maybe<Scalars['String']['output']>;
};

export type InsightsV1ValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateValue?: InputMaybe<Scalars['String']['input']>;
  decimalValue?: InputMaybe<GoogleTypeDecimalInput>;
  intValue?: InputMaybe<Scalars['Long']['input']>;
  nullValue?: InputMaybe<InsightsV1NullValue>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1Wrapped = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  stats: Array<InsightsV1WrappedStatistic>;
};

export type InsightsV1WrappedAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1WrappedCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type InsightsV1WrappedCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsightsV1WrappedExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type InsightsV1WrappedQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1WrappedReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1WrappedResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1WrappedReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type InsightsV1WrappedResult = Error | InsightsV1Wrapped;

export type InsightsV1WrappedStatistic = {
  statistic?: Maybe<InsightsV1Statistic>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type IoCloudeventsV1CloudEvent = {
  attributes: Array<IoCloudeventsV1CloudEventAttributesEntry>;
  binaryData?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  protoData?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  specVersion?: Maybe<Scalars['String']['output']>;
  textData?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IoCloudeventsV1CloudEventAttributesEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<IoCloudeventsV1CloudEventCloudEventAttributeValue>;
};

export type IoCloudeventsV1CloudEventCloudEventAttributeValue = {
  ceBoolean?: Maybe<Scalars['Boolean']['output']>;
  ceBytes?: Maybe<Scalars['String']['output']>;
  ceInteger?: Maybe<Scalars['Int']['output']>;
  ceString?: Maybe<Scalars['String']['output']>;
  ceTimestamp?: Maybe<Scalars['String']['output']>;
  ceUri?: Maybe<Scalars['String']['output']>;
  ceUriRef?: Maybe<Scalars['String']['output']>;
};

export type MaterializerV1BloomFilterDetails = {
  falsePositiveRate: Scalars['Float']['output'];
  keyCount: Scalars['Long']['output'];
  sizeBytes: Scalars['Long']['output'];
};

export type MaterializerV1BloomFilterDetailsInput = {
  falsePositiveRate: Scalars['Float']['input'];
  keyCount: Scalars['Long']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sizeBytes: Scalars['Long']['input'];
};

export type MaterializerV1BloomFilterStatus = {
  bloomFilterEndTime?: Maybe<Scalars['String']['output']>;
  bloomFilterStartTime?: Maybe<Scalars['String']['output']>;
  details?: Maybe<MaterializerV1BloomFilterDetails>;
  ingestionRate?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<MaterializerV1GcsFile>;
  progress: Scalars['Float']['output'];
  state: MaterializerV1BloomFilterStatusState;
};

export type MaterializerV1BloomFilterStatusInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum MaterializerV1BloomFilterStatusState {
  Building = 'BUILDING',
  Cancelled = 'CANCELLED',
  Done = 'DONE',
}

export enum MaterializerV1ColumnType {
  ColumnTypeInt32 = 'COLUMN_TYPE_INT32',
  ColumnTypeInt64 = 'COLUMN_TYPE_INT64',
  ColumnTypeString = 'COLUMN_TYPE_STRING',
}

export type MaterializerV1EventsMaterializedSegmentLoadJobCancelled = {
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsMaterializedSegmentLoadJobCompleted = {
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsMaterializedSegmentLoadJobCreated = {
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsMaterializedSegmentLoadJobFailed = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1EventsMaterializedSegmentLoadJobUpdated = {
  loadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJob>;
};

export type MaterializerV1GcsFile = {
  bucket: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type MaterializerV1GcsFileInput = {
  bucket: Scalars['String']['input'];
  path: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1IngestionStatus = {
  ingestionEndTime?: Maybe<Scalars['String']['output']>;
  ingestionRate?: Maybe<Scalars['Float']['output']>;
  ingestionStartTime: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
  state?: Maybe<MaterializerV1IngestionStatusState>;
};

export type MaterializerV1IngestionStatusInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum MaterializerV1IngestionStatusState {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Ingesting = 'INGESTING',
}

export type MaterializerV1ListMaterializedSegmentLoadJobsResponse = {
  materializedSegmentLoadJobs: Array<MaterializerV1MaterializedSegmentLoadJob>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MaterializerV1ListMaterializedSegmentLoadJobsResponseResult =
  | Error
  | MaterializerV1ListMaterializedSegmentLoadJobsResponse;

export type MaterializerV1MaterializedSegmentLoadJob = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  bloomFilterStatus?: Maybe<MaterializerV1BloomFilterStatus>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  entityIdColumn: Scalars['String']['output'];
  entityIdColumnType?: Maybe<MaterializerV1ColumnType>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exportEndTime?: Maybe<Scalars['String']['output']>;
  exportStartTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  ingestionStatus?: Maybe<MaterializerV1IngestionStatus>;
  labels: Array<MaterializerV1MaterializedSegmentLoadJobLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  parent: FlagsAdminV1MaterializedSegmentResult;
  progress: Scalars['Float']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  rowCount?: Maybe<Scalars['Long']['output']>;
  sql: Scalars['String']['output'];
  state?: Maybe<MaterializerV1MaterializedSegmentLoadJobJobState>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MaterializerV1MaterializedSegmentLoadJobAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type MaterializerV1MaterializedSegmentLoadJobCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MaterializerV1MaterializedSegmentLoadJobQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MaterializerV1MaterializedSegmentLoadJobReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobInput = {
  entityIdColumn: Scalars['String']['input'];
  entityIdColumnType?: InputMaybe<MaterializerV1ColumnType>;
  labels?: InputMaybe<
    Array<MaterializerV1MaterializedSegmentLoadJobLabelsEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
};

export enum MaterializerV1MaterializedSegmentLoadJobJobState {
  JobStateCancelled = 'JOB_STATE_CANCELLED',
  JobStateCompleted = 'JOB_STATE_COMPLETED',
  JobStateFailed = 'JOB_STATE_FAILED',
  JobStatePending = 'JOB_STATE_PENDING',
  JobStateRunning = 'JOB_STATE_RUNNING',
}

export type MaterializerV1MaterializedSegmentLoadJobLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MaterializerV1MaterializedSegmentLoadJobLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MaterializerV1MaterializedSegmentLoadJobResult =
  | Error
  | MaterializerV1MaterializedSegmentLoadJob;

export type MetaAnalysisData = {
  error?: Maybe<Scalars['String']['output']>;
  experiments?: Maybe<Array<MetaAnalysisDataExperimentEntry>>;
  metrics?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MetaAnalysisDataExperimentEntry = {
  analysisResult?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exposureTable?: Maybe<Scalars['String']['output']>;
  instanceName: Scalars['String']['output'];
  metricCalculations?: Maybe<
    Array<MetaAnalysisDataExperimentEntryMetricCalculationEntry>
  >;
  startTime?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<Array<MetaAnalysisDataExperimentEntryTreatmentEntry>>;
};

export type MetaAnalysisDataExperimentEntryMetricCalculationEntry = {
  calculation?: Maybe<Scalars['String']['output']>;
  metricName: Scalars['String']['output'];
  state?: Maybe<MetaAnalysisDataExperimentEntryMetricCalculationEntryState>;
};

export enum MetaAnalysisDataExperimentEntryMetricCalculationEntryState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type MetaAnalysisDataExperimentEntryTreatmentEntry = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

export type MetaAnalysisDataInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  experiments?: InputMaybe<Array<MetaAnalysisDataInputExperimentEntryInput>>;
  metrics?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAnalysisDataInputExperimentEntryInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  instanceName: Scalars['String']['input'];
  metricCalculations?: InputMaybe<
    Array<MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInput>
  >;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<MetaAnalysisDataInputExperimentEntryInputTreatmentEntryInput>
  >;
};

export type MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInput =
  {
    calculation?: InputMaybe<Scalars['String']['input']>;
    metricName: Scalars['String']['input'];
    state?: InputMaybe<MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInputState>;
  };

export enum MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInputState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type MetaAnalysisDataInputExperimentEntryInputTreatmentEntryInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type MetricRoleOneOfInput = {
  guardrailMetric?: InputMaybe<MetricsDataInputMetricInputGuardrailMetricInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  successMetric?: InputMaybe<MetricsDataInputMetricInputSuccessMetricInput>;
};

export type MetricsData = {
  assignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  assignmentTableSource?: Maybe<MetricsDataAssignmentTableSource>;
  bucket?: Maybe<MetricsDataBucket>;
  entity?: Maybe<MetricsV1EntityResult>;
  entityFilters?: Maybe<Array<MetricsDataEntityFilter>>;
  entitySource?: Maybe<MetricsDataEntitySource>;
  exposureCalculation?: Maybe<MetricsV1ExposureCalculationResult>;
  exposureFilter?: Maybe<MetricsDataExposureFilter>;
  exposureMetric?: Maybe<MetricsV1MetricResult>;
  exposureMetricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  exposureMetricSchedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  exposureTableSchedule?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  filters?: Maybe<Array<MetricsDataExposureFilter>>;
  metrics: Array<MetricsDataMetric>;
};

export enum MetricsDataAssignmentTableSource {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export enum MetricsDataBucket {
  BucketingTemporalUnitUnspecified = 'BUCKETING_TEMPORAL_UNIT_UNSPECIFIED',
  Days = 'DAYS',
  Hours = 'HOURS',
}

export type MetricsDataEntityFilter = {
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  filter?: Maybe<MetricsDataEntityFilterFilter>;
};

export type MetricsDataEntityFilterFilter = {
  criteria: Scalars['JSON']['output'];
  expression: Scalars['JSON']['output'];
};

export enum MetricsDataEntitySource {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export type MetricsDataExposureFilter = {
  displayName?: Maybe<Scalars['String']['output']>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  filter?: Maybe<MetricsDataExposureFilterFilter>;
};

export type MetricsDataExposureFilterFilter = {
  criteria: Scalars['JSON']['output'];
  expression: Scalars['JSON']['output'];
};

export type MetricsDataInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  assignmentTableSource?: InputMaybe<MetricsDataInputAssignmentTableSource>;
  bucket?: InputMaybe<MetricsDataInputBucket>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityFilters?: InputMaybe<Array<MetricsDataInputEntityFilterInput>>;
  entitySource?: InputMaybe<MetricsDataInputEntitySource>;
  exposureCalculation?: InputMaybe<Scalars['String']['input']>;
  exposureFilter?: InputMaybe<MetricsDataInputExposureFilterInput>;
  exposureMetric?: InputMaybe<Scalars['String']['input']>;
  exposureMetricCalculation?: InputMaybe<Scalars['String']['input']>;
  exposureMetricSchedule?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<MetricsDataInputExposureFilterInput>>;
  metrics: Array<MetricsDataInputMetricInput>;
};

export enum MetricsDataInputAssignmentTableSource {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export enum MetricsDataInputBucket {
  BucketingTemporalUnitUnspecified = 'BUCKETING_TEMPORAL_UNIT_UNSPECIFIED',
  Days = 'DAYS',
  Hours = 'HOURS',
}

export type MetricsDataInputEntityFilterInput = {
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MetricsDataInputEntityFilterInputFilterInput>;
};

export type MetricsDataInputEntityFilterInputFilterInput = {
  criteria: Scalars['JSON']['input'];
  expression: Scalars['JSON']['input'];
};

export enum MetricsDataInputEntitySource {
  Auto = 'AUTO',
  Manual = 'MANUAL',
}

export type MetricsDataInputExposureFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MetricsDataInputExposureFilterInputFilterInput>;
};

export type MetricsDataInputExposureFilterInputFilterInput = {
  criteria: Scalars['JSON']['input'];
  expression: Scalars['JSON']['input'];
};

export type MetricsDataInputMetricInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  metric: Scalars['String']['input'];
  metricRole: MetricRoleOneOfInput;
  preferredDirection?: InputMaybe<MetricsDataInputMetricInputPreferredDirection>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  surfaceOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsDataInputMetricInputGuardrailMetricInput = {
  metricKind: MetricsDataInputMetricInputGuardrailMetricInputMetricKind;
  nonInferiorityMargin?: InputMaybe<Scalars['Float']['input']>;
};

export enum MetricsDataInputMetricInputGuardrailMetricInputMetricKind {
  Guardrail = 'GUARDRAIL',
  Monitoring = 'MONITORING',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export enum MetricsDataInputMetricInputPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MetricsDataInputMetricInputSuccessMetricInput = {
  metricKind: MetricsDataInputMetricInputSuccessMetricInputMetricKind;
  minimumDetectableEffect?: InputMaybe<Scalars['Float']['input']>;
};

export enum MetricsDataInputMetricInputSuccessMetricInputMetricKind {
  Guardrail = 'GUARDRAIL',
  Monitoring = 'MONITORING',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type MetricsDataMetric = {
  calculation?: Maybe<MetricsV1MetricCalculationResult>;
  metric: MetricsV1MetricResult;
  metricRole: MetricsDataMetricMetricRoleUnion;
  preferredDirection?: Maybe<MetricsDataMetricPreferredDirection>;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
  surfaceOnly?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsDataMetricGuardrailMetric = {
  metricKind: MetricsDataMetricGuardrailMetricMetricKind;
  nonInferiorityMargin?: Maybe<Scalars['Float']['output']>;
};

export enum MetricsDataMetricGuardrailMetricMetricKind {
  Guardrail = 'GUARDRAIL',
  Monitoring = 'MONITORING',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type MetricsDataMetricMetricRoleUnion =
  | MetricsDataMetricGuardrailMetric
  | MetricsDataMetricSuccessMetric;

export enum MetricsDataMetricPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MetricsDataMetricSuccessMetric = {
  metricKind: MetricsDataMetricSuccessMetricMetricKind;
  minimumDetectableEffect?: Maybe<Scalars['Float']['output']>;
};

export enum MetricsDataMetricSuccessMetricMetricKind {
  Guardrail = 'GUARDRAIL',
  Monitoring = 'MONITORING',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type MetricsV1Aggregation = {
  cap?: Maybe<MetricsV1ValueCap>;
  threshold?: Maybe<MetricsV1AggregationThreshold>;
  type: MetricsV1AggregationType;
};

export type MetricsV1AggregationInput = {
  cap?: InputMaybe<MetricsV1ValueCapInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<MetricsV1AggregationThresholdInput>;
  type: MetricsV1AggregationType;
};

export type MetricsV1AggregationThreshold = {
  direction: MetricsV1AggregationThresholdDirection;
  threshold: GoogleTypeDecimal;
};

export enum MetricsV1AggregationThresholdDirection {
  AggregationThresholdDirectionEq = 'AGGREGATION_THRESHOLD_DIRECTION_EQ',
  AggregationThresholdDirectionGt = 'AGGREGATION_THRESHOLD_DIRECTION_GT',
  AggregationThresholdDirectionGte = 'AGGREGATION_THRESHOLD_DIRECTION_GTE',
  AggregationThresholdDirectionLt = 'AGGREGATION_THRESHOLD_DIRECTION_LT',
  AggregationThresholdDirectionLte = 'AGGREGATION_THRESHOLD_DIRECTION_LTE',
}

export type MetricsV1AggregationThresholdInput = {
  direction: MetricsV1AggregationThresholdDirection;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  threshold: GoogleTypeDecimalInput;
};

export enum MetricsV1AggregationType {
  AggregationTypeApproxCountDistinct = 'AGGREGATION_TYPE_APPROX_COUNT_DISTINCT',
  AggregationTypeAvg = 'AGGREGATION_TYPE_AVG',
  AggregationTypeCount = 'AGGREGATION_TYPE_COUNT',
  AggregationTypeCountDistinct = 'AGGREGATION_TYPE_COUNT_DISTINCT',
  AggregationTypeMax = 'AGGREGATION_TYPE_MAX',
  AggregationTypeMin = 'AGGREGATION_TYPE_MIN',
  AggregationTypeSum = 'AGGREGATION_TYPE_SUM',
}

export type MetricsV1ApplyMetricsSyncRequestSyncResourceInput = {
  factTable?: InputMaybe<MetricsV1FactTableInput>;
  measurement?: InputMaybe<MetricsV1MeasurementInput>;
  metric?: InputMaybe<MetricsV1MetricInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ApplyMetricsSyncResponse = {
  archived: Array<MetricsV1ApplyMetricsSyncResponseResourceOutcome>;
  outcomes: Array<MetricsV1ApplyMetricsSyncResponseResourceOutcome>;
};

export type MetricsV1ApplyMetricsSyncResponseResourceOutcome = {
  action?: Maybe<MetricsV1ApplyMetricsSyncResponseResourceOutcomeAction>;
  changedFields: Array<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum MetricsV1ApplyMetricsSyncResponseResourceOutcomeAction {
  Adopt = 'ADOPT',
  Archive = 'ARCHIVE',
  Create = 'CREATE',
  Error = 'ERROR',
  Unchanged = 'UNCHANGED',
  Update = 'UPDATE',
}

export type MetricsV1ApplyMetricsSyncResponseResult =
  | Error
  | MetricsV1ApplyMetricsSyncResponse;

export type MetricsV1AssignmentData = {
  endTime: Scalars['String']['output'];
  exposureKey: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  variants: Array<Scalars['String']['output']>;
};

export type MetricsV1AssignmentTable = {
  assignmentDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataDeliveredUntilUpdateStrategyConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfig>;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions: Array<MetricsV1Column>;
  displayName: Scalars['String']['output'];
  entityColumn: MetricsV1Column;
  error?: Maybe<MetricsV1OperationError>;
  exposureKeyColumn: MetricsV1Column;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1AssignmentTableLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  partitionedUpdateStrategyState?: Maybe<MetricsV1PartitionedUpdateStrategyState>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  timestampColumn: MetricsV1Column;
  timestampTruncation?: Maybe<MetricsV1TimeTruncation>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  variantKeyColumn: MetricsV1Column;
};

export type MetricsV1AssignmentTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1AssignmentTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1AssignmentTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1AssignmentTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1AssignmentTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableInput = {
  assignmentDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<MetricsV1ColumnInput>>;
  displayName: Scalars['String']['input'];
  entityColumn: MetricsV1ColumnInput;
  exposureKeyColumn: MetricsV1ColumnInput;
  labels?: InputMaybe<Array<MetricsV1AssignmentTableLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
  timestampColumn: MetricsV1ColumnInput;
  timestampTruncation?: InputMaybe<MetricsV1TimeTruncationInput>;
  variantKeyColumn: MetricsV1ColumnInput;
};

export type MetricsV1AssignmentTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1AssignmentTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1AssignmentTableResult = Error | MetricsV1AssignmentTable;

export enum MetricsV1AwsRegion {
  AfSouth_1 = 'AF_SOUTH_1',
  ApEast_1 = 'AP_EAST_1',
  ApNortheast_1 = 'AP_NORTHEAST_1',
  ApNortheast_2 = 'AP_NORTHEAST_2',
  ApNortheast_3 = 'AP_NORTHEAST_3',
  ApSoutheast_1 = 'AP_SOUTHEAST_1',
  ApSoutheast_2 = 'AP_SOUTHEAST_2',
  ApSoutheast_3 = 'AP_SOUTHEAST_3',
  ApSoutheast_4 = 'AP_SOUTHEAST_4',
  ApSouth_1 = 'AP_SOUTH_1',
  ApSouth_2 = 'AP_SOUTH_2',
  CaCentral_1 = 'CA_CENTRAL_1',
  CnNorthwest_1 = 'CN_NORTHWEST_1',
  CnNorth_1 = 'CN_NORTH_1',
  EuCentral_1 = 'EU_CENTRAL_1',
  EuCentral_2 = 'EU_CENTRAL_2',
  EuNorth_1 = 'EU_NORTH_1',
  EuSouth_1 = 'EU_SOUTH_1',
  EuSouth_2 = 'EU_SOUTH_2',
  EuWest_1 = 'EU_WEST_1',
  EuWest_2 = 'EU_WEST_2',
  EuWest_3 = 'EU_WEST_3',
  IlCentral_1 = 'IL_CENTRAL_1',
  MeCentral_1 = 'ME_CENTRAL_1',
  MeSouth_1 = 'ME_SOUTH_1',
  SaEast_1 = 'SA_EAST_1',
  UsEast_1 = 'US_EAST_1',
  UsEast_2 = 'US_EAST_2',
  UsGovEast_1 = 'US_GOV_EAST_1',
  UsGovWest_1 = 'US_GOV_WEST_1',
  UsIsoEast_1 = 'US_ISO_EAST_1',
  UsIsoWest_1 = 'US_ISO_WEST_1',
  UsWest_1 = 'US_WEST_1',
  UsWest_2 = 'US_WEST_2',
}

export type MetricsV1BigQueryConfig = {
  bigQueryLocation?: Maybe<Scalars['String']['output']>;
  dataset?: Maybe<Scalars['String']['output']>;
  exportJobsServiceAccount?: Maybe<Scalars['String']['output']>;
  gcpProjectId?: Maybe<Scalars['String']['output']>;
  interactiveProjectId?: Maybe<Scalars['String']['output']>;
  processingProjectId?: Maybe<Scalars['String']['output']>;
  serviceAccount?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1BigQueryConfigInput = {
  dataset?: InputMaybe<Scalars['String']['input']>;
  exportJobsServiceAccount?: InputMaybe<Scalars['String']['input']>;
  gcpProjectId?: InputMaybe<Scalars['String']['input']>;
  interactiveProjectId?: InputMaybe<Scalars['String']['input']>;
  processingProjectId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  serviceAccount?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1BigQueryJobStats = {
  billingTier?: Maybe<Scalars['Int']['output']>;
  cacheHit: Scalars['Boolean']['output'];
  createTime: Scalars['String']['output'];
  dmlAffectedRowsCount?: Maybe<Scalars['Long']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  estimatedBytesProcessed?: Maybe<Scalars['Long']['output']>;
  referencedTables: Array<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  statementType: Scalars['String']['output'];
  totalBytesBilled?: Maybe<Scalars['Long']['output']>;
  totalBytesProcessed?: Maybe<Scalars['Long']['output']>;
  totalPartitionsProcessed?: Maybe<Scalars['Long']['output']>;
  totalSlotMs?: Maybe<Scalars['Long']['output']>;
};

export type MetricsV1Column = {
  name: Scalars['String']['output'];
  repeated?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<MetricsV1ColumnType>;
};

export type MetricsV1ColumnInput = {
  name: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  repeated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ColumnIssue = {
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum MetricsV1ColumnType {
  ColumnTypeBoolean = 'COLUMN_TYPE_BOOLEAN',
  ColumnTypeBytes = 'COLUMN_TYPE_BYTES',
  ColumnTypeDate = 'COLUMN_TYPE_DATE',
  ColumnTypeDecimal = 'COLUMN_TYPE_DECIMAL',
  ColumnTypeDouble = 'COLUMN_TYPE_DOUBLE',
  ColumnTypeHllSketch = 'COLUMN_TYPE_HLL_SKETCH',
  ColumnTypeInt32 = 'COLUMN_TYPE_INT32',
  ColumnTypeInt64 = 'COLUMN_TYPE_INT64',
  ColumnTypeString = 'COLUMN_TYPE_STRING',
  ColumnTypeTimestamp = 'COLUMN_TYPE_TIMESTAMP',
  ColumnTypeTimestampWithoutTimezone = 'COLUMN_TYPE_TIMESTAMP_WITHOUT_TIMEZONE',
}

export type MetricsV1ContiguousPartition = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  endTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  startTime: Scalars['String']['output'];
};

export type MetricsV1ContiguousPartitionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ContiguousPartitionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ContiguousPartitionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ContiguousPartitionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ContiguousPartitionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ContiguousPartitionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ContiguousPartitionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ContiguousPartitionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ContiguousPartitionResult =
  | Error
  | MetricsV1ContiguousPartition;

export type MetricsV1DataDeliveredUntilUpdateStrategyConfig = {
  automaticUpdateConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfig>;
  dailyUpdateConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig>;
  disableEmptyPartitions?: Maybe<Scalars['Boolean']['output']>;
  hourlyUpdateConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig>;
  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
};

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfig =
  {
    changeThreshold?: Maybe<GoogleTypeDecimal>;
    commitDelay: Scalars['String']['output'];
    /** @deprecated No longer supported */
    incrementDuration?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfigInput =
  {
    changeThreshold?: InputMaybe<GoogleTypeDecimalInput>;
    commitDelay: Scalars['String']['input'];
    incrementDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfig =
  {
    maxZeroDuration?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfigInput =
  {
    maxZeroDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfig =
  {
    maxZeroDuration?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfigInput =
  {
    maxZeroDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1DataDeliveredUntilUpdateStrategyConfigInput = {
  automaticUpdateConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfigInput>;
  dailyUpdateConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfigInput>;
  disableEmptyPartitions?: InputMaybe<Scalars['Boolean']['input']>;
  hourlyUpdateConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  strategy: MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy;
};

export enum MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
}

export type MetricsV1DataWarehouse = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  config: MetricsV1DataWarehouseConfig;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<MetricsV1DataWarehouseLabelsEntry>;
  limits?: Maybe<MetricsV1DataWarehouseDataWarehouseLimits>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1DataWarehouseAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DataWarehouseCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1DataWarehouseCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DataWarehouseExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1DataWarehouseQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseConfig = {
  bigQueryConfig?: Maybe<MetricsV1BigQueryConfig>;
  dataBricksConfig?: Maybe<MetricsV1DatabricksConfig>;
  redshiftConfig?: Maybe<MetricsV1RedshiftConfig>;
  snowflakeConfig?: Maybe<MetricsV1SnowflakeConfig>;
};

export type MetricsV1DataWarehouseConfigInput = {
  bigQueryConfig?: InputMaybe<MetricsV1BigQueryConfigInput>;
  dataBricksConfig?: InputMaybe<MetricsV1DatabricksConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig?: InputMaybe<MetricsV1RedshiftConfigInput>;
  snowflakeConfig?: InputMaybe<MetricsV1SnowflakeConfigInput>;
};

export type MetricsV1DataWarehouseDataWarehouseLimits = {
  maxConcurrentInteractiveQueries?: Maybe<Scalars['Long']['output']>;
  maxConcurrentQueries?: Maybe<Scalars['Long']['output']>;
};

export type MetricsV1DataWarehouseDataWarehouseLimitsInput = {
  maxConcurrentInteractiveQueries?: InputMaybe<Scalars['Long']['input']>;
  maxConcurrentQueries?: InputMaybe<Scalars['Long']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseInput = {
  config: MetricsV1DataWarehouseConfigInput;
  labels?: InputMaybe<Array<MetricsV1DataWarehouseLabelsEntryInput>>;
  limits?: InputMaybe<MetricsV1DataWarehouseDataWarehouseLimitsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DataWarehouseLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DataWarehouseResult = Error | MetricsV1DataWarehouse;

export type MetricsV1DataWarehouseStatsEntry = {
  bqStats?: Maybe<MetricsV1DataWarehouseStatsEntryBqStats>;
  entryTime: Scalars['String']['output'];
  failedQueryCount: Scalars['Long']['output'];
  totalQueryCount: Scalars['Long']['output'];
};

export type MetricsV1DataWarehouseStatsEntryBqStats = {
  totalBytesBilled: Scalars['Long']['output'];
  totalBytesProcessed: Scalars['Long']['output'];
  totalSlotMs: Scalars['Long']['output'];
};

export type MetricsV1DatabricksConfig = {
  clientId?: Maybe<Scalars['String']['output']>;
  exposureSchema?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  resultsSchema?: Maybe<Scalars['String']['output']>;
  warehouseId?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DatabricksConfigInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultsSchema?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1Dependency = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  dataStatus: Array<MetricsV1DependencyDataStatus>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  parent?: Maybe<MetricsV1DependencyResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  table: MetricsV1DependencyTableScheduleReference;
};

export type MetricsV1DependencyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DependencyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1DependencyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DependencyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1DependencyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DependencyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DependencyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DependencyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DependencyAssignmentReference = {
  assignmentTable: MetricsV1AssignmentTableResult;
};

export type MetricsV1DependencyDataStatus = {
  endTime: Scalars['String']['output'];
  fulfilled?: Maybe<Scalars['Boolean']['output']>;
  startTime: Scalars['String']['output'];
};

export type MetricsV1DependencyDimensionReference = {
  dimensionTable: MetricsV1DimensionTableResult;
};

export type MetricsV1DependencyEntityRelationReference = {
  entityRelationTable: MetricsV1EntityRelationTableResult;
};

export type MetricsV1DependencyExposureReference = {
  exposureTable: MetricsV1ExposureTableResult;
  scheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
};

export type MetricsV1DependencyFactReference = {
  factTable: MetricsV1FactTableResult;
};

export type MetricsV1DependencyMeasurementReference = {
  measurementTable: MetricsV1MeasurementTableResult;
  scheduledMeasurementCalculation: MetricsV1ScheduledMeasurementCalculationResult;
};

export type MetricsV1DependencyResult = Error | MetricsV1Dependency;

export type MetricsV1DependencyTableScheduleReference = {
  assignments?: Maybe<MetricsV1DependencyAssignmentReference>;
  dimensions?: Maybe<MetricsV1DependencyDimensionReference>;
  entityRelation?: Maybe<MetricsV1DependencyEntityRelationReference>;
  exposures?: Maybe<MetricsV1DependencyExposureReference>;
  facts?: Maybe<MetricsV1DependencyFactReference>;
  measurements?: Maybe<MetricsV1DependencyMeasurementReference>;
};

export type MetricsV1DescribeAssignmentTableResponse = {
  assignmentsData: Array<MetricsV1AssignmentData>;
  name: MetricsV1AssignmentTableResult;
};

export type MetricsV1DescribeAssignmentTableResponseResult =
  | Error
  | MetricsV1DescribeAssignmentTableResponse;

export type MetricsV1DimensionFilterInput = {
  allowedValues: Array<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataDeliveredUntilUpdateStrategyConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfig>;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensionDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  dimensions: Array<MetricsV1Column>;
  displayName: Scalars['String']['output'];
  entityColumnMapping: MetricsV1EntityColumnMapping;
  error?: Maybe<MetricsV1OperationError>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1DimensionTableLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  partitionedUpdateStrategyState?: Maybe<MetricsV1PartitionedUpdateStrategyState>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  timeConfig?: Maybe<MetricsV1DimensionTableTimeConfig>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  valueMappings: Array<MetricsV1DimensionTableDimensionValueMapping>;
};

export type MetricsV1DimensionTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DimensionTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1DimensionTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1DimensionTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1DimensionTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableDimensionValueMapping = {
  column: Scalars['String']['output'];
  mappings: Array<MetricsV1DimensionTableValueMapping>;
};

export type MetricsV1DimensionTableDimensionValueMappingInput = {
  column: Scalars['String']['input'];
  mappings: Array<MetricsV1DimensionTableValueMappingInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableInput = {
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  dimensions: Array<MetricsV1ColumnInput>;
  displayName: Scalars['String']['input'];
  entityColumnMapping: MetricsV1EntityColumnMappingInput;
  labels?: InputMaybe<Array<MetricsV1DimensionTableLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
  timeConfig?: InputMaybe<MetricsV1DimensionTableTimeConfigInput>;
  valueMappings?: InputMaybe<
    Array<MetricsV1DimensionTableDimensionValueMappingInput>
  >;
};

export type MetricsV1DimensionTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DimensionTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionTableResult = Error | MetricsV1DimensionTable;

export type MetricsV1DimensionTableTimeConfig = {
  timestampColumn: MetricsV1Column;
  window: Scalars['String']['output'];
};

export type MetricsV1DimensionTableTimeConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timestampColumn: MetricsV1ColumnInput;
  window: Scalars['String']['input'];
};

export type MetricsV1DimensionTableValueMapping = {
  inputDimensionValue?: Maybe<Scalars['String']['output']>;
  outputDimensionValue?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DimensionTableValueMappingInput = {
  inputDimensionValue?: InputMaybe<Scalars['String']['input']>;
  outputDimensionValue?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1DimensionValue = {
  dimension?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1DimensionValueInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1Entity = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  defaultAssignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  displayName: Scalars['String']['output'];
  entityIdentityBindings?: Maybe<MetricsV1ListEntityIdentityBindingsResponseResult>;
  entityRelationTables?: Maybe<MetricsV1ListEntityRelationTablesResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1EntityLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  primaryKeyType: MetricsV1ColumnType;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1EntityAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1EntityCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityEntityIdentityBindingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityEntityRelationTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1EntityQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityColumn = {
  column: Scalars['String']['output'];
  entity: MetricsV1EntityResult;
};

export type MetricsV1EntityColumnMapping = {
  column: MetricsV1Column;
  entity: MetricsV1EntityResult;
};

export type MetricsV1EntityColumnMappingInput = {
  column: MetricsV1ColumnInput;
  entity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBinding = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  entity?: Maybe<MetricsV1EntityResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  labels: Array<MetricsV1EntityIdentityBindingLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  value: Scalars['String']['output'];
};

export type MetricsV1EntityIdentityBindingAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityIdentityBindingCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1EntityIdentityBindingCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityIdentityBindingExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1EntityIdentityBindingQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingInput = {
  identity: Scalars['String']['input'];
  labels?: InputMaybe<Array<MetricsV1EntityIdentityBindingLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type MetricsV1EntityIdentityBindingLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1EntityIdentityBindingLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityIdentityBindingResult =
  | Error
  | MetricsV1EntityIdentityBinding;

export type MetricsV1EntityInput = {
  defaultAssignmentTable?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<MetricsV1EntityLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  primaryKeyType: MetricsV1ColumnType;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1EntityLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  error?: Maybe<MetricsV1OperationError>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1EntityRelationTableLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  parentEntityIdColumn: MetricsV1Column;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  targetEntity: MetricsV1EntityResult;
  targetEntityIdColumn: MetricsV1Column;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1EntityRelationTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityRelationTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1EntityRelationTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1EntityRelationTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1EntityRelationTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableInput = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1EntityRelationTableLabelsEntryInput>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  parentEntityIdColumn: MetricsV1ColumnInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
  targetEntity: Scalars['String']['input'];
  targetEntityIdColumn: MetricsV1ColumnInput;
};

export type MetricsV1EntityRelationTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1EntityRelationTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1EntityRelationTableResult =
  | Error
  | MetricsV1EntityRelationTable;

export type MetricsV1EntityResult = Error | MetricsV1Entity;

export type MetricsV1EntitySamplingConfig = {
  hashSeed?: Maybe<Scalars['String']['output']>;
  sampleRate: Scalars['Float']['output'];
};

export type MetricsV1EntitySamplingConfigInput = {
  hashSeed?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sampleRate: Scalars['Float']['input'];
};

export type MetricsV1EventsAssignmentTableCreated = {
  assignmentTable: MetricsV1AssignmentTable;
};

export type MetricsV1EventsAssignmentTableUpdated = {
  assignmentTable: MetricsV1AssignmentTable;
};

export type MetricsV1EventsDataWarehouseCreated = {
  dataWarehouse: MetricsV1DataWarehouse;
};

export type MetricsV1EventsDataWarehouseUpdated = {
  dataWarehouse: MetricsV1DataWarehouse;
};

export type MetricsV1EventsDimensionTableCreated = {
  dimensionTable: MetricsV1DimensionTable;
};

export type MetricsV1EventsDimensionTableUpdated = {
  dimensionTable: MetricsV1DimensionTable;
};

export type MetricsV1EventsEntityCreated = {
  entity: MetricsV1Entity;
};

export type MetricsV1EventsEntityDeleted = {
  entity: Scalars['String']['output'];
};

export type MetricsV1EventsEntityIdentityBindingCreated = {
  entityIdentityBinding: MetricsV1EntityIdentityBinding;
};

export type MetricsV1EventsEntityIdentityBindingDeleted = {
  entityIdentityBinding: Scalars['String']['output'];
};

export type MetricsV1EventsEntityIdentityBindingUpdated = {
  entityIdentityBinding: MetricsV1EntityIdentityBinding;
};

export type MetricsV1EventsEntityRelationTableCreated = {
  entityRelationTable: MetricsV1EntityRelationTable;
};

export type MetricsV1EventsEntityRelationTableDeleted = {
  entityRelationTable: Scalars['String']['output'];
};

export type MetricsV1EventsEntityRelationTableUpdated = {
  entityRelationTable: MetricsV1EntityRelationTable;
};

export type MetricsV1EventsEntityUpdated = {
  entity: MetricsV1Entity;
};

export type MetricsV1EventsExposureCalculationCompleted = {
  exposureCalculation: MetricsV1ExposureCalculation;
};

export type MetricsV1EventsExposureCalculationCreated = {
  exposureCalculation: MetricsV1ExposureCalculation;
};

export type MetricsV1EventsExposureCalculationFailed = {
  error?: Maybe<Scalars['String']['output']>;
  exposureCalculation: MetricsV1ExposureCalculation;
};

export type MetricsV1EventsExposureCalculationUpdated = {
  exposureCalculation: MetricsV1ExposureCalculation;
};

export type MetricsV1EventsExposureTableCreated = {
  exposureTable: MetricsV1ExposureTable;
};

export type MetricsV1EventsExposureTableUpdated = {
  exposureTable: MetricsV1ExposureTable;
};

export type MetricsV1EventsFactTableCreated = {
  factTable: MetricsV1FactTable;
};

export type MetricsV1EventsFactTableUpdated = {
  factTable: MetricsV1FactTable;
};

export type MetricsV1EventsMeasurementCalculationCompleted = {
  measurementCalculation: MetricsV1MeasurementCalculation;
};

export type MetricsV1EventsMeasurementCalculationCreated = {
  measurementCalculation: MetricsV1MeasurementCalculation;
};

export type MetricsV1EventsMeasurementCalculationFailed = {
  error?: Maybe<Scalars['String']['output']>;
  measurementCalculation: MetricsV1MeasurementCalculation;
};

export type MetricsV1EventsMeasurementCalculationUpdated = {
  measurementCalculation: MetricsV1MeasurementCalculation;
};

export type MetricsV1EventsMeasurementCreated = {
  measurement: MetricsV1Measurement;
};

export type MetricsV1EventsMeasurementTableCreated = {
  measurementTable: MetricsV1MeasurementTable;
};

export type MetricsV1EventsMeasurementTableUpdated = {
  measurementTable: MetricsV1MeasurementTable;
};

export type MetricsV1EventsMeasurementUpdated = {
  measurement: MetricsV1Measurement;
  oldMeasurement?: Maybe<MetricsV1Measurement>;
};

export type MetricsV1EventsMetricCalculationCompleted = {
  metricCalculation: MetricsV1MetricCalculation;
};

export type MetricsV1EventsMetricCalculationCreated = {
  metricCalculation: MetricsV1MetricCalculation;
};

export type MetricsV1EventsMetricCalculationFailed = {
  error?: Maybe<Scalars['String']['output']>;
  metricCalculation: MetricsV1MetricCalculation;
};

export type MetricsV1EventsMetricCalculationUpdated = {
  metricCalculation: MetricsV1MetricCalculation;
};

export type MetricsV1EventsMetricCreated = {
  metric: MetricsV1Metric;
};

export type MetricsV1EventsMetricUpdated = {
  metric: MetricsV1Metric;
  oldMetric?: Maybe<MetricsV1Metric>;
};

export type MetricsV1EventsPartitionCreated = {
  partition: MetricsV1Partition;
};

export type MetricsV1EventsPartitionDeleted = {
  partition: MetricsV1Partition;
};

export type MetricsV1EventsProcessRoundLogVerificationFailed = {
  actualCount?: Maybe<Scalars['Long']['output']>;
  expectedCount?: Maybe<Scalars['Long']['output']>;
  processRoundLog: MetricsV1ProcessRoundLog;
  queryEndTime?: Maybe<Scalars['String']['output']>;
  queryStartTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1EventsRetriggerCreated = {
  retrigger: MetricsV1Retrigger;
};

export type MetricsV1EventsRetriggerScheduledExposureCalculationCompleted = {
  scheduledExposureCalculation: MetricsV1ScheduledExposureCalculation;
};

export type MetricsV1EventsRetriggerScheduledMeasurementCalculationCompleted = {
  scheduledMeasurementCalculation: MetricsV1ScheduledMeasurementCalculation;
};

export type MetricsV1EventsRetriggerScheduledMetricCalculationCompleted = {
  scheduledMetricCalculation: MetricsV1ScheduledMetricCalculation;
};

export type MetricsV1EventsRetriggerUpdated = {
  retrigger: MetricsV1Retrigger;
};

export type MetricsV1EventsScheduledExposureCalculationCreated = {
  scheduledExposureCalculation: MetricsV1ScheduledExposureCalculation;
};

export type MetricsV1EventsScheduledExposureCalculationDeleted = {
  scheduledExposureCalculation: Scalars['String']['output'];
};

export type MetricsV1EventsScheduledExposureCalculationUpdated = {
  scheduledExposureCalculation: MetricsV1ScheduledExposureCalculation;
};

export type MetricsV1EventsScheduledMeasurementCalculationCreated = {
  scheduledMeasurementCalculation: MetricsV1ScheduledMeasurementCalculation;
};

export type MetricsV1EventsScheduledMeasurementCalculationDeleted = {
  scheduledMeasurementCalculation: Scalars['String']['output'];
};

export type MetricsV1EventsScheduledMeasurementCalculationUpdated = {
  scheduledMeasurementCalculation: MetricsV1ScheduledMeasurementCalculation;
};

export type MetricsV1EventsScheduledMetricCalculationCreated = {
  scheduledMetricCalculation: MetricsV1ScheduledMetricCalculation;
};

export type MetricsV1EventsScheduledMetricCalculationDeleted = {
  scheduledMetricCalculation: Scalars['String']['output'];
};

export type MetricsV1EventsScheduledMetricCalculationUpdated = {
  scheduledMetricCalculation: MetricsV1ScheduledMetricCalculation;
};

export type MetricsV1EventsSqlJobCreated = {
  sqlJob: MetricsV1SqlJob;
};

export type MetricsV1EventsSqlJobUpdated = {
  sqlJob: MetricsV1SqlJob;
};

export type MetricsV1ExistsDataWarehousesResponse = {
  demoData?: Maybe<Scalars['Boolean']['output']>;
  exists?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1ExistsDataWarehousesResponseResult =
  | Error
  | MetricsV1ExistsDataWarehousesResponse;

export type MetricsV1ExposureCalculation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  endTime: Scalars['String']['output'];
  entity: MetricsV1EntityResult;
  error?: Maybe<Scalars['String']['output']>;
  exposureCalculationSpec: MetricsV1ExposureCalculationSpec;
  exposureTable: MetricsV1ExposureTableResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1ExposureCalculationLabelsEntry>;
  name: Scalars['String']['output'];
  outdatedSourceDataInfo?: Maybe<MetricsV1OutdatedSourceDataInfo>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retriggered?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schedule?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  scheduleIteration: Scalars['Int']['output'];
  sql: Scalars['String']['output'];
  sqlJob: MetricsV1SqlJobResult;
  startTime: Scalars['String']['output'];
  state: MetricsV1ExposureCalculationState;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ExposureCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ExposureCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ExposureCalculationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationGroup = {
  group: Scalars['String']['output'];
  variantKey: Scalars['String']['output'];
};

export type MetricsV1ExposureCalculationGroupInput = {
  group: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variantKey: Scalars['String']['input'];
};

export type MetricsV1ExposureCalculationInput = {
  endTime: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  exposureCalculationSpec: MetricsV1ExposureCalculationSpecInput;
  labels?: InputMaybe<Array<MetricsV1ExposureCalculationLabelsEntryInput>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type MetricsV1ExposureCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ExposureCalculationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationResult =
  | Error
  | MetricsV1ExposureCalculation;

export type MetricsV1ExposureCalculationSpec = {
  assignmentFilter?: Maybe<MetricsV1Filter>;
  assignmentTable: MetricsV1AssignmentTableResult;
  /** @deprecated No longer supported */
  entityFilter?: Maybe<MetricsV1ExposureCalculationSpecEntityFilter>;
  entityFilters: Array<MetricsV1ExposureCalculationSpecEntityFilter>;
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  /** @deprecated No longer supported */
  exposureFilter?: Maybe<MetricsV1ExposureCalculationSpecExposureFilter>;
  exposureKey?: Maybe<Scalars['String']['output']>;
  filters: Array<MetricsV1ExposureCalculationSpecExposureFilter>;
  groups: Array<MetricsV1ExposureCalculationGroup>;
  splitDimensions: Array<Scalars['String']['output']>;
};

export type MetricsV1ExposureCalculationSpecEntityFilter = {
  dimensionTable: MetricsV1DimensionTableResult;
  filter?: Maybe<MetricsV1Filter>;
};

export type MetricsV1ExposureCalculationSpecEntityFilterInput = {
  dimensionTable: Scalars['String']['input'];
  filter?: InputMaybe<MetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationSpecExposureFilter = {
  displayName?: Maybe<Scalars['String']['output']>;
  factTable: MetricsV1FactTableResult;
  filter?: Maybe<MetricsV1Filter>;
};

export type MetricsV1ExposureCalculationSpecExposureFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  factTable: Scalars['String']['input'];
  filter?: InputMaybe<MetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureCalculationSpecInput = {
  assignmentFilter?: InputMaybe<MetricsV1FilterInput>;
  assignmentTable: Scalars['String']['input'];
  entityFilter?: InputMaybe<MetricsV1ExposureCalculationSpecEntityFilterInput>;
  entityFilters?: InputMaybe<
    Array<MetricsV1ExposureCalculationSpecEntityFilterInput>
  >;
  entitySampling?: InputMaybe<MetricsV1EntitySamplingConfigInput>;
  exposureFilter?: InputMaybe<MetricsV1ExposureCalculationSpecExposureFilterInput>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<
    Array<MetricsV1ExposureCalculationSpecExposureFilterInput>
  >;
  groups?: InputMaybe<Array<MetricsV1ExposureCalculationGroupInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  splitDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MetricsV1ExposureCalculationState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
}

export type MetricsV1ExposureTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  dimensions: Array<MetricsV1Column>;
  displayName: Scalars['String']['output'];
  entity: MetricsV1EntityResult;
  entityIdColumn: MetricsV1Column;
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  error?: Maybe<MetricsV1OperationError>;
  exposedEntitiesMetric?: Maybe<Scalars['String']['output']>;
  exposureCalculation?: Maybe<MetricsV1ExposureCalculationResult>;
  exposureDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  exposureFilterColumn?: Maybe<MetricsV1Column>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  firstExposureTimeColumn: MetricsV1Column;
  firstExposureTruncation?: Maybe<MetricsV1TimeTruncation>;
  groupNameColumn: MetricsV1Column;
  labels: Array<MetricsV1ExposureTableLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ExposureTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ExposureTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ExposureTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ExposureTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableInput = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<MetricsV1ColumnInput>>;
  displayName: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  entityIdColumn: MetricsV1ColumnInput;
  entitySampling?: InputMaybe<MetricsV1EntitySamplingConfigInput>;
  exposureDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  exposureFilterColumn?: InputMaybe<MetricsV1ColumnInput>;
  firstExposureTimeColumn: MetricsV1ColumnInput;
  firstExposureTruncation?: InputMaybe<MetricsV1TimeTruncationInput>;
  groupNameColumn: MetricsV1ColumnInput;
  labels?: InputMaybe<Array<MetricsV1ExposureTableLabelsEntryInput>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql: Scalars['String']['input'];
};

export type MetricsV1ExposureTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ExposureTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExposureTableResult = Error | MetricsV1ExposureTable;

export type MetricsV1Expression = {
  and?: Maybe<MetricsV1ExpressionOperands>;
  not?: Maybe<MetricsV1Expression>;
  or?: Maybe<MetricsV1ExpressionOperands>;
  ref?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ExpressionInput = {
  and?: InputMaybe<MetricsV1ExpressionOperandsInput>;
  not?: InputMaybe<MetricsV1ExpressionInput>;
  or?: InputMaybe<MetricsV1ExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ExpressionOperands = {
  operands: Array<MetricsV1Expression>;
};

export type MetricsV1ExpressionOperandsInput = {
  operands: Array<MetricsV1ExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataDeliveredUntilUpdateStrategyConfig?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfig>;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions: Array<MetricsV1Column>;
  displayName: Scalars['String']['output'];
  entities: Array<MetricsV1EntityColumnMapping>;
  error?: Maybe<MetricsV1OperationError>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  labels: Array<MetricsV1FactTableLabelsEntry>;
  measures: Array<MetricsV1Measure>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  partitionedUpdateStrategyState?: Maybe<MetricsV1PartitionedUpdateStrategyState>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  source?: Maybe<MetricsV1MetricMetricSource>;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  timestampColumn: MetricsV1Column;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1FactTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1FactTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1FactTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1FactTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1FactTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableColumnsSuggestion = {
  dimensions: Array<Scalars['String']['output']>;
  entities: Array<MetricsV1EntityColumn>;
  measures: Array<Scalars['String']['output']>;
  timestampColumn: Scalars['String']['output'];
};

export type MetricsV1FactTableInput = {
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<MetricsV1ColumnInput>>;
  displayName: Scalars['String']['input'];
  entities: Array<MetricsV1EntityColumnMappingInput>;
  factDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1FactTableLabelsEntryInput>>;
  measures?: InputMaybe<Array<MetricsV1MeasureInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  skipSqlPreview?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<MetricsV1MetricMetricSourceInput>;
  sql: Scalars['String']['input'];
  timestampColumn: MetricsV1ColumnInput;
};

export type MetricsV1FactTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1FactTableLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FactTableResult = Error | MetricsV1FactTable;

export type MetricsV1FailedQueryResult = {
  error?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1Filter = {
  criteria: Array<MetricsV1FilterCriteriaEntry>;
  expression: MetricsV1Expression;
};

export type MetricsV1FilterCriteriaEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<MetricsV1FilterCriterion>;
};

export type MetricsV1FilterCriteriaEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<MetricsV1FilterCriterionInput>;
};

export type MetricsV1FilterCriterion = {
  attribute?: Maybe<MetricsV1FilterCriterionAttributeCriterion>;
};

export type MetricsV1FilterCriterionAttributeCriterion = {
  attribute: Scalars['String']['output'];
  eqRule?: Maybe<MetricsV1FilterEqRule>;
  likeRule?: Maybe<MetricsV1FilterLikeRule>;
  rangeRule?: Maybe<MetricsV1FilterRangeRule>;
  setRule?: Maybe<MetricsV1FilterSetRule>;
};

export type MetricsV1FilterCriterionAttributeCriterionInput = {
  attribute: Scalars['String']['input'];
  eqRule?: InputMaybe<MetricsV1FilterEqRuleInput>;
  likeRule?: InputMaybe<MetricsV1FilterLikeRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<MetricsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<MetricsV1FilterSetRuleInput>;
};

export type MetricsV1FilterCriterionInput = {
  attribute?: InputMaybe<MetricsV1FilterCriterionAttributeCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FilterEqRule = {
  value: MetricsV1FilterValue;
};

export type MetricsV1FilterEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value: MetricsV1FilterValueInput;
};

export type MetricsV1FilterInput = {
  criteria: Array<MetricsV1FilterCriteriaEntryInput>;
  expression: MetricsV1ExpressionInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FilterLikeRule = {
  pattern: Scalars['String']['output'];
};

export type MetricsV1FilterLikeRuleInput = {
  pattern: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FilterRangeRule = {
  endExclusive?: Maybe<MetricsV1FilterValue>;
  endInclusive?: Maybe<MetricsV1FilterValue>;
  startExclusive?: Maybe<MetricsV1FilterValue>;
  startInclusive?: Maybe<MetricsV1FilterValue>;
};

export type MetricsV1FilterRangeRuleInput = {
  endExclusive?: InputMaybe<MetricsV1FilterValueInput>;
  endInclusive?: InputMaybe<MetricsV1FilterValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<MetricsV1FilterValueInput>;
  startInclusive?: InputMaybe<MetricsV1FilterValueInput>;
};

export type MetricsV1FilterSetRule = {
  values: Array<MetricsV1FilterValue>;
};

export type MetricsV1FilterSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values: Array<MetricsV1FilterValueInput>;
};

export type MetricsV1FilterValue = {
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  nullValue?: Maybe<MetricsV1FilterValueNull>;
  numberValue?: Maybe<Scalars['Float']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  timestampValue?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1FilterValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  nullValue?: InputMaybe<MetricsV1FilterValueNullInput>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1FilterValueNull = {
  dummyField?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1FilterValueNullInput = {
  dummyField?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1JobStats = {
  bigQueryJobStats?: Maybe<MetricsV1BigQueryJobStats>;
  redshiftJobStats?: Maybe<MetricsV1RedshiftJobStats>;
};

export type MetricsV1ListAssignmentTablesResponse = {
  assignmentTables: Array<MetricsV1AssignmentTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListAssignmentTablesResponseResult =
  | Error
  | MetricsV1ListAssignmentTablesResponse;

export type MetricsV1ListContiguousPartitionsResponse = {
  contiguousPartitions: Array<MetricsV1ContiguousPartition>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListContiguousPartitionsResponseResult =
  | Error
  | MetricsV1ListContiguousPartitionsResponse;

export type MetricsV1ListDataWarehousesResponse = {
  dataWarehouses: Array<MetricsV1DataWarehouse>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListDataWarehousesResponseResult =
  | Error
  | MetricsV1ListDataWarehousesResponse;

export type MetricsV1ListDependenciesResponse = {
  dependencies: Array<MetricsV1Dependency>;
};

export type MetricsV1ListDependenciesResponseResult =
  | Error
  | MetricsV1ListDependenciesResponse;

export type MetricsV1ListDimensionTablesResponse = {
  dimensionTables: Array<MetricsV1DimensionTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListDimensionTablesResponseResult =
  | Error
  | MetricsV1ListDimensionTablesResponse;

export type MetricsV1ListEntitiesResponse = {
  entities: Array<MetricsV1Entity>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListEntitiesResponseResult =
  | Error
  | MetricsV1ListEntitiesResponse;

export type MetricsV1ListEntityIdentityBindingsResponse = {
  entityIdentityBindings: Array<MetricsV1EntityIdentityBinding>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListEntityIdentityBindingsResponseResult =
  | Error
  | MetricsV1ListEntityIdentityBindingsResponse;

export type MetricsV1ListEntityRelationTablesResponse = {
  entityRelationTables: Array<MetricsV1EntityRelationTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListEntityRelationTablesResponseResult =
  | Error
  | MetricsV1ListEntityRelationTablesResponse;

export type MetricsV1ListExposureCalculationsResponse = {
  exposureCalculations: Array<MetricsV1ExposureCalculation>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListExposureCalculationsResponseResult =
  | Error
  | MetricsV1ListExposureCalculationsResponse;

export type MetricsV1ListExposureTablesResponse = {
  exposureTables: Array<MetricsV1ExposureTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListExposureTablesResponseResult =
  | Error
  | MetricsV1ListExposureTablesResponse;

export type MetricsV1ListFactTablesResponse = {
  factTables: Array<MetricsV1FactTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListFactTablesResponseResult =
  | Error
  | MetricsV1ListFactTablesResponse;

export type MetricsV1ListMeasurementCalculationsResponse = {
  measurementCalculations: Array<MetricsV1MeasurementCalculation>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListMeasurementCalculationsResponseResult =
  | Error
  | MetricsV1ListMeasurementCalculationsResponse;

export type MetricsV1ListMeasurementTablesResponse = {
  measurementTables: Array<MetricsV1MeasurementTable>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListMeasurementTablesResponseResult =
  | Error
  | MetricsV1ListMeasurementTablesResponse;

export type MetricsV1ListMeasurementsResponse = {
  measurements: Array<MetricsV1Measurement>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  totalSize?: Maybe<Scalars['Int']['output']>;
};

export type MetricsV1ListMeasurementsResponseResult =
  | Error
  | MetricsV1ListMeasurementsResponse;

export type MetricsV1ListMetricCalculationsResponse = {
  metricCalculations: Array<MetricsV1MetricCalculation>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListMetricCalculationsResponseResult =
  | Error
  | MetricsV1ListMetricCalculationsResponse;

export type MetricsV1ListMetricsResponse = {
  metrics: Array<MetricsV1Metric>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ListMetricsResponseResult =
  | Error
  | MetricsV1ListMetricsResponse;

export type MetricsV1ListPartitionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  partitions: Array<MetricsV1Partition>;
};

export type MetricsV1ListPartitionsResponseResult =
  | Error
  | MetricsV1ListPartitionsResponse;

export type MetricsV1ListProcessRoundLogsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  processRoundLogs: Array<MetricsV1ProcessRoundLog>;
};

export type MetricsV1ListProcessRoundLogsResponseResult =
  | Error
  | MetricsV1ListProcessRoundLogsResponse;

export type MetricsV1ListRetriggersResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  retriggers: Array<MetricsV1Retrigger>;
};

export type MetricsV1ListRetriggersResponseResult =
  | Error
  | MetricsV1ListRetriggersResponse;

export type MetricsV1ListScheduledExposureCalculationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  scheduledExposureCalculations: Array<MetricsV1ScheduledExposureCalculation>;
};

export type MetricsV1ListScheduledExposureCalculationsResponseResult =
  | Error
  | MetricsV1ListScheduledExposureCalculationsResponse;

export type MetricsV1ListScheduledMeasurementCalculationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  scheduledMeasurementCalculations: Array<MetricsV1ScheduledMeasurementCalculation>;
};

export type MetricsV1ListScheduledMeasurementCalculationsResponseResult =
  | Error
  | MetricsV1ListScheduledMeasurementCalculationsResponse;

export type MetricsV1ListScheduledMetricCalculationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  scheduledMetricCalculations: Array<MetricsV1ScheduledMetricCalculation>;
};

export type MetricsV1ListScheduledMetricCalculationsResponseResult =
  | Error
  | MetricsV1ListScheduledMetricCalculationsResponse;

export type MetricsV1Measure = {
  column: MetricsV1Column;
  declaredType?: Maybe<MetricsV1ColumnType>;
  displayName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<MetricsV1Unit>;
};

export type MetricsV1MeasureInput = {
  column: MetricsV1ColumnInput;
  declaredType?: InputMaybe<MetricsV1ColumnType>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<MetricsV1UnitInput>;
};

export type MetricsV1Measurement = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  entity: MetricsV1EntityResult;
  etag?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable: MetricsV1FactTableResult;
  filter?: Maybe<MetricsV1Filter>;
  filterString?: Maybe<Scalars['String']['output']>;
  labels: Array<MetricsV1MeasurementLabelsEntry>;
  name: Scalars['String']['output'];
  nullHandling?: Maybe<MetricsV1MetricNullHandlingConfig>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<MetricsV1MetricMetricSource>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  typeSpec: MetricsV1MetricMetricTypeSpec;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1MeasurementAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MeasurementCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MeasurementQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  endTime: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1MeasurementCalculationLabelsEntry>;
  measurementCalculationSpec: MetricsV1MeasurementCalculationSpec;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retriggered?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schedule?: Maybe<MetricsV1ScheduledMeasurementCalculationResult>;
  scheduleIteration: Scalars['Int']['output'];
  sql?: Maybe<Scalars['String']['output']>;
  sqlJob?: Maybe<MetricsV1SqlJobResult>;
  startTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1MeasurementCalculationState>;
  supersededBy?: Maybe<MetricsV1MeasurementCalculationResult>;
  superseeds?: Maybe<MetricsV1MetricCalculationResult>;
  times: MetricsV1MeasurementCalculationTimes;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1MeasurementCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MeasurementCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MeasurementCalculationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MeasurementCalculationResult =
  | Error
  | MetricsV1MeasurementCalculation;

export type MetricsV1MeasurementCalculationSpec = {
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  exposureTable: MetricsV1ExposureTableResult;
  metric: MetricsV1MetricResult;
  splitDimensions: Array<MetricsV1MetricCalculationDimension>;
};

export enum MetricsV1MeasurementCalculationState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
}

export type MetricsV1MeasurementCalculationTimes = {
  exposureEndTime: Scalars['String']['output'];
  exposureStartTime: Scalars['String']['output'];
  factEndTime?: Maybe<Scalars['String']['output']>;
  factStartTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MeasurementInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  etag?: InputMaybe<Scalars['String']['input']>;
  factTable: Scalars['String']['input'];
  filter?: InputMaybe<MetricsV1FilterInput>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1MeasurementLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullHandling?: InputMaybe<MetricsV1MetricNullHandlingConfigInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetricsV1MetricMetricSourceInput>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  typeSpec: MetricsV1MetricMetricTypeSpecInput;
};

export type MetricsV1MeasurementLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MeasurementLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementResult = Error | MetricsV1Measurement;

export type MetricsV1MeasurementTable = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  entity: MetricsV1EntityResult;
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  error?: Maybe<MetricsV1OperationError>;
  exposureTable: MetricsV1ExposureTableResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable: MetricsV1FactTableResult;
  labels: Array<MetricsV1MeasurementTableLabelsEntry>;
  measurementDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  metric: MetricsV1MetricResult;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduledMeasurementCalculation?: Maybe<MetricsV1ScheduledMeasurementCalculationResult>;
  schemaValidationJob: MetricsV1SqlJobResult;
  sql: Scalars['String']['output'];
  state: MetricsV1TableState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1MeasurementTableAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementTableCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MeasurementTableCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MeasurementTableExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MeasurementTableQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTableReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTableResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTableReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MeasurementTableLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MeasurementTableResult = Error | MetricsV1MeasurementTable;

export type MetricsV1Metric = {
  /** @deprecated No longer supported */
  aggregationWindow?: Maybe<Scalars['String']['output']>;
  archiveInfo?: Maybe<MetricsV1MetricArchiveInfo>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  defaultEffectSize?: Maybe<GoogleTypeDecimal>;
  deleteTime?: Maybe<Scalars['String']['output']>;
  derivedUnit?: Maybe<MetricsV1MetricCompositeUnit>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  entity?: Maybe<MetricsV1EntityResult>;
  etag?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  exposureOffset?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  filter?: Maybe<MetricsV1Filter>;
  filterString?: Maybe<Scalars['String']['output']>;
  labels: Array<MetricsV1MetricLabelsEntry>;
  measurement?: Maybe<MetricsV1MeasurementResult>;
  measurementConfig?: Maybe<MetricsV1MetricMeasurementConfig>;
  name: Scalars['String']['output'];
  nullHandling?: Maybe<MetricsV1MetricNullHandlingConfig>;
  owner?: Maybe<IamV1IdentityResult>;
  preferredDirection?: Maybe<MetricsV1MetricPreferredDirection>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<MetricsV1MetricMetricSource>;
  state?: Maybe<MetricsV1MetricState>;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  typeSpec?: Maybe<MetricsV1MetricMetricTypeSpec>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  varianceReductionConfig?: Maybe<MetricsV1MetricVarianceReductionConfig>;
  verification?: Maybe<MetricsV1MetricMetricVerification>;
};

export type MetricsV1MetricAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MetricCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MetricQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricArchiveInfo = {
  archiveTime?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricArchiveInfoInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricAverageMetricSpec = {
  aggregation: MetricsV1Aggregation;
  measurement?: Maybe<MetricsV1Column>;
};

export type MetricsV1MetricAverageMetricSpecInput = {
  aggregation: MetricsV1AggregationInput;
  measurement?: InputMaybe<MetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricBucketStats = {
  dimensions: Array<MetricsV1DimensionValue>;
  summaryStats: MetricsV1SummaryStats;
  variant: Scalars['String']['output'];
};

export type MetricsV1MetricBucketStatsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  effectiveEntitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  endTime?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1MetricCalculationLabelsEntry>;
  metricCalculationSpec: MetricsV1MetricCalculationSpec;
  metricResults?: Maybe<MetricsV1MetricResults>;
  name: Scalars['String']['output'];
  outdatedSourceDataInfo?: Maybe<MetricsV1OutdatedSourceDataInfo>;
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryMetricCalculation?: Maybe<MetricsV1QueryMetricCalculationResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retriggered?: Maybe<Scalars['Boolean']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  scheduleIteration: Scalars['Int']['output'];
  sql?: Maybe<Scalars['String']['output']>;
  sqlJob?: Maybe<MetricsV1SqlJobResult>;
  startTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1MetricCalculationState>;
  supersededBy?: Maybe<MetricsV1MetricCalculationResult>;
  superseeds?: Maybe<MetricsV1MetricCalculationResult>;
  times: MetricsV1MetricCalculationTimes;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1MetricCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1MetricCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1MetricCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1MetricCalculationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationQueryMetricCalculationArgs = {
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  dimensionFilters?: InputMaybe<
    Array<MetricsV1QueryMetricCalculationRequestDimensionFiltersEntryInput>
  >;
  groupByDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationAvailableData = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricCalculationAvailableDataInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationDimension = {
  column: Scalars['String']['output'];
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
};

export type MetricsV1MetricCalculationDimensionInput = {
  column: Scalars['String']['input'];
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationEndTimeConfig = {
  availableData?: Maybe<MetricsV1MetricCalculationAvailableData>;
  exposureEndTime?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
};

export type MetricsV1MetricCalculationEndTimeConfigInput = {
  availableData?: InputMaybe<MetricsV1MetricCalculationAvailableDataInput>;
  exposureEndTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  endTimeConfig?: InputMaybe<MetricsV1MetricCalculationEndTimeConfigInput>;
  exposureEndTime?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1MetricCalculationLabelsEntryInput>>;
  metricCalculationSpec: MetricsV1MetricCalculationSpecInput;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type MetricsV1MetricCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricCalculationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCalculationResult =
  | Error
  | MetricsV1MetricCalculation;

export type MetricsV1MetricCalculationSpec = {
  entitySampling?: Maybe<MetricsV1EntitySamplingConfig>;
  exposureGroups: Array<Scalars['String']['output']>;
  exposureTable: MetricsV1ExposureTableResult;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  metric: MetricsV1MetricResult;
  scaleUpResults?: Maybe<Scalars['Boolean']['output']>;
  splitDimensions: Array<MetricsV1MetricCalculationDimension>;
};

export type MetricsV1MetricCalculationSpecInput = {
  entitySampling?: InputMaybe<MetricsV1EntitySamplingConfigInput>;
  exposureGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  exposureTable: Scalars['String']['input'];
  measurementTable?: InputMaybe<Scalars['String']['input']>;
  metric: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scaleUpResults?: InputMaybe<Scalars['Boolean']['input']>;
  splitDimensions?: InputMaybe<Array<MetricsV1MetricCalculationDimensionInput>>;
};

export enum MetricsV1MetricCalculationState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
}

export type MetricsV1MetricCalculationTimes = {
  exposureEndTime: Scalars['String']['output'];
  exposureStartTime: Scalars['String']['output'];
  factEndTime: Scalars['String']['output'];
  factStartTime: Scalars['String']['output'];
};

export type MetricsV1MetricCalculationTimesInput = {
  exposureEndTime: Scalars['String']['input'];
  exposureStartTime: Scalars['String']['input'];
  factEndTime: Scalars['String']['input'];
  factStartTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricCompositeUnit = {
  denominator?: Maybe<MetricsV1Unit>;
  numerator: MetricsV1Unit;
};

export type MetricsV1MetricCompositeUnitInput = {
  denominator?: InputMaybe<MetricsV1UnitInput>;
  numerator: MetricsV1UnitInput;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricInput = {
  aggregationWindow?: InputMaybe<Scalars['String']['input']>;
  defaultEffectSize?: InputMaybe<GoogleTypeDecimalInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  entity?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MetricsV1FilterInput>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MetricsV1MetricLabelsEntryInput>>;
  measurement?: InputMaybe<Scalars['String']['input']>;
  measurementConfig?: InputMaybe<MetricsV1MetricMeasurementConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullHandling?: InputMaybe<MetricsV1MetricNullHandlingConfigInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<MetricsV1MetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MetricsV1MetricMetricSourceInput>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  typeSpec?: InputMaybe<MetricsV1MetricMetricTypeSpecInput>;
  varianceReductionConfig?: InputMaybe<MetricsV1MetricVarianceReductionConfigInput>;
};

export type MetricsV1MetricLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricMeasurementConfig = {
  closedWindow?: Maybe<MetricsV1MetricMeasurementConfigClosedWindowConfig>;
  openWindow?: Maybe<MetricsV1MetricMeasurementConfigOpenWindowConfig>;
  semiOpenWindow?: Maybe<MetricsV1MetricMeasurementConfigSemiOpenWindowConfig>;
};

export type MetricsV1MetricMeasurementConfigClosedWindowConfig = {
  aggregationWindow: Scalars['String']['output'];
  exposureOffset: Scalars['String']['output'];
};

export type MetricsV1MetricMeasurementConfigClosedWindowConfigInput = {
  aggregationWindow: Scalars['String']['input'];
  exposureOffset: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricMeasurementConfigInput = {
  closedWindow?: InputMaybe<MetricsV1MetricMeasurementConfigClosedWindowConfigInput>;
  openWindow?: InputMaybe<MetricsV1MetricMeasurementConfigOpenWindowConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semiOpenWindow?: InputMaybe<MetricsV1MetricMeasurementConfigSemiOpenWindowConfigInput>;
};

export type MetricsV1MetricMeasurementConfigOpenWindowConfig = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricMeasurementConfigOpenWindowConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricMeasurementConfigSemiOpenWindowConfig = {
  aggregationWindow: Scalars['String']['output'];
  exposureOffset?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricMeasurementConfigSemiOpenWindowConfigInput = {
  aggregationWindow: Scalars['String']['input'];
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricMetricSource = {
  reference?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MetricsV1MetricMetricSourceType>;
};

export type MetricsV1MetricMetricSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MetricsV1MetricMetricSourceType>;
};

export enum MetricsV1MetricMetricSourceType {
  Api = 'API',
  Repository = 'REPOSITORY',
}

export type MetricsV1MetricMetricTypeSpec = {
  averageMetricSpec?: Maybe<MetricsV1MetricAverageMetricSpec>;
  quantileMetricSpec?: Maybe<MetricsV1MetricQuantileMetricSpec>;
  ratioMetricSpec?: Maybe<MetricsV1MetricRatioMetricSpec>;
};

export type MetricsV1MetricMetricTypeSpecInput = {
  averageMetricSpec?: InputMaybe<MetricsV1MetricAverageMetricSpecInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileMetricSpec?: InputMaybe<MetricsV1MetricQuantileMetricSpecInput>;
  ratioMetricSpec?: InputMaybe<MetricsV1MetricRatioMetricSpecInput>;
};

export type MetricsV1MetricMetricVerification = {
  state?: Maybe<MetricsV1MetricMetricVerificationVerificationState>;
  verifier?: Maybe<IamV1IdentityResult>;
  verifyTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1MetricMetricVerificationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  verifier?: InputMaybe<Scalars['String']['input']>;
  verifyTime?: InputMaybe<Scalars['String']['input']>;
};

export enum MetricsV1MetricMetricVerificationVerificationState {
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED',
}

export type MetricsV1MetricNullHandlingConfig = {
  replaceEntityNullWithZero?: Maybe<Scalars['Boolean']['output']>;
  replaceMeasureNullWithZero?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1MetricNullHandlingConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  replaceEntityNullWithZero?: InputMaybe<Scalars['Boolean']['input']>;
  replaceMeasureNullWithZero?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MetricsV1MetricPreferredDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MetricsV1MetricQuantileMetricSpec = {
  aggregation: MetricsV1Aggregation;
  measurement?: Maybe<MetricsV1Column>;
  quantileLevel: Scalars['Float']['output'];
};

export type MetricsV1MetricQuantileMetricSpecInput = {
  aggregation: MetricsV1AggregationInput;
  measurement?: InputMaybe<MetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileLevel: Scalars['Float']['input'];
};

export type MetricsV1MetricRatioMetricSpec = {
  denominator?: Maybe<MetricsV1Column>;
  denominatorAggregation: MetricsV1Aggregation;
  denominatorFilter?: Maybe<MetricsV1Filter>;
  numerator?: Maybe<MetricsV1Column>;
  numeratorAggregation: MetricsV1Aggregation;
  numeratorFilter?: Maybe<MetricsV1Filter>;
};

export type MetricsV1MetricRatioMetricSpecInput = {
  denominator?: InputMaybe<MetricsV1ColumnInput>;
  denominatorAggregation: MetricsV1AggregationInput;
  denominatorFilter?: InputMaybe<MetricsV1FilterInput>;
  numerator?: InputMaybe<MetricsV1ColumnInput>;
  numeratorAggregation: MetricsV1AggregationInput;
  numeratorFilter?: InputMaybe<MetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricResult = Error | MetricsV1Metric;

export type MetricsV1MetricResults = {
  metricBucketStats: Array<MetricsV1MetricBucketStats>;
};

export type MetricsV1MetricResultsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1MetricRow = {
  aggCount?: Maybe<Scalars['Int']['output']>;
  dimensions: Array<MetricsV1MetricRowDimensionsEntry>;
  value?: Maybe<MetricsV1SummaryStats>;
};

export type MetricsV1MetricRowDimensionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum MetricsV1MetricState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
}

export type MetricsV1MetricVarianceReductionConfig = {
  aggregationWindowOverride?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1MetricVarianceReductionConfigInput = {
  aggregationWindowOverride?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1OperationError = {
  details: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1OperationErrorInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1OutdatedSourceDataInfo = {
  actualCount: Scalars['Long']['output'];
  expectedCount: Scalars['Long']['output'];
  queryEndTime: Scalars['String']['output'];
  queryStartTime: Scalars['String']['output'];
  table: Scalars['String']['output'];
};

export type MetricsV1OutdatedSourceDataInfoInput = {
  actualCount: Scalars['Long']['input'];
  expectedCount: Scalars['Long']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  queryEndTime: Scalars['String']['input'];
  queryStartTime: Scalars['String']['input'];
  table: Scalars['String']['input'];
};

export type MetricsV1Partition = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  endTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  info?: Maybe<MetricsV1PartitionPartitionInfo>;
  labels: Array<MetricsV1PartitionLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  startTime: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1PartitionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1PartitionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1PartitionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1PartitionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1PartitionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionInput = {
  endTime: Scalars['String']['input'];
  info?: InputMaybe<MetricsV1PartitionPartitionInfoInput>;
  labels?: InputMaybe<Array<MetricsV1PartitionLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type MetricsV1PartitionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PartitionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1PartitionPartitionInfo = {
  maxTime: Scalars['String']['output'];
  minTime: Scalars['String']['output'];
  rowCount: Scalars['Long']['output'];
};

export type MetricsV1PartitionPartitionInfoInput = {
  maxTime: Scalars['String']['input'];
  minTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rowCount: Scalars['Long']['input'];
};

export type MetricsV1PartitionResult = Error | MetricsV1Partition;

export type MetricsV1PartitionedTimestampUpdateProcessRoundResult = {
  state?: Maybe<MetricsV1PartitionedUpdateStrategyState>;
  updatedDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PartitionedUpdateStrategyState = {
  count?: Maybe<Scalars['Long']['output']>;
  currentPartitionLastCheckTime?: Maybe<Scalars['String']['output']>;
  existsCheckDuration?: Maybe<Scalars['String']['output']>;
  state?: Maybe<MetricsV1PartitionedUpdateStrategyStateState>;
  usualLateness?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PartitionedUpdateStrategyStateInput = {
  count?: InputMaybe<Scalars['Long']['input']>;
  currentPartitionLastCheckTime?: InputMaybe<Scalars['String']['input']>;
  existsCheckDuration?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  usualLateness?: InputMaybe<Scalars['String']['input']>;
};

export enum MetricsV1PartitionedUpdateStrategyStateState {
  NextPartitionIsInTheFuture = 'NEXT_PARTITION_IS_IN_THE_FUTURE',
  PartitionsUsuallyArriveLater = 'PARTITIONS_USUALLY_ARRIVE_LATER',
  PartitionDoesNotExist = 'PARTITION_DOES_NOT_EXIST',
}

export type MetricsV1PendingQueryResult = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PreviewSqlQueryResponse = {
  job?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1PreviewSqlQueryResponseResult =
  | Error
  | MetricsV1PreviewSqlQueryResponse;

export type MetricsV1ProcessRoundLog = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  partition?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  /** @deprecated No longer supported */
  result?: Maybe<MetricsV1PartitionedTimestampUpdateProcessRoundResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sqlJob?: Maybe<MetricsV1SqlJobResult>;
  table: Scalars['String']['output'];
  timestamp?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResult>;
  verificationState: MetricsV1ProcessRoundLogVerificationState;
  /** @deprecated No longer supported */
  watermarkState?: Maybe<MetricsV1WatermarkState>;
};

export type MetricsV1ProcessRoundLogAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ProcessRoundLogCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ProcessRoundLogCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ProcessRoundLogExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ProcessRoundLogQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ProcessRoundLogReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ProcessRoundLogResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ProcessRoundLogReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ProcessRoundLogPartitionCheckResult = {
  partitionArrivesLater?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultPartitionArrivesLater>;
  partitionCommitted?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultPartitionCommitted>;
  partitionError?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultPartitionError>;
  partitionNotCommitted?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultPartitionNotCommitted>;
  partitionTime?: Maybe<Scalars['String']['output']>;
};

export enum MetricsV1ProcessRoundLogPartitionCheckResultNoCommitReason {
  NoCommitReasonEmptyNotAllowed = 'NO_COMMIT_REASON_EMPTY_NOT_ALLOWED',
  NoCommitReasonEmptyWithinMaxWaitTime = 'NO_COMMIT_REASON_EMPTY_WITHIN_MAX_WAIT_TIME',
}

export type MetricsV1ProcessRoundLogPartitionCheckResultPartitionArrivesLater =
  {
    expectedArrivalTime?: Maybe<Scalars['String']['output']>;
    usualLateness?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1ProcessRoundLogPartitionCheckResultPartitionCommitted = {
  count?: Maybe<Scalars['Long']['output']>;
  maxWaitTimeReached?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1ProcessRoundLogPartitionCheckResultPartitionError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ProcessRoundLogPartitionCheckResultPartitionNotCommitted =
  {
    noCommitReason?: Maybe<MetricsV1ProcessRoundLogPartitionCheckResultNoCommitReason>;
  };

export type MetricsV1ProcessRoundLogResult = Error | MetricsV1ProcessRoundLog;

export type MetricsV1ProcessRoundLogTimestampCheckResult = {
  currentDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  dataCommitted?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResultDataCommitted>;
  dataError?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResultDataError>;
  dataPendingCommit?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResultDataPendingCommit>;
  newDataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ProcessRoundLogTimestampCheckResultDataCommitted = {
  count?: Maybe<Scalars['Long']['output']>;
};

export type MetricsV1ProcessRoundLogTimestampCheckResultDataError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ProcessRoundLogTimestampCheckResultDataPendingCommit = {
  currentCount?: Maybe<Scalars['Long']['output']>;
  newDataDeliveredUntil?: Maybe<Scalars['Boolean']['output']>;
  noCommitReason?: Maybe<MetricsV1ProcessRoundLogTimestampCheckResultNoCommitReason>;
  previousCount?: Maybe<Scalars['Long']['output']>;
};

export enum MetricsV1ProcessRoundLogTimestampCheckResultNoCommitReason {
  NoCommitReasonCommitTimeNotReached = 'NO_COMMIT_REASON_COMMIT_TIME_NOT_REACHED',
  NoCommitReasonOutsideCommitThreshold = 'NO_COMMIT_REASON_OUTSIDE_COMMIT_THRESHOLD',
}

export enum MetricsV1ProcessRoundLogVerificationState {
  Error = 'ERROR',
  Failed = 'FAILED',
  Passed = 'PASSED',
  VerificationNotNeeded = 'VERIFICATION_NOT_NEEDED',
  VerificationPending = 'VERIFICATION_PENDING',
}

export type MetricsV1QueryAvailableTimeRangeResponse = {
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type MetricsV1QueryAvailableTimeRangeResponseResult =
  | Error
  | MetricsV1QueryAvailableTimeRangeResponse;

export enum MetricsV1QueryDataWarehouseStatsRequestStatsInterval {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
}

export type MetricsV1QueryDataWarehouseStatsResponse = {
  stats: Array<MetricsV1DataWarehouseStatsEntry>;
};

export type MetricsV1QueryDataWarehouseStatsResponseResult =
  | Error
  | MetricsV1QueryDataWarehouseStatsResponse;

export type MetricsV1QueryMetricCalculationRequestDimensionFiltersEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<MetricsV1DimensionFilterInput>;
};

export type MetricsV1QueryMetricCalculationResponse = {
  dimensions: Array<Scalars['String']['output']>;
  rows: Array<MetricsV1MetricRow>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1QueryMetricCalculationResponseResult =
  | Error
  | MetricsV1QueryMetricCalculationResponse;

export type MetricsV1QueryScheduledMetricCalculationRequestDimensionFiltersEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<MetricsV1DimensionFilterInput>;
  };

export type MetricsV1QueryScheduledMetricCalculationResponse = {
  dimensions: Array<Scalars['String']['output']>;
  maxStartTime?: Maybe<Scalars['String']['output']>;
  minStartTime?: Maybe<Scalars['String']['output']>;
  rows: Array<MetricsV1MetricRow>;
};

export type MetricsV1QueryScheduledMetricCalculationResponseResult =
  | Error
  | MetricsV1QueryScheduledMetricCalculationResponse;

export type MetricsV1RedshiftConfig = {
  cluster: Scalars['String']['output'];
  credentialsSettings?: Maybe<MetricsV1RedshiftConfigCredentialsAuthenticationSettings>;
  dataApiEndpoint?: Maybe<Scalars['String']['output']>;
  database: Scalars['String']['output'];
  exposureSchema?: Maybe<Scalars['String']['output']>;
  region: MetricsV1AwsRegion;
  roleArn: Scalars['String']['output'];
  webIdentitySettings?: Maybe<MetricsV1RedshiftConfigWebIdentityAuthenticationSettings>;
};

export type MetricsV1RedshiftConfigCredentialsAuthenticationSettings = {
  accessKeyId: Scalars['String']['output'];
};

export type MetricsV1RedshiftConfigCredentialsAuthenticationSettingsInput = {
  accessKeyId: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secretAccessKey?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RedshiftConfigInput = {
  cluster: Scalars['String']['input'];
  credentialsSettings?: InputMaybe<MetricsV1RedshiftConfigCredentialsAuthenticationSettingsInput>;
  dataApiEndpoint?: InputMaybe<Scalars['String']['input']>;
  database: Scalars['String']['input'];
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region: MetricsV1AwsRegion;
  roleArn: Scalars['String']['input'];
  webIdentitySettings?: InputMaybe<MetricsV1RedshiftConfigWebIdentityAuthenticationSettingsInput>;
};

export type MetricsV1RedshiftConfigWebIdentityAuthenticationSettings = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1RedshiftConfigWebIdentityAuthenticationSettingsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RedshiftJobStats = {
  duration?: Maybe<Scalars['String']['output']>;
  resultSizeBytes?: Maybe<Scalars['Long']['output']>;
};

export type MetricsV1Retrigger = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  completeTime?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  currentTime: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<MetricsV1RetriggerLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  targetTime: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1RetriggerAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1RetriggerCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1RetriggerCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1RetriggerExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1RetriggerQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RetriggerReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RetriggerResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RetriggerReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1RetriggerAllScheduledMetricCalculationsResponse = {
  retriggerInfo?: Maybe<MetricsV1ScheduledMetricCalculationRetriggerInfo>;
};

export type MetricsV1RetriggerAllScheduledMetricCalculationsResponseResult =
  | Error
  | MetricsV1RetriggerAllScheduledMetricCalculationsResponse;

export type MetricsV1RetriggerLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1RetriggerResult = Error | MetricsV1Retrigger;

export type MetricsV1SampleRow = {
  values: Array<MetricsV1SampleRowValuesEntry>;
};

export type MetricsV1SampleRowValuesEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1SampleRows = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  failedQueryResult?: Maybe<MetricsV1FailedQueryResult>;
  name: MetricsV1SqlJobResult;
  pendingQueryResult?: Maybe<MetricsV1PendingQueryResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sampleRows: Array<MetricsV1SampleRow>;
  successfulQueryResult?: Maybe<MetricsV1SuccessfulQueryResult>;
};

export type MetricsV1SampleRowsAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SampleRowsCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1SampleRowsCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SampleRowsExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1SampleRowsQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SampleRowsReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SampleRowsResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SampleRowsReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SampleRowsResult = Error | MetricsV1SampleRows;

export type MetricsV1ScheduledExposureCalculation = {
  activeRetrigger?: Maybe<MetricsV1RetriggerResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entity: MetricsV1EntityResult;
  executedCalculationsCount: Scalars['Int']['output'];
  exposedEntitiesMetric?: Maybe<MetricsV1MetricResult>;
  exposedEntitiesMetricSchedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  exposureCalculationSpec: MetricsV1ExposureCalculationSpec;
  exposureCalculations?: Maybe<MetricsV1ListExposureCalculationsResponseResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  iteration: Scalars['Int']['output'];
  labels: Array<MetricsV1ScheduledExposureCalculationLabelsEntry>;
  name: Scalars['String']['output'];
  nextAssignmentEndTime: Scalars['String']['output'];
  nextAssignmentStartTime: Scalars['String']['output'];
  nextScheduledRunTime: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleEndTime?: Maybe<Scalars['String']['output']>;
  scheduleIntervals: Array<Scalars['String']['output']>;
  scheduleStartTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1ScheduledExposureCalculationState>;
  status: MetricsV1ScheduledExposureCalculationStatus;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ScheduledExposureCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledExposureCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ScheduledExposureCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledExposureCalculationExposureCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ScheduledExposureCalculationQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledExposureCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  exposureCalculationSpec: MetricsV1ExposureCalculationSpecInput;
  labels?: InputMaybe<
    Array<MetricsV1ScheduledExposureCalculationLabelsEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals: Array<Scalars['String']['input']>;
  scheduleStartTime: Scalars['String']['input'];
};

export type MetricsV1ScheduledExposureCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ScheduledExposureCalculationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationResult =
  | Error
  | MetricsV1ScheduledExposureCalculation;

export enum MetricsV1ScheduledExposureCalculationState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
}

export type MetricsV1ScheduledExposureCalculationStatus = {
  calculating?: Maybe<MetricsV1ScheduledExposureCalculationStatusCalculating>;
  cancelled?: Maybe<MetricsV1ScheduledExposureCalculationStatusCancelled>;
  error?: Maybe<MetricsV1ScheduledExposureCalculationStatusError>;
  scheduled?: Maybe<MetricsV1ScheduledExposureCalculationStatusScheduled>;
  waiting?: Maybe<MetricsV1ScheduledExposureCalculationStatusWaiting>;
};

export type MetricsV1ScheduledExposureCalculationStatusCalculating = {
  exposureCalculation: MetricsV1ExposureCalculationResult;
};

export type MetricsV1ScheduledExposureCalculationStatusCalculatingInput = {
  exposureCalculation: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationStatusCancelled = {
  cancelledTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledExposureCalculationStatusCancelledInput = {
  cancelledTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationStatusError = {
  errorMessage: Scalars['String']['output'];
};

export type MetricsV1ScheduledExposureCalculationStatusErrorInput = {
  errorMessage: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationStatusInput = {
  calculating?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusCalculatingInput>;
  cancelled?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusCancelledInput>;
  error?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusErrorInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusScheduledInput>;
  waiting?: InputMaybe<MetricsV1ScheduledExposureCalculationStatusWaitingInput>;
};

export type MetricsV1ScheduledExposureCalculationStatusScheduled = {
  nextScheduleTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledExposureCalculationStatusScheduledInput = {
  nextScheduleTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledExposureCalculationStatusWaiting = {
  assignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  dataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  needDataUntilTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledExposureCalculationStatusWaitingInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  needDataUntilTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculation = {
  activeRetrigger?: Maybe<MetricsV1RetriggerResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  executedCalculationsCount: Scalars['Int']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  iteration: Scalars['Int']['output'];
  labels: Array<MetricsV1ScheduledMeasurementCalculationLabelsEntry>;
  measurementCalculationSpec: MetricsV1MeasurementCalculationSpec;
  measurementCalculations?: Maybe<MetricsV1ListMeasurementCalculationsResponseResult>;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  name: Scalars['String']['output'];
  nextExposureEndTime: Scalars['String']['output'];
  nextExposureStartTime: Scalars['String']['output'];
  nextScheduledRunTime: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleEndTime?: Maybe<Scalars['String']['output']>;
  scheduleIntervals: Array<Scalars['String']['output']>;
  scheduleStartTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1ScheduledMeasurementCalculationState>;
  status: MetricsV1ScheduledMeasurementCalculationStatus;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ScheduledMeasurementCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type MetricsV1ScheduledMeasurementCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ScheduledMeasurementCalculationMeasurementCalculationsArgs =
  {
    filter?: InputMaybe<Scalars['String']['input']>;
    orderBy?: InputMaybe<Scalars['String']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMeasurementCalculationQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMeasurementCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMeasurementCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ScheduledMeasurementCalculationResult =
  | Error
  | MetricsV1ScheduledMeasurementCalculation;

export enum MetricsV1ScheduledMeasurementCalculationState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
}

export type MetricsV1ScheduledMeasurementCalculationStatus = {
  calculating?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusCalculating>;
  cancelled?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusCancelled>;
  error?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusError>;
  scheduled?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusScheduled>;
  waiting?: Maybe<MetricsV1ScheduledMeasurementCalculationStatusWaiting>;
};

export type MetricsV1ScheduledMeasurementCalculationStatusCalculating = {
  measurementCalculation: MetricsV1MeasurementCalculationResult;
};

export type MetricsV1ScheduledMeasurementCalculationStatusCancelled = {
  cancelledTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMeasurementCalculationStatusError = {
  errorMessage: Scalars['String']['output'];
};

export type MetricsV1ScheduledMeasurementCalculationStatusScheduled = {
  nextScheduleTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMeasurementCalculationStatusWaiting = {
  dataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  needDataUntilTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculation = {
  activeRetrigger?: Maybe<MetricsV1RetriggerResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  executedCalculationsCount: Scalars['Int']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  iteration: Scalars['Int']['output'];
  labels: Array<MetricsV1ScheduledMetricCalculationLabelsEntry>;
  latestCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  metricCalculationSpec: MetricsV1MetricCalculationSpec;
  metricCalculations?: Maybe<MetricsV1ListMetricCalculationsResponseResult>;
  name: Scalars['String']['output'];
  nextExposureEndTime: Scalars['String']['output'];
  nextExposureStartTime: Scalars['String']['output'];
  nextScheduledRunTime: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  queryScheduledMetricCalculation?: Maybe<MetricsV1QueryScheduledMetricCalculationResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  scheduleEndTime?: Maybe<Scalars['String']['output']>;
  scheduleIntervals: Array<Scalars['String']['output']>;
  scheduleStartTime: Scalars['String']['output'];
  state?: Maybe<MetricsV1ScheduledMetricCalculationState>;
  status: MetricsV1ScheduledMetricCalculationStatus;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1ScheduledMetricCalculationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1ScheduledMetricCalculationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1ScheduledMetricCalculationMetricCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationQueryScheduledMetricCalculationArgs =
  {
    accumulateDimension?: InputMaybe<Scalars['String']['input']>;
    dimensionFilters?: InputMaybe<
      Array<MetricsV1QueryScheduledMetricCalculationRequestDimensionFiltersEntryInput>
    >;
    endTime?: InputMaybe<Scalars['String']['input']>;
    groupByDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
    includeAllCombinations?: InputMaybe<Scalars['Boolean']['input']>;
    startTime?: InputMaybe<Scalars['String']['input']>;
    timeZone?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMetricCalculationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationInput = {
  labels?: InputMaybe<
    Array<MetricsV1ScheduledMetricCalculationLabelsEntryInput>
  >;
  metricCalculationSpec: MetricsV1MetricCalculationSpecInput;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals: Array<Scalars['String']['input']>;
  scheduleStartTime: Scalars['String']['input'];
};

export type MetricsV1ScheduledMetricCalculationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ScheduledMetricCalculationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationResult =
  | Error
  | MetricsV1ScheduledMetricCalculation;

export type MetricsV1ScheduledMetricCalculationRetriggerInfo = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retriggerInfoItems: Array<Scalars['String']['output']>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type MetricsV1ScheduledMetricCalculationRetriggerInfoCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoExternalDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1ExternalDocumentView>;
  };

export type MetricsV1ScheduledMetricCalculationRetriggerInfoQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMetricCalculationRetriggerInfoReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationRetriggerInfoResourcePermissionsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1ScheduledMetricCalculationRetriggerInfoReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export enum MetricsV1ScheduledMetricCalculationState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
}

export type MetricsV1ScheduledMetricCalculationStatus = {
  calculating?: Maybe<MetricsV1ScheduledMetricCalculationStatusCalculating>;
  cancelled?: Maybe<MetricsV1ScheduledMetricCalculationStatusCancelled>;
  error?: Maybe<MetricsV1ScheduledMetricCalculationStatusError>;
  scheduled?: Maybe<MetricsV1ScheduledMetricCalculationStatusScheduled>;
  waiting?: Maybe<MetricsV1ScheduledMetricCalculationStatusWaiting>;
};

export type MetricsV1ScheduledMetricCalculationStatusCalculating = {
  metricCalculation: MetricsV1MetricCalculationResult;
};

export type MetricsV1ScheduledMetricCalculationStatusCalculatingInput = {
  metricCalculation: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationStatusCancelled = {
  cancelledTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculationStatusCancelledInput = {
  cancelledTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationStatusError = {
  errorMessage: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculationStatusErrorInput = {
  errorMessage: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationStatusInput = {
  calculating?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusCalculatingInput>;
  cancelled?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusCancelledInput>;
  error?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusErrorInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusScheduledInput>;
  waiting?: InputMaybe<MetricsV1ScheduledMetricCalculationStatusWaitingInput>;
};

export type MetricsV1ScheduledMetricCalculationStatusScheduled = {
  nextScheduleTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculationStatusScheduledInput = {
  nextScheduleTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ScheduledMetricCalculationStatusWaiting = {
  dataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  needDataUntilTime: Scalars['String']['output'];
};

export type MetricsV1ScheduledMetricCalculationStatusWaitingInput = {
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  measurementTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SnowflakeConfig = {
  account: Scalars['String']['output'];
  authenticationKey: IamV1CryptoKeyResult;
  exposureDatabase: Scalars['String']['output'];
  exposureSchema: Scalars['String']['output'];
  role: Scalars['String']['output'];
  user: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type MetricsV1SnowflakeConfigInput = {
  account: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  exposureDatabase: Scalars['String']['input'];
  exposureSchema: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  user: Scalars['String']['input'];
  warehouse: Scalars['String']['input'];
};

export type MetricsV1SqlJob = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  failedQueryResult?: Maybe<MetricsV1FailedQueryResult>;
  labels: Array<MetricsV1SqlJobLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  pendingQueryResult?: Maybe<MetricsV1PendingQueryResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state?: Maybe<MetricsV1SqlJobState>;
  successfulQueryResult?: Maybe<MetricsV1SuccessfulQueryResult>;
  triggeringResource?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MetricsV1SqlJobType>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type MetricsV1SqlJobAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SqlJobCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type MetricsV1SqlJobCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetricsV1SqlJobExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type MetricsV1SqlJobQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SqlJobReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SqlJobResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SqlJobReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SqlJobLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1SqlJobResult = Error | MetricsV1SqlJob;

export enum MetricsV1SqlJobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PendingRetry = 'PENDING_RETRY',
  Running = 'RUNNING',
  Throttled = 'THROTTLED',
}

export enum MetricsV1SqlJobType {
  Count = 'COUNT',
  CreateTable = 'CREATE_TABLE',
  DescribeAssignmentsTable = 'DESCRIBE_ASSIGNMENTS_TABLE',
  Execute = 'EXECUTE',
  Exists = 'EXISTS',
  ExposureCalculation = 'EXPOSURE_CALCULATION',
  MeasurementCalculation = 'MEASUREMENT_CALCULATION',
  MetricCalculation = 'METRIC_CALCULATION',
  Preview = 'PREVIEW',
  Truncate = 'TRUNCATE',
}

export type MetricsV1SuccessfulQueryResult = {
  issues: Array<MetricsV1ColumnIssue>;
  jobStats?: Maybe<MetricsV1JobStats>;
  schema: Array<MetricsV1Column>;
  tableIssues: Array<MetricsV1TableIssue>;
};

export type MetricsV1SuggestFactTableColumnsResponse = {
  error?: Maybe<Scalars['String']['output']>;
  suggestion?: Maybe<MetricsV1FactTableColumnsSuggestion>;
};

export type MetricsV1SuggestFactTableColumnsResponseResult =
  | Error
  | MetricsV1SuggestFactTableColumnsResponse;

export type MetricsV1SuggestMetricResponse = {
  error?: Maybe<Scalars['String']['output']>;
  metric?: Maybe<MetricsV1Metric>;
};

export type MetricsV1SuggestMetricResponseResult =
  | Error
  | MetricsV1SuggestMetricResponse;

export type MetricsV1SummaryStats = {
  averageSummaryStats?: Maybe<MetricsV1SummaryStatsAverageSummaryStats>;
  quantileSummaryStats?: Maybe<MetricsV1SummaryStatsQuantileSummaryStats>;
  ratioSummaryStats?: Maybe<MetricsV1SummaryStatsRatioSummaryStats>;
};

export type MetricsV1SummaryStatsAverageSummaryStats = {
  count?: Maybe<Scalars['Long']['output']>;
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  sumOfSquares?: Maybe<Scalars['Float']['output']>;
  summaryStatsInfo?: Maybe<MetricsV1SummaryStatsSummaryStatsInfo>;
  variance?: Maybe<Scalars['Float']['output']>;
  varianceReductionStats?: Maybe<MetricsV1SummaryStatsAverageSummaryStatsVarianceReductionStats>;
};

export type MetricsV1SummaryStatsAverageSummaryStatsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SummaryStatsAverageSummaryStatsVarianceReductionStats = {
  count?: Maybe<Scalars['Long']['output']>;
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  covariance?: Maybe<Scalars['Float']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  postCount?: Maybe<Scalars['Long']['output']>;
  postSum?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  sumOfProducts?: Maybe<Scalars['Float']['output']>;
  sumOfSquares?: Maybe<Scalars['Float']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
};

export type MetricsV1SummaryStatsAverageSummaryStatsVarianceReductionStatsInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1SummaryStatsInput = {
  averageSummaryStats?: InputMaybe<MetricsV1SummaryStatsAverageSummaryStatsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileSummaryStats?: InputMaybe<MetricsV1SummaryStatsQuantileSummaryStatsInput>;
  ratioSummaryStats?: InputMaybe<MetricsV1SummaryStatsRatioSummaryStatsInput>;
};

export type MetricsV1SummaryStatsQuantileSummaryStats = {
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  indicatorObservationSumOfProducts?: Maybe<Scalars['Long']['output']>;
  indicatorSum?: Maybe<Scalars['Long']['output']>;
  indicatorSumOfSquares?: Maybe<Scalars['Long']['output']>;
  observationCount?: Maybe<Scalars['Long']['output']>;
  observationCountSumOfSquares?: Maybe<Scalars['Long']['output']>;
  quantileLevel?: Maybe<Scalars['Float']['output']>;
  sumLogValue?: Maybe<Scalars['Float']['output']>;
  sumLogValueSquared?: Maybe<Scalars['Float']['output']>;
  userCount?: Maybe<Scalars['Long']['output']>;
  varianceReductionStats?: Maybe<MetricsV1SummaryStatsQuantileSummaryStatsQuantileVarianceReductionStats>;
};

export type MetricsV1SummaryStatsQuantileSummaryStatsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SummaryStatsQuantileSummaryStatsQuantileVarianceReductionStats =
  {
    covariateSum?: Maybe<Scalars['Float']['output']>;
    covariateSumOfSquares?: Maybe<Scalars['Float']['output']>;
    indicatorCovariateSumOfProducts?: Maybe<Scalars['Float']['output']>;
    observationCovariateSumOfProducts?: Maybe<Scalars['Float']['output']>;
  };

export type MetricsV1SummaryStatsQuantileSummaryStatsQuantileVarianceReductionStatsInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1SummaryStatsRatioSummaryStats = {
  count?: Maybe<Scalars['Long']['output']>;
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  denominatorMean?: Maybe<Scalars['Float']['output']>;
  denominatorSum?: Maybe<Scalars['Float']['output']>;
  denominatorSumOfSquares?: Maybe<Scalars['Float']['output']>;
  denominatorSummaryStatsInfo?: Maybe<MetricsV1SummaryStatsSummaryStatsInfo>;
  denominatorVariance?: Maybe<Scalars['Float']['output']>;
  numeratorDenominatorCovariance?: Maybe<Scalars['Float']['output']>;
  numeratorMean?: Maybe<Scalars['Float']['output']>;
  numeratorSum?: Maybe<Scalars['Float']['output']>;
  numeratorSumOfSquares?: Maybe<Scalars['Float']['output']>;
  numeratorSummaryStatsInfo?: Maybe<MetricsV1SummaryStatsSummaryStatsInfo>;
  numeratorVariance?: Maybe<Scalars['Float']['output']>;
  sumOfProducts?: Maybe<Scalars['Float']['output']>;
  varianceReductionStats?: Maybe<MetricsV1SummaryStatsRatioSummaryStatsVarianceReductionStats>;
};

export type MetricsV1SummaryStatsRatioSummaryStatsInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1SummaryStatsRatioSummaryStatsVarianceReductionStats = {
  count?: Maybe<Scalars['Long']['output']>;
  countMissing?: Maybe<Scalars['Long']['output']>;
  countMissingRows?: Maybe<Scalars['Long']['output']>;
  denominatorDenominatorSumOfProducts?: Maybe<Scalars['Float']['output']>;
  denominatorMean?: Maybe<Scalars['Float']['output']>;
  denominatorNumeratorSumOfProducts?: Maybe<Scalars['Float']['output']>;
  denominatorSum?: Maybe<Scalars['Float']['output']>;
  denominatorSumOfSquares?: Maybe<Scalars['Float']['output']>;
  denominatorVariance?: Maybe<Scalars['Float']['output']>;
  numeratorDenominatorCovariance?: Maybe<Scalars['Float']['output']>;
  numeratorDenominatorSumOfProducts?: Maybe<Scalars['Float']['output']>;
  numeratorMean?: Maybe<Scalars['Float']['output']>;
  numeratorNumeratorSumOfProducts?: Maybe<Scalars['Float']['output']>;
  numeratorSum?: Maybe<Scalars['Float']['output']>;
  numeratorSumOfSquares?: Maybe<Scalars['Float']['output']>;
  numeratorVariance?: Maybe<Scalars['Float']['output']>;
  postDenominatorSum?: Maybe<Scalars['Float']['output']>;
  postNumeratorSum?: Maybe<Scalars['Float']['output']>;
  preDenominatorPostDenominatorCovariance?: Maybe<Scalars['Float']['output']>;
  preDenominatorPostNumeratorCovariance?: Maybe<Scalars['Float']['output']>;
  preNumeratorPostDenominatorCovariance?: Maybe<Scalars['Float']['output']>;
  preNumeratorPostNumeratorCovariance?: Maybe<Scalars['Float']['output']>;
  sumOfProducts?: Maybe<Scalars['Float']['output']>;
};

export type MetricsV1SummaryStatsRatioSummaryStatsVarianceReductionStatsInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type MetricsV1SummaryStatsSummaryStatsInfo = {
  countZeroes?: Maybe<Scalars['Long']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type MetricsV1SummaryStatsSummaryStatsInfoInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1TableIssue = {
  message?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<MetricsV1TableIssueTableIssueSeverity>;
};

export enum MetricsV1TableIssueTableIssueSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING',
}

export enum MetricsV1TableState {
  TableStateActive = 'TABLE_STATE_ACTIVE',
  TableStateCreating = 'TABLE_STATE_CREATING',
  TableStateDeleted = 'TABLE_STATE_DELETED',
  TableStateFailed = 'TABLE_STATE_FAILED',
  TableStateUpdating = 'TABLE_STATE_UPDATING',
}

export type MetricsV1TimeTruncation = {
  behaviour: MetricsV1TruncationBehavior;
  timeZone: MetricsV1TruncationTimeZone;
  window: MetricsV1TruncationWindow;
};

export type MetricsV1TimeTruncationInput = {
  behaviour: MetricsV1TruncationBehavior;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeZone: MetricsV1TruncationTimeZone;
  window: MetricsV1TruncationWindow;
};

export enum MetricsV1TruncationBehavior {
  TruncationBehaviorStart = 'TRUNCATION_BEHAVIOR_START',
}

export enum MetricsV1TruncationTimeZone {
  TruncationTimezoneUtc = 'TRUNCATION_TIMEZONE_UTC',
}

export enum MetricsV1TruncationWindow {
  TruncationWindowDay = 'TRUNCATION_WINDOW_DAY',
  TruncationWindowHour = 'TRUNCATION_WINDOW_HOUR',
}

export type MetricsV1Unit = {
  baseUnit?: Maybe<MetricsV1UnitBaseUnit>;
  baseUnitMultiplier?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customUnit?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<MetricsV1EntityResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
};

export enum MetricsV1UnitBaseUnit {
  Bit = 'BIT',
  Byte = 'BYTE',
  None = 'NONE',
  Percent = 'PERCENT',
  Second = 'SECOND',
}

export type MetricsV1UnitInput = {
  baseUnit?: InputMaybe<MetricsV1UnitBaseUnit>;
  baseUnitMultiplier?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customUnit?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ValidateDataWarehouseConfigResponse = {
  bigQueryConfigValidation?: Maybe<MetricsV1ValidateDataWarehouseConfigResponseBigQueryConfigValidation>;
  redshiftConfigValidation?: Maybe<MetricsV1ValidateDataWarehouseConfigResponseRedshiftConfigValidation>;
  snowflakeConfigValidation?: Maybe<MetricsV1ValidateDataWarehouseConfigResponseSnowflakeConfigValidation>;
  successful?: Maybe<Scalars['Boolean']['output']>;
  validation: Array<MetricsV1ValidateDataWarehouseConfigResponseValidation>;
};

export type MetricsV1ValidateDataWarehouseConfigResponseBigQueryConfigValidation =
  {
    location?: Maybe<Scalars['String']['output']>;
  };

export type MetricsV1ValidateDataWarehouseConfigResponseRedshiftConfigValidation =
  {
    availableSchemas: Array<Scalars['String']['output']>;
  };

export type MetricsV1ValidateDataWarehouseConfigResponseResult =
  | Error
  | MetricsV1ValidateDataWarehouseConfigResponse;

export type MetricsV1ValidateDataWarehouseConfigResponseSnowflakeConfigValidation =
  {
    databases: Array<Scalars['String']['output']>;
    roles: Array<Scalars['String']['output']>;
    schemas: Array<Scalars['String']['output']>;
    warehouses: Array<Scalars['String']['output']>;
  };

export type MetricsV1ValidateDataWarehouseConfigResponseValidation = {
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MetricsV1ValidateMetricResponse = {
  errors: Array<MetricsV1ValidateMetricResponseError>;
};

export type MetricsV1ValidateMetricResponseError = {
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1ValidateMetricResponseResult =
  | Error
  | MetricsV1ValidateMetricResponse;

export type MetricsV1ValidateSnowflakeConfigInput = {
  account: Scalars['String']['input'];
  authenticationKey: Scalars['String']['input'];
  exposureDatabase?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
  warehouse?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1ValueCap = {
  max?: Maybe<GoogleTypeDecimal>;
  min?: Maybe<GoogleTypeDecimal>;
};

export type MetricsV1ValueCapInput = {
  max?: InputMaybe<GoogleTypeDecimalInput>;
  min?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsV1WatermarkState = {
  automaticUpdateState?: Maybe<MetricsV1WatermarkStateAutomaticUpdateStrategyState>;
  config?: Maybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfig>;
  dataDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
};

export type MetricsV1WatermarkStateAutomaticUpdateStrategyState = {
  count?: Maybe<Scalars['Long']['output']>;
  countTime?: Maybe<Scalars['String']['output']>;
  incrementCommitTime?: Maybe<Scalars['String']['output']>;
  updatedDeliveredUntilTime?: Maybe<Scalars['String']['output']>;
};

export type ModuleData = {
  abtest?: Maybe<AbTestData>;
  analysis?: Maybe<AnalysisData>;
  audiences?: Maybe<AudiencesData>;
  background?: Maybe<BackgroundData>;
  c4sabtest?: Maybe<C4sAbTest>;
  c4srollout?: Maybe<C4sRollout>;
  decision?: Maybe<DecisionRecordData>;
  eptest?: Maybe<EpTest>;
  explore?: Maybe<ExploreData>;
  exposure?: Maybe<ExposureData>;
  flags?: Maybe<FlagsData>;
  hypothesis?: Maybe<HypothesisData>;
  metaanalysis?: Maybe<MetaAnalysisData>;
  metrics?: Maybe<MetricsData>;
  monitoring?: Maybe<MonitoringMetricsData>;
  planning?: Maybe<PlanningData>;
  reanalysis?: Maybe<ReanalysisData>;
  remoteconfig?: Maybe<RemoteConfigData>;
  report?: Maybe<ReportData>;
  reviews?: Maybe<ReviewsData>;
  rollout?: Maybe<RolloutData>;
  samplesize?: Maybe<SampleSizeData>;
  spotifyanalysis?: Maybe<SpotifyAnalysis>;
  staticconfig?: Maybe<StaticConfig>;
  stats?: Maybe<StatsData>;
};

export type ModuleDataInput = {
  abtest?: InputMaybe<AbTestDataInput>;
  analysis?: InputMaybe<AnalysisDataInput>;
  audiences?: InputMaybe<AudiencesDataInput>;
  background?: InputMaybe<BackgroundDataInput>;
  c4sabtest?: InputMaybe<C4sAbTestInput>;
  c4srollout?: InputMaybe<C4sRolloutInput>;
  decision?: InputMaybe<DecisionRecordDataInput>;
  eptest?: InputMaybe<EpTestInput>;
  explore?: InputMaybe<ExploreDataInput>;
  exposure?: InputMaybe<ExposureDataInput>;
  flags?: InputMaybe<FlagsDataInput>;
  hypothesis?: InputMaybe<HypothesisDataInput>;
  metaanalysis?: InputMaybe<MetaAnalysisDataInput>;
  metrics?: InputMaybe<MetricsDataInput>;
  monitoring?: InputMaybe<MonitoringMetricsDataInput>;
  planning?: InputMaybe<PlanningDataInput>;
  reanalysis?: InputMaybe<ReanalysisDataInput>;
  remoteconfig?: InputMaybe<RemoteConfigDataInput>;
  report?: InputMaybe<ReportDataInput>;
  reviews?: InputMaybe<ReviewsDataInput>;
  rollout?: InputMaybe<RolloutDataInput>;
  samplesize?: InputMaybe<SampleSizeDataInput>;
  spotifyanalysis?: InputMaybe<SpotifyAnalysisInput>;
  staticconfig?: InputMaybe<StaticConfigInput>;
  stats?: InputMaybe<StatsDataInput>;
};

export type MonitoringMetricsData = {
  metrics: Array<MonitoringMetricsDataMonitoringMetric>;
  results?: Maybe<Array<MonitoringMetricsDataMonitoringMetricResult>>;
};

export type MonitoringMetricsDataInput = {
  metrics: Array<MonitoringMetricsDataInputMonitoringMetricInput>;
  results?: InputMaybe<
    Array<MonitoringMetricsDataInputMonitoringMetricResultInput>
  >;
};

export type MonitoringMetricsDataInputMonitoringMetricInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  metric: Scalars['String']['input'];
  preferredDirection?: InputMaybe<MonitoringMetricsDataInputMonitoringMetricInputPreferredDirection>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
};

export enum MonitoringMetricsDataInputMonitoringMetricInputPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MonitoringMetricsDataInputMonitoringMetricResultInput = {
  analysisResult: Scalars['String']['input'];
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  groups: Array<MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInput>;
  metric: Scalars['String']['input'];
};

export type MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInput =
  {
    group: Scalars['String']['input'];
    state: MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInputState;
  };

export enum MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInputState {
  Normal = 'NORMAL',
  SignificantDecrease = 'SIGNIFICANT_DECREASE',
  SignificantIncrease = 'SIGNIFICANT_INCREASE',
}

export type MonitoringMetricsDataMonitoringMetric = {
  alpha?: Maybe<Scalars['Float']['output']>;
  metric: MetricsV1MetricResult;
  preferredDirection?: Maybe<MonitoringMetricsDataMonitoringMetricPreferredDirection>;
  schedule?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
};

export enum MonitoringMetricsDataMonitoringMetricPreferredDirection {
  Any = 'ANY',
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type MonitoringMetricsDataMonitoringMetricResult = {
  analysisResult: StatsV2AnalysisAnalysisResultResult;
  exposureFilter?: Maybe<Scalars['String']['output']>;
  groups: Array<MonitoringMetricsDataMonitoringMetricResultMonitoringGroupResult>;
  metric: MetricsV1MetricResult;
};

export type MonitoringMetricsDataMonitoringMetricResultMonitoringGroupResult = {
  group: Scalars['String']['output'];
  state: MonitoringMetricsDataMonitoringMetricResultMonitoringGroupResultState;
};

export enum MonitoringMetricsDataMonitoringMetricResultMonitoringGroupResultState {
  Normal = 'NORMAL',
  SignificantDecrease = 'SIGNIFICANT_DECREASE',
  SignificantIncrease = 'SIGNIFICANT_INCREASE',
}

export type Mutation = {
  addFlagClient?: Maybe<FlagsAdminV1FlagResult>;
  addGroupMembers?: Maybe<IamV1AddGroupMembersResponseResult>;
  addMessage?: Maybe<ConversationsV1ConversationMessageResult>;
  addSurfaceIdentityBinding?: Maybe<WorkflowV1SurfaceIdentityBindingResult>;
  allocateSegment?: Maybe<FlagsAdminV1SegmentResult>;
  answerQuestions?: Maybe<OnboardingV1LearningProgressResult>;
  applyMetricsSync?: Maybe<MetricsV1ApplyMetricsSyncResponseResult>;
  archiveFlag?: Maybe<FlagsAdminV1FlagResult>;
  archiveManagedWorkspace?: Maybe<AiworkflowsV1ArchiveManagedWorkspaceResponseResult>;
  archiveMetric?: Maybe<MetricsV1MetricResult>;
  archiveReview?: Maybe<CollaborationV1ArchiveReviewResponseResult>;
  archiveSegment?: Maybe<FlagsAdminV1SegmentResult>;
  backfillPromptHooks?: Maybe<CollaborationV1BackfillPromptHooksResponseResult>;
  batchDownloadRecording?: Maybe<RecordingV1BatchDownloadRecordingResponseResult>;
  cancelAiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  cancelMaterializedSegmentLoadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJobResult>;
  cancelMetricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  cancelScheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  cancelScheduledMeasurementCalculation?: Maybe<MetricsV1ScheduledMeasurementCalculationResult>;
  cancelScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  cancelSqlJob?: Maybe<MetricsV1SqlJobResult>;
  capturePulseBlock?: Maybe<PulseV1CapturePulseBlockResponseResult>;
  checkPermissions?: Maybe<WorkflowV1CheckPermissionsResponseResult>;
  checkSdkCompatibility?: Maybe<InsightsV1CheckSdkCompatibilityResponseResult>;
  clearChat?: Maybe<ConversationsV2ChatResult>;
  cloneWorkflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  closeIssue?: Maybe<ObservationsV1IssueResult>;
  completeTask?: Maybe<ObservationsV1TaskResult>;
  computeSegmentSpaceCalendar?: Maybe<FlagsAdminV1ComputeSegmentSpaceCalendarResponseResult>;
  configurePulseRefreshSchedule?: Maybe<PulseV1ConfigurePulseRefreshScheduleResponseResult>;
  configureSlack?: Maybe<ActivityV1SlackAdminConfigResult>;
  confirmTool?: Maybe<ConversationsV2ConfirmToolResponseResult>;
  convertSubscription?: Maybe<BillingV1ConvertSubscriptionResponseResult>;
  createAgent?: Maybe<IamV1AgentResult>;
  createAgentReviewPreview?: Maybe<CollaborationV1AgentReviewPreviewResult>;
  createAiWorkflowInstance?: Maybe<AiworkflowsV1AiWorkflowInstanceResult>;
  createAiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  createAiWorkflowTrigger?: Maybe<AiworkflowsV1AiWorkflowTriggerResult>;
  createAnalysisResult?: Maybe<StatsV2AnalysisAnalysisResultResult>;
  createApiClient?: Maybe<IamV1ApiClientResult>;
  createAssignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  createAttachment?: Maybe<CollaborationV1AttachmentResult>;
  createChat?: Maybe<ConversationsV2ChatResult>;
  createCleanupTasks?: Maybe<AiworkflowsV1AiWorkflowInstanceResult>;
  createClient?: Maybe<IamV1ClientResult>;
  createClientCredential?: Maybe<IamV1ClientCredentialResult>;
  createCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  createCollection?: Maybe<CollectionsV1CollectionResult>;
  createCollectionEntry?: Maybe<CollectionsV1CollectionEntryResult>;
  createComment?: Maybe<CollaborationV1CommentResult>;
  createCommentReply?: Maybe<CollaborationV1CommentReplyResult>;
  createConversation?: Maybe<ConversationsV1ConversationResult>;
  createCryptoKey?: Maybe<IamV1CryptoKeyResult>;
  createDashboard?: Maybe<InsightsV1DashboardResult>;
  createDataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  createDimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  createEntity?: Maybe<MetricsV1EntityResult>;
  createEntityIdentityBinding?: Maybe<MetricsV1EntityIdentityBindingResult>;
  createEntityRelationTable?: Maybe<MetricsV1EntityRelationTableResult>;
  createEnvironment?: Maybe<FlagsAdminV1EnvironmentResult>;
  createEvaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverrideResult>;
  createEventConnection?: Maybe<ConnectorsV1EventConnectionResult>;
  createEventDefinition?: Maybe<EventsAdminV1EventDefinitionResult>;
  createExclusivityGroup?: Maybe<WorkflowV1ExclusivityGroupResult>;
  createExposureCalculation?: Maybe<MetricsV1ExposureCalculationResult>;
  createExposureTable?: Maybe<MetricsV1ExposureTableResult>;
  createExternalDocument?: Maybe<CollaborationV1ExternalDocumentResult>;
  createExternalIntegration?: Maybe<AiworkflowsV1ExternalIntegrationResult>;
  createFactTable?: Maybe<MetricsV1FactTableResult>;
  createFeed?: Maybe<ActivityV1FeedResult>;
  createFlag?: Maybe<FlagsAdminV1FlagResult>;
  createFlagAppliedConnection?: Maybe<ConnectorsV1FlagAppliedConnectionResult>;
  createGroup?: Maybe<IamV1GroupResult>;
  createHoldback?: Maybe<WorkflowV1HoldbackResult>;
  createInitiative?: Maybe<WorkflowV1InitiativeResult>;
  createInsightsDocument?: Maybe<InsightsV1InsightsDocumentResult>;
  createInsightsMetric?: Maybe<InsightsV1InsightsMetricResult>;
  createIssue?: Maybe<ObservationsV1IssueResult>;
  createLabel?: Maybe<AdminLabelsV1LabelResult>;
  createManagedDataWarehouse?: Maybe<OnboardingV1ManagedDataWarehouseProvisioningResult>;
  createMaterializedSegment?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  createMaterializedSegmentLoadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJobResult>;
  createMeasurement?: Maybe<MetricsV1MeasurementResult>;
  createMetric?: Maybe<MetricsV1MetricResult>;
  createMetricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  createOAuthApp?: Maybe<IamV1OAuthAppResult>;
  createObservation?: Maybe<ObservationsV1ObservationResult>;
  createPartition?: Maybe<MetricsV1PartitionResult>;
  createPlatformConnection?: Maybe<ConnectorsV1PlatformConnectionResult>;
  createPolicy?: Maybe<IamV1PolicyResult>;
  createPresence?: Maybe<CollaborationV1PresenceResult>;
  createProject?: Maybe<CollaborationV1ProjectResult>;
  createPromptHook?: Maybe<ConversationsV2PromptHookResult>;
  createPulse?: Maybe<PulseV1PulseResult>;
  createPulseBlock?: Maybe<PulseV1PulseBlockResult>;
  createReaction?: Maybe<CollaborationV1ReactionResult>;
  createRecordingPolicy?: Maybe<RecordingV1RecordingPolicyResult>;
  createRecordingRule?: Maybe<RecordingV1RecordingRuleResult>;
  createResourcePermission?: Maybe<FgaV1ResourcePermissionResult>;
  createReview?: Maybe<CollaborationV1ReviewResult>;
  createRole?: Maybe<IamV1RoleResult>;
  createRule?: Maybe<FlagsAdminV1FlagRuleResult>;
  createScheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  createScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  createSegment?: Maybe<FlagsAdminV1SegmentResult>;
  createSurface?: Maybe<WorkflowV1SurfaceResult>;
  createTask?: Maybe<ObservationsV1TaskResult>;
  createTheme?: Maybe<ObservationsV1ThemeResult>;
  createUserInvitation?: Maybe<IamV1UserInvitationResult>;
  createVariant?: Maybe<FlagsAdminV1FlagVariantResult>;
  createWorkflow?: Maybe<WorkflowV1WorkflowResult>;
  createWorkflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  createWorkflowSecret?: Maybe<WorkflowV1WorkflowSecretResult>;
  createWorkflowTemplate?: Maybe<WorkflowV1WorkflowTemplateResult>;
  createWorkflowVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
  deleteAgent?: Maybe<GoogleProtobufEmptyResult>;
  deleteAiWorkflowTrigger?: Maybe<GoogleProtobufEmptyResult>;
  deleteAnalysisResult?: Maybe<GoogleProtobufEmptyResult>;
  deleteApiClient?: Maybe<GoogleProtobufEmptyResult>;
  deleteAssignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  deleteAttachment?: Maybe<CollaborationV1AttachmentResult>;
  deleteChat?: Maybe<GoogleProtobufEmptyResult>;
  deleteCheck?: Maybe<GoogleProtobufEmptyResult>;
  deleteClient?: Maybe<GoogleProtobufEmptyResult>;
  deleteClientCredential?: Maybe<GoogleProtobufEmptyResult>;
  deleteCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  deleteCollection?: Maybe<GoogleProtobufEmptyResult>;
  deleteCollectionEntry?: Maybe<GoogleProtobufEmptyResult>;
  deleteComment?: Maybe<CollaborationV1CommentResult>;
  deleteCommentReply?: Maybe<CollaborationV1CommentReplyResult>;
  deleteConversation?: Maybe<GoogleProtobufEmptyResult>;
  deleteCryptoKey?: Maybe<IamV1CryptoKeyResult>;
  deleteDataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  deleteDimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  deleteEntity?: Maybe<GoogleProtobufEmptyResult>;
  deleteEntityIdentityBinding?: Maybe<GoogleProtobufEmptyResult>;
  deleteEntityRelationTable?: Maybe<GoogleProtobufEmptyResult>;
  deleteEnvironment?: Maybe<GoogleProtobufEmptyResult>;
  deleteEvaluationContextFieldOverride?: Maybe<GoogleProtobufEmptyResult>;
  deleteEventConnection?: Maybe<GoogleProtobufEmptyResult>;
  deleteEventDefinition?: Maybe<GoogleProtobufEmptyResult>;
  deleteExclusivityGroup?: Maybe<GoogleProtobufEmptyResult>;
  deleteExposureTable?: Maybe<GoogleProtobufEmptyResult>;
  deleteExternalDocument?: Maybe<CollaborationV1ExternalDocumentResult>;
  deleteExternalIntegration?: Maybe<GoogleProtobufEmptyResult>;
  deleteFactTable?: Maybe<MetricsV1FactTableResult>;
  deleteFeed?: Maybe<GoogleProtobufEmptyResult>;
  deleteFlagAppliedConnection?: Maybe<GoogleProtobufEmptyResult>;
  deleteGroup?: Maybe<GoogleProtobufEmptyResult>;
  deleteHoldback?: Maybe<GoogleProtobufEmptyResult>;
  deleteInitiative?: Maybe<GoogleProtobufEmptyResult>;
  deleteInsightsDocument?: Maybe<GoogleProtobufEmptyResult>;
  deleteIssue?: Maybe<GoogleProtobufEmptyResult>;
  deleteLabel?: Maybe<GoogleProtobufEmptyResult>;
  deleteMaterializedSegment?: Maybe<GoogleProtobufEmptyResult>;
  deleteMeasurement?: Maybe<MetricsV1MeasurementResult>;
  deleteMetric?: Maybe<MetricsV1MetricResult>;
  deleteOAuthApp?: Maybe<GoogleProtobufEmptyResult>;
  deleteObservation?: Maybe<GoogleProtobufEmptyResult>;
  deletePartition?: Maybe<GoogleProtobufEmptyResult>;
  deletePlatformConnection?: Maybe<GoogleProtobufEmptyResult>;
  deletePolicy?: Maybe<GoogleProtobufEmptyResult>;
  deletePresence?: Maybe<GoogleProtobufEmptyResult>;
  deleteProject?: Maybe<GoogleProtobufEmptyResult>;
  deletePromptHook?: Maybe<GoogleProtobufEmptyResult>;
  deletePulse?: Maybe<GoogleProtobufEmptyResult>;
  deletePulseBlock?: Maybe<GoogleProtobufEmptyResult>;
  deleteReaction?: Maybe<GoogleProtobufEmptyResult>;
  deleteRecordingPolicy?: Maybe<GoogleProtobufEmptyResult>;
  deleteRecordingRule?: Maybe<GoogleProtobufEmptyResult>;
  deleteResourcePermission?: Maybe<GoogleProtobufEmptyResult>;
  deleteReview?: Maybe<GoogleProtobufEmptyResult>;
  deleteReviewResponse?: Maybe<CollaborationV1ReviewResponseResult>;
  deleteRole?: Maybe<GoogleProtobufEmptyResult>;
  deleteRule?: Maybe<GoogleProtobufEmptyResult>;
  deleteScheduledMetricCalculation?: Maybe<GoogleProtobufEmptyResult>;
  deleteSurface?: Maybe<GoogleProtobufEmptyResult>;
  deleteTask?: Maybe<GoogleProtobufEmptyResult>;
  deleteTheme?: Maybe<GoogleProtobufEmptyResult>;
  deleteUser?: Maybe<GoogleProtobufEmptyResult>;
  deleteUserInvitation?: Maybe<GoogleProtobufEmptyResult>;
  deleteVariant?: Maybe<GoogleProtobufEmptyResult>;
  deleteWorkflowInstance?: Maybe<GoogleProtobufEmptyResult>;
  deleteWorkflowSecret?: Maybe<GoogleProtobufEmptyResult>;
  deleteWorkflowTemplate?: Maybe<GoogleProtobufEmptyResult>;
  deriveClientEvaluationContextSchema?: Maybe<FlagsAdminV1DeriveClientEvaluationContextSchemaResponseResult>;
  describeAssignmentTable?: Maybe<MetricsV1DescribeAssignmentTableResponseResult>;
  disableSlack?: Maybe<GoogleProtobufEmptyResult>;
  discardDraftEvent?: Maybe<GoogleProtobufEmptyResult>;
  evictPulseBlockCache?: Maybe<GoogleProtobufEmptyResult>;
  executeCheck?: Maybe<FgaV1ExecuteCheckResponseResult>;
  executeFunction?: Maybe<WorkflowV1ExecuteFunctionResponseResult>;
  executeSql?: Maybe<InsightsV1ExecuteSqlResponseResult>;
  extractKnowledge?: Maybe<GoogleProtobufEmptyResult>;
  extractObservations?: Maybe<ObservationsV1ExtractObservationsResponseResult>;
  followResources?: Maybe<GoogleProtobufEmptyResult>;
  generateClientCredentialEncryptionKey?: Maybe<IamV1GenerateClientCredentialEncryptionKeyResponseResult>;
  generateCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  initiateImageUpload?: Maybe<WorkflowV1InitiateImageUploadResponseResult>;
  initiateTarUpload?: Maybe<WorkflowV1InitiateTarUploadResponseResult>;
  instantiateGithubInstallation?: Maybe<AiworkflowsV1InstantiateGithubInstallationResponseResult>;
  instantiateIntercomInstallation?: Maybe<AiworkflowsV1InstantiateIntercomInstallationResponseResult>;
  interruptChat?: Maybe<ConversationsV2ChatEventResult>;
  markFeedEntriesAsRead?: Maybe<GoogleProtobufEmptyResult>;
  pauseAiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  previewAgentReview?: Maybe<CollaborationV1PreviewAgentReviewResponseResult>;
  previewInsightsMetric?: Maybe<InsightsV1PreviewInsightsMetricResponseResult>;
  previewPulseBlock?: Maybe<PulseV1PulseBlockResult>;
  previewSqlQuery?: Maybe<MetricsV1PreviewSqlQueryResponseResult>;
  promotePrimaryDataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  publishCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  publishMetric?: Maybe<MetricsV1MetricResult>;
  rangeQuery?: Maybe<InsightsV1QueryResponseResult>;
  refreshPulse?: Maybe<PulseV1RefreshPulseResponseResult>;
  refreshPulseBlock?: Maybe<PulseV1RefreshPulseBlockResponseResult>;
  registerManagedWorkspace?: Maybe<AiworkflowsV1ManagedWorkspaceResult>;
  removeClientCredentialEncryptionKey?: Maybe<IamV1ClientCredentialResult>;
  removeDemoData?: Maybe<GoogleProtobufEmptyResult>;
  removeFlagClient?: Maybe<FlagsAdminV1FlagResult>;
  removeGroupMembers?: Maybe<IamV1RemoveGroupMembersResponseResult>;
  removeSurfaceIdentityBinding?: Maybe<GoogleProtobufEmptyResult>;
  reopenIssue?: Maybe<ObservationsV1IssueResult>;
  reorderRecordingRules?: Maybe<GoogleProtobufEmptyResult>;
  requestReviewResponses?: Maybe<CollaborationV1RequestReviewResponsesResponseResult>;
  resolveFlagsVerbose?: Maybe<FlagsResolverAdminV1ResolveFlagsVerboseResponseResult>;
  resumeAiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  resumeScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  retriggerAllScheduledMetricCalculations?: Maybe<MetricsV1RetriggerAllScheduledMetricCalculationsResponseResult>;
  retriggerMetricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  retriggerScheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  retriggerScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  segmentAvailableSpace?: Maybe<FlagsAdminV1SegmentAvailableSpaceResponseResult>;
  sendUserMessage?: Maybe<ConversationsV2ChatEventResult>;
  staleReview?: Maybe<CollaborationV1StaleReviewResponseResult>;
  startBillingPortalSession?: Maybe<BillingV1BillingPortalSessionResult>;
  startCheckoutSession?: Maybe<BillingV1CheckoutSessionResult>;
  startInvestigation?: Maybe<ObservationsV1ThemeResult>;
  startTask?: Maybe<ObservationsV1TaskResult>;
  storeSlackUserInfo?: Maybe<IamV1StoreSlackUserInfoResponseResult>;
  submitReviewResponse?: Maybe<CollaborationV1SubmitReviewResponseResponseResult>;
  suggestFactTableColumns?: Maybe<MetricsV1SuggestFactTableColumnsResponseResult>;
  suggestMetric?: Maybe<MetricsV1SuggestMetricResponseResult>;
  syncInsightsTableContexts?: Maybe<InsightsV1SyncInsightsTableContextsResponseResult>;
  takeSuggestedAction?: Maybe<ObservationsV1IssueResult>;
  testWebhook?: Maybe<ActivityV1TestWebhookResponseResult>;
  transitionWorkflowInstance?: Maybe<WorkflowV1TransitionWorkflowInstanceResponseResult>;
  unarchiveFlag?: Maybe<FlagsAdminV1FlagResult>;
  unarchiveMetric?: Maybe<MetricsV1MetricResult>;
  undeleteEnvironment?: Maybe<FlagsAdminV1EnvironmentResult>;
  undeleteFactTable?: Maybe<MetricsV1FactTableResult>;
  undoReaction?: Maybe<CollaborationV1UndoReactionResponseResult>;
  unfollowResources?: Maybe<GoogleProtobufEmptyResult>;
  unpublishCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  updateAgent?: Maybe<IamV1AgentResult>;
  updateAiWorkflowTrigger?: Maybe<AiworkflowsV1AiWorkflowTriggerResult>;
  updateAnalysisResult?: Maybe<StatsV2AnalysisAnalysisResultResult>;
  updateApiClient?: Maybe<IamV1ApiClientResult>;
  updateAssignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  updateAttachment?: Maybe<CollaborationV1AttachmentResult>;
  updateChat?: Maybe<ConversationsV2ChatResult>;
  updateChatEvent?: Maybe<ConversationsV2ChatEventResult>;
  updateCheck?: Maybe<WorkflowV1WorkflowInstanceCheckResult>;
  updateClient?: Maybe<IamV1ClientResult>;
  updateClientCredential?: Maybe<IamV1ClientCredentialResult>;
  updateCollaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  updateCollection?: Maybe<CollectionsV1CollectionResult>;
  updateComment?: Maybe<CollaborationV1CommentResult>;
  updateCommentReply?: Maybe<CollaborationV1CommentReplyResult>;
  updateConversation?: Maybe<ConversationsV1ConversationResult>;
  updateConversationMessage?: Maybe<ConversationsV1ConversationMessageResult>;
  updateDataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  updateDimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  updateEntity?: Maybe<MetricsV1EntityResult>;
  updateEntityIdentityBinding?: Maybe<MetricsV1EntityIdentityBindingResult>;
  updateEntityRelationTable?: Maybe<MetricsV1EntityRelationTableResult>;
  updateEnvironment?: Maybe<FlagsAdminV1EnvironmentResult>;
  updateEvaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverrideResult>;
  updateEventDefinition?: Maybe<EventsAdminV1EventDefinitionResult>;
  updateExclusivityGroup?: Maybe<WorkflowV1ExclusivityGroupResult>;
  updateExposureTable?: Maybe<MetricsV1ExposureTableResult>;
  updateExternalIntegration?: Maybe<AiworkflowsV1ExternalIntegrationResult>;
  updateFactTable?: Maybe<MetricsV1FactTableResult>;
  updateFeed?: Maybe<ActivityV1FeedResult>;
  updateFlag?: Maybe<FlagsAdminV1FlagResult>;
  updateGroup?: Maybe<IamV1GroupResult>;
  updateHoldback?: Maybe<WorkflowV1HoldbackResult>;
  updateInitiative?: Maybe<WorkflowV1InitiativeResult>;
  updateInsightsDocument?: Maybe<InsightsV1InsightsDocumentResult>;
  updateInsightsMetric?: Maybe<InsightsV1InsightsMetricResult>;
  updateInsightsTableContext?: Maybe<InsightsV1InsightsTableContextResult>;
  updateIssue?: Maybe<ObservationsV1IssueResult>;
  updateLabel?: Maybe<AdminLabelsV1LabelResult>;
  updateLearningProgress?: Maybe<OnboardingV1LearningProgressResult>;
  updateMaterializedSegment?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  updateMeasurement?: Maybe<MetricsV1MeasurementResult>;
  updateMetric?: Maybe<MetricsV1MetricResult>;
  updateOAuthApp?: Maybe<IamV1OAuthAppResult>;
  updateObservation?: Maybe<ObservationsV1ObservationResult>;
  updatePolicy?: Maybe<IamV1PolicyResult>;
  updatePresence?: Maybe<CollaborationV1PresenceResult>;
  updateProject?: Maybe<CollaborationV1ProjectResult>;
  updatePromptHook?: Maybe<ConversationsV2PromptHookResult>;
  updatePulse?: Maybe<PulseV1PulseResult>;
  updatePulseBlock?: Maybe<PulseV1PulseBlockResult>;
  updateRecordingPolicy?: Maybe<RecordingV1RecordingPolicyResult>;
  updateRecordingRule?: Maybe<RecordingV1RecordingRuleResult>;
  updateReview?: Maybe<CollaborationV1ReviewResult>;
  updateRole?: Maybe<IamV1RoleResult>;
  updateRule?: Maybe<FlagsAdminV1FlagRuleResult>;
  updateScheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  updateScheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  updateSegment?: Maybe<FlagsAdminV1SegmentResult>;
  updateSurface?: Maybe<WorkflowV1SurfaceResult>;
  updateTask?: Maybe<ObservationsV1TaskResult>;
  updateTheme?: Maybe<ObservationsV1ThemeResult>;
  updateUser?: Maybe<IamV1UserResult>;
  updateVariant?: Maybe<FlagsAdminV1FlagVariantResult>;
  updateWorkflow?: Maybe<WorkflowV1WorkflowResult>;
  updateWorkflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  updateWorkflowSecret?: Maybe<WorkflowV1WorkflowSecretResult>;
  updateWorkflowTemplate?: Maybe<WorkflowV1WorkflowTemplateResult>;
  upgradeWorkflowInstances?: Maybe<WorkflowV1UpgradeWorkflowInstancesResponseResult>;
  validateDataWarehouseConfig?: Maybe<MetricsV1ValidateDataWarehouseConfigResponseResult>;
  validateEventConnectionConfig?: Maybe<ConnectorsV1ValidateEventConnectionConfigResponseResult>;
  validateFlagAppliedConnectionConfig?: Maybe<ConnectorsV1ValidateFlagAppliedConnectionConfigResponseResult>;
  validateMetric?: Maybe<MetricsV1ValidateMetricResponseResult>;
  validatePlatformConnectionConfig?: Maybe<ConnectorsV1ValidatePlatformConnectionConfigResponseResult>;
  verifyMetric?: Maybe<MetricsV1MetricResult>;
  writeDemoData?: Maybe<GoogleProtobufEmptyResult>;
  writeFlagAssigned?: Maybe<FlagsAdminV1WriteFlagAssignedResponseResult>;
  writeResolveInfo?: Maybe<FlagsAdminV1WriteResolveInfoResponseResult>;
  writeResourcePermissions?: Maybe<FgaV1WriteResourcePermissionsResponseResult>;
};

export type MutationAddFlagClientArgs = {
  client: Scalars['String']['input'];
  flag: Scalars['String']['input'];
};

export type MutationAddGroupMembersArgs = {
  group: Scalars['String']['input'];
  identities: Array<Scalars['String']['input']>;
};

export type MutationAddMessageArgs = {
  message: ConversationsV1ConversationMessageInput;
  parent: Scalars['String']['input'];
};

export type MutationAddSurfaceIdentityBindingArgs = {
  parent: Scalars['String']['input'];
  surfaceIdentityBinding: WorkflowV1SurfaceIdentityBindingInput;
};

export type MutationAllocateSegmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationAnswerQuestionsArgs = {
  course: Scalars['String']['input'];
  questionUpdates: Array<OnboardingV1AnswerQuestionsRequestQuestionUpdateInput>;
};

export type MutationApplyMetricsSyncArgs = {
  adopt?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  reference: Scalars['String']['input'];
  resources?: InputMaybe<
    Array<MetricsV1ApplyMetricsSyncRequestSyncResourceInput>
  >;
};

export type MutationArchiveFlagArgs = {
  name: Scalars['String']['input'];
};

export type MutationArchiveManagedWorkspaceArgs = {
  account: Scalars['String']['input'];
};

export type MutationArchiveMetricArgs = {
  archiveInfo?: InputMaybe<MetricsV1MetricArchiveInfoInput>;
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationArchiveReviewArgs = {
  name: Scalars['String']['input'];
};

export type MutationArchiveSegmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationBatchDownloadRecordingArgs = {
  names: Array<Scalars['String']['input']>;
};

export type MutationCancelAiWorkflowScheduleArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelMaterializedSegmentLoadJobArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelScheduledExposureCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelScheduledMeasurementCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelScheduledMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationCancelSqlJobArgs = {
  name: Scalars['String']['input'];
};

export type MutationCapturePulseBlockArgs = {
  blockType?: InputMaybe<PulseV1PulseBlockType>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  selectedContent?: InputMaybe<Scalars['String']['input']>;
  sourceChat?: InputMaybe<Scalars['String']['input']>;
  sourceEvent?: InputMaybe<Scalars['String']['input']>;
  visualizationSpec?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationCheckPermissionsArgs = {
  workflowInstance: Scalars['String']['input'];
};

export type MutationCheckSdkCompatibilityArgs = {
  featureIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationClearChatArgs = {
  name: Scalars['String']['input'];
};

export type MutationCloneWorkflowInstanceArgs = {
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationCloseIssueArgs = {
  closeReason: ObservationsV1IssueCloseReason;
  name: Scalars['String']['input'];
};

export type MutationCompleteTaskArgs = {
  name: Scalars['String']['input'];
};

export type MutationComputeSegmentSpaceCalendarArgs = {
  endDate: GoogleTypeDateInput;
  segments?: InputMaybe<Array<FlagsAdminV1SegmentScheduleInput>>;
  startDate: GoogleTypeDateInput;
};

export type MutationConfigurePulseRefreshScheduleArgs = {
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  hour?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
  pulse: Scalars['String']['input'];
  schedule: PulseV1PulseRefreshSchedule;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationConfigureSlackArgs = {
  code: Scalars['String']['input'];
  stateToken: Scalars['String']['input'];
};

export type MutationConfirmToolArgs = {
  decision: ConversationsV2ToolConfirmationResponseDecision;
  name: Scalars['String']['input'];
};

export type MutationCreateAgentArgs = {
  agent: IamV1AgentInput;
  agentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAgentReviewPreviewArgs = {
  agentReviewPreview: CollaborationV1AgentReviewPreviewInput;
  agentReviewPreviewId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAiWorkflowInstanceArgs = {
  aiWorkflowInstance: AiworkflowsV1AiWorkflowInstanceInput;
  aiWorkflowInstanceId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAiWorkflowScheduleArgs = {
  aiWorkflowSchedule: AiworkflowsV1AiWorkflowScheduleInput;
  aiWorkflowScheduleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAiWorkflowTriggerArgs = {
  aiWorkflowTrigger: AiworkflowsV1AiWorkflowTriggerInput;
  aiWorkflowTriggerId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAnalysisResultArgs = {
  analysisResult: StatsV2AnalysisAnalysisResultInput;
  analysisResultId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateApiClientArgs = {
  apiClient: IamV1ApiClientInput;
  apiClientId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAssignmentTableArgs = {
  assignmentTable: MetricsV1AssignmentTableInput;
  assignmentTableId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateAttachmentArgs = {
  attachment: CollaborationV1AttachmentInput;
  attachmentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateChatArgs = {
  chat: ConversationsV2ChatInput;
  chatId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCleanupTasksArgs = {
  name: Scalars['String']['input'];
  targets: Array<AiworkflowsV1CleanupTargetInput>;
};

export type MutationCreateClientArgs = {
  client: IamV1ClientInput;
};

export type MutationCreateClientCredentialArgs = {
  clientCredential: IamV1ClientCredentialInput;
  parent: Scalars['String']['input'];
};

export type MutationCreateCollaborativeDocumentArgs = {
  collaborativeDocument: CollaborationV1CollaborativeDocumentInput;
  collaborativeDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCollectionArgs = {
  collection: CollectionsV1CollectionInput;
  collectionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCollectionEntryArgs = {
  collectionEntry: CollectionsV1CollectionEntryInput;
  parent: Scalars['String']['input'];
};

export type MutationCreateCommentArgs = {
  comment: CollaborationV1CommentInput;
  commentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCommentReplyArgs = {
  commentReply: CollaborationV1CommentReplyInput;
  commentReplyId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateConversationArgs = {
  conversation: ConversationsV1ConversationInput;
};

export type MutationCreateCryptoKeyArgs = {
  cryptoKey: IamV1CryptoKeyInput;
  cryptoKeyId: Scalars['String']['input'];
};

export type MutationCreateDashboardArgs = {
  dashboard: InsightsV1DashboardInput;
  dashboardId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateDataWarehouseArgs = {
  dataWarehouse: MetricsV1DataWarehouseInput;
  dataWarehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateDimensionTableArgs = {
  dimensionTable: MetricsV1DimensionTableInput;
  dimensionTableId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateEntityArgs = {
  entity: MetricsV1EntityInput;
  entityId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateEntityIdentityBindingArgs = {
  entityIdentityBinding: MetricsV1EntityIdentityBindingInput;
  entityIdentityBindingId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateEntityRelationTableArgs = {
  entityRelationTable: MetricsV1EntityRelationTableInput;
  entityRelationTableId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateEnvironmentArgs = {
  environment: FlagsAdminV1EnvironmentInput;
  environmentId: Scalars['String']['input'];
};

export type MutationCreateEvaluationContextFieldOverrideArgs = {
  evaluationContextFieldOverride: FlagsAdminV1EvaluationContextFieldOverrideInput;
  evaluationContextFieldOverrideId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateEventConnectionArgs = {
  eventConnection: ConnectorsV1EventConnectionInput;
  eventConnectionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateEventDefinitionArgs = {
  eventDefinition: EventsAdminV1EventDefinitionInput;
  eventDefinitionId: Scalars['String']['input'];
};

export type MutationCreateExclusivityGroupArgs = {
  exclusivityGroup: WorkflowV1ExclusivityGroupInput;
  exclusivityGroupId: Scalars['String']['input'];
  parent: Scalars['String']['input'];
};

export type MutationCreateExposureCalculationArgs = {
  exposureCalculation: MetricsV1ExposureCalculationInput;
  exposureCalculationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateExposureTableArgs = {
  exposureTable: MetricsV1ExposureTableInput;
  exposureTableId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateExternalDocumentArgs = {
  externalDocument: CollaborationV1ExternalDocumentInput;
  externalDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateExternalIntegrationArgs = {
  externalIntegration: AiworkflowsV1ExternalIntegrationInput;
  externalIntegrationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateFactTableArgs = {
  factTable: MetricsV1FactTableInput;
  factTableId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateFeedArgs = {
  feed: ActivityV1FeedInput;
  feedId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateFlagArgs = {
  flag: FlagsAdminV1FlagInput;
  flagId: Scalars['String']['input'];
};

export type MutationCreateFlagAppliedConnectionArgs = {
  flagAppliedConnection: ConnectorsV1FlagAppliedConnectionInput;
  flagAppliedConnectionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateGroupArgs = {
  group: IamV1GroupInput;
  groupId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateHoldbackArgs = {
  holdback: WorkflowV1HoldbackInput;
  holdbackId: Scalars['String']['input'];
  parent: Scalars['String']['input'];
};

export type MutationCreateInitiativeArgs = {
  initiative: WorkflowV1InitiativeInput;
  initiativeId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateInsightsDocumentArgs = {
  insightsDocument: InsightsV1InsightsDocumentInput;
  insightsDocumentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateInsightsMetricArgs = {
  insightsMetric: InsightsV1InsightsMetricInput;
  insightsMetricId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateIssueArgs = {
  issue: ObservationsV1IssueInput;
  issueId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateLabelArgs = {
  label: AdminLabelsV1LabelInput;
  labelId: Scalars['String']['input'];
};

export type MutationCreateMaterializedSegmentArgs = {
  materializedSegment: FlagsAdminV1MaterializedSegmentInput;
  materializedSegmentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateMaterializedSegmentLoadJobArgs = {
  materializedSegmentLoadJob: MaterializerV1MaterializedSegmentLoadJobInput;
  materializedSegmentLoadJobId?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationCreateMeasurementArgs = {
  measurement: MetricsV1MeasurementInput;
  measurementId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateMetricArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  metric: MetricsV1MetricInput;
  metricId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateMetricCalculationArgs = {
  metricCalculation: MetricsV1MetricCalculationInput;
  metricCalculationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOAuthAppArgs = {
  oAuthAppId?: InputMaybe<Scalars['String']['input']>;
  oauthApp: IamV1OAuthAppInput;
};

export type MutationCreateObservationArgs = {
  observation: ObservationsV1ObservationInput;
  observationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePartitionArgs = {
  parent: Scalars['String']['input'];
  partition: MetricsV1PartitionInput;
};

export type MutationCreatePlatformConnectionArgs = {
  platformConnection: ConnectorsV1PlatformConnectionInput;
  platformConnectionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePolicyArgs = {
  policy: IamV1PolicyInput;
  policyId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePresenceArgs = {
  presence: CollaborationV1PresenceInput;
  presenceId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateProjectArgs = {
  project: CollaborationV1ProjectInput;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePromptHookArgs = {
  promptHook: ConversationsV2PromptHookInput;
  promptHookId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePulseArgs = {
  pulse: PulseV1PulseInput;
  pulseId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreatePulseBlockArgs = {
  parent: Scalars['String']['input'];
  pulseBlock: PulseV1PulseBlockInput;
  pulseBlockId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateReactionArgs = {
  reaction: CollaborationV1ReactionInput;
  reactionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRecordingPolicyArgs = {
  recordingPolicy: RecordingV1RecordingPolicyInput;
  recordingPolicyId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRecordingRuleArgs = {
  parent: Scalars['String']['input'];
  recordingRule: RecordingV1RecordingRuleInput;
  recordingRuleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateResourcePermissionArgs = {
  resourcePermission: FgaV1ResourcePermissionInput;
};

export type MutationCreateReviewArgs = {
  review: CollaborationV1ReviewInput;
  reviewId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRoleArgs = {
  role: IamV1RoleInput;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateRuleArgs = {
  parent: Scalars['String']['input'];
  rule: FlagsAdminV1FlagRuleInput;
  ruleId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateScheduledExposureCalculationArgs = {
  scheduledExposureCalculation: MetricsV1ScheduledExposureCalculationInput;
  scheduledExposureCalculationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateScheduledMetricCalculationArgs = {
  scheduledMetricCalculation: MetricsV1ScheduledMetricCalculationInput;
  scheduledMetricCalculationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateSegmentArgs = {
  segment: FlagsAdminV1SegmentInput;
  segmentId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateSurfaceArgs = {
  surface: WorkflowV1SurfaceInput;
  surfaceId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateTaskArgs = {
  task: ObservationsV1TaskInput;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateThemeArgs = {
  theme: ObservationsV1ThemeInput;
  themeId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateUserInvitationArgs = {
  userInvitation: IamV1UserInvitationInput;
};

export type MutationCreateVariantArgs = {
  parent: Scalars['String']['input'];
  variant: FlagsAdminV1FlagVariantInput;
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateWorkflowArgs = {
  workflow: WorkflowV1WorkflowInput;
  workflowId: Scalars['String']['input'];
};

export type MutationCreateWorkflowInstanceArgs = {
  parent: Scalars['String']['input'];
  workflowInstance: WorkflowV1WorkflowInstanceInput;
  workflowInstanceId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateWorkflowSecretArgs = {
  workflowSecret: WorkflowV1WorkflowSecretInput;
  workflowSecretId: Scalars['String']['input'];
};

export type MutationCreateWorkflowTemplateArgs = {
  workflowTemplate: WorkflowV1WorkflowTemplateInput;
  workflowTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateWorkflowVersionArgs = {
  parent: Scalars['String']['input'];
  workflowVersion: WorkflowV1WorkflowVersionInput;
};

export type MutationDeleteAgentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteAiWorkflowTriggerArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteAnalysisResultArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteApiClientArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteAssignmentTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteAttachmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteChatArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteCheckArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteClientArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteClientCredentialArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteCollaborativeDocumentArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteCollectionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteCollectionEntryArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteCommentArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteCommentReplyArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteConversationArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteCryptoKeyArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteDataWarehouseArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteDimensionTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEntityArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteEntityIdentityBindingArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEntityRelationTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEnvironmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEvaluationContextFieldOverrideArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEventConnectionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteEventDefinitionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteExclusivityGroupArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteExposureTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteExternalDocumentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteExternalIntegrationArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteFactTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteFeedArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteFlagAppliedConnectionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteGroupArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteHoldbackArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteInitiativeArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteInsightsDocumentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteIssueArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteLabelArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteMaterializedSegmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteMeasurementArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteMetricArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteOAuthAppArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteObservationArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePartitionArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeletePlatformConnectionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePolicyArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePresenceArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteProjectArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePromptHookArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeletePulseArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeletePulseBlockArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteReactionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteRecordingPolicyArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteRecordingRuleArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteResourcePermissionArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteReviewArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteReviewResponseArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteRoleArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteRuleArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteScheduledMetricCalculationArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type MutationDeleteSurfaceArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteTaskArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteThemeArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteUserArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteUserInvitationArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteVariantArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteWorkflowInstanceArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteWorkflowSecretArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteWorkflowTemplateArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeriveClientEvaluationContextSchemaArgs = {
  clients?: InputMaybe<Array<Scalars['String']['input']>>;
  mustMatchSchema?: InputMaybe<FlagsAdminV1EvaluationContextSchemaInput>;
};

export type MutationDescribeAssignmentTableArgs = {
  endTime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type MutationDiscardDraftEventArgs = {
  name: Scalars['String']['input'];
};

export type MutationEvictPulseBlockCacheArgs = {
  name: Scalars['String']['input'];
};

export type MutationExecuteCheckArgs = {
  resourceRelations: Array<FgaV1ResourceRelationInput>;
};

export type MutationExecuteFunctionArgs = {
  functionName: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  workflowInstance: Scalars['String']['input'];
};

export type MutationExecuteSqlArgs = {
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export type MutationExtractKnowledgeArgs = {
  fragments: Array<CollaborationV1KnowledgeFragmentInput>;
  parent: Scalars['String']['input'];
};

export type MutationExtractObservationsArgs = {
  content: Scalars['String']['input'];
  eventTime?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source: ObservationsV1SourceInput;
};

export type MutationFollowResourcesArgs = {
  activityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  feed?: InputMaybe<Scalars['String']['input']>;
  resources: Array<Scalars['String']['input']>;
};

export type MutationGenerateClientCredentialEncryptionKeyArgs = {
  name: Scalars['String']['input'];
};

export type MutationGenerateCollaborativeDocumentArgs = {
  name: Scalars['String']['input'];
};

export type MutationInitiateTarUploadArgs = {
  extension?: InputMaybe<Scalars['String']['input']>;
  fileSizeBytes: Scalars['Int']['input'];
};

export type MutationInterruptChatArgs = {
  name: Scalars['String']['input'];
};

export type MutationMarkFeedEntriesAsReadArgs = {
  entries?: InputMaybe<ActivityV1MarkFeedEntriesAsReadRequestFeedEntriesInput>;
  markRead?: InputMaybe<ActivityV1MarkFeedEntriesAsReadRequestMarkReadTimeInput>;
};

export type MutationPauseAiWorkflowScheduleArgs = {
  name: Scalars['String']['input'];
};

export type MutationPreviewAgentReviewArgs = {
  agent: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

export type MutationPreviewInsightsMetricArgs = {
  dataSource: Scalars['String']['input'];
  expression: InsightsV1ArithmeticExpressionInput;
  filter?: InputMaybe<InsightsV1FilterInput>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  timeConfig?: InputMaybe<InsightsV1TimeConfigInput>;
};

export type MutationPreviewPulseBlockArgs = {
  pulseBlock: PulseV1PulseBlockInput;
};

export type MutationPreviewSqlQueryArgs = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};

export type MutationPromotePrimaryDataWarehouseArgs = {
  name: Scalars['String']['input'];
};

export type MutationPublishCollaborativeDocumentArgs = {
  activityMessage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  publisher?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPublishMetricArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationRangeQueryArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  graph: InsightsV1GraphType;
  labelFilters?: InputMaybe<
    Array<InsightsV1RangeQueryRequestLabelFiltersEntryInput>
  >;
  startTime?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefreshPulseArgs = {
  pulse: Scalars['String']['input'];
};

export type MutationRefreshPulseBlockArgs = {
  pulseBlock: Scalars['String']['input'];
};

export type MutationRegisterManagedWorkspaceArgs = {
  account: Scalars['String']['input'];
};

export type MutationRemoveClientCredentialEncryptionKeyArgs = {
  name: Scalars['String']['input'];
};

export type MutationRemoveFlagClientArgs = {
  client: Scalars['String']['input'];
  flag: Scalars['String']['input'];
};

export type MutationRemoveGroupMembersArgs = {
  group: Scalars['String']['input'];
  identities: Array<Scalars['String']['input']>;
};

export type MutationRemoveSurfaceIdentityBindingArgs = {
  name: Scalars['String']['input'];
};

export type MutationReopenIssueArgs = {
  name: Scalars['String']['input'];
};

export type MutationReorderRecordingRulesArgs = {
  parent: Scalars['String']['input'];
  rules: Array<Scalars['String']['input']>;
};

export type MutationRequestReviewResponsesArgs = {
  name: Scalars['String']['input'];
  reviewers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationResolveFlagsVerboseArgs = {
  clientSecret: Scalars['String']['input'];
  evaluationContext?: InputMaybe<Scalars['JSON']['input']>;
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationResumeAiWorkflowScheduleArgs = {
  name: Scalars['String']['input'];
};

export type MutationResumeScheduledMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationRetriggerAllScheduledMetricCalculationsArgs = {
  factTable?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRetriggerMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationRetriggerScheduledExposureCalculationArgs = {
  name: Scalars['String']['input'];
  retriggerDependentMetricSchedules?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationRetriggerScheduledMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type MutationSegmentAvailableSpaceArgs = {
  queryParams?: InputMaybe<FlagsAdminV1SegmentAvailableSpaceRequestQueryParamsInput>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendUserMessageArgs = {
  chatEventId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  userMessage: ConversationsV2UserMessageInput;
};

export type MutationStaleReviewArgs = {
  name: Scalars['String']['input'];
};

export type MutationStartCheckoutSessionArgs = {
  creditPack?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartInvestigationArgs = {
  name: Scalars['String']['input'];
};

export type MutationStartTaskArgs = {
  name: Scalars['String']['input'];
};

export type MutationStoreSlackUserInfoArgs = {
  code: Scalars['String']['input'];
};

export type MutationSubmitReviewResponseArgs = {
  action?: InputMaybe<CollaborationV1ReviewResponseAction>;
  comment?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type MutationSuggestFactTableColumnsArgs = {
  schema: Array<MetricsV1ColumnInput>;
};

export type MutationSuggestMetricArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSyncInsightsTableContextsArgs = {
  includeEnrichment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationTakeSuggestedActionArgs = {
  name: Scalars['String']['input'];
  suggestedActionId: Scalars['String']['input'];
};

export type MutationTestWebhookArgs = {
  account: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};

export type MutationTransitionWorkflowInstanceArgs = {
  action: Scalars['String']['input'];
  actualTransitionTime?: InputMaybe<Scalars['String']['input']>;
  asyncTransition?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationUnarchiveFlagArgs = {
  name: Scalars['String']['input'];
};

export type MutationUnarchiveMetricArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationUndeleteEnvironmentArgs = {
  name: Scalars['String']['input'];
};

export type MutationUndeleteFactTableArgs = {
  name: Scalars['String']['input'];
};

export type MutationUndoReactionArgs = {
  emoji: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

export type MutationUnfollowResourcesArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
  resources: Array<Scalars['String']['input']>;
};

export type MutationUnpublishCollaborativeDocumentArgs = {
  name: Scalars['String']['input'];
};

export type MutationUpdateAgentArgs = {
  agent: PartialIamV1AgentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAiWorkflowTriggerArgs = {
  aiWorkflowTrigger: PartialAiworkflowsV1AiWorkflowTriggerInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAnalysisResultArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  analysisResult: PartialStatsV2AnalysisAnalysisResultInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateApiClientArgs = {
  apiClient: PartialIamV1ApiClientInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAssignmentTableArgs = {
  assignmentTable: PartialMetricsV1AssignmentTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAttachmentArgs = {
  attachment: PartialCollaborationV1AttachmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateChatArgs = {
  chat: PartialConversationsV2ChatInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateChatEventArgs = {
  chatEvent: PartialConversationsV2ChatEventInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCheckArgs = {
  check: WorkflowV1WorkflowInstanceCheckInput;
};

export type MutationUpdateClientArgs = {
  client: PartialIamV1ClientInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateClientCredentialArgs = {
  clientCredential: PartialIamV1ClientCredentialInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCollaborativeDocumentArgs = {
  collaborativeDocument: PartialCollaborationV1CollaborativeDocumentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCollectionArgs = {
  collection: PartialCollectionsV1CollectionInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCommentArgs = {
  comment: PartialCollaborationV1CommentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCommentReplyArgs = {
  commentReply: PartialCollaborationV1CommentReplyInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateConversationArgs = {
  conversation: PartialConversationsV1ConversationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateConversationMessageArgs = {
  conversationMessage: PartialConversationsV1ConversationMessageInput;
  parent: Scalars['String']['input'];
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateDataWarehouseArgs = {
  dataWarehouse: PartialMetricsV1DataWarehouseInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateDimensionTableArgs = {
  dimensionTable: PartialMetricsV1DimensionTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEntityArgs = {
  entity: PartialMetricsV1EntityInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEntityIdentityBindingArgs = {
  entityIdentityBinding: PartialMetricsV1EntityIdentityBindingInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEntityRelationTableArgs = {
  entityRelationTable: PartialMetricsV1EntityRelationTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEnvironmentArgs = {
  environment: PartialFlagsAdminV1EnvironmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEvaluationContextFieldOverrideArgs = {
  evaluationContextFieldOverride: PartialFlagsAdminV1EvaluationContextFieldOverrideInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEventDefinitionArgs = {
  eventDefinition: PartialEventsAdminV1EventDefinitionInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateExclusivityGroupArgs = {
  exclusivityGroup: PartialWorkflowV1ExclusivityGroupInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateExposureTableArgs = {
  exposureTable: PartialMetricsV1ExposureTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateExternalIntegrationArgs = {
  externalIntegration: PartialAiworkflowsV1ExternalIntegrationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFactTableArgs = {
  factTable: PartialMetricsV1FactTableInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFeedArgs = {
  feed: PartialActivityV1FeedInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFlagArgs = {
  flag: PartialFlagsAdminV1FlagInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateGroupArgs = {
  group: PartialIamV1GroupInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateHoldbackArgs = {
  holdback: PartialWorkflowV1HoldbackInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInitiativeArgs = {
  initiative: PartialWorkflowV1InitiativeInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInsightsDocumentArgs = {
  insightsDocument: PartialInsightsV1InsightsDocumentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInsightsMetricArgs = {
  insightsMetric: PartialInsightsV1InsightsMetricInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInsightsTableContextArgs = {
  insightsTableContext: PartialInsightsV1InsightsTableContextInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateIssueArgs = {
  issue: PartialObservationsV1IssueInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateLabelArgs = {
  label: PartialAdminLabelsV1LabelInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateLearningProgressArgs = {
  learningProgress: PartialOnboardingV1LearningProgressInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMaterializedSegmentArgs = {
  materializedSegment: PartialFlagsAdminV1MaterializedSegmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMeasurementArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  measurement: PartialMetricsV1MeasurementInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMetricArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  metric: PartialMetricsV1MetricInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateOAuthAppArgs = {
  oauthApp: PartialIamV1OAuthAppInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateObservationArgs = {
  observation: PartialObservationsV1ObservationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePolicyArgs = {
  policy: PartialIamV1PolicyInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePresenceArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  presence: PartialCollaborationV1PresenceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateProjectArgs = {
  project: PartialCollaborationV1ProjectInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePromptHookArgs = {
  promptHook: PartialConversationsV2PromptHookInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePulseArgs = {
  pulse: PartialPulseV1PulseInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePulseBlockArgs = {
  pulseBlock: PartialPulseV1PulseBlockInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRecordingPolicyArgs = {
  recordingPolicy: PartialRecordingV1RecordingPolicyInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRecordingRuleArgs = {
  recordingRule: PartialRecordingV1RecordingRuleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateReviewArgs = {
  review: PartialCollaborationV1ReviewInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRoleArgs = {
  role: PartialIamV1RoleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRuleArgs = {
  rule: PartialFlagsAdminV1FlagRuleInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateScheduledExposureCalculationArgs = {
  scheduledExposureCalculation: PartialMetricsV1ScheduledExposureCalculationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateScheduledMetricCalculationArgs = {
  scheduledMetricCalculation: PartialMetricsV1ScheduledMetricCalculationInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateSegmentArgs = {
  segment: PartialFlagsAdminV1SegmentInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateSurfaceArgs = {
  surface: PartialWorkflowV1SurfaceInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTaskArgs = {
  task: PartialObservationsV1TaskInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateThemeArgs = {
  theme: PartialObservationsV1ThemeInput;
  updateMask?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateUserArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  user: PartialIamV1UserInput;
};

export type MutationUpdateVariantArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  variant: PartialFlagsAdminV1FlagVariantInput;
};

export type MutationUpdateWorkflowArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  workflow: PartialWorkflowV1WorkflowInput;
};

export type MutationUpdateWorkflowInstanceArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  workflowInstance: PartialWorkflowV1WorkflowInstanceInput;
};

export type MutationUpdateWorkflowSecretArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  workflowSecret: PartialWorkflowV1WorkflowSecretInput;
};

export type MutationUpdateWorkflowTemplateArgs = {
  updateMask?: InputMaybe<Scalars['String']['input']>;
  workflowTemplate: PartialWorkflowV1WorkflowTemplateInput;
};

export type MutationUpgradeWorkflowInstancesArgs = {
  lowestVersion: Scalars['String']['input'];
  name: Scalars['String']['input'];
  setCurrentVersion?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationValidateDataWarehouseConfigArgs = {
  bigQueryConfig?: InputMaybe<MetricsV1BigQueryConfigInput>;
  existingWarehouse?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig?: InputMaybe<MetricsV1RedshiftConfigInput>;
  snowflakeConfig?: InputMaybe<MetricsV1ValidateSnowflakeConfigInput>;
};

export type MutationValidateEventConnectionConfigArgs = {
  bigQuery?: InputMaybe<ConnectorsV1EventConnectionBigQueryEventConnectionConfigInput>;
  databricks?: InputMaybe<ConnectorsV1EventConnectionDatabricksEventConnectionConfigInput>;
  redshift?: InputMaybe<ConnectorsV1EventConnectionRedshiftEventConnectionConfigInput>;
  snowflake?: InputMaybe<ConnectorsV1PartialSnowflakeConfigInput>;
};

export type MutationValidateFlagAppliedConnectionConfigArgs = {
  bigQuery?: InputMaybe<ConnectorsV1FlagAppliedConnectionBigQueryFlagAppliedConnectionConfigInput>;
  databricks?: InputMaybe<ConnectorsV1FlagAppliedConnectionDatabricksFlagAppliedConnectionConfigInput>;
  kinesis?: InputMaybe<ConnectorsV1FlagAppliedConnectionKinesisFlagAppliedConnectionConfigInput>;
  pubsub?: InputMaybe<ConnectorsV1FlagAppliedConnectionPubsubFlagAppliedConnectionConfigInput>;
  redshift?: InputMaybe<ConnectorsV1FlagAppliedConnectionRedshiftFlagAppliedConnectionConfigInput>;
  snowflake?: InputMaybe<ConnectorsV1PartialSnowflakeConfigInput>;
};

export type MutationValidateMetricArgs = {
  metric: MetricsV1MetricInput;
};

export type MutationValidatePlatformConnectionConfigArgs = {
  kinesis?: InputMaybe<ConnectorsV1PlatformConnectionKinesisPlatformConnectionConfigInput>;
  pubsub?: InputMaybe<ConnectorsV1PlatformConnectionPubsubPlatformConnectionConfigInput>;
};

export type MutationVerifyMetricArgs = {
  etag?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  verification: MetricsV1MetricMetricVerificationVerificationState;
};

export type MutationWriteFlagAssignedArgs = {
  flagAssigned?: InputMaybe<Array<FlagsResolverV1EventsFlagAssignedInput>>;
};

export type MutationWriteResolveInfoArgs = {
  clientResolveInfo?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestClientResolveInfoInput>
  >;
  flagResolveInfo?: InputMaybe<
    Array<FlagsAdminV1WriteResolveInfoRequestFlagResolveInfoInput>
  >;
};

export type MutationWriteResourcePermissionsArgs = {
  addPermissions?: InputMaybe<Array<FgaV1ResourcePermissionInput>>;
  removePermissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ObservationsV1EventsIssueCreated = {
  issue?: Maybe<ObservationsV1Issue>;
};

export type ObservationsV1EventsIssueDeleted = {
  deletedIssue?: Maybe<ObservationsV1Issue>;
  issue?: Maybe<ObservationsV1IssueResult>;
};

export type ObservationsV1EventsIssueUpdated = {
  issue?: Maybe<ObservationsV1Issue>;
  oldIssue?: Maybe<ObservationsV1Issue>;
};

export type ObservationsV1EventsObservationCreated = {
  observation?: Maybe<ObservationsV1Observation>;
};

export type ObservationsV1EventsObservationDeleted = {
  deletedObservation?: Maybe<ObservationsV1Observation>;
  observation?: Maybe<ObservationsV1ObservationResult>;
};

export type ObservationsV1EventsObservationUpdated = {
  observation?: Maybe<ObservationsV1Observation>;
  oldObservation?: Maybe<ObservationsV1Observation>;
};

export type ObservationsV1EventsTaskCreated = {
  task?: Maybe<ObservationsV1Task>;
};

export type ObservationsV1EventsTaskDeleted = {
  deletedTask?: Maybe<ObservationsV1Task>;
  task?: Maybe<ObservationsV1TaskResult>;
};

export type ObservationsV1EventsTaskUpdated = {
  oldTask?: Maybe<ObservationsV1Task>;
  task?: Maybe<ObservationsV1Task>;
};

export type ObservationsV1EventsThemeCreated = {
  theme?: Maybe<ObservationsV1Theme>;
};

export type ObservationsV1EventsThemeDeleted = {
  deletedTheme?: Maybe<ObservationsV1Theme>;
  theme?: Maybe<ObservationsV1ThemeResult>;
};

export type ObservationsV1EventsThemeUpdated = {
  oldTheme?: Maybe<ObservationsV1Theme>;
  theme?: Maybe<ObservationsV1Theme>;
};

export type ObservationsV1ExtractObservationsResponse = {
  deletedObservations: Array<ObservationsV1ObservationResult>;
  observations: Array<ObservationsV1Observation>;
};

export type ObservationsV1ExtractObservationsResponseResult =
  | Error
  | ObservationsV1ExtractObservationsResponse;

export type ObservationsV1Issue = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  closeReason?: Maybe<ObservationsV1IssueCloseReason>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ObservationsV1IssueLabelsEntry>;
  name: Scalars['String']['output'];
  observationActivity: Array<ObservationsV1IssueActivityBucket>;
  observationCount?: Maybe<Scalars['Int']['output']>;
  problemStatement?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  progressSummary?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  snoozedUntilTime?: Maybe<Scalars['String']['output']>;
  state: ObservationsV1IssueState;
  suggestedActions: Array<ObservationsV1IssueSuggestedAction>;
  surfaces: Array<WorkflowV1SurfaceResult>;
  theme?: Maybe<ObservationsV1ThemeResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1IssueAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssueCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1IssueCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1IssueExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1IssueQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueActivityBucket = {
  count?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1IssueActivityBucketInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export enum ObservationsV1IssueCloseReason {
  Fixed = 'FIXED',
  NonIssue = 'NON_ISSUE',
  WontFix = 'WONT_FIX',
}

export type ObservationsV1IssueInput = {
  confidenceScore?: InputMaybe<Scalars['Float']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<ObservationsV1IssueLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  snoozedUntilTime?: InputMaybe<Scalars['String']['input']>;
  suggestedActions?: InputMaybe<Array<ObservationsV1IssueSuggestedActionInput>>;
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1IssueLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1IssueResult = Error | ObservationsV1Issue;

export enum ObservationsV1IssueState {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
}

export type ObservationsV1IssueSuggestedAction = {
  chat?: Maybe<ConversationsV2ChatResult>;
  displayName: Scalars['String']['output'];
  document?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  id?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ObservationsV1IssueSuggestedActionState>;
};

export type ObservationsV1IssueSuggestedActionInput = {
  displayName: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum ObservationsV1IssueSuggestedActionState {
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Suggested = 'SUGGESTED',
}

export type ObservationsV1ListIssuesResponse = {
  issues: Array<ObservationsV1Issue>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1ListIssuesResponseResult =
  | Error
  | ObservationsV1ListIssuesResponse;

export type ObservationsV1ListObservationsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  observations: Array<ObservationsV1Observation>;
};

export type ObservationsV1ListObservationsResponseResult =
  | Error
  | ObservationsV1ListObservationsResponse;

export type ObservationsV1ListTasksResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  tasks: Array<ObservationsV1Task>;
};

export type ObservationsV1ListTasksResponseResult =
  | Error
  | ObservationsV1ListTasksResponse;

export type ObservationsV1ListThemesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  themes: Array<ObservationsV1Theme>;
};

export type ObservationsV1ListThemesResponseResult =
  | Error
  | ObservationsV1ListThemesResponse;

export type ObservationsV1Observation = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  eventTime: Scalars['String']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  issue?: Maybe<ObservationsV1IssueResult>;
  kind: Scalars['String']['output'];
  labels: Array<ObservationsV1ObservationLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source: ObservationsV1Source;
  summary: Scalars['String']['output'];
  surfaces: Array<WorkflowV1SurfaceResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1ObservationAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ObservationCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1ObservationCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ObservationExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1ObservationQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationInput = {
  eventTime: Scalars['String']['input'];
  excerpt?: InputMaybe<Scalars['String']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  labels?: InputMaybe<Array<ObservationsV1ObservationLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source: ObservationsV1SourceInput;
  summary: Scalars['String']['input'];
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ObservationsV1ObservationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1ObservationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ObservationResult = Error | ObservationsV1Observation;

export type ObservationsV1SearchIssuesHit = {
  issue: ObservationsV1Issue;
  score?: Maybe<Scalars['Float']['output']>;
};

export type ObservationsV1SearchIssuesResponse = {
  hits: Array<ObservationsV1SearchIssuesHit>;
};

export type ObservationsV1SearchIssuesResponseResult =
  | Error
  | ObservationsV1SearchIssuesResponse;

export type ObservationsV1SearchObservationsHit = {
  observation: ObservationsV1Observation;
  score?: Maybe<Scalars['Float']['output']>;
};

export type ObservationsV1SearchObservationsResponse = {
  hits: Array<ObservationsV1SearchObservationsHit>;
};

export type ObservationsV1SearchObservationsResponseResult =
  | Error
  | ObservationsV1SearchObservationsResponse;

export type ObservationsV1SearchThemesHit = {
  score?: Maybe<Scalars['Float']['output']>;
  theme: ObservationsV1Theme;
};

export type ObservationsV1SearchThemesResponse = {
  hits: Array<ObservationsV1SearchThemesHit>;
};

export type ObservationsV1SearchThemesResponseResult =
  | Error
  | ObservationsV1SearchThemesResponse;

export type ObservationsV1Source = {
  externalId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  origin: ObservationsV1SourceOrigin;
  system: Scalars['String']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1SourceInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  origin: ObservationsV1SourceOrigin;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  system: Scalars['String']['input'];
  uri?: InputMaybe<Scalars['String']['input']>;
};

export enum ObservationsV1SourceOrigin {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  System = 'SYSTEM',
}

export type ObservationsV1Task = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  dependencies: Array<ObservationsV1TaskResult>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<ObservationsV1TaskLabelsEntry>;
  name: Scalars['String']['output'];
  plan?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resource?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: ObservationsV1TaskState;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1TaskAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1TaskCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1TaskCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1TaskExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1TaskQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskInput = {
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<ObservationsV1TaskLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1TaskLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1TaskResult = Error | ObservationsV1Task;

export enum ObservationsV1TaskState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
}

export type ObservationsV1Theme = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  chat?: Maybe<ConversationsV2ChatResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  issueCount?: Maybe<Scalars['Int']['output']>;
  labels: Array<ObservationsV1ThemeLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: ObservationsV1ThemeState;
  systemCreated?: Maybe<Scalars['Boolean']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type ObservationsV1ThemeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ThemeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type ObservationsV1ThemeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObservationsV1ThemeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type ObservationsV1ThemeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeInput = {
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<ObservationsV1ThemeLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationsV1ThemeLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationsV1ThemeResult = Error | ObservationsV1Theme;

export enum ObservationsV1ThemeState {
  Idle = 'IDLE',
  Investigating = 'INVESTIGATING',
}

export type OnboardingV1AnswerQuestionsRequestQuestionUpdateInput = {
  currentAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
  lessonIndex: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionIndex: Scalars['Int']['input'];
};

export type OnboardingV1LearningProgress = {
  completedCourses?: Maybe<Scalars['Int']['output']>;
  courseProgresses: Array<OnboardingV1LearningProgressCourseProgress>;
};

export type OnboardingV1LearningProgressCourseProgress = {
  completedLessons?: Maybe<Scalars['Int']['output']>;
  course: Scalars['String']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  lessonProgresses: Array<OnboardingV1LearningProgressLessonProgress>;
};

export type OnboardingV1LearningProgressCourseProgressInput = {
  course: Scalars['String']['input'];
  lessonProgresses?: InputMaybe<
    Array<OnboardingV1LearningProgressLessonProgressInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1LearningProgressInput = {
  courseProgresses?: InputMaybe<
    Array<OnboardingV1LearningProgressCourseProgressInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1LearningProgressLessonProgress = {
  completedQuestions?: Maybe<Scalars['Int']['output']>;
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  lessonIndex: Scalars['Int']['output'];
  questionProgresses: Array<OnboardingV1LearningProgressQuestionProgress>;
};

export type OnboardingV1LearningProgressLessonProgressInput = {
  lessonIndex: Scalars['Int']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionProgresses?: InputMaybe<
    Array<OnboardingV1LearningProgressQuestionProgressInput>
  >;
};

export type OnboardingV1LearningProgressQuestionProgress = {
  correctAnswerIndex: Scalars['Int']['output'];
  currentAnswerIndex?: Maybe<Scalars['Int']['output']>;
  questionIndex: Scalars['Int']['output'];
};

export type OnboardingV1LearningProgressQuestionProgressInput = {
  currentAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionIndex: Scalars['Int']['input'];
};

export type OnboardingV1LearningProgressResult =
  | Error
  | OnboardingV1LearningProgress;

export type OnboardingV1ManagedDataWarehouseProvisioning = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  error?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: OnboardingV1ManagedDataWarehouseProvisioningState;
  updateTime: Scalars['String']['output'];
};

export type OnboardingV1ManagedDataWarehouseProvisioningAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningCollaborativeDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
  };

export type OnboardingV1ManagedDataWarehouseProvisioningCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningExternalDocumentsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
    showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    view?: InputMaybe<CollaborationV1ExternalDocumentView>;
  };

export type OnboardingV1ManagedDataWarehouseProvisioningQueryIsFollowingResourceArgs =
  {
    feed?: InputMaybe<Scalars['String']['input']>;
  };

export type OnboardingV1ManagedDataWarehouseProvisioningReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningResourcePermissionsArgs =
  {
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    pageToken?: InputMaybe<Scalars['String']['input']>;
  };

export type OnboardingV1ManagedDataWarehouseProvisioningReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingV1ManagedDataWarehouseProvisioningResult =
  | Error
  | OnboardingV1ManagedDataWarehouseProvisioning;

export enum OnboardingV1ManagedDataWarehouseProvisioningState {
  Active = 'ACTIVE',
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Failed = 'FAILED',
}

export type PartialAbTestDataInput = {
  flag?: InputMaybe<Scalars['String']['input']>;
  rollout?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialAbTestDataInputTreatmentInput>>
  >;
};

export type PartialAbTestDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialActionsV1TypesActionInput = {
  executeFunctionAction?: InputMaybe<PartialActionsV1TypesExecuteFunctionActionInput>;
  pagerdutyAction?: InputMaybe<PartialActionsV1TypesPagerDutyActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  transitionAction?: InputMaybe<PartialActionsV1TypesTransitionWorkflowActionInput>;
};

export type PartialActionsV1TypesActivityTriggerInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesAutomatedActionInput = {
  action?: InputMaybe<PartialActionsV1TypesActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<PartialActionsV1TypesTriggerInput>;
};

export type PartialActionsV1TypesExecuteFunctionActionInput = {
  function?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesPagerDutyActionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  pdKey?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<ActionsV1TypesSeverity>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesStateTriggerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesTransitionWorkflowActionInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActionsV1TypesTriggerInput = {
  activityTrigger?: InputMaybe<PartialActionsV1TypesActivityTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stateTrigger?: InputMaybe<PartialActionsV1TypesStateTriggerInput>;
};

export type PartialActivityV1FeedChannelConfigBatchingConfigInput = {
  priority?: InputMaybe<ActivityV1ActivityPriority>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedChannelConfigDigestConfigInput = {
  interval?: InputMaybe<ActivityV1FeedChannelConfigDigestConfigDigestInterval>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedChannelConfigEmailInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedChannelConfigInput = {
  activityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  batchingConfig?: InputMaybe<PartialActivityV1FeedChannelConfigBatchingConfigInput>;
  digestConfig?: InputMaybe<PartialActivityV1FeedChannelConfigDigestConfigInput>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<PartialActivityV1FeedChannelConfigEmailInput>;
  priority?: InputMaybe<ActivityV1ActivityPriority>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slack?: InputMaybe<PartialActivityV1FeedChannelConfigSlackInput>;
  webhook?: InputMaybe<PartialActivityV1FeedChannelConfigWebhookInput>;
};

export type PartialActivityV1FeedChannelConfigSlackInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedChannelConfigWebhookInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedInput = {
  channels?: InputMaybe<
    Array<InputMaybe<PartialActivityV1FeedChannelConfigInput>>
  >;
  labels?: InputMaybe<Array<InputMaybe<PartialActivityV1FeedLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialActivityV1FeedLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAdminLabelsV1LabelInput = {
  allowedValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialAdminLabelsV1LabelLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resourceTypes?: InputMaybe<Array<InputMaybe<AdminLabelsV1LabelResourceType>>>;
};

export type PartialAdminLabelsV1LabelLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ActionInput = {
  executeFunctionAction?: InputMaybe<PartialAiworkflowsV1ExecuteFunctionActionInput>;
  notifyFeedAction?: InputMaybe<PartialAiworkflowsV1NotifyFeedActionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  runPromptAction?: InputMaybe<PartialAiworkflowsV1RunPromptActionInput>;
  transitionWorkflowAction?: InputMaybe<PartialAiworkflowsV1TransitionWorkflowActionInput>;
};

export type PartialAiworkflowsV1ActivityTriggerInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1AiWorkflowTriggerInput = {
  action?: InputMaybe<PartialAiworkflowsV1ActionInput>;
  filterName?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialAiworkflowsV1AiWorkflowTriggerLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<PartialAiworkflowsV1TriggerInput>;
};

export type PartialAiworkflowsV1AiWorkflowTriggerLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1CreateClaudeAgentsIntegrationDetailsInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1CreateCursorIntegrationDetailsInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1CreateIntercomIntegrationDetailsInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1DashboardAlertTriggerInput = {
  condition?: InputMaybe<PartialAiworkflowsV1ThresholdConditionInput>;
  graphType?: InputMaybe<Scalars['String']['input']>;
  labelFilters?: InputMaybe<
    Array<
      InputMaybe<PartialAiworkflowsV1DashboardAlertTriggerLabelFiltersEntryInput>
    >
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1DashboardAlertTriggerLabelFiltersEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ExecuteFunctionActionInput = {
  function?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ExternalIntegrationInput = {
  claudeAgents?: InputMaybe<PartialAiworkflowsV1CreateClaudeAgentsIntegrationDetailsInput>;
  cursor?: InputMaybe<PartialAiworkflowsV1CreateCursorIntegrationDetailsInput>;
  github?: InputMaybe<PartialAiworkflowsV1GithubIntegrationDetailsInput>;
  intercom?: InputMaybe<PartialAiworkflowsV1CreateIntercomIntegrationDetailsInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialAiworkflowsV1ExternalIntegrationLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ExternalIntegrationLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1GithubIntegrationDetailsInput = {
  appId?: InputMaybe<Scalars['Long']['input']>;
  installationId?: InputMaybe<Scalars['Long']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1NotifyFeedActionInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<AiworkflowsV1AlertSeverity>;
};

export type PartialAiworkflowsV1RunPromptActionInput = {
  actorType?: InputMaybe<AiworkflowsV1ActorType>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<AiworkflowsV1TaskType>;
};

export type PartialAiworkflowsV1StateTriggerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1ThresholdConditionInput = {
  comparator?: InputMaybe<AiworkflowsV1Comparator>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  thresholdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialAiworkflowsV1TransitionWorkflowActionInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialAiworkflowsV1TriggerInput = {
  activityTrigger?: InputMaybe<PartialAiworkflowsV1ActivityTriggerInput>;
  dashboardAlertTrigger?: InputMaybe<PartialAiworkflowsV1DashboardAlertTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stateTrigger?: InputMaybe<PartialAiworkflowsV1StateTriggerInput>;
};

export type PartialAnalysisDataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialAnalysisDataInputTreatmentInput>>
  >;
};

export type PartialAnalysisDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialAudiencesDataInput = {
  audiences?: InputMaybe<
    Array<InputMaybe<PartialAudiencesDataInputAudienceInput>>
  >;
};

export type PartialAudiencesDataInputAudienceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialBackgroundDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PartialC4sAbTestInput = {
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  rampUpDuration?: InputMaybe<C4sAbTestInputRampUpDuration>;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialC4sAbTestInputTreatmentInput>>
  >;
};

export type PartialC4sAbTestInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyAssignments?: InputMaybe<
    Array<
      InputMaybe<PartialC4sAbTestInputTreatmentInputPropertyAssignmentInput>
    >
  >;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialC4sAbTestInputTreatmentInputPropertyAssignmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialC4sRolloutInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  monitoringDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  monitoringDisabledAt?: InputMaybe<Scalars['String']['input']>;
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<PartialC4sRolloutInputScheduleInput>;
  treatmentGroupProportion?: InputMaybe<
    Array<InputMaybe<Scalars['Long']['input']>>
  >;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialC4sRolloutInputTreatmentInput>>
  >;
};

export type PartialC4sRolloutInputScheduleInput = {
  state?: InputMaybe<C4sRolloutInputScheduleInputState>;
  stateReason?: InputMaybe<PartialC4sRolloutInputScheduleInputScheduleStateReasonInput>;
  steps?: InputMaybe<
    Array<InputMaybe<PartialC4sRolloutInputScheduleInputScheduleStepsInput>>
  >;
};

export type PartialC4sRolloutInputScheduleInputScheduleStateReasonInput = {
  failed?: InputMaybe<C4sRolloutInputScheduleInputScheduleStateReasonInputFailed>;
};

export type PartialC4sRolloutInputScheduleInputScheduleStepsInput = {
  durationSincePreviousStep?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<C4sRolloutInputScheduleInputScheduleStepsInputStatus>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialC4sRolloutInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideGroupId?: InputMaybe<Scalars['Long']['input']>;
  overrideUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  propertyAssignments?: InputMaybe<
    Array<
      InputMaybe<PartialC4sRolloutInputTreatmentInputPropertyAssignmentInput>
    >
  >;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialC4sRolloutInputTreatmentInputPropertyAssignmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1AnchorDocumentAnchorInput = {
  document?: InputMaybe<Scalars['String']['input']>;
  endNode?: InputMaybe<Scalars['String']['input']>;
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  startNode?: InputMaybe<Scalars['String']['input']>;
  startOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type PartialCollaborationV1AnchorInput = {
  document?: InputMaybe<PartialCollaborationV1AnchorDocumentAnchorInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<PartialCollaborationV1AnchorZoneAnchorInput>;
};

export type PartialCollaborationV1AnchorZoneAnchorInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1AttachmentInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1AttachmentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1AttachmentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CollaborativeDocumentInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialCollaborationV1CollaborativeDocumentLabelsEntryInput>
    >
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  realtimeEditing?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CollaborativeDocumentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CommentInput = {
  anchor?: InputMaybe<PartialCollaborationV1AnchorInput>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1CommentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CommentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CommentReplyInput = {
  action?: InputMaybe<CollaborationV1CommentReplyAction>;
  assignee?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1CommentReplyLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1CommentReplyLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1PresenceInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  initiatives?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ProjectLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<PartialCollaborationV1ProjectSummaryInput>;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialCollaborationV1ProjectLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ProjectSummaryInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ReviewInput = {
  assignedReviewers?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ReviewReviewersInput>>
  >;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ReviewLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<
    Array<InputMaybe<PartialCollaborationV1ReviewReviewerInput>>
  >;
};

export type PartialCollaborationV1ReviewLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCollaborationV1ReviewReviewerInput = {
  identity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<CollaborationV1ReviewReviewerReviewRole>;
};

export type PartialCollaborationV1ReviewReviewersInput = {
  identity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<CollaborationV1ReviewReviewersReviewRole>;
};

export type PartialCollectionsV1CollectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialCollectionsV1CollectionLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resourceTypes?: InputMaybe<Array<InputMaybe<CollectionsV1ResourceType>>>;
};

export type PartialCollectionsV1CollectionLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConclusionOneOfInput = {
  conclusion?: InputMaybe<PartialExploreDataInputAnalysisInputConclusionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialConversationsV1ApprovedToolCallInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV1ConversationInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  approvedToolCalls?: InputMaybe<
    Array<InputMaybe<PartialConversationsV1ApprovedToolCallInput>>
  >;
  lifecycle?: InputMaybe<ConversationsV1ConversationLifecycle>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ConversationsV1ConversationSource>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV1ConversationMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  generatedKind?: InputMaybe<ConversationsV1GeneratedKind>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  pendingApproval?: InputMaybe<PartialConversationsV1PendingApprovalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<ConversationsV1MessageRole>;
  toolCalls?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV1PendingApprovalInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2AssistantMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  phase?: InputMaybe<ConversationsV2AssistantMessagePhase>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ChatEventInput = {
  assistantMessage?: InputMaybe<PartialConversationsV2AssistantMessageInput>;
  clear?: InputMaybe<PartialConversationsV2ClearInput>;
  compactionResult?: InputMaybe<PartialConversationsV2CompactionResultInput>;
  compactionStart?: InputMaybe<PartialConversationsV2CompactionStartInput>;
  error?: InputMaybe<PartialConversationsV2ErrorInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialConversationsV2ChatEventLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<PartialConversationsV2NotificationInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  thinking?: InputMaybe<PartialConversationsV2ThinkingInput>;
  toolCall?: InputMaybe<PartialConversationsV2ToolCallInput>;
  toolConfirmationRequest?: InputMaybe<PartialConversationsV2ToolConfirmationRequestInput>;
  toolConfirmationResponse?: InputMaybe<PartialConversationsV2ToolConfirmationResponseInput>;
  toolResult?: InputMaybe<PartialConversationsV2ToolResultInput>;
  userInterrupt?: InputMaybe<PartialConversationsV2UserInterruptInput>;
  userMessage?: InputMaybe<PartialConversationsV2UserMessageInput>;
};

export type PartialConversationsV2ChatEventLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ChatInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialConversationsV2ChatLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ConversationsV2ChatSource>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialConversationsV2ChatLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ChildChatStoppedInput = {
  childChat?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ClearInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2CompactionResultInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2CompactionStartInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2EventTriggerInput = {
  eventType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2MessagePartInput = {
  imageUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2NotificationInput = {
  childChatStopped?: InputMaybe<PartialConversationsV2ChildChatStoppedInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2PromptHookApprovedToolInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2PromptHookInput = {
  agent?: InputMaybe<Scalars['String']['input']>;
  approvedTools?: InputMaybe<
    Array<InputMaybe<PartialConversationsV2PromptHookApprovedToolInput>>
  >;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialConversationsV2PromptHookLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  promptTemplate?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  trigger?: InputMaybe<PartialConversationsV2PromptHookTriggerInput>;
};

export type PartialConversationsV2PromptHookLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2PromptHookTriggerInput = {
  eventTrigger?: InputMaybe<PartialConversationsV2EventTriggerInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleTrigger?: InputMaybe<PartialConversationsV2ScheduleTriggerInput>;
};

export type PartialConversationsV2ScheduleTriggerInput = {
  cron?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ThinkingInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ToolCallInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ToolConfirmationRequestInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tool?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ToolConfirmationResponseInput = {
  decision?: InputMaybe<ConversationsV2ToolConfirmationResponseDecision>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  toolRequestEvent?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2ToolResultInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  toolCallEvent?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2UserInterruptInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialConversationsV2UserMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<PartialConversationsV2MessagePartInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialDecisionRecordDataInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<DecisionRecordDataInputOutcome>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialDimensionsOneOfInput = {
  metricCalculationDimensionTableDimension?: InputMaybe<PartialExploreDataInputAnalysisInputMetricInputMetricCalculationDimensionTableDimensionInput>;
  metricCalculationFactTableDimension?: InputMaybe<PartialExploreDataInputAnalysisInputMetricInputMetricCalculationFactTableDimensionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialEpTestInput = {
  myConfigField?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1EventDefinitionInput = {
  labels?: InputMaybe<
    Array<InputMaybe<PartialEventsAdminV1EventDefinitionLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<InputMaybe<PartialEventsAdminV1EventDefinitionSchemaEntryInput>>
  >;
};

export type PartialEventsAdminV1EventDefinitionLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1EventDefinitionSchemaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialEventsAdminV1EventSchemaInput>;
};

export type PartialEventsAdminV1EventSchemaBoolSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaDateSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaDoubleSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaInput = {
  boolSchema?: InputMaybe<PartialEventsAdminV1EventSchemaBoolSchemaInput>;
  dateSchema?: InputMaybe<PartialEventsAdminV1EventSchemaDateSchemaInput>;
  doubleSchema?: InputMaybe<PartialEventsAdminV1EventSchemaDoubleSchemaInput>;
  intSchema?: InputMaybe<PartialEventsAdminV1EventSchemaIntSchemaInput>;
  listSchema?: InputMaybe<PartialEventsAdminV1EventSchemaListSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringSchema?: InputMaybe<PartialEventsAdminV1EventSchemaStringSchemaInput>;
  structSchema?: InputMaybe<PartialEventsAdminV1EventSchemaStructSchemaInput>;
  timestampSchema?: InputMaybe<PartialEventsAdminV1EventSchemaTimestampSchemaInput>;
};

export type PartialEventsAdminV1EventSchemaIntSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaListSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  elementSchema?: InputMaybe<PartialEventsAdminV1EventSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1EventSchemaStringSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1EventSchemaStructSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<
      InputMaybe<PartialEventsAdminV1EventSchemaStructSchemaSchemaEntryInput>
    >
  >;
};

export type PartialEventsAdminV1EventSchemaStructSchemaSchemaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialEventsAdminV1EventSchemaInput>;
};

export type PartialEventsAdminV1EventSchemaTimestampSchemaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeInput>;
};

export type PartialEventsAdminV1FieldSemanticTypeCountrySemanticTypeInput = {
  format?: InputMaybe<EventsAdminV1FieldSemanticTypeCountrySemanticTypeCountryFormat>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1FieldSemanticTypeEntitySemanticTypeInput = {
  entity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialEventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValueInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialEventsAdminV1FieldSemanticTypeEnumSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<
    Array<
      InputMaybe<PartialEventsAdminV1FieldSemanticTypeEnumSemanticTypeEnumValueInput>
    >
  >;
};

export type PartialEventsAdminV1FieldSemanticTypeInput = {
  country?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeCountrySemanticTypeInput>;
  entityReference?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeEntitySemanticTypeInput>;
  enumType?: InputMaybe<PartialEventsAdminV1FieldSemanticTypeEnumSemanticTypeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInput = {
  exploratoryAnalyses?: InputMaybe<
    Array<InputMaybe<PartialExploreDataInputAnalysisInput>>
  >;
};

export type PartialExploreDataInputAnalysisInput = {
  analysisResults?: InputMaybe<
    Array<InputMaybe<PartialExploreDataInputAnalysisInputAnalysisResultInput>>
  >;
  conclusion?: InputMaybe<PartialConclusionOneOfInput>;
  createTime?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialExploreDataInputAnalysisInputLabelInput>>
  >;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metrics?: InputMaybe<
    Array<InputMaybe<PartialExploreDataInputAnalysisInputMetricInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  splitByExposureFilters?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ExploreDataInputAnalysisInputState>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  useCustomDateRange?: InputMaybe<Scalars['Boolean']['input']>;
  useScheduledCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialExploreDataInputAnalysisInputAnalysisResultInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  exposureFilterName?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInputAnalysisInputConclusionInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInputAnalysisInputLabelInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInputAnalysisInputMetricInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  calculationError?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialDimensionsOneOfInput>>>;
  metricCalculation?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduledCalculation?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExploreDataInputAnalysisInputMetricInputMetricCalculationDimensionTableDimensionInput =
  {
    column?: InputMaybe<Scalars['String']['input']>;
    dimensionTable?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialExploreDataInputAnalysisInputMetricInputMetricCalculationFactTableDimensionInput =
  {
    column?: InputMaybe<Scalars['String']['input']>;
    factTable?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialExposureDataInput = {
  exposure?: InputMaybe<
    Array<InputMaybe<PartialExposureDataInputExposureEntryInput>>
  >;
};

export type PartialExposureDataInputExposureEntryInput = {
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  totalExposureCount?: InputMaybe<Scalars['Long']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialExposureOneOfInput = {
  exposureCalculation?: InputMaybe<PartialSampleSizeDataInputExposureCalculationInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledExposureCalculation?: InputMaybe<PartialSampleSizeDataInputScheduledExposureCalculationInput>;
};

export type PartialExposureSourceOneOfInput = {
  assignmentTable?: InputMaybe<PartialSampleSizeDataInputAssignmentTableInput>;
  existingInstance?: InputMaybe<PartialSampleSizeDataInputExistingInstanceInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialFlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeInput =
  {
    format?: InputMaybe<FlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeCountryFormat>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1ContextFieldSemanticTypeDateSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1ContextFieldSemanticTypeEntitySemanticTypeInput =
  {
    entity?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValueInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<
    Array<
      InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeEnumValueInput>
    >
  >;
};

export type PartialFlagsAdminV1ContextFieldSemanticTypeInput = {
  country?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeCountrySemanticTypeInput>;
  date?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeDateSemanticTypeInput>;
  entityReference?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeEntitySemanticTypeInput>;
  enumType?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeEnumSemanticTypeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeTimestampSemanticTypeInput>;
  version?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeVersionSemanticTypeInput>;
};

export type PartialFlagsAdminV1ContextFieldSemanticTypeTimestampSemanticTypeInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1ContextFieldSemanticTypeVersionSemanticTypeInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1EnvironmentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1EnvironmentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1EnvironmentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1EvaluationContextFieldOverrideInput = {
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<FlagsAdminV1EvaluationContextSchemaFieldKind>;
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialFlagsAdminV1EvaluationContextFieldOverrideLabelsEntryInput>
    >
  >;
  log?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nonPii?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semanticType?: InputMaybe<PartialFlagsAdminV1ContextFieldSemanticTypeInput>;
};

export type PartialFlagsAdminV1EvaluationContextFieldOverrideLabelsEntryInput =
  {
    key?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1FlagInput = {
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<InputMaybe<PartialFlagsAdminV1FlagRuleInput>>>;
  schema?: InputMaybe<PartialFlagsTypesV1FlagSchemaStructFlagSchemaInput>;
  usageMetadata?: InputMaybe<PartialFlagsAdminV1FlagUsageMetadataInput>;
  variants?: InputMaybe<Array<InputMaybe<PartialFlagsAdminV1FlagVariantInput>>>;
};

export type PartialFlagsAdminV1FlagLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleAssignmentClientDefaultAssignmentInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsAdminV1FlagRuleAssignmentFallthroughAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleAssignmentInput = {
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  bucketRanges?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagRuleBucketRangeInput>>
  >;
  clientDefault?: InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentClientDefaultAssignmentInput>;
  fallthrough?: InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentFallthroughAssignmentInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentVariantAssignmentInput>;
};

export type PartialFlagsAdminV1FlagRuleAssignmentSpecInput = {
  assignments?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentInput>>
  >;
  bucketCount?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleAssignmentVariantAssignmentInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleBucketRangeInput = {
  lower?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['Int']['input']>;
};

export type PartialFlagsAdminV1FlagRuleInput = {
  assignmentSpec?: InputMaybe<PartialFlagsAdminV1FlagRuleAssignmentSpecInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagRuleLabelsEntryInput>>
  >;
  materializationSpec?: InputMaybe<PartialFlagsAdminV1FlagRuleMaterializationSpecInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleMaterializationSpecInput = {
  mode?: InputMaybe<PartialFlagsAdminV1FlagRuleMaterializationSpecMaterializationReadModeInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  readMaterialization?: InputMaybe<Scalars['String']['input']>;
  writeMaterialization?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1FlagRuleMaterializationSpecMaterializationReadModeInput =
  {
    materializationMustMatch?: InputMaybe<Scalars['Boolean']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    segmentTargetingCanBeIgnored?: InputMaybe<Scalars['Boolean']['input']>;
  };

export type PartialFlagsAdminV1FlagUsageMetadataInput = {
  lastApplyTime?: InputMaybe<Scalars['String']['input']>;
  lastResolveTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resolveCount?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialFlagsAdminV1FlagVariantInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1FlagVariantLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialFlagsAdminV1FlagVariantLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1MaterializedSegmentInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1MaterializedSegmentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1MaterializedSegmentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1SegmentAllocationInput = {
  exclusiveTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exclusivityTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  proportion?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1SegmentInput = {
  allocation?: InputMaybe<PartialFlagsAdminV1SegmentAllocationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialFlagsAdminV1SegmentLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<PartialFlagsTypesV1TargetingInput>;
  workflowInstance?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsAdminV1SegmentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsDataInput = {
  audiences?: InputMaybe<Array<InputMaybe<PartialFlagsDataInputAudienceInput>>>;
  flag?: InputMaybe<Scalars['String']['input']>;
  ignoreTargetingForSticky?: InputMaybe<Scalars['Boolean']['input']>;
  intakePaused?: InputMaybe<Scalars['Boolean']['input']>;
  materialization?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  stickyAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsDataInputAudienceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intakePaused?: InputMaybe<Scalars['Boolean']['input']>;
  launchTime?: InputMaybe<Scalars['String']['input']>;
  materialization?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  stopTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1ExpressionInput = {
  and?: InputMaybe<PartialFlagsTypesV1ExpressionOperandsInput>;
  not?: InputMaybe<PartialFlagsTypesV1ExpressionInput>;
  or?: InputMaybe<PartialFlagsTypesV1ExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1ExpressionOperandsInput = {
  operands?: InputMaybe<Array<InputMaybe<PartialFlagsTypesV1ExpressionInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaBoolFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaDoubleFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaInput = {
  boolSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaBoolFlagSchemaInput>;
  doubleSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaDoubleFlagSchemaInput>;
  intSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaIntFlagSchemaInput>;
  listSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaListFlagSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaStringFlagSchemaInput>;
  structSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaStructFlagSchemaInput>;
};

export type PartialFlagsTypesV1FlagSchemaIntFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaListFlagSchemaInput = {
  elementSchema?: InputMaybe<PartialFlagsTypesV1FlagSchemaInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaStringFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1FlagSchemaStructFlagSchemaInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<
    Array<
      InputMaybe<PartialFlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntryInput>
    >
  >;
};

export type PartialFlagsTypesV1FlagSchemaStructFlagSchemaSchemaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialFlagsTypesV1FlagSchemaInput>;
};

export type PartialFlagsTypesV1TargetingAllRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<PartialFlagsTypesV1TargetingInnerRuleInput>;
};

export type PartialFlagsTypesV1TargetingAnyRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rule?: InputMaybe<PartialFlagsTypesV1TargetingInnerRuleInput>;
};

export type PartialFlagsTypesV1TargetingCriteriaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialFlagsTypesV1TargetingCriterionInput>;
};

export type PartialFlagsTypesV1TargetingCriterionAttributeCriterionInput = {
  allRule?: InputMaybe<PartialFlagsTypesV1TargetingAllRuleInput>;
  anyRule?: InputMaybe<PartialFlagsTypesV1TargetingAnyRuleInput>;
  attributeName?: InputMaybe<Scalars['String']['input']>;
  endsWithRule?: InputMaybe<PartialFlagsTypesV1TargetingEndsWithRuleInput>;
  eqRule?: InputMaybe<PartialFlagsTypesV1TargetingEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialFlagsTypesV1TargetingRangeRuleInput>;
  setRule?: InputMaybe<PartialFlagsTypesV1TargetingSetRuleInput>;
  startsWithRule?: InputMaybe<PartialFlagsTypesV1TargetingStartsWithRuleInput>;
};

export type PartialFlagsTypesV1TargetingCriterionInput = {
  attribute?: InputMaybe<PartialFlagsTypesV1TargetingCriterionAttributeCriterionInput>;
  materializedSegment?: InputMaybe<PartialFlagsTypesV1TargetingCriterionMaterializedSegmentCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<PartialFlagsTypesV1TargetingCriterionSegmentCriterionInput>;
};

export type PartialFlagsTypesV1TargetingCriterionMaterializedSegmentCriterionInput =
  {
    materializedSegment?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialFlagsTypesV1TargetingCriterionSegmentCriterionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingEndsWithRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
};

export type PartialFlagsTypesV1TargetingInnerRuleInput = {
  endsWithRule?: InputMaybe<PartialFlagsTypesV1TargetingEndsWithRuleInput>;
  eqRule?: InputMaybe<PartialFlagsTypesV1TargetingEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialFlagsTypesV1TargetingRangeRuleInput>;
  setRule?: InputMaybe<PartialFlagsTypesV1TargetingSetRuleInput>;
  startsWithRule?: InputMaybe<PartialFlagsTypesV1TargetingStartsWithRuleInput>;
};

export type PartialFlagsTypesV1TargetingInput = {
  criteria?: InputMaybe<
    Array<InputMaybe<PartialFlagsTypesV1TargetingCriteriaEntryInput>>
  >;
  expression?: InputMaybe<PartialFlagsTypesV1ExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingListValueInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<
    Array<InputMaybe<PartialFlagsTypesV1TargetingValueInput>>
  >;
};

export type PartialFlagsTypesV1TargetingRangeRuleInput = {
  endExclusive?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
  endInclusive?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
  startInclusive?: InputMaybe<PartialFlagsTypesV1TargetingValueInput>;
};

export type PartialFlagsTypesV1TargetingSemanticVersionInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<
    Array<InputMaybe<PartialFlagsTypesV1TargetingValueInput>>
  >;
};

export type PartialFlagsTypesV1TargetingStartsWithRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialFlagsTypesV1TargetingValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  listValue?: InputMaybe<PartialFlagsTypesV1TargetingListValueInput>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
  versionValue?: InputMaybe<PartialFlagsTypesV1TargetingSemanticVersionInput>;
};

export type PartialGoogleTypeDecimalInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialHypothesisDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1AgentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1AgentLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pictureUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewerSkill?: InputMaybe<PartialIamV1AgentReviewerSkillInput>;
};

export type PartialIamV1AgentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1AgentReviewerSkillInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ApiClientInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1ApiClientLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ApiClientLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ClientCredentialClientSecretInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ClientCredentialInput = {
  clientSecret?: InputMaybe<PartialIamV1ClientCredentialClientSecretInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  environments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialIamV1ClientCredentialLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sdkType?: InputMaybe<IamV1ClientCredentialSdkType>;
};

export type PartialIamV1ClientCredentialLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ClientInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1ClientLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1ClientLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1GroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1GroupLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slackChannel?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1GroupLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1OAuthAppInput = {
  allowedCallbackUrls?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  allowedLogoutUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowedWebOrigins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1OAuthAppLabelsEntryInput>>>;
  logoUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1OAuthAppLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1PermissionInput = {
  category?: InputMaybe<IamV1PermissionCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IamV1PermissionType>;
};

export type PartialIamV1PolicyInput = {
  identities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1PolicyLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialIamV1PolicyLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1RoleInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1RoleLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<PartialIamV1PermissionInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1RoleLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<InputMaybe<PartialIamV1UserLabelsEntryInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureUri?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PartialIamV1UserLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ArithmeticExpressionAggregateInput = {
  average?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  count?: InputMaybe<PartialInsightsV1ArithmeticExpressionCountInput>;
  max?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  min?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sum?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
};

export type PartialInsightsV1ArithmeticExpressionCountInput = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ArithmeticExpressionDivideInput = {
  denominator?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  numerator?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ArithmeticExpressionInput = {
  aggregate?: InputMaybe<PartialInsightsV1ArithmeticExpressionAggregateInput>;
  divide?: InputMaybe<PartialInsightsV1ArithmeticExpressionDivideInput>;
  field?: InputMaybe<Scalars['String']['input']>;
  multiply?: InputMaybe<PartialInsightsV1ArithmeticExpressionOperandsInput>;
  negate?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  plus?: InputMaybe<PartialInsightsV1ArithmeticExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  subtract?: InputMaybe<PartialInsightsV1ArithmeticExpressionSubtractInput>;
  value?: InputMaybe<PartialInsightsV1ValueInput>;
};

export type PartialInsightsV1ArithmeticExpressionOperandsInput = {
  operands?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1ArithmeticExpressionInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ArithmeticExpressionSubtractInput = {
  left?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
};

export type PartialInsightsV1ExampleQueryInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterAnyRuleInput = {
  eqRule?: InputMaybe<PartialInsightsV1FilterEqRuleInput>;
  itemAttribute?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialInsightsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<PartialInsightsV1FilterSetRuleInput>;
};

export type PartialInsightsV1FilterBooleanExpressionInput = {
  and?: InputMaybe<PartialInsightsV1FilterBooleanExpressionOperandsInput>;
  not?: InputMaybe<PartialInsightsV1FilterBooleanExpressionInput>;
  or?: InputMaybe<PartialInsightsV1FilterBooleanExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterBooleanExpressionOperandsInput = {
  operands?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1FilterBooleanExpressionInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterCriteriaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialInsightsV1FilterCriterionInput>;
};

export type PartialInsightsV1FilterCriterionAttributeCriterionInput = {
  anyRule?: InputMaybe<PartialInsightsV1FilterAnyRuleInput>;
  attribute?: InputMaybe<Scalars['String']['input']>;
  eqRule?: InputMaybe<PartialInsightsV1FilterEqRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialInsightsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<PartialInsightsV1FilterSetRuleInput>;
};

export type PartialInsightsV1FilterCriterionInput = {
  attribute?: InputMaybe<PartialInsightsV1FilterCriterionAttributeCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialInsightsV1ValueInput>;
};

export type PartialInsightsV1FilterInput = {
  criteria?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1FilterCriteriaEntryInput>>
  >;
  expression?: InputMaybe<PartialInsightsV1FilterBooleanExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1FilterRangeRuleInput = {
  endExclusive?: InputMaybe<PartialInsightsV1ValueInput>;
  endInclusive?: InputMaybe<PartialInsightsV1ValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<PartialInsightsV1ValueInput>;
  startInclusive?: InputMaybe<PartialInsightsV1ValueInput>;
};

export type PartialInsightsV1FilterSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<PartialInsightsV1ValueInput>>>;
};

export type PartialInsightsV1InsightsDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1InsightsDocumentLabelsEntryInput>>
  >;
  lifecycle?: InputMaybe<InsightsV1InsightsDocumentLifecycle>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1InsightsDocumentLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1InsightsMetricInput = {
  dataSource?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  expression?: InputMaybe<PartialInsightsV1ArithmeticExpressionInput>;
  filter?: InputMaybe<PartialInsightsV1FilterInput>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1InsightsMetricLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<PartialInsightsV1TimeConfigInput>;
};

export type PartialInsightsV1InsightsMetricLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1InsightsTableContextInput = {
  capabilitySummary?: InputMaybe<Scalars['String']['input']>;
  contextMarkdown?: InputMaybe<Scalars['String']['input']>;
  ddl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  exampleQueries?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1ExampleQueryInput>>
  >;
  factTable?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialInsightsV1InsightsTableContextLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsightsV1InsightsContextSource>;
};

export type PartialInsightsV1InsightsTableContextLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1TimeAggregationConfigInput = {
  allCombinations?: InputMaybe<Scalars['Boolean']['input']>;
  maxLength?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  truncation?: InputMaybe<InsightsV1Truncation>;
  until?: InputMaybe<InsightsV1TimeSeriesEnd>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1TimeConfigInput = {
  disableDeleteTimeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeColumn?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeAggregation?: InputMaybe<PartialInsightsV1TimeAggregationConfigInput>;
  timeColumn?: InputMaybe<Scalars['String']['input']>;
};

export type PartialInsightsV1ValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateValue?: InputMaybe<Scalars['String']['input']>;
  decimalValue?: InputMaybe<PartialGoogleTypeDecimalInput>;
  intValue?: InputMaybe<Scalars['Long']['input']>;
  nullValue?: InputMaybe<InsightsV1NullValue>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetaAnalysisDataInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  experiments?: InputMaybe<
    Array<InputMaybe<PartialMetaAnalysisDataInputExperimentEntryInput>>
  >;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetaAnalysisDataInputExperimentEntryInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  instanceName?: InputMaybe<Scalars['String']['input']>;
  metricCalculations?: InputMaybe<
    Array<
      InputMaybe<PartialMetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInput>
    >
  >;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<
      InputMaybe<PartialMetaAnalysisDataInputExperimentEntryInputTreatmentEntryInput>
    >
  >;
};

export type PartialMetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInput =
  {
    calculation?: InputMaybe<Scalars['String']['input']>;
    metricName?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<MetaAnalysisDataInputExperimentEntryInputMetricCalculationEntryInputState>;
  };

export type PartialMetaAnalysisDataInputExperimentEntryInputTreatmentEntryInput =
  {
    id?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    weight?: InputMaybe<Scalars['Long']['input']>;
  };

export type PartialMetricRoleOneOfInput = {
  guardrailMetric?: InputMaybe<PartialMetricsDataInputMetricInputGuardrailMetricInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  successMetric?: InputMaybe<PartialMetricsDataInputMetricInputSuccessMetricInput>;
};

export type PartialMetricsDataInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  assignmentTableSource?: InputMaybe<MetricsDataInputAssignmentTableSource>;
  bucket?: InputMaybe<MetricsDataInputBucket>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityFilters?: InputMaybe<
    Array<InputMaybe<PartialMetricsDataInputEntityFilterInput>>
  >;
  entitySource?: InputMaybe<MetricsDataInputEntitySource>;
  exposureCalculation?: InputMaybe<Scalars['String']['input']>;
  exposureFilter?: InputMaybe<PartialMetricsDataInputExposureFilterInput>;
  exposureMetric?: InputMaybe<Scalars['String']['input']>;
  exposureMetricCalculation?: InputMaybe<Scalars['String']['input']>;
  exposureMetricSchedule?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<
    Array<InputMaybe<PartialMetricsDataInputExposureFilterInput>>
  >;
  metrics?: InputMaybe<Array<InputMaybe<PartialMetricsDataInputMetricInput>>>;
};

export type PartialMetricsDataInputEntityFilterInput = {
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsDataInputEntityFilterInputFilterInput>;
};

export type PartialMetricsDataInputEntityFilterInputFilterInput = {
  criteria?: InputMaybe<Scalars['JSON']['input']>;
  expression?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialMetricsDataInputExposureFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsDataInputExposureFilterInputFilterInput>;
};

export type PartialMetricsDataInputExposureFilterInputFilterInput = {
  criteria?: InputMaybe<Scalars['JSON']['input']>;
  expression?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialMetricsDataInputMetricInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  metricRole?: InputMaybe<PartialMetricRoleOneOfInput>;
  preferredDirection?: InputMaybe<MetricsDataInputMetricInputPreferredDirection>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
  surfaceOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialMetricsDataInputMetricInputGuardrailMetricInput = {
  metricKind?: InputMaybe<MetricsDataInputMetricInputGuardrailMetricInputMetricKind>;
  nonInferiorityMargin?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialMetricsDataInputMetricInputSuccessMetricInput = {
  metricKind?: InputMaybe<MetricsDataInputMetricInputSuccessMetricInputMetricKind>;
  minimumDetectableEffect?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialMetricsV1AggregationInput = {
  cap?: InputMaybe<PartialMetricsV1ValueCapInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<PartialMetricsV1AggregationThresholdInput>;
  type?: InputMaybe<MetricsV1AggregationType>;
};

export type PartialMetricsV1AggregationThresholdInput = {
  direction?: InputMaybe<MetricsV1AggregationThresholdDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<PartialGoogleTypeDecimalInput>;
};

export type PartialMetricsV1AssignmentTableInput = {
  assignmentDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialMetricsV1ColumnInput>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  exposureKeyColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1AssignmentTableLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  timestampColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  timestampTruncation?: InputMaybe<PartialMetricsV1TimeTruncationInput>;
  variantKeyColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
};

export type PartialMetricsV1AssignmentTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1BigQueryConfigInput = {
  dataset?: InputMaybe<Scalars['String']['input']>;
  exportJobsServiceAccount?: InputMaybe<Scalars['String']['input']>;
  gcpProjectId?: InputMaybe<Scalars['String']['input']>;
  interactiveProjectId?: InputMaybe<Scalars['String']['input']>;
  processingProjectId?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  serviceAccount?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ColumnInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  repeated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfigInput =
  {
    changeThreshold?: InputMaybe<PartialGoogleTypeDecimalInput>;
    commitDelay?: InputMaybe<Scalars['String']['input']>;
    incrementDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfigInput =
  {
    maxZeroDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfigInput =
  {
    maxZeroDuration?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigInput = {
  automaticUpdateConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigAutomaticUpdateStrategyConfigInput>;
  dailyUpdateConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigDailyUpdateStrategyConfigInput>;
  disableEmptyPartitions?: InputMaybe<Scalars['Boolean']['input']>;
  hourlyUpdateConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigHourlyUpdateStrategyConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<MetricsV1DataDeliveredUntilUpdateStrategyConfigStrategy>;
};

export type PartialMetricsV1DataWarehouseConfigInput = {
  bigQueryConfig?: InputMaybe<PartialMetricsV1BigQueryConfigInput>;
  dataBricksConfig?: InputMaybe<PartialMetricsV1DatabricksConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  redshiftConfig?: InputMaybe<PartialMetricsV1RedshiftConfigInput>;
  snowflakeConfig?: InputMaybe<PartialMetricsV1SnowflakeConfigInput>;
};

export type PartialMetricsV1DataWarehouseDataWarehouseLimitsInput = {
  maxConcurrentInteractiveQueries?: InputMaybe<Scalars['Long']['input']>;
  maxConcurrentQueries?: InputMaybe<Scalars['Long']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DataWarehouseInput = {
  config?: InputMaybe<PartialMetricsV1DataWarehouseConfigInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1DataWarehouseLabelsEntryInput>>
  >;
  limits?: InputMaybe<PartialMetricsV1DataWarehouseDataWarehouseLimitsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DataWarehouseLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DatabricksConfigInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultsSchema?: InputMaybe<Scalars['String']['input']>;
  warehouseId?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DimensionTableDimensionValueMappingInput = {
  column?: InputMaybe<Scalars['String']['input']>;
  mappings?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1DimensionTableValueMappingInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DimensionTableInput = {
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialMetricsV1ColumnInput>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityColumnMapping?: InputMaybe<PartialMetricsV1EntityColumnMappingInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1DimensionTableLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<PartialMetricsV1DimensionTableTimeConfigInput>;
  valueMappings?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1DimensionTableDimensionValueMappingInput>>
  >;
};

export type PartialMetricsV1DimensionTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DimensionTableTimeConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timestampColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  window?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1DimensionTableValueMappingInput = {
  inputDimensionValue?: InputMaybe<Scalars['String']['input']>;
  outputDimensionValue?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityColumnMappingInput = {
  column?: InputMaybe<PartialMetricsV1ColumnInput>;
  entity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityIdentityBindingInput = {
  identity?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1EntityIdentityBindingLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityIdentityBindingLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityInput = {
  defaultAssignmentTable?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1EntityLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  primaryKeyType?: InputMaybe<MetricsV1ColumnType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntityRelationTableInput = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1EntityRelationTableLabelsEntryInput>>
  >;
  owner?: InputMaybe<Scalars['String']['input']>;
  parentEntityIdColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  targetEntity?: InputMaybe<Scalars['String']['input']>;
  targetEntityIdColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
};

export type PartialMetricsV1EntityRelationTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1EntitySamplingConfigInput = {
  hashSeed?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sampleRate?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialMetricsV1ExposureCalculationGroupInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExposureCalculationSpecEntityFilterInput = {
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExposureCalculationSpecExposureFilterInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExposureCalculationSpecInput = {
  assignmentFilter?: InputMaybe<PartialMetricsV1FilterInput>;
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  entityFilter?: InputMaybe<PartialMetricsV1ExposureCalculationSpecEntityFilterInput>;
  entityFilters?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1ExposureCalculationSpecEntityFilterInput>>
  >;
  entitySampling?: InputMaybe<PartialMetricsV1EntitySamplingConfigInput>;
  exposureFilter?: InputMaybe<PartialMetricsV1ExposureCalculationSpecExposureFilterInput>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<
    Array<
      InputMaybe<PartialMetricsV1ExposureCalculationSpecExposureFilterInput>
    >
  >;
  groups?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1ExposureCalculationGroupInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  splitDimensions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialMetricsV1ExposureTableInput = {
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialMetricsV1ColumnInput>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  entityIdColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  entitySampling?: InputMaybe<PartialMetricsV1EntitySamplingConfigInput>;
  exposureDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  exposureFilterColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  firstExposureTimeColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  firstExposureTruncation?: InputMaybe<PartialMetricsV1TimeTruncationInput>;
  groupNameColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1ExposureTableLabelsEntryInput>>
  >;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExposureTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExpressionInput = {
  and?: InputMaybe<PartialMetricsV1ExpressionOperandsInput>;
  not?: InputMaybe<PartialMetricsV1ExpressionInput>;
  or?: InputMaybe<PartialMetricsV1ExpressionOperandsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ExpressionOperandsInput = {
  operands?: InputMaybe<Array<InputMaybe<PartialMetricsV1ExpressionInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FactTableInput = {
  dataDeliveredUntilUpdateStrategyConfig?: InputMaybe<PartialMetricsV1DataDeliveredUntilUpdateStrategyConfigInput>;
  dataWarehouse?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Array<InputMaybe<PartialMetricsV1ColumnInput>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entities?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1EntityColumnMappingInput>>
  >;
  factDataDeliveredUntilTime?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1FactTableLabelsEntryInput>>
  >;
  measures?: InputMaybe<Array<InputMaybe<PartialMetricsV1MeasureInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  skipSqlPreview?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<PartialMetricsV1MetricMetricSourceInput>;
  sql?: InputMaybe<Scalars['String']['input']>;
  timestampColumn?: InputMaybe<PartialMetricsV1ColumnInput>;
};

export type PartialMetricsV1FactTableLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterCriteriaEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialMetricsV1FilterCriterionInput>;
};

export type PartialMetricsV1FilterCriterionAttributeCriterionInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  eqRule?: InputMaybe<PartialMetricsV1FilterEqRuleInput>;
  likeRule?: InputMaybe<PartialMetricsV1FilterLikeRuleInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  rangeRule?: InputMaybe<PartialMetricsV1FilterRangeRuleInput>;
  setRule?: InputMaybe<PartialMetricsV1FilterSetRuleInput>;
};

export type PartialMetricsV1FilterCriterionInput = {
  attribute?: InputMaybe<PartialMetricsV1FilterCriterionAttributeCriterionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterEqRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<PartialMetricsV1FilterValueInput>;
};

export type PartialMetricsV1FilterInput = {
  criteria?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1FilterCriteriaEntryInput>>
  >;
  expression?: InputMaybe<PartialMetricsV1ExpressionInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterLikeRuleInput = {
  pattern?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterRangeRuleInput = {
  endExclusive?: InputMaybe<PartialMetricsV1FilterValueInput>;
  endInclusive?: InputMaybe<PartialMetricsV1FilterValueInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startExclusive?: InputMaybe<PartialMetricsV1FilterValueInput>;
  startInclusive?: InputMaybe<PartialMetricsV1FilterValueInput>;
};

export type PartialMetricsV1FilterSetRuleInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<PartialMetricsV1FilterValueInput>>>;
};

export type PartialMetricsV1FilterValueInput = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  nullValue?: InputMaybe<PartialMetricsV1FilterValueNullInput>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestampValue?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1FilterValueNullInput = {
  dummyField?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MeasureInput = {
  column?: InputMaybe<PartialMetricsV1ColumnInput>;
  declaredType?: InputMaybe<MetricsV1ColumnType>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<PartialMetricsV1UnitInput>;
};

export type PartialMetricsV1MeasurementInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsV1FilterInput>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1MeasurementLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  nullHandling?: InputMaybe<PartialMetricsV1MetricNullHandlingConfigInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialMetricsV1MetricMetricSourceInput>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  typeSpec?: InputMaybe<PartialMetricsV1MetricMetricTypeSpecInput>;
};

export type PartialMetricsV1MeasurementLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricAverageMetricSpecInput = {
  aggregation?: InputMaybe<PartialMetricsV1AggregationInput>;
  measurement?: InputMaybe<PartialMetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricCalculationDimensionInput = {
  column?: InputMaybe<Scalars['String']['input']>;
  dimensionTable?: InputMaybe<Scalars['String']['input']>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricCalculationSpecInput = {
  entitySampling?: InputMaybe<PartialMetricsV1EntitySamplingConfigInput>;
  exposureGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exposureTable?: InputMaybe<Scalars['String']['input']>;
  measurementTable?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scaleUpResults?: InputMaybe<Scalars['Boolean']['input']>;
  splitDimensions?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1MetricCalculationDimensionInput>>
  >;
};

export type PartialMetricsV1MetricInput = {
  aggregationWindow?: InputMaybe<Scalars['String']['input']>;
  defaultEffectSize?: InputMaybe<PartialGoogleTypeDecimalInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PartialMetricsV1FilterInput>;
  filterString?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialMetricsV1MetricLabelsEntryInput>>
  >;
  measurement?: InputMaybe<Scalars['String']['input']>;
  measurementConfig?: InputMaybe<PartialMetricsV1MetricMeasurementConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nullHandling?: InputMaybe<PartialMetricsV1MetricNullHandlingConfigInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<MetricsV1MetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialMetricsV1MetricMetricSourceInput>;
  systemCreated?: InputMaybe<Scalars['Boolean']['input']>;
  typeSpec?: InputMaybe<PartialMetricsV1MetricMetricTypeSpecInput>;
  varianceReductionConfig?: InputMaybe<PartialMetricsV1MetricVarianceReductionConfigInput>;
};

export type PartialMetricsV1MetricLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricMeasurementConfigClosedWindowConfigInput = {
  aggregationWindow?: InputMaybe<Scalars['String']['input']>;
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricMeasurementConfigInput = {
  closedWindow?: InputMaybe<PartialMetricsV1MetricMeasurementConfigClosedWindowConfigInput>;
  openWindow?: InputMaybe<PartialMetricsV1MetricMeasurementConfigOpenWindowConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  semiOpenWindow?: InputMaybe<PartialMetricsV1MetricMeasurementConfigSemiOpenWindowConfigInput>;
};

export type PartialMetricsV1MetricMeasurementConfigOpenWindowConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricMeasurementConfigSemiOpenWindowConfigInput = {
  aggregationWindow?: InputMaybe<Scalars['String']['input']>;
  exposureOffset?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricMetricSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MetricsV1MetricMetricSourceType>;
};

export type PartialMetricsV1MetricMetricTypeSpecInput = {
  averageMetricSpec?: InputMaybe<PartialMetricsV1MetricAverageMetricSpecInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileMetricSpec?: InputMaybe<PartialMetricsV1MetricQuantileMetricSpecInput>;
  ratioMetricSpec?: InputMaybe<PartialMetricsV1MetricRatioMetricSpecInput>;
};

export type PartialMetricsV1MetricNullHandlingConfigInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  replaceEntityNullWithZero?: InputMaybe<Scalars['Boolean']['input']>;
  replaceMeasureNullWithZero?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialMetricsV1MetricQuantileMetricSpecInput = {
  aggregation?: InputMaybe<PartialMetricsV1AggregationInput>;
  measurement?: InputMaybe<PartialMetricsV1ColumnInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quantileLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialMetricsV1MetricRatioMetricSpecInput = {
  denominator?: InputMaybe<PartialMetricsV1ColumnInput>;
  denominatorAggregation?: InputMaybe<PartialMetricsV1AggregationInput>;
  denominatorFilter?: InputMaybe<PartialMetricsV1FilterInput>;
  numerator?: InputMaybe<PartialMetricsV1ColumnInput>;
  numeratorAggregation?: InputMaybe<PartialMetricsV1AggregationInput>;
  numeratorFilter?: InputMaybe<PartialMetricsV1FilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1MetricVarianceReductionConfigInput = {
  aggregationWindowOverride?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1RedshiftConfigCredentialsAuthenticationSettingsInput =
  {
    accessKeyId?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    secretAccessKey?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1RedshiftConfigInput = {
  cluster?: InputMaybe<Scalars['String']['input']>;
  credentialsSettings?: InputMaybe<PartialMetricsV1RedshiftConfigCredentialsAuthenticationSettingsInput>;
  dataApiEndpoint?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<MetricsV1AwsRegion>;
  roleArn?: InputMaybe<Scalars['String']['input']>;
  webIdentitySettings?: InputMaybe<PartialMetricsV1RedshiftConfigWebIdentityAuthenticationSettingsInput>;
};

export type PartialMetricsV1RedshiftConfigWebIdentityAuthenticationSettingsInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialMetricsV1ScheduledExposureCalculationInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  exposureCalculationSpec?: InputMaybe<PartialMetricsV1ExposureCalculationSpecInput>;
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialMetricsV1ScheduledExposureCalculationLabelsEntryInput>
    >
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduleStartTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ScheduledExposureCalculationLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ScheduledMetricCalculationInput = {
  labels?: InputMaybe<
    Array<
      InputMaybe<PartialMetricsV1ScheduledMetricCalculationLabelsEntryInput>
    >
  >;
  metricCalculationSpec?: InputMaybe<PartialMetricsV1MetricCalculationSpecInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIntervals?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduleStartTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ScheduledMetricCalculationLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1SnowflakeConfigInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  authenticationKey?: InputMaybe<Scalars['String']['input']>;
  exposureDatabase?: InputMaybe<Scalars['String']['input']>;
  exposureSchema?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  warehouse?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1TimeTruncationInput = {
  behaviour?: InputMaybe<MetricsV1TruncationBehavior>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<MetricsV1TruncationTimeZone>;
  window?: InputMaybe<MetricsV1TruncationWindow>;
};

export type PartialMetricsV1UnitInput = {
  baseUnit?: InputMaybe<MetricsV1UnitBaseUnit>;
  baseUnitMultiplier?: InputMaybe<Scalars['Float']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  customUnit?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  factTable?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMetricsV1ValueCapInput = {
  max?: InputMaybe<PartialGoogleTypeDecimalInput>;
  min?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialModuleDataInput = {
  abtest?: InputMaybe<PartialAbTestDataInput>;
  analysis?: InputMaybe<PartialAnalysisDataInput>;
  audiences?: InputMaybe<PartialAudiencesDataInput>;
  background?: InputMaybe<PartialBackgroundDataInput>;
  c4sabtest?: InputMaybe<PartialC4sAbTestInput>;
  c4srollout?: InputMaybe<PartialC4sRolloutInput>;
  decision?: InputMaybe<PartialDecisionRecordDataInput>;
  eptest?: InputMaybe<PartialEpTestInput>;
  explore?: InputMaybe<PartialExploreDataInput>;
  exposure?: InputMaybe<PartialExposureDataInput>;
  flags?: InputMaybe<PartialFlagsDataInput>;
  hypothesis?: InputMaybe<PartialHypothesisDataInput>;
  metaanalysis?: InputMaybe<PartialMetaAnalysisDataInput>;
  metrics?: InputMaybe<PartialMetricsDataInput>;
  monitoring?: InputMaybe<PartialMonitoringMetricsDataInput>;
  planning?: InputMaybe<PartialPlanningDataInput>;
  reanalysis?: InputMaybe<PartialReanalysisDataInput>;
  remoteconfig?: InputMaybe<PartialRemoteConfigDataInput>;
  report?: InputMaybe<PartialReportDataInput>;
  reviews?: InputMaybe<PartialReviewsDataInput>;
  rollout?: InputMaybe<PartialRolloutDataInput>;
  samplesize?: InputMaybe<PartialSampleSizeDataInput>;
  spotifyanalysis?: InputMaybe<PartialSpotifyAnalysisInput>;
  staticconfig?: InputMaybe<PartialStaticConfigInput>;
  stats?: InputMaybe<PartialStatsDataInput>;
};

export type PartialMonitoringMetricsDataInput = {
  metrics?: InputMaybe<
    Array<InputMaybe<PartialMonitoringMetricsDataInputMonitoringMetricInput>>
  >;
  results?: InputMaybe<
    Array<
      InputMaybe<PartialMonitoringMetricsDataInputMonitoringMetricResultInput>
    >
  >;
};

export type PartialMonitoringMetricsDataInputMonitoringMetricInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<MonitoringMetricsDataInputMonitoringMetricInputPreferredDirection>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  surface?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMonitoringMetricsDataInputMonitoringMetricResultInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<
    Array<
      InputMaybe<PartialMonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInput>
    >
  >;
  metric?: InputMaybe<Scalars['String']['input']>;
};

export type PartialMonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInput =
  {
    group?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<MonitoringMetricsDataInputMonitoringMetricResultInputMonitoringGroupResultInputState>;
  };

export type PartialObservationsV1IssueInput = {
  confidenceScore?: InputMaybe<Scalars['Float']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1IssueLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  snoozedUntilTime?: InputMaybe<Scalars['String']['input']>;
  suggestedActions?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1IssueSuggestedActionInput>>
  >;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1IssueLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1IssueSuggestedActionInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1ObservationInput = {
  eventTime?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1ObservationLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialObservationsV1SourceInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialObservationsV1ObservationLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1SourceInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  origin?: InputMaybe<ObservationsV1SourceOrigin>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1TaskInput = {
  dependencies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1TaskLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1TaskLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1ThemeInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialObservationsV1ThemeLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialObservationsV1ThemeLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialOnboardingV1LearningProgressCourseProgressInput = {
  course?: InputMaybe<Scalars['String']['input']>;
  lessonProgresses?: InputMaybe<
    Array<InputMaybe<PartialOnboardingV1LearningProgressLessonProgressInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialOnboardingV1LearningProgressInput = {
  courseProgresses?: InputMaybe<
    Array<InputMaybe<PartialOnboardingV1LearningProgressCourseProgressInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialOnboardingV1LearningProgressLessonProgressInput = {
  lessonIndex?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionProgresses?: InputMaybe<
    Array<InputMaybe<PartialOnboardingV1LearningProgressQuestionProgressInput>>
  >;
};

export type PartialOnboardingV1LearningProgressQuestionProgressInput = {
  currentAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  questionIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type PartialPlanningDataInput = {
  actual?: InputMaybe<PartialPlanningDataInputPeriodInput>;
  planned?: InputMaybe<PartialPlanningDataInputPeriodInput>;
};

export type PartialPlanningDataInputPeriodInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1AgentOutputInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1AgentSourceInput = {
  instructions?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialPulseV1PulseBlockInput = {
  blockType?: InputMaybe<PulseV1PulseBlockType>;
  currentResult?: InputMaybe<PartialPulseV1PulseBlockOutputInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<PartialPulseV1PulseBlockOriginInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultData?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PartialPulseV1PulseBlockSourceInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1PulseBlockOriginInput = {
  conversation?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1PulseBlockOutputInput = {
  agentOutput?: InputMaybe<PartialPulseV1AgentOutputInput>;
  captureTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  queryResult?: InputMaybe<PartialPulseV1QueryResultInput>;
};

export type PartialPulseV1PulseBlockSourceInput = {
  agent?: InputMaybe<PartialPulseV1AgentSourceInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<PartialPulseV1SqlSourceInput>;
  staticResult?: InputMaybe<PartialPulseV1StaticResultSourceInput>;
};

export type PartialPulseV1PulseInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reportingConfig?: InputMaybe<PartialPulseV1ReportingConfigInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  userSummary?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1QueryResultInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultRef?: InputMaybe<Scalars['String']['input']>;
  visualizationSpec?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialPulseV1ReportingConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slack?: InputMaybe<PartialPulseV1SlackDestinationInput>;
};

export type PartialPulseV1SlackDestinationInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1SqlSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type PartialPulseV1StaticResultSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReanalysisDataInput = {
  configChanged?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  exposureMetricState?: InputMaybe<ReanalysisDataInputExposureMetricState>;
  exposureState?: InputMaybe<ReanalysisDataInputExposureState>;
  metrics?: InputMaybe<
    Array<InputMaybe<PartialReanalysisDataInputMetricDataInput>>
  >;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialReanalysisDataInputTreatmentInput>>
  >;
};

export type PartialReanalysisDataInputMetricDataInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ReanalysisDataInputMetricDataInputState>;
};

export type PartialReanalysisDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialRecordingV1RecordingPolicyInput = {
  clients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialRecordingV1RecordingPolicyLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRecordingV1RecordingPolicyLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRecordingV1RecordingRuleInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialRecordingV1RecordingRuleLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  sessionSampleRate?: InputMaybe<Scalars['Float']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRecordingV1RecordingRuleLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRemoteConfigDataInput = {
  epExperimentOverride?: InputMaybe<PartialRemoteConfigDataInputEpExperimentOverrideInput>;
  overridePolicyMap?: InputMaybe<Scalars['JSON']['input']>;
  policyId?: InputMaybe<Scalars['String']['input']>;
  policyName?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<
    Array<InputMaybe<PartialRemoteConfigDataInputPropertyInput>>
  >;
};

export type PartialRemoteConfigDataInputEpExperimentOverrideInput = {
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRemoteConfigDataInputPropertyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<InputMaybe<PartialSectionsOneOfInput>>>;
};

export type PartialReportDataInputHypothesisSectionInput = {
  hypothesisData?: InputMaybe<PartialReportDataInputHypothesisSectionInputHypothesisDataInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputHypothesisSectionInputHypothesisDataInput = {
  hypothesis?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputImagesSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  imagesData?: InputMaybe<PartialReportDataInputImagesSectionInputImagesDataInput>;
};

export type PartialReportDataInputImagesSectionInputImagesDataInput = {
  images?: InputMaybe<
    Array<
      InputMaybe<PartialReportDataInputImagesSectionInputImagesDataInputImageDataInput>
    >
  >;
};

export type PartialReportDataInputImagesSectionInputImagesDataInputImageDataInput =
  {
    id?: InputMaybe<Scalars['String']['input']>;
    imageUri?: InputMaybe<Scalars['String']['input']>;
    label?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialReportDataInputMetricsSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  metricsData?: InputMaybe<PartialReportDataInputMetricsSectionInputMetricsDataInput>;
};

export type PartialReportDataInputMetricsSectionInputMetricsDataInput = {
  metrics?: InputMaybe<
    Array<
      InputMaybe<PartialReportDataInputMetricsSectionInputMetricsDataInputMetricInput>
    >
  >;
};

export type PartialReportDataInputMetricsSectionInputMetricsDataInputMetricInput =
  {
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
    metric?: InputMaybe<Scalars['String']['input']>;
    metricName?: InputMaybe<Scalars['String']['input']>;
    treatments?: InputMaybe<
      Array<
        InputMaybe<PartialReportDataInputMetricsSectionInputMetricsDataInputMetricInputMetricTreatmentConfigInput>
      >
    >;
  };

export type PartialReportDataInputMetricsSectionInputMetricsDataInputMetricInputMetricTreatmentConfigInput =
  {
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
    treatment?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialReportDataInputNextSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  nextData?: InputMaybe<PartialReportDataInputNextSectionInputNextDataInput>;
};

export type PartialReportDataInputNextSectionInputNextDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputOutcomeSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  outcomeData?: InputMaybe<PartialReportDataInputOutcomeSectionInputOutcomeDataInput>;
};

export type PartialReportDataInputOutcomeSectionInputOutcomeDataInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputRecommendationSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  recommendationsData?: InputMaybe<PartialReportDataInputRecommendationSectionInputRecommendationsDataInput>;
};

export type PartialReportDataInputRecommendationSectionInputRecommendationsDataInput =
  {
    content?: InputMaybe<
      Array<
        InputMaybe<PartialReportDataInputRecommendationSectionInputRecommendationsDataInputRecommendationsContentInput>
      >
    >;
  };

export type PartialReportDataInputRecommendationSectionInputRecommendationsDataInputRecommendationsContentInput =
  {
    id?: InputMaybe<Scalars['String']['input']>;
    shippingRecommendation?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    variant?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialReportDataInputResultsSectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  resultsData?: InputMaybe<PartialReportDataInputResultsSectionInputResultsDataInput>;
};

export type PartialReportDataInputResultsSectionInputResultsDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReportDataInputSummarySectionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  summaryData?: InputMaybe<PartialReportDataInputSummarySectionInputSummaryDataInput>;
};

export type PartialReportDataInputSummarySectionInputSummaryDataInput = {
  imageUri?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReviewsDataInput = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  optionalReviews?: InputMaybe<
    Array<InputMaybe<PartialReviewsDataInputSurfaceReviewDataInput>>
  >;
  requiredReviews?: InputMaybe<
    Array<InputMaybe<PartialReviewsDataInputSurfaceReviewDataInput>>
  >;
  reviewId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReviewsDataInputStatus>;
};

export type PartialReviewsDataInputSurfaceReviewDataInput = {
  responses?: InputMaybe<
    Array<
      InputMaybe<PartialReviewsDataInputSurfaceReviewDataInputResponseInput>
    >
  >;
  state?: InputMaybe<ReviewsDataInputSurfaceReviewDataInputState>;
  surface?: InputMaybe<Scalars['String']['input']>;
};

export type PartialReviewsDataInputSurfaceReviewDataInputResponseInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  reviewer?: InputMaybe<Scalars['String']['input']>;
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<ReviewsDataInputSurfaceReviewDataInputResponseInputState>;
};

export type PartialRolloutDataInput = {
  abtest?: InputMaybe<Scalars['String']['input']>;
  controlAssignmentId?: InputMaybe<Scalars['String']['input']>;
  controlVariant?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  initialReach?: InputMaybe<Scalars['String']['input']>;
  monitoringDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  reusableBucketRanges?: InputMaybe<
    Array<InputMaybe<PartialRolloutDataInputBucketRangeInput>>
  >;
  schedule?: InputMaybe<PartialRolloutDataInputScheduleInput>;
  treatmentGroupProportion?: InputMaybe<Scalars['Float']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variantAssignmentId?: InputMaybe<Scalars['String']['input']>;
  variantImageUri?: InputMaybe<Scalars['String']['input']>;
};

export type PartialRolloutDataInputBucketRangeInput = {
  lower?: InputMaybe<Scalars['Long']['input']>;
  upper?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialRolloutDataInputScheduleInput = {
  state?: InputMaybe<RolloutDataInputScheduleInputState>;
  stateReason?: InputMaybe<PartialRolloutDataInputScheduleInputScheduleStateReasonInput>;
  steps?: InputMaybe<
    Array<InputMaybe<PartialRolloutDataInputScheduleInputScheduleStepsInput>>
  >;
};

export type PartialRolloutDataInputScheduleInputScheduleStateReasonInput = {
  failed?: InputMaybe<RolloutDataInputScheduleInputScheduleStateReasonInputFailed>;
};

export type PartialRolloutDataInputScheduleInputScheduleStepsInput = {
  durationSincePreviousStep?: InputMaybe<Scalars['String']['input']>;
  reach?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RolloutDataInputScheduleInputScheduleStepsInputStatus>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInput = {
  assignmentTableData?: InputMaybe<PartialSampleSizeDataInputAssignmentTableDataInput>;
  error?: InputMaybe<Scalars['String']['input']>;
  existingInstanceData?: InputMaybe<PartialSampleSizeDataInputExistingInstanceDataInput>;
  exposure?: InputMaybe<PartialExposureOneOfInput>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  exposureCalculationData?: InputMaybe<PartialSampleSizeDataInputExposureCalculationDataInput>;
  exposureCalculationName?: InputMaybe<Scalars['String']['input']>;
  exposureKind?: InputMaybe<SampleSizeDataInputExposureKind>;
  exposureSource?: InputMaybe<PartialExposureSourceOneOfInput>;
  exposureSourceKind?: InputMaybe<SampleSizeDataInputExposureSourceKind>;
  hasCustomizedExposureSource?: InputMaybe<Scalars['Boolean']['input']>;
  metrics?: InputMaybe<
    Array<InputMaybe<PartialSampleSizeDataInputSampleSizeMetricInput>>
  >;
  powerAnalysis?: InputMaybe<Scalars['JSON']['input']>;
  request?: InputMaybe<Scalars['JSON']['input']>;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  scheduledExposureCalculationData?: InputMaybe<PartialSampleSizeDataInputScheduledExposureCalculationDataInput>;
  state?: InputMaybe<SampleSizeDataInputState>;
  statsParameters?: InputMaybe<PartialSampleSizeDataInputStatsParametersInput>;
  statsTestConfiguration?: InputMaybe<Scalars['JSON']['input']>;
  useScheduledCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialSampleSizeDataInputAssignmentTableDataInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PartialSampleSizeDataInputAssignmentTableDataInputSampleSizeFilterInput>;
};

export type PartialSampleSizeDataInputAssignmentTableDataInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputAssignmentTableInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  customEndTime?: InputMaybe<Scalars['String']['input']>;
  customStartTime?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PartialSampleSizeDataInputAssignmentTableInputSampleSizeFilterInput>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  samplingFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialSampleSizeDataInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputExistingInstanceDataInput = {
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  workflowInstance?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputExistingInstanceInput = {
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  workflowInstance?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputExposureCalculationDataInput = {
  assignmentTable?: InputMaybe<PartialSampleSizeDataInputExposureCalculationDataInputAssignmentTableInput>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputExposureCalculationDataInputAssignmentTableInput =
  {
    assignmentTable?: InputMaybe<Scalars['String']['input']>;
    filters?: InputMaybe<PartialSampleSizeDataInputExposureCalculationDataInputAssignmentTableInputSampleSizeFilterInput>;
  };

export type PartialSampleSizeDataInputExposureCalculationDataInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputExposureCalculationInput = {
  assignmentTable?: InputMaybe<PartialSampleSizeDataInputExposureCalculationInputAssignmentTableInput>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  exposureCalculationName?: InputMaybe<Scalars['String']['input']>;
  scheduledExposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputExposureCalculationInputAssignmentTableInput =
  {
    assignmentTable?: InputMaybe<Scalars['String']['input']>;
    customEndTime?: InputMaybe<Scalars['String']['input']>;
    customStartTime?: InputMaybe<Scalars['String']['input']>;
    filters?: InputMaybe<PartialSampleSizeDataInputExposureCalculationInputAssignmentTableInputSampleSizeFilterInput>;
    runtime?: InputMaybe<Scalars['String']['input']>;
    samplingFactor?: InputMaybe<Scalars['Float']['input']>;
  };

export type PartialSampleSizeDataInputExposureCalculationInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputSampleSizeMetricInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  forecastedData?: InputMaybe<
    Array<
      InputMaybe<PartialSampleSizeDataInputSampleSizeMetricInputForecastedDataPointInput>
    >
  >;
  metric?: InputMaybe<Scalars['String']['input']>;
  metricCalculation?: InputMaybe<Scalars['JSON']['input']>;
  metricCalculationName?: InputMaybe<Scalars['String']['input']>;
  observedData?: InputMaybe<
    Array<
      InputMaybe<PartialSampleSizeDataInputSampleSizeMetricInputObservedDataPointInput>
    >
  >;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  scheduledMetricCalculation?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputState>;
  summaryStats?: InputMaybe<PartialSampleSizeDataInputSampleSizeMetricInputSummaryStatsInput>;
  type?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputType>;
};

export type PartialSampleSizeDataInputSampleSizeMetricInputForecastedDataPointInput =
  {
    dayIndex?: InputMaybe<Scalars['Long']['input']>;
    expectedSampleSize?: InputMaybe<Scalars['Long']['input']>;
    requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  };

export type PartialSampleSizeDataInputSampleSizeMetricInputObservedDataPointInput =
  {
    dayIndex?: InputMaybe<Scalars['Long']['input']>;
    expectedSampleSize?: InputMaybe<Scalars['Long']['input']>;
    mean?: InputMaybe<Scalars['Float']['input']>;
    requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
    variance?: InputMaybe<Scalars['Float']['input']>;
  };

export type PartialSampleSizeDataInputSampleSizeMetricInputSummaryStatsInput = {
  count?: InputMaybe<Scalars['Long']['input']>;
  mean?: InputMaybe<Scalars['Float']['input']>;
  variance?: InputMaybe<Scalars['Float']['input']>;
  varianceReductionRate?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialSampleSizeDataInputScheduledExposureCalculationDataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  existingInstance?: InputMaybe<PartialSampleSizeDataInputScheduledExposureCalculationDataInputExistingInstanceInput>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputScheduledExposureCalculationDataInputExistingInstanceInput =
  {
    exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
    workflowInstance?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputScheduledExposureCalculationInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  existingInstance?: InputMaybe<PartialSampleSizeDataInputScheduledExposureCalculationInputExistingInstanceInput>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialSampleSizeDataInputScheduledExposureCalculationInputExistingInstanceInput =
  {
    exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
    workflowInstance?: InputMaybe<Scalars['String']['input']>;
  };

export type PartialSampleSizeDataInputStatsParametersInput = {
  allocationProportion?: InputMaybe<Scalars['String']['input']>;
  alpha?: InputMaybe<Scalars['Float']['input']>;
  power?: InputMaybe<Scalars['Float']['input']>;
  testHorizonStrategy?: InputMaybe<SampleSizeDataInputStatsParametersInputTestHorizonStrategy>;
};

export type PartialSectionsOneOfInput = {
  hypothesisSection?: InputMaybe<PartialReportDataInputHypothesisSectionInput>;
  imagesSection?: InputMaybe<PartialReportDataInputImagesSectionInput>;
  metricsSection?: InputMaybe<PartialReportDataInputMetricsSectionInput>;
  nextSection?: InputMaybe<PartialReportDataInputNextSectionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  outcomeSection?: InputMaybe<PartialReportDataInputOutcomeSectionInput>;
  recommendationSection?: InputMaybe<PartialReportDataInputRecommendationSectionInput>;
  resultsSection?: InputMaybe<PartialReportDataInputResultsSectionInput>;
  summarySection?: InputMaybe<PartialReportDataInputSummarySectionInput>;
};

export type PartialSpotifyAnalysisInput = {
  experimentId?: InputMaybe<Scalars['Long']['input']>;
  mhMetrics?: InputMaybe<
    Array<InputMaybe<PartialSpotifyAnalysisInputMhMetricInput>>
  >;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialSpotifyAnalysisInputTreatmentInput>>
  >;
};

export type PartialSpotifyAnalysisInputMhMetricInput = {
  expectedSampleSize?: InputMaybe<Scalars['String']['input']>;
  guardrail?: InputMaybe<PartialSpotifyAnalysisInputMhMetricInputGuardrailInput>;
  metricName?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['JSON']['input']>;
  success?: InputMaybe<PartialSpotifyAnalysisInputMhMetricInputSuccessInput>;
  userCreated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialSpotifyAnalysisInputMhMetricInputGuardrailInput = {
  nonInferiorityMargin?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialSpotifyAnalysisInputMhMetricInputSuccessInput = {
  minimumDetectableEffect?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialSpotifyAnalysisInputTreatmentInput = {
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialStaticConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  propertyAssignments?: InputMaybe<
    Array<InputMaybe<PartialStaticConfigInputPropertyAssignmentInput>>
  >;
  treatmentId?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialStaticConfigInputPropertyAssignmentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsDataInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  analysisResults?: InputMaybe<
    Array<InputMaybe<PartialStatsDataInputAnalysisResultInput>>
  >;
  fallbackSampleSize?: InputMaybe<Scalars['String']['input']>;
  metricInformation?: InputMaybe<
    Array<InputMaybe<PartialStatsDataInputMetricInformationInput>>
  >;
  metricMethods?: InputMaybe<
    Array<InputMaybe<PartialStatsDataInputMethodInput>>
  >;
  power?: InputMaybe<Scalars['Float']['input']>;
  testHorizonStrategy?: InputMaybe<StatsDataInputTestHorizonStrategy>;
};

export type PartialStatsDataInputAnalysisResultInput = {
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  exposureFilterName?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsDataInputMethodInput = {
  method?: InputMaybe<StatsDataInputMethodInputMethod>;
  metricName?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsDataInputMetricInformationInput = {
  expectedSampleSize?: InputMaybe<Scalars['String']['input']>;
  metricName?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisAnalysisResultInput = {
  annotations?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsAnnotationInput>>
  >;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisAnalysisResultLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsHypothesisResultInput>>
  >;
  treatments?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisTreatmentInfoInput>>
  >;
};

export type PartialStatsV2AnalysisAnalysisResultLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisEstimateInput = {
  estimate?: InputMaybe<Scalars['Float']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  lower?: InputMaybe<Scalars['Float']['input']>;
  powered?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialStatsV2AnalysisMetricDetailsInput = {
  direction?: InputMaybe<StatsV2AnalysisMetricDirection>;
  hasRun?: InputMaybe<Scalars['Boolean']['input']>;
  metricType?: InputMaybe<StatsV2AnalysisMetricType>;
  plannedEffectSize?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisMetricStatusInput = {
  decisionIsSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  decisionPowered?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metricType?: InputMaybe<StatsV2AnalysisMetricType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatsV2AnalysisMetricResultStatus>;
  validationIsSignificant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartialStatsV2AnalysisRecommendationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<StatsV2AnalysisShippingRecommendation>;
  status?: InputMaybe<PartialStatsV2AnalysisRecommendationStatusInput>;
};

export type PartialStatsV2AnalysisRecommendationStatusInput = {
  guardrail?: InputMaybe<StatsV2AnalysisGuardrailStatus>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<StatsV2AnalysisQualityStatus>;
  success?: InputMaybe<StatsV2AnalysisSuccessStatus>;
  tanking?: InputMaybe<StatsV2AnalysisTankingStatus>;
};

export type PartialStatsV2AnalysisSampleSizeEstimateInput = {
  current?: InputMaybe<Scalars['Long']['input']>;
  poweredEffectAbs?: InputMaybe<Scalars['Float']['input']>;
  poweredEffectRel?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialStatsV2AnalysisSrmGroupResultInput = {
  expected?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  observed?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisSrmResultDimensionsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisSrmResultInput = {
  dimensions?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisSrmResultDimensionsEntryInput>>
  >;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisSrmGroupResultInput>>
  >;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PartialStatsV2AnalysisMetricStatusInput>;
};

export type PartialStatsV2AnalysisStatsAnnotationContextItemInput = {
  key?: InputMaybe<StatsV2AnalysisStatsAnnotationContext>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsAnnotationErrorInput = {
  category?: InputMaybe<StatsV2AnalysisStatsAnnotationErrorCategory>;
  details?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsAnnotationInput = {
  context?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsAnnotationContextItemInput>>
  >;
  error?: InputMaybe<PartialStatsV2AnalysisStatsAnnotationErrorInput>;
  info?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  warning?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsComparisonPairInput = {
  baseline?: InputMaybe<Scalars['String']['input']>;
  compared?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsComparisonResultDimensionsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisStatsComparisonResultInput = {
  comparisonId?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<
    Array<
      InputMaybe<PartialStatsV2AnalysisStatsComparisonResultDimensionsEntryInput>
    >
  >;
  groupStats?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsGroupStatsInput>>
  >;
  groups?: InputMaybe<PartialStatsV2AnalysisStatsComparisonPairInput>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  lastDeteriorationResult?: InputMaybe<PartialStatsV2AnalysisStatsResultInput>;
  lastResult?: InputMaybe<PartialStatsV2AnalysisStatsResultInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsResultInput>>
  >;
  sampleSize?: InputMaybe<PartialStatsV2AnalysisSampleSizeEstimateInput>;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PartialStatsV2AnalysisMetricStatusInput>;
  usedDataType?: InputMaybe<StatsV2AnalysisStatsDataType>;
};

export type PartialStatsV2AnalysisStatsGroupStatsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sampleSize?: InputMaybe<Scalars['Long']['input']>;
};

export type PartialStatsV2AnalysisStatsHypothesisResultInput = {
  annotations?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsAnnotationInput>>
  >;
  id?: InputMaybe<Scalars['String']['input']>;
  metricDetails?: InputMaybe<PartialStatsV2AnalysisMetricDetailsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisStatsComparisonResultInput>>
  >;
  srmResult?: InputMaybe<
    Array<InputMaybe<PartialStatsV2AnalysisSrmResultInput>>
  >;
  statsSettings?: InputMaybe<PartialStatsV2AnalysisStatsSettingsInput>;
};

export type PartialStatsV2AnalysisStatsResultInput = {
  baselineEstimateAbs?: InputMaybe<Scalars['Float']['input']>;
  baselineEstimateRel?: InputMaybe<Scalars['Float']['input']>;
  baselineSampleSize?: InputMaybe<Scalars['Long']['input']>;
  comparedEstimateAbs?: InputMaybe<Scalars['Float']['input']>;
  comparedEstimateRel?: InputMaybe<Scalars['Float']['input']>;
  comparedSampleSize?: InputMaybe<Scalars['Long']['input']>;
  differenceEstimateAbs?: InputMaybe<PartialStatsV2AnalysisEstimateInput>;
  differenceEstimateRel?: InputMaybe<PartialStatsV2AnalysisEstimateInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultTime?: InputMaybe<Scalars['String']['input']>;
  unadjustedEstimateBaseline?: InputMaybe<Scalars['Float']['input']>;
  unadjustedEstimateCompared?: InputMaybe<Scalars['Float']['input']>;
  varianceReductionRate?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialStatsV2AnalysisStatsSettingsInput = {
  adjustedAlpha?: InputMaybe<Scalars['Float']['input']>;
  adjustedBeta?: InputMaybe<Scalars['Float']['input']>;
  hasVarianceReduction?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<StatsV2AnalysisMethod>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialStatsV2AnalysisTreatmentInfoInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<PartialStatsV2AnalysisRecommendationInput>;
};

export type PartialWorkflowV1ExclusivityGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1ExclusivityGroupLabelsEntryInput>>
  >;
  mode?: InputMaybe<WorkflowV1ExclusivityGroupMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1ExclusivityGroupLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1HoldbackInput = {
  allocation?: InputMaybe<PartialGoogleTypeDecimalInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1HoldbackLabelsEntryInput>>
  >;
  mode?: InputMaybe<WorkflowV1HoldbackMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1HoldbackLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeAssociatedMetricInput = {
  guardrailMetric?: InputMaybe<PartialWorkflowV1InitiativeGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1InitiativePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1InitiativeSuccessMetricInput>;
};

export type PartialWorkflowV1InitiativeGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeInput = {
  automatedActions?: InputMaybe<
    Array<InputMaybe<PartialActionsV1TypesAutomatedActionInput>>
  >;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1InitiativeLabelsEntryInput>>
  >;
  metricConfig?: InputMaybe<PartialWorkflowV1InitiativeMetricConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<PartialWorkflowV1InitiativeReviewsInput>;
  stakeholders?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1InitiativeStakeholderInput>>
  >;
};

export type PartialWorkflowV1InitiativeLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeMetricConfigInput = {
  associatedMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1InitiativeAssociatedMetricInput>>
  >;
  mandatoryMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1InitiativeMetricInput>>
  >;
  metrics?: InputMaybe<Array<InputMaybe<PartialWorkflowV1LinkedMetricInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeMetricInput = {
  guardrailMetric?: InputMaybe<PartialWorkflowV1InitiativeGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1InitiativePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1InitiativeSuccessMetricInput>;
};

export type PartialWorkflowV1InitiativeReviewsInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialWorkflowV1InitiativeStakeholderInput = {
  identity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1InitiativeSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1LinkedMetricGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1LinkedMetricInput = {
  enforcementLevel?: InputMaybe<WorkflowV1EnforcementLevel>;
  guardrailMetric?: InputMaybe<PartialWorkflowV1LinkedMetricGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1LinkedMetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1LinkedMetricSuccessMetricInput>;
};

export type PartialWorkflowV1LinkedMetricSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceAssociatedMetricInput = {
  guardrailMetric?: InputMaybe<PartialWorkflowV1SurfaceGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1SurfacePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1SurfaceSuccessMetricInput>;
};

export type PartialWorkflowV1SurfaceGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceInput = {
  automatedActions?: InputMaybe<
    Array<InputMaybe<PartialActionsV1TypesAutomatedActionInput>>
  >;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceLabelsEntryInput>>
  >;
  metricConfig?: InputMaybe<PartialWorkflowV1SurfaceMetricConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<PartialWorkflowV1SurfaceReviewsInput>;
  stakeholders?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceStakeholderInput>>
  >;
};

export type PartialWorkflowV1SurfaceLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceMetricConfigInput = {
  associatedMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceAssociatedMetricInput>>
  >;
  mandatoryMetrics?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1SurfaceMetricInput>>
  >;
  metrics?: InputMaybe<Array<InputMaybe<PartialWorkflowV1LinkedMetricInput>>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceMetricInput = {
  guardrailMetric?: InputMaybe<PartialWorkflowV1SurfaceGuardrailMetricInput>;
  metric?: InputMaybe<Scalars['String']['input']>;
  preferredDirection?: InputMaybe<WorkflowV1SurfacePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<PartialWorkflowV1SurfaceSuccessMetricInput>;
};

export type PartialWorkflowV1SurfaceReviewsInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartialWorkflowV1SurfaceStakeholderInput = {
  identity?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1SurfaceSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<PartialGoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInput = {
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  initiatives?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobQueue?: InputMaybe<PartialWorkflowV1WorkflowInstanceWorkflowJobQueueInput>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowInstanceLabelsEntryInput>>
  >;
  moduleData?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowInstanceModuleDataEntryInput>>
  >;
  moduleData2?: InputMaybe<PartialModuleDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  template?: InputMaybe<Scalars['String']['input']>;
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceModuleDataEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceWorkflowJobInput = {
  func?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  runTime?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowInstanceWorkflowJobQueueInput = {
  items?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowInstanceWorkflowJobInput>>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowSecretInput = {
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowSecretLabelsEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowSecretLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  initiatives?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labels?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowTemplateLabelsEntryInput>>
  >;
  moduleData?: InputMaybe<
    Array<InputMaybe<PartialWorkflowV1WorkflowTemplateModuleDataEntryInput>>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceInstance?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowTemplateLabelsEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PartialWorkflowV1WorkflowTemplateModuleDataEntryInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type PlanningData = {
  actual?: Maybe<PlanningDataPeriod>;
  planned?: Maybe<PlanningDataPeriod>;
};

export type PlanningDataInput = {
  actual?: InputMaybe<PlanningDataInputPeriodInput>;
  planned?: InputMaybe<PlanningDataInputPeriodInput>;
};

export type PlanningDataInputPeriodInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type PlanningDataPeriod = {
  endTime?: Maybe<Scalars['String']['output']>;
  runtime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type PulseV1AgentOutput = {
  content: Scalars['String']['output'];
};

export type PulseV1AgentOutputInput = {
  content: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1AgentSource = {
  instructions: Scalars['String']['output'];
  tools: Array<Scalars['String']['output']>;
};

export type PulseV1AgentSourceInput = {
  instructions: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PulseV1CapturePulseBlockResponse = {
  block?: Maybe<PulseV1PulseBlock>;
  pulse?: Maybe<PulseV1Pulse>;
};

export type PulseV1CapturePulseBlockResponseResult =
  | Error
  | PulseV1CapturePulseBlockResponse;

export type PulseV1ConfigurePulseRefreshScheduleResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type PulseV1ConfigurePulseRefreshScheduleResponseResult =
  | Error
  | PulseV1ConfigurePulseRefreshScheduleResponse;

export type PulseV1EventsPulseCreated = {
  pulse?: Maybe<PulseV1Pulse>;
};

export type PulseV1EventsPulseUpdated = {
  pulse?: Maybe<PulseV1Pulse>;
};

export type PulseV1ListPulseBlocksResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pulseBlocks: Array<PulseV1PulseBlock>;
};

export type PulseV1ListPulseBlocksResponseResult =
  | Error
  | PulseV1ListPulseBlocksResponse;

export type PulseV1ListPulsesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  pulses: Array<PulseV1Pulse>;
};

export type PulseV1ListPulsesResponseResult = Error | PulseV1ListPulsesResponse;

export type PulseV1Pulse = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  blocks: Array<PulseV1PulseBlock>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  projects: Array<CollaborationV1ProjectResult>;
  pulseBlocks?: Maybe<PulseV1ListPulseBlocksResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  reportingConfig?: Maybe<PulseV1ReportingConfig>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryStale?: Maybe<Scalars['Boolean']['output']>;
  summaryUpdateTime?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  userSummary?: Maybe<Scalars['String']['output']>;
  userSummaryUpdateTime?: Maybe<Scalars['String']['output']>;
};

export type PulseV1PulseAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type PulseV1PulseCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type PulseV1PulsePulseBlocksArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlock = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  blockType?: Maybe<PulseV1PulseBlockType>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  currentResult?: Maybe<PulseV1PulseBlockOutput>;
  displayName?: Maybe<Scalars['String']['output']>;
  error?: Maybe<PulseV1PulseBlockError>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  name: Scalars['String']['output'];
  origin?: Maybe<PulseV1PulseBlockOrigin>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  refreshTime?: Maybe<Scalars['String']['output']>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  source?: Maybe<PulseV1PulseBlockSource>;
  state?: Maybe<PulseV1PulseBlockState>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryUpdateTime?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type PulseV1PulseBlockAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseBlockCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type PulseV1PulseBlockCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PulseV1PulseBlockExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type PulseV1PulseBlockQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type PulseV1PulseBlockErrorInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockInput = {
  blockType?: InputMaybe<PulseV1PulseBlockType>;
  currentResult?: InputMaybe<PulseV1PulseBlockOutputInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<PulseV1PulseBlockOriginInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultData?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<PulseV1PulseBlockSourceInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockOrigin = {
  conversation?: Maybe<Scalars['String']['output']>;
  event?: Maybe<ConversationsV2ChatEventResult>;
  message?: Maybe<Scalars['String']['output']>;
};

export type PulseV1PulseBlockOriginInput = {
  conversation?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1PulseBlockOutput = {
  agentOutput?: Maybe<PulseV1AgentOutput>;
  captureTime?: Maybe<Scalars['String']['output']>;
  queryResult?: Maybe<PulseV1QueryResult>;
};

export type PulseV1PulseBlockOutputInput = {
  agentOutput?: InputMaybe<PulseV1AgentOutputInput>;
  captureTime?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  queryResult?: InputMaybe<PulseV1QueryResultInput>;
};

export type PulseV1PulseBlockResult = Error | PulseV1PulseBlock;

export type PulseV1PulseBlockSource = {
  agent?: Maybe<PulseV1AgentSource>;
  sql?: Maybe<PulseV1SqlSource>;
  staticResult?: Maybe<PulseV1StaticResultSource>;
};

export type PulseV1PulseBlockSourceInput = {
  agent?: InputMaybe<PulseV1AgentSourceInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sql?: InputMaybe<PulseV1SqlSourceInput>;
  staticResult?: InputMaybe<PulseV1StaticResultSourceInput>;
};

export enum PulseV1PulseBlockState {
  Active = 'ACTIVE',
  Error = 'ERROR',
  Pending = 'PENDING',
}

export enum PulseV1PulseBlockType {
  PulseBlockTypeBigNumber = 'PULSE_BLOCK_TYPE_BIG_NUMBER',
  PulseBlockTypeChart = 'PULSE_BLOCK_TYPE_CHART',
  PulseBlockTypeTable = 'PULSE_BLOCK_TYPE_TABLE',
  PulseBlockTypeText = 'PULSE_BLOCK_TYPE_TEXT',
}

export type PulseV1PulseInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  projects?: InputMaybe<Array<Scalars['String']['input']>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reportingConfig?: InputMaybe<PulseV1ReportingConfigInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  userSummary?: InputMaybe<Scalars['String']['input']>;
};

export enum PulseV1PulseRefreshSchedule {
  PulseRefreshScheduleDaily = 'PULSE_REFRESH_SCHEDULE_DAILY',
  PulseRefreshScheduleHourly = 'PULSE_REFRESH_SCHEDULE_HOURLY',
  PulseRefreshScheduleOff = 'PULSE_REFRESH_SCHEDULE_OFF',
  PulseRefreshScheduleWeekly = 'PULSE_REFRESH_SCHEDULE_WEEKLY',
}

export type PulseV1PulseResult = Error | PulseV1Pulse;

export enum PulseV1PulseView {
  PulseViewBasic = 'PULSE_VIEW_BASIC',
  PulseViewFull = 'PULSE_VIEW_FULL',
}

export type PulseV1QueryResult = {
  resultData?: Maybe<Scalars['String']['output']>;
  resultRef?: Maybe<Scalars['String']['output']>;
  visualizationSpec?: Maybe<Scalars['JSON']['output']>;
};

export type PulseV1QueryResultInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultRef?: InputMaybe<Scalars['String']['input']>;
  visualizationSpec?: InputMaybe<Scalars['JSON']['input']>;
};

export type PulseV1RefreshPulseBlockResponse = {
  pulseBlock?: Maybe<PulseV1PulseBlock>;
};

export type PulseV1RefreshPulseBlockResponseResult =
  | Error
  | PulseV1RefreshPulseBlockResponse;

export type PulseV1RefreshPulseResponse = {
  pulse?: Maybe<PulseV1Pulse>;
  refreshedBlocks: Array<PulseV1PulseBlock>;
};

export type PulseV1RefreshPulseResponseResult =
  | Error
  | PulseV1RefreshPulseResponse;

export type PulseV1ReportingConfig = {
  enabled?: Maybe<Scalars['Boolean']['output']>;
  slack?: Maybe<PulseV1SlackDestination>;
};

export type PulseV1ReportingConfigInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  slack?: InputMaybe<PulseV1SlackDestinationInput>;
};

export type PulseV1ResolvePulseRefreshScheduleResponse = {
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  hour?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['Int']['output']>;
  minute?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<PulseV1PulseRefreshSchedule>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type PulseV1ResolvePulseRefreshScheduleResponseResult =
  | Error
  | PulseV1ResolvePulseRefreshScheduleResponse;

export type PulseV1SlackDestination = {
  channel: Scalars['String']['output'];
};

export type PulseV1SlackDestinationInput = {
  channel: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1SqlSource = {
  query: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type PulseV1SqlSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
};

export type PulseV1StaticResultSource = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type PulseV1StaticResultSourceInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  accountTokenUsage?: Maybe<AiworkflowsV1AccountTokenUsageResult>;
  activities?: Maybe<ActivityV1ListActivitiesResponseResult>;
  activity?: Maybe<ActivityV1ActivityResult>;
  activityType?: Maybe<ActivityV1ActivityTypeResult>;
  activityTypes?: Maybe<ActivityV1ListActivityTypesResponseResult>;
  agent?: Maybe<IamV1AgentResult>;
  agentReviewPreview?: Maybe<CollaborationV1AgentReviewPreviewResult>;
  agents?: Maybe<IamV1ListAgentsResponseResult>;
  aggregateRecordingFilterValues?: Maybe<RecordingV1AggregateRecordingFilterValuesResponseResult>;
  aiWorkflowInstance?: Maybe<AiworkflowsV1AiWorkflowInstanceResult>;
  aiWorkflowInstances?: Maybe<AiworkflowsV1ListAiWorkflowInstancesResponseResult>;
  aiWorkflowSchedule?: Maybe<AiworkflowsV1AiWorkflowScheduleResult>;
  aiWorkflowSchedules?: Maybe<AiworkflowsV1ListAiWorkflowSchedulesResponseResult>;
  aiWorkflowTrigger?: Maybe<AiworkflowsV1AiWorkflowTriggerResult>;
  aiWorkflowTriggers?: Maybe<AiworkflowsV1ListAiWorkflowTriggersResponseResult>;
  analysisResult?: Maybe<StatsV2AnalysisAnalysisResultResult>;
  analysisResults?: Maybe<StatsV2AnalysisListAnalysisResultsResponseResult>;
  apiClient?: Maybe<IamV1ApiClientResult>;
  apiClientSecret?: Maybe<IamV1ApiClientSecretResult>;
  apiClients?: Maybe<IamV1ListApiClientsResponseResult>;
  assignmentTable?: Maybe<MetricsV1AssignmentTableResult>;
  assignmentTables?: Maybe<MetricsV1ListAssignmentTablesResponseResult>;
  attachment?: Maybe<CollaborationV1AttachmentResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  chat?: Maybe<ConversationsV2ChatResult>;
  chatEvent?: Maybe<ConversationsV2ChatEventResult>;
  chatEvents?: Maybe<ConversationsV2ListChatEventsResponseResult>;
  chats?: Maybe<ConversationsV2ListChatsResponseResult>;
  check?: Maybe<WorkflowV1WorkflowInstanceCheckResult>;
  checks?: Maybe<WorkflowV1ListChecksResponseResult>;
  client?: Maybe<IamV1ClientResult>;
  clientCredential?: Maybe<IamV1ClientCredentialResult>;
  clientCredentialEncryptionKey?: Maybe<IamV1ClientCredentialEncryptionKeyResult>;
  clientCredentials?: Maybe<IamV1ListClientCredentialsResponseResult>;
  clients?: Maybe<IamV1ListClientsResponseResult>;
  collaborativeDocument?: Maybe<CollaborationV1CollaborativeDocumentResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  collection?: Maybe<CollectionsV1CollectionResult>;
  collectionEntries?: Maybe<CollectionsV1ListCollectionEntriesResponseResult>;
  collectionEntry?: Maybe<CollectionsV1CollectionEntryResult>;
  collections?: Maybe<CollectionsV1ListCollectionsResponseResult>;
  comment?: Maybe<CollaborationV1CommentResult>;
  commentReplies?: Maybe<CollaborationV1ListCommentRepliesResponseResult>;
  commentReply?: Maybe<CollaborationV1CommentReplyResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  contiguousPartition?: Maybe<MetricsV1ContiguousPartitionResult>;
  contiguousPartitions?: Maybe<MetricsV1ListContiguousPartitionsResponseResult>;
  conversation?: Maybe<ConversationsV1ConversationResult>;
  conversations?: Maybe<ConversationsV1ListConversationsResponseResult>;
  cryptoKey?: Maybe<IamV1CryptoKeyResult>;
  cryptoKeys?: Maybe<IamV1ListCryptoKeysResponseResult>;
  currentAccount?: Maybe<AdminV1AccountInfoResult>;
  currentStripeCustomer?: Maybe<BillingV1StripeCustomerResult>;
  currentUser?: Maybe<IamV1CurrentUserResult>;
  dashboard?: Maybe<InsightsV1DashboardResult>;
  dashboards?: Maybe<InsightsV1ListDashboardsResponseResult>;
  dataWarehouse?: Maybe<MetricsV1DataWarehouseResult>;
  dataWarehouses?: Maybe<MetricsV1ListDataWarehousesResponseResult>;
  dependencies?: Maybe<MetricsV1ListDependenciesResponseResult>;
  dependency?: Maybe<MetricsV1DependencyResult>;
  dimensionTable?: Maybe<MetricsV1DimensionTableResult>;
  dimensionTables?: Maybe<MetricsV1ListDimensionTablesResponseResult>;
  distinctCount?: Maybe<FlagsAdminV1DistinctCountResult>;
  downloadRecording?: Maybe<RecordingV1DownloadRecordingResponseResult>;
  entities?: Maybe<MetricsV1ListEntitiesResponseResult>;
  entity?: Maybe<MetricsV1EntityResult>;
  entityIdentityBinding?: Maybe<MetricsV1EntityIdentityBindingResult>;
  entityIdentityBindings?: Maybe<MetricsV1ListEntityIdentityBindingsResponseResult>;
  entityRelationTable?: Maybe<MetricsV1EntityRelationTableResult>;
  entityRelationTables?: Maybe<MetricsV1ListEntityRelationTablesResponseResult>;
  environment?: Maybe<FlagsAdminV1EnvironmentResult>;
  environments?: Maybe<FlagsAdminV1ListEnvironmentsResponseResult>;
  evaluationContextFieldOverride?: Maybe<FlagsAdminV1EvaluationContextFieldOverrideResult>;
  evaluationContextFieldOverrides?: Maybe<FlagsAdminV1ListEvaluationContextFieldOverridesResponseResult>;
  event?: Maybe<ConnectorsV1EventResult>;
  eventConnection?: Maybe<ConnectorsV1EventConnectionResult>;
  eventConnections?: Maybe<ConnectorsV1ListEventConnectionsResponseResult>;
  eventDefinition?: Maybe<EventsAdminV1EventDefinitionResult>;
  eventDefinitions?: Maybe<EventsAdminV1ListEventDefinitionsResponseResult>;
  eventType?: Maybe<ConnectorsV1EventTypeResult>;
  eventTypes?: Maybe<ConnectorsV1ListEventTypesResponseResult>;
  events?: Maybe<ConnectorsV1ListEventsResponseResult>;
  exclusivityGroup?: Maybe<WorkflowV1ExclusivityGroupResult>;
  exclusivityGroups?: Maybe<WorkflowV1ListExclusivityGroupsResponseResult>;
  existsDataWarehouses?: Maybe<MetricsV1ExistsDataWarehousesResponseResult>;
  existsSlack?: Maybe<ActivityV1SlackAdminConfigResult>;
  exportConversation?: Maybe<ConversationsV1ExportConversationResponseResult>;
  exposureCalculation?: Maybe<MetricsV1ExposureCalculationResult>;
  exposureCalculations?: Maybe<MetricsV1ListExposureCalculationsResponseResult>;
  exposureTable?: Maybe<MetricsV1ExposureTableResult>;
  exposureTables?: Maybe<MetricsV1ListExposureTablesResponseResult>;
  externalDocument?: Maybe<CollaborationV1ExternalDocumentResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  externalIntegration?: Maybe<AiworkflowsV1ExternalIntegrationResult>;
  externalIntegrations?: Maybe<AiworkflowsV1ListExternalIntegrationsResponseResult>;
  factTable?: Maybe<MetricsV1FactTableResult>;
  factTableContext?: Maybe<InsightsV1FactTableContextResult>;
  factTableContexts?: Maybe<InsightsV1ListFactTableContextsResponseResult>;
  factTableSummaries?: Maybe<InsightsV1ListFactTableSummariesResponseResult>;
  factTableSummary?: Maybe<InsightsV1FactTableSummaryResult>;
  factTables?: Maybe<MetricsV1ListFactTablesResponseResult>;
  feed?: Maybe<ActivityV1FeedResult>;
  feedEntries?: Maybe<ActivityV1ListFeedEntriesResponseResult>;
  feedEntry?: Maybe<ActivityV1FeedEntryResult>;
  feedSubscription?: Maybe<ActivityV1FeedSubscriptionResult>;
  feedSubscriptions?: Maybe<ActivityV1ListFeedSubscriptionsResponseResult>;
  feeds?: Maybe<ActivityV1ListFeedsResponseResult>;
  flag?: Maybe<FlagsAdminV1FlagResult>;
  flagAppliedConnection?: Maybe<ConnectorsV1FlagAppliedConnectionResult>;
  flagAppliedConnections?: Maybe<ConnectorsV1ListFlagAppliedConnectionsResponseResult>;
  flags?: Maybe<FlagsAdminV1ListFlagsResponseResult>;
  generateUsageReport?: Maybe<BillingV1UsageReportResult>;
  getFastlyLoggingChallenge?: Maybe<GoogleApiHttpBodyResult>;
  getLatestSdkVersions?: Maybe<InsightsV1GetLatestSdkVersionsResponseResult>;
  getTiptapToken?: Maybe<CollaborationV1GetTiptapTokenResponseResult>;
  group?: Maybe<IamV1GroupResult>;
  groupMembers?: Maybe<IamV1ListGroupMembersResponseResult>;
  groups?: Maybe<IamV1ListGroupsResponseResult>;
  hasExternalIntegration?: Maybe<AiworkflowsV1HasExternalIntegrationResponseResult>;
  holdback?: Maybe<WorkflowV1HoldbackResult>;
  holdbacks?: Maybe<WorkflowV1ListHoldbacksResponseResult>;
  identities?: Maybe<IamV1ListIdentitiesResponseResult>;
  identity?: Maybe<IamV1IdentityResult>;
  initiative?: Maybe<WorkflowV1InitiativeResult>;
  initiatives?: Maybe<WorkflowV1ListInitiativesResponseResult>;
  insightsDocument?: Maybe<InsightsV1InsightsDocumentResult>;
  insightsDocuments?: Maybe<InsightsV1ListInsightsDocumentsResponseResult>;
  insightsMetric?: Maybe<InsightsV1InsightsMetricResult>;
  insightsTableContext?: Maybe<InsightsV1InsightsTableContextResult>;
  insightsTableContexts?: Maybe<InsightsV1ListInsightsTableContextsResponseResult>;
  issue?: Maybe<ObservationsV1IssueResult>;
  issues?: Maybe<ObservationsV1ListIssuesResponseResult>;
  label?: Maybe<AdminLabelsV1LabelResult>;
  labels?: Maybe<AdminLabelsV1ListLabelsResponseResult>;
  learningProgress?: Maybe<OnboardingV1LearningProgressResult>;
  managedAgentSettings?: Maybe<AiworkflowsV1ManagedAgentSettingsResult>;
  managedDataWarehouseProvisioning?: Maybe<OnboardingV1ManagedDataWarehouseProvisioningResult>;
  managedSessions?: Maybe<AiworkflowsV1ListManagedSessionsResponseResult>;
  materializedSegment?: Maybe<FlagsAdminV1MaterializedSegmentResult>;
  materializedSegmentLoadJob?: Maybe<MaterializerV1MaterializedSegmentLoadJobResult>;
  materializedSegmentLoadJobs?: Maybe<MaterializerV1ListMaterializedSegmentLoadJobsResponseResult>;
  materializedSegments?: Maybe<FlagsAdminV1ListMaterializedSegmentsResponseResult>;
  measurement?: Maybe<MetricsV1MeasurementResult>;
  measurementCalculation?: Maybe<MetricsV1MeasurementCalculationResult>;
  measurementCalculations?: Maybe<MetricsV1ListMeasurementCalculationsResponseResult>;
  measurementTable?: Maybe<MetricsV1MeasurementTableResult>;
  measurementTables?: Maybe<MetricsV1ListMeasurementTablesResponseResult>;
  measurements?: Maybe<MetricsV1ListMeasurementsResponseResult>;
  metric?: Maybe<MetricsV1MetricResult>;
  metricCalculation?: Maybe<MetricsV1MetricCalculationResult>;
  metricCalculations?: Maybe<MetricsV1ListMetricCalculationsResponseResult>;
  metrics?: Maybe<MetricsV1ListMetricsResponseResult>;
  oAuthApp?: Maybe<IamV1OAuthAppResult>;
  oAuthApps?: Maybe<IamV1ListOAuthAppsResponseResult>;
  observation?: Maybe<ObservationsV1ObservationResult>;
  observations?: Maybe<ObservationsV1ListObservationsResponseResult>;
  partition?: Maybe<MetricsV1PartitionResult>;
  partitions?: Maybe<MetricsV1ListPartitionsResponseResult>;
  permissions?: Maybe<IamV1ListPermissionsResponseResult>;
  platformConnection?: Maybe<ConnectorsV1PlatformConnectionResult>;
  platformConnections?: Maybe<ConnectorsV1ListPlatformConnectionsResponseResult>;
  policies?: Maybe<IamV1ListPoliciesResponseResult>;
  policy?: Maybe<IamV1PolicyResult>;
  presence?: Maybe<CollaborationV1PresenceResult>;
  presences?: Maybe<CollaborationV1ListPresencesResponseResult>;
  processRoundLog?: Maybe<MetricsV1ProcessRoundLogResult>;
  processRoundLogs?: Maybe<MetricsV1ListProcessRoundLogsResponseResult>;
  project?: Maybe<CollaborationV1ProjectResult>;
  projects?: Maybe<CollaborationV1ListProjectsResponseResult>;
  promptHook?: Maybe<ConversationsV2PromptHookResult>;
  promptHooks?: Maybe<ConversationsV2ListPromptHooksResponseResult>;
  pulse?: Maybe<PulseV1PulseResult>;
  pulseBlock?: Maybe<PulseV1PulseBlockResult>;
  pulseBlocks?: Maybe<PulseV1ListPulseBlocksResponseResult>;
  pulses?: Maybe<PulseV1ListPulsesResponseResult>;
  queryAccountDistinctCount?: Maybe<FlagsAdminV1QueryAccountDistinctCountResponseResult>;
  queryActivityTypes?: Maybe<ActivityV1QueryActivityTypesResponseResult>;
  queryAssignmentDistinctCount?: Maybe<FlagsAdminV1QueryAssignmentDistinctCountResponseResult>;
  queryAvailableTimeRange?: Maybe<MetricsV1QueryAvailableTimeRangeResponseResult>;
  queryBillingOverview?: Maybe<BillingV1BillingOverviewResult>;
  queryDataWarehouseStats?: Maybe<MetricsV1QueryDataWarehouseStatsResponseResult>;
  queryDraftEvents?: Maybe<EventsAdminV1QueryDraftEventsResponseResult>;
  queryEventsUsage?: Maybe<EventsAdminV1QueryEventsUsageResponseResult>;
  queryFlagUsage?: Maybe<FlagsAdminV1QueryFlagUsageResponseResult>;
  queryInsightsMetric?: Maybe<InsightsV1QueryInsightsMetricResponseResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryMetricCalculation?: Maybe<MetricsV1QueryMetricCalculationResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  queryRuleWorkflowInstance?: Maybe<FlagsAdminV1QueryRuleWorkflowInstanceResponseResult>;
  queryScheduledMetricCalculation?: Maybe<MetricsV1QueryScheduledMetricCalculationResponseResult>;
  querySegmentReferences?: Maybe<FlagsAdminV1QuerySegmentReferencesResponseResult>;
  queryTrialUsageInfo?: Maybe<BillingV1QueryTrialUsageInfoResponseResult>;
  queryWorkflowInstancePermissions?: Maybe<WorkflowV1QueryWorkflowInstancePermissionsResponseResult>;
  reaction?: Maybe<CollaborationV1ReactionResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  recording?: Maybe<RecordingV1RecordingResult>;
  recordingPolicies?: Maybe<RecordingV1ListRecordingPoliciesResponseResult>;
  recordingPolicy?: Maybe<RecordingV1RecordingPolicyResult>;
  recordingRule?: Maybe<RecordingV1RecordingRuleResult>;
  recordingRules?: Maybe<RecordingV1ListRecordingRulesResponseResult>;
  recordings?: Maybe<RecordingV1ListRecordingsResponseResult>;
  repositories?: Maybe<RepositoriesV1ListRepositoriesResponseResult>;
  repository?: Maybe<RepositoriesV1RepositoryResult>;
  resolvePulseRefreshSchedule?: Maybe<PulseV1ResolvePulseRefreshScheduleResponseResult>;
  resourcePermission?: Maybe<FgaV1ResourcePermissionResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  retrigger?: Maybe<MetricsV1RetriggerResult>;
  retriggers?: Maybe<MetricsV1ListRetriggersResponseResult>;
  review?: Maybe<CollaborationV1ReviewResult>;
  reviewResponse?: Maybe<CollaborationV1ReviewResponseResult>;
  reviewResponses?: Maybe<CollaborationV1ListReviewResponsesResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  role?: Maybe<IamV1RoleResult>;
  roles?: Maybe<IamV1ListRolesResponseResult>;
  rule?: Maybe<FlagsAdminV1FlagRuleResult>;
  rules?: Maybe<FlagsAdminV1ListRulesResponseResult>;
  sampleRows?: Maybe<MetricsV1SampleRowsResult>;
  scheduledExposureCalculation?: Maybe<MetricsV1ScheduledExposureCalculationResult>;
  scheduledExposureCalculations?: Maybe<MetricsV1ListScheduledExposureCalculationsResponseResult>;
  scheduledMeasurementCalculation?: Maybe<MetricsV1ScheduledMeasurementCalculationResult>;
  scheduledMeasurementCalculations?: Maybe<MetricsV1ListScheduledMeasurementCalculationsResponseResult>;
  scheduledMetricCalculation?: Maybe<MetricsV1ScheduledMetricCalculationResult>;
  scheduledMetricCalculations?: Maybe<MetricsV1ListScheduledMetricCalculationsResponseResult>;
  search?: Maybe<SearchV1ExternalSearchResponseResult>;
  searchFactTableSummaries?: Maybe<InsightsV1SearchFactTableSummariesResponseResult>;
  searchIssues?: Maybe<ObservationsV1SearchIssuesResponseResult>;
  searchObservations?: Maybe<ObservationsV1SearchObservationsResponseResult>;
  searchProviderDocuments?: Maybe<CollaborationV1SearchProviderDocumentsResponseResult>;
  searchRecordings?: Maybe<RecordingV1SearchRecordingsResponseResult>;
  searchThemes?: Maybe<ObservationsV1SearchThemesResponseResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  segments?: Maybe<FlagsAdminV1ListSegmentsResponseResult>;
  sku?: Maybe<BillingV1SkuResult>;
  skus?: Maybe<BillingV1ListSkusResponseResult>;
  sqlJob?: Maybe<MetricsV1SqlJobResult>;
  suggestedQuestions?: Maybe<InsightsV1ListSuggestedQuestionsResponseResult>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
  surfaceIdentityBinding?: Maybe<WorkflowV1SurfaceIdentityBindingResult>;
  surfaceIdentityBindings?: Maybe<WorkflowV1ListSurfaceIdentityBindingsResponseResult>;
  surfaces?: Maybe<WorkflowV1ListSurfacesResponseResult>;
  task?: Maybe<ObservationsV1TaskResult>;
  tasks?: Maybe<ObservationsV1ListTasksResponseResult>;
  theme?: Maybe<ObservationsV1ThemeResult>;
  themes?: Maybe<ObservationsV1ListThemesResponseResult>;
  usageReport?: Maybe<BillingV1UsageReportResult>;
  user?: Maybe<IamV1UserResult>;
  userGroups?: Maybe<IamV1ListUserGroupsResponseResult>;
  userInvitation?: Maybe<IamV1UserInvitationResult>;
  userInvitations?: Maybe<IamV1ListUserInvitationsResponseResult>;
  userRequestedReviewResponses?: Maybe<CollaborationV1ListUserRequestedReviewResponsesResponseResult>;
  users?: Maybe<IamV1ListUsersResponseResult>;
  variant?: Maybe<FlagsAdminV1FlagVariantResult>;
  variants?: Maybe<FlagsAdminV1ListVariantsResponseResult>;
  workflow?: Maybe<WorkflowV1WorkflowResult>;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  workflowInstances?: Maybe<WorkflowV1ListWorkflowInstancesResponseResult>;
  workflowLog?: Maybe<WorkflowV1WorkflowLogResult>;
  workflowLogs?: Maybe<WorkflowV1ListWorkflowLogsResponseResult>;
  workflowSecret?: Maybe<WorkflowV1WorkflowSecretResult>;
  workflowSecrets?: Maybe<WorkflowV1ListWorkflowSecretsResponseResult>;
  workflowTemplate?: Maybe<WorkflowV1WorkflowTemplateResult>;
  workflowTemplates?: Maybe<WorkflowV1ListWorkflowTemplatesResponseResult>;
  workflowVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
  workflowVersions?: Maybe<WorkflowV1ListWorkflowVersionsResponseResult>;
  workflows?: Maybe<WorkflowV1ListWorkflowsResponseResult>;
  wrapped?: Maybe<InsightsV1WrappedResult>;
};

export type QueryActivitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type QueryActivityArgs = {
  name: Scalars['String']['input'];
};

export type QueryActivityTypeArgs = {
  name: Scalars['String']['input'];
};

export type QueryActivityTypesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAgentArgs = {
  name: Scalars['String']['input'];
};

export type QueryAgentReviewPreviewArgs = {
  name: Scalars['String']['input'];
};

export type QueryAgentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAggregateRecordingFilterValuesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAiWorkflowInstanceArgs = {
  name: Scalars['String']['input'];
};

export type QueryAiWorkflowInstancesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAiWorkflowScheduleArgs = {
  name: Scalars['String']['input'];
};

export type QueryAiWorkflowSchedulesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAiWorkflowTriggerArgs = {
  name: Scalars['String']['input'];
};

export type QueryAiWorkflowTriggersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAnalysisResultArgs = {
  name: Scalars['String']['input'];
};

export type QueryAnalysisResultsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryApiClientArgs = {
  name: Scalars['String']['input'];
};

export type QueryApiClientSecretArgs = {
  name: Scalars['String']['input'];
};

export type QueryApiClientsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAssignmentTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryAssignmentTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryAttachmentArgs = {
  name: Scalars['String']['input'];
};

export type QueryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryChatArgs = {
  name: Scalars['String']['input'];
};

export type QueryChatEventArgs = {
  name: Scalars['String']['input'];
};

export type QueryChatEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryChatsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCheckArgs = {
  name: Scalars['String']['input'];
};

export type QueryChecksArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryClientArgs = {
  name: Scalars['String']['input'];
};

export type QueryClientCredentialArgs = {
  name: Scalars['String']['input'];
};

export type QueryClientCredentialEncryptionKeyArgs = {
  name: Scalars['String']['input'];
};

export type QueryClientCredentialsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryClientsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCollaborativeDocumentArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type QueryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type QueryCollectionArgs = {
  name: Scalars['String']['input'];
};

export type QueryCollectionEntriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryCollectionEntryArgs = {
  name: Scalars['String']['input'];
};

export type QueryCollectionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCommentArgs = {
  name: Scalars['String']['input'];
};

export type QueryCommentRepliesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryCommentReplyArgs = {
  name: Scalars['String']['input'];
};

export type QueryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryContiguousPartitionArgs = {
  name: Scalars['String']['input'];
};

export type QueryContiguousPartitionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryConversationArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<ConversationsV1ConversationView>;
};

export type QueryConversationsArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<ConversationsV1ConversationView>;
};

export type QueryCryptoKeyArgs = {
  name: Scalars['String']['input'];
};

export type QueryCryptoKeysArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDashboardArgs = {
  name: Scalars['String']['input'];
};

export type QueryDashboardsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDataWarehouseArgs = {
  name: Scalars['String']['input'];
};

export type QueryDataWarehousesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDependenciesArgs = {
  parent: Scalars['String']['input'];
};

export type QueryDependencyArgs = {
  name: Scalars['String']['input'];
};

export type QueryDimensionTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryDimensionTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDistinctCountArgs = {
  name: Scalars['String']['input'];
};

export type QueryDownloadRecordingArgs = {
  name: Scalars['String']['input'];
};

export type QueryEntitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEntityArgs = {
  name: Scalars['String']['input'];
};

export type QueryEntityIdentityBindingArgs = {
  name: Scalars['String']['input'];
};

export type QueryEntityIdentityBindingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEntityRelationTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryEntityRelationTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryEnvironmentArgs = {
  name: Scalars['String']['input'];
};

export type QueryEnvironmentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryEvaluationContextFieldOverrideArgs = {
  name: Scalars['String']['input'];
};

export type QueryEvaluationContextFieldOverridesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventArgs = {
  name: Scalars['String']['input'];
};

export type QueryEventConnectionArgs = {
  name: Scalars['String']['input'];
};

export type QueryEventConnectionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventDefinitionArgs = {
  name: Scalars['String']['input'];
};

export type QueryEventDefinitionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventTypeArgs = {
  name: Scalars['String']['input'];
};

export type QueryEventTypesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventsArgs = {
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExclusivityGroupArgs = {
  name: Scalars['String']['input'];
};

export type QueryExclusivityGroupsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryExportConversationArgs = {
  format?: InputMaybe<ConversationsV1ExportFormat>;
  name: Scalars['String']['input'];
};

export type QueryExposureCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryExposureCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryExposureTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryExposureTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryExternalDocumentArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type QueryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type QueryExternalIntegrationArgs = {
  name: Scalars['String']['input'];
};

export type QueryExternalIntegrationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFactTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryFactTableContextArgs = {
  name: Scalars['String']['input'];
};

export type QueryFactTableContextsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFactTableSummariesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFactTableSummaryArgs = {
  name: Scalars['String']['input'];
};

export type QueryFactTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFeedArgs = {
  name: Scalars['String']['input'];
};

export type QueryFeedEntriesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeedEntryArgs = {
  name: Scalars['String']['input'];
};

export type QueryFeedSubscriptionArgs = {
  name: Scalars['String']['input'];
};

export type QueryFeedSubscriptionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeedsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFlagArgs = {
  name: Scalars['String']['input'];
};

export type QueryFlagAppliedConnectionArgs = {
  name: Scalars['String']['input'];
};

export type QueryFlagAppliedConnectionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFlagsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGenerateUsageReportArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resolution?: InputMaybe<BillingV1ReportResolution>;
  startTime: Scalars['String']['input'];
};

export type QueryGetTiptapTokenArgs = {
  name: Scalars['String']['input'];
};

export type QueryGroupArgs = {
  name: Scalars['String']['input'];
};

export type QueryGroupMembersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryGroupsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHasExternalIntegrationArgs = {
  integrationType: AiworkflowsV1ExternalIntegrationType;
  verify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryHoldbackArgs = {
  name: Scalars['String']['input'];
};

export type QueryHoldbacksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryIdentitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryIdentityArgs = {
  name: Scalars['String']['input'];
};

export type QueryInitiativeArgs = {
  name: Scalars['String']['input'];
};

export type QueryInitiativesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryInsightsDocumentArgs = {
  name: Scalars['String']['input'];
};

export type QueryInsightsDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryInsightsMetricArgs = {
  name: Scalars['String']['input'];
};

export type QueryInsightsTableContextArgs = {
  name: Scalars['String']['input'];
};

export type QueryInsightsTableContextsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIssueArgs = {
  name: Scalars['String']['input'];
};

export type QueryIssuesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryLabelArgs = {
  name: Scalars['String']['input'];
};

export type QueryLabelsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryManagedDataWarehouseProvisioningArgs = {
  name: Scalars['String']['input'];
};

export type QueryManagedSessionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMaterializedSegmentArgs = {
  name: Scalars['String']['input'];
};

export type QueryMaterializedSegmentLoadJobArgs = {
  name: Scalars['String']['input'];
};

export type QueryMaterializedSegmentLoadJobsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryMaterializedSegmentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMeasurementArgs = {
  name: Scalars['String']['input'];
};

export type QueryMeasurementCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryMeasurementCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryMeasurementTableArgs = {
  name: Scalars['String']['input'];
};

export type QueryMeasurementTablesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryMeasurementsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryMetricArgs = {
  name: Scalars['String']['input'];
};

export type QueryMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryMetricCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryMetricsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryOAuthAppArgs = {
  name: Scalars['String']['input'];
};

export type QueryOAuthAppsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryObservationArgs = {
  name: Scalars['String']['input'];
};

export type QueryObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPartitionArgs = {
  name: Scalars['String']['input'];
};

export type QueryPartitionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryPermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPlatformConnectionArgs = {
  name: Scalars['String']['input'];
};

export type QueryPlatformConnectionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPoliciesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPolicyArgs = {
  name: Scalars['String']['input'];
};

export type QueryPresenceArgs = {
  name: Scalars['String']['input'];
};

export type QueryPresencesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProcessRoundLogArgs = {
  name: Scalars['String']['input'];
};

export type QueryProcessRoundLogsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryProjectArgs = {
  name: Scalars['String']['input'];
};

export type QueryProjectsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPromptHookArgs = {
  name: Scalars['String']['input'];
};

export type QueryPromptHooksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPulseArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<PulseV1PulseView>;
};

export type QueryPulseBlockArgs = {
  name: Scalars['String']['input'];
};

export type QueryPulseBlocksArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryPulsesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQueryAccountDistinctCountArgs = {
  kind: FlagsAdminV1DistinctCountKind;
};

export type QueryQueryActivityTypesArgs = {
  resource: Scalars['String']['input'];
};

export type QueryQueryAssignmentDistinctCountArgs = {
  assignmentId: Scalars['String']['input'];
  kind: FlagsAdminV1DistinctCountKind;
  rule: Scalars['String']['input'];
};

export type QueryQueryAvailableTimeRangeArgs = {
  exposureCalculationSpec?: InputMaybe<MetricsV1ExposureCalculationSpecInput>;
  metricCalculationSpec?: InputMaybe<MetricsV1MetricCalculationSpecInput>;
};

export type QueryQueryDataWarehouseStatsArgs = {
  endTime: Scalars['String']['input'];
  interval?: InputMaybe<MetricsV1QueryDataWarehouseStatsRequestStatsInterval>;
  startTime: Scalars['String']['input'];
};

export type QueryQueryDraftEventsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQueryEventsUsageArgs = {
  endTime: Scalars['String']['input'];
  eventDefinition: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type QueryQueryFlagUsageArgs = {
  endTime: Scalars['String']['input'];
  flag: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type QueryQueryInsightsMetricArgs = {
  filter?: InputMaybe<InsightsV1FilterInput>;
  name: Scalars['String']['input'];
};

export type QueryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type QueryQueryMetricCalculationArgs = {
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  dimensionFilters?: InputMaybe<
    Array<MetricsV1QueryMetricCalculationRequestDimensionFiltersEntryInput>
  >;
  groupByDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQueryReactionSummaryArgs = {
  name: Scalars['String']['input'];
};

export type QueryQueryRuleWorkflowInstanceArgs = {
  rule: Scalars['String']['input'];
};

export type QueryQueryScheduledMetricCalculationArgs = {
  accumulateDimension?: InputMaybe<Scalars['String']['input']>;
  dimensionFilters?: InputMaybe<
    Array<MetricsV1QueryScheduledMetricCalculationRequestDimensionFiltersEntryInput>
  >;
  endTime?: InputMaybe<Scalars['String']['input']>;
  groupByDimensions?: InputMaybe<Array<Scalars['String']['input']>>;
  includeAllCombinations?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQuerySegmentReferencesArgs = {
  name: Scalars['String']['input'];
};

export type QueryQueryWorkflowInstancePermissionsArgs = {
  name: Scalars['String']['input'];
};

export type QueryReactionArgs = {
  name: Scalars['String']['input'];
};

export type QueryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type QueryRecordingArgs = {
  name: Scalars['String']['input'];
};

export type QueryRecordingPoliciesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRecordingPolicyArgs = {
  name: Scalars['String']['input'];
};

export type QueryRecordingRuleArgs = {
  name: Scalars['String']['input'];
};

export type QueryRecordingRulesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryRecordingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRepositoryArgs = {
  name: Scalars['String']['input'];
};

export type QueryResolvePulseRefreshScheduleArgs = {
  pulse: Scalars['String']['input'];
};

export type QueryResourcePermissionArgs = {
  name: Scalars['String']['input'];
};

export type QueryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
};

export type QueryResourceRelationsArgs = {
  parent: Scalars['String']['input'];
};

export type QueryRetriggerArgs = {
  name: Scalars['String']['input'];
};

export type QueryRetriggersArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryReviewArgs = {
  name: Scalars['String']['input'];
};

export type QueryReviewResponseArgs = {
  name: Scalars['String']['input'];
};

export type QueryReviewResponsesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRoleArgs = {
  name: Scalars['String']['input'];
};

export type QueryRolesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRuleArgs = {
  name: Scalars['String']['input'];
};

export type QueryRulesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QuerySampleRowsArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledExposureCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledExposureCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryScheduledMeasurementCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledMeasurementCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryScheduledMetricCalculationArgs = {
  name: Scalars['String']['input'];
};

export type QueryScheduledMetricCalculationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchArgs = {
  enableSemanticSearch?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  resourceSpecificFilters?: InputMaybe<SearchV1ExternalSearchRequestFiltersInput>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  types: Array<SearchV1ExternalResourceType>;
};

export type QuerySearchFactTableSummariesArgs = {
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};

export type QuerySearchIssuesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  semanticQuery: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchObservationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  semanticQuery: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySearchProviderDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  provider: CollaborationV1SearchProvider;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySearchRecordingsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  semanticQuery: Scalars['String']['input'];
};

export type QuerySearchThemesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  semanticQuery: Scalars['String']['input'];
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerySegmentArgs = {
  name: Scalars['String']['input'];
  view?: InputMaybe<FlagsAdminV1SegmentView>;
};

export type QuerySegmentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<FlagsAdminV1SegmentView>;
};

export type QuerySkuArgs = {
  name: Scalars['String']['input'];
};

export type QuerySkusArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySqlJobArgs = {
  name: Scalars['String']['input'];
};

export type QuerySuggestedQuestionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySurfaceArgs = {
  name: Scalars['String']['input'];
};

export type QuerySurfaceIdentityBindingArgs = {
  name: Scalars['String']['input'];
};

export type QuerySurfaceIdentityBindingsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QuerySurfacesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTaskArgs = {
  name: Scalars['String']['input'];
};

export type QueryTasksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryThemeArgs = {
  name: Scalars['String']['input'];
};

export type QueryThemesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryUsageReportArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resolution?: InputMaybe<BillingV1ReportResolution>;
  startTime: Scalars['String']['input'];
};

export type QueryUserArgs = {
  name: Scalars['String']['input'];
};

export type QueryUserGroupsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryUserInvitationArgs = {
  name: Scalars['String']['input'];
};

export type QueryUserInvitationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserRequestedReviewResponsesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUsersArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVariantArgs = {
  name: Scalars['String']['input'];
};

export type QueryVariantsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryWorkflowArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowInstanceArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowInstancesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryWorkflowLogArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowLogsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
};

export type QueryWorkflowSecretArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowSecretsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryWorkflowTemplateArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowTemplatesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryWorkflowVersionArgs = {
  name: Scalars['String']['input'];
};

export type QueryWorkflowVersionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  parent: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryWorkflowsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryWrappedArgs = {
  name: Scalars['String']['input'];
};

export type ReanalysisData = {
  configChanged?: Maybe<Scalars['Boolean']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exposureKey?: Maybe<Scalars['String']['output']>;
  exposureMetricState?: Maybe<ReanalysisDataExposureMetricState>;
  exposureState?: Maybe<ReanalysisDataExposureState>;
  metrics?: Maybe<Array<ReanalysisDataMetricData>>;
  startTime?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<Array<ReanalysisDataTreatment>>;
};

export enum ReanalysisDataExposureMetricState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export enum ReanalysisDataExposureState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type ReanalysisDataInput = {
  configChanged?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exposureKey?: InputMaybe<Scalars['String']['input']>;
  exposureMetricState?: InputMaybe<ReanalysisDataInputExposureMetricState>;
  exposureState?: InputMaybe<ReanalysisDataInputExposureState>;
  metrics?: InputMaybe<Array<ReanalysisDataInputMetricDataInput>>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<Array<ReanalysisDataInputTreatmentInput>>;
};

export enum ReanalysisDataInputExposureMetricState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export enum ReanalysisDataInputExposureState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type ReanalysisDataInputMetricDataInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ReanalysisDataInputMetricDataInputState>;
};

export enum ReanalysisDataInputMetricDataInputState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type ReanalysisDataInputTreatmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  imageUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variantKey: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type ReanalysisDataMetricData = {
  calculation?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ReanalysisDataMetricDataState>;
};

export enum ReanalysisDataMetricDataState {
  StateCancelled = 'STATE_CANCELLED',
  StateCompleted = 'STATE_COMPLETED',
  StateFailed = 'STATE_FAILED',
  StateRunning = 'STATE_RUNNING',
  StateUnspecified = 'STATE_UNSPECIFIED',
}

export type ReanalysisDataTreatment = {
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  imageUri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  variantKey: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

export type RecordingV1AggregateRecordingFilterValuesResponse = {
  labels: Array<RecordingV1FieldValues>;
  tags: Array<RecordingV1FieldValues>;
};

export type RecordingV1AggregateRecordingFilterValuesResponseResult =
  | Error
  | RecordingV1AggregateRecordingFilterValuesResponse;

export type RecordingV1BatchDownloadRecordingResponse = {
  recordingsDownload: Array<RecordingV1RecordingDownload>;
};

export type RecordingV1BatchDownloadRecordingResponseResult =
  | Error
  | RecordingV1BatchDownloadRecordingResponse;

export type RecordingV1DownloadRecordingResponse = {
  downloadUri: Scalars['String']['output'];
};

export type RecordingV1DownloadRecordingResponseResult =
  | Error
  | RecordingV1DownloadRecordingResponse;

export type RecordingV1EventsRecordingCreated = {
  recording: RecordingV1Recording;
};

export type RecordingV1EventsRecordingDeleted = {
  recording: RecordingV1Recording;
};

export type RecordingV1EventsRecordingUpdated = {
  recording: RecordingV1Recording;
};

export type RecordingV1FieldValues = {
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type RecordingV1ListRecordingPoliciesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  recordingPolicies: Array<RecordingV1RecordingPolicy>;
};

export type RecordingV1ListRecordingPoliciesResponseResult =
  | Error
  | RecordingV1ListRecordingPoliciesResponse;

export type RecordingV1ListRecordingRulesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  recordingRules: Array<RecordingV1RecordingRule>;
};

export type RecordingV1ListRecordingRulesResponseResult =
  | Error
  | RecordingV1ListRecordingRulesResponse;

export type RecordingV1ListRecordingsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  recordings: Array<RecordingV1Recording>;
};

export type RecordingV1ListRecordingsResponseResult =
  | Error
  | RecordingV1ListRecordingsResponse;

export type RecordingV1Recording = {
  analysis?: Maybe<RecordingV1RecordingAnalysis>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  client?: Maybe<Scalars['String']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName?: Maybe<Scalars['String']['output']>;
  downloadRecording?: Maybe<RecordingV1DownloadRecordingResponseResult>;
  duration?: Maybe<Scalars['String']['output']>;
  environmentInfo?: Maybe<RecordingV1RecordingEnvironmentInfo>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  flagEvaluations: Array<RecordingV1RecordingFlagEvaluation>;
  gcsUri?: Maybe<Scalars['String']['output']>;
  labels: Array<RecordingV1RecordingLabelsEntry>;
  metrics: Array<RecordingV1RecordingMetricsEntry>;
  name: Scalars['String']['output'];
  pageDetails: Array<RecordingV1RecordingPageDetails>;
  pageMetrics: Array<RecordingV1RecordingPageMetric>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  routing?: Maybe<RecordingV1RecordingRouting>;
  sdkInfo?: Maybe<RecordingV1RecordingSdkInfo>;
  state?: Maybe<RecordingV1RecordingState>;
  tags: Array<RecordingV1RecordingTagsEntry>;
  targetingKey?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowInstances: Array<RecordingV1RecordingWorkflowInstanceInfo>;
};

export type RecordingV1RecordingAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type RecordingV1RecordingCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type RecordingV1RecordingQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingAnalysis = {
  intent?: Maybe<Scalars['String']['output']>;
  missedOpportunities: Array<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingDownload = {
  downloadUri?: Maybe<Scalars['String']['output']>;
  recording?: Maybe<RecordingV1RecordingResult>;
};

export type RecordingV1RecordingEnvironmentInfo = {
  browser?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  devicePixelRatio?: Maybe<Scalars['Float']['output']>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  screenHeight?: Maybe<Scalars['Int']['output']>;
  screenWidth?: Maybe<Scalars['Int']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  viewportHeight?: Maybe<Scalars['Int']['output']>;
  viewportWidth?: Maybe<Scalars['Int']['output']>;
};

export type RecordingV1RecordingFlagEvaluation = {
  flag: Scalars['String']['output'];
  variants: Array<RecordingV1RecordingFlagVariant>;
};

export type RecordingV1RecordingFlagVariant = {
  assignmentOrigin?: Maybe<Scalars['String']['output']>;
  variant: Scalars['String']['output'];
};

export type RecordingV1RecordingLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingMetric = {
  value?: Maybe<Scalars['Float']['output']>;
};

export type RecordingV1RecordingMetricsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<RecordingV1RecordingMetric>;
};

export type RecordingV1RecordingPageDetails = {
  metadata?: Maybe<Scalars['JSON']['output']>;
  pageUri: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingPageMetric = {
  metric: Scalars['String']['output'];
  metricValue: Scalars['Float']['output'];
  pageUri: Scalars['String']['output'];
};

export type RecordingV1RecordingPolicy = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  clients: Array<IamV1ClientResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  displayName?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<RecordingV1RecordingPolicyLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  recordingRules?: Maybe<RecordingV1ListRecordingRulesResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type RecordingV1RecordingPolicyAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingPolicyCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type RecordingV1RecordingPolicyCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingPolicyExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type RecordingV1RecordingPolicyQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyRecordingRulesArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyInput = {
  clients: Array<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<RecordingV1RecordingPolicyLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingPolicyLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingPolicyResult =
  | Error
  | RecordingV1RecordingPolicy;

export type RecordingV1RecordingResult = Error | RecordingV1Recording;

export type RecordingV1RecordingRouting = {
  entryPage?: Maybe<Scalars['String']['output']>;
  exitPage?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  routes: Array<RecordingV1RecordingPageDetails>;
};

export type RecordingV1RecordingRule = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  environments: Array<FlagsAdminV1EnvironmentResult>;
  etag?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<RecordingV1RecordingRuleLabelsEntry>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  sessionSampleRate?: Maybe<Scalars['Float']['output']>;
  targetingKeySelector?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type RecordingV1RecordingRuleAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingRuleCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type RecordingV1RecordingRuleCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordingV1RecordingRuleExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type RecordingV1RecordingRuleQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  etag?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<RecordingV1RecordingRuleLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  sessionSampleRate?: InputMaybe<Scalars['Float']['input']>;
  targetingKeySelector?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RecordingV1RecordingRuleLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RecordingV1RecordingRuleResult = Error | RecordingV1RecordingRule;

export type RecordingV1RecordingSdkInfo = {
  analyzerVersion?: Maybe<Scalars['String']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  sdkVersion?: Maybe<Scalars['String']['output']>;
};

export enum RecordingV1RecordingState {
  Analyzed = 'ANALYZED',
  Discarded = 'DISCARDED',
  PendingAnalysis = 'PENDING_ANALYSIS',
  PendingUpload = 'PENDING_UPLOAD',
}

export type RecordingV1RecordingTagValues = {
  values: Array<Scalars['String']['output']>;
};

export type RecordingV1RecordingTagsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<RecordingV1RecordingTagValues>;
};

export type RecordingV1RecordingWorkflowInstanceInfo = {
  displayName?: Maybe<Scalars['String']['output']>;
  workflow: Scalars['String']['output'];
  workflowType: RecordingV1RecordingWorkflowType;
};

export enum RecordingV1RecordingWorkflowType {
  AbTest = 'AB_TEST',
  Analysis = 'ANALYSIS',
  Rollout = 'ROLLOUT',
}

export type RecordingV1SearchRecordingsHit = {
  recording?: Maybe<RecordingV1Recording>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type RecordingV1SearchRecordingsResponse = {
  hits: Array<RecordingV1SearchRecordingsHit>;
};

export type RecordingV1SearchRecordingsResponseResult =
  | Error
  | RecordingV1SearchRecordingsResponse;

export type RemoteConfigData = {
  epExperimentOverride?: Maybe<RemoteConfigDataEpExperimentOverride>;
  overridePolicyMap?: Maybe<Scalars['JSON']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyName?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Array<RemoteConfigDataProperty>>;
};

export type RemoteConfigDataEpExperimentOverride = {
  startTime: Scalars['String']['output'];
};

export type RemoteConfigDataInput = {
  epExperimentOverride?: InputMaybe<RemoteConfigDataInputEpExperimentOverrideInput>;
  overridePolicyMap?: InputMaybe<Scalars['JSON']['input']>;
  policyId?: InputMaybe<Scalars['String']['input']>;
  policyName?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Array<RemoteConfigDataInputPropertyInput>>;
};

export type RemoteConfigDataInputEpExperimentOverrideInput = {
  startTime: Scalars['String']['input'];
};

export type RemoteConfigDataInputPropertyInput = {
  name: Scalars['String']['input'];
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  scope: Scalars['String']['input'];
};

export type RemoteConfigDataProperty = {
  name: Scalars['String']['output'];
  offline?: Maybe<Scalars['Boolean']['output']>;
  scope: Scalars['String']['output'];
};

export type ReportData = {
  name?: Maybe<Scalars['String']['output']>;
  sections: Array<ReportDataSectionsUnion>;
};

export type ReportDataHypothesisSection = {
  hypothesisData: ReportDataHypothesisSectionHypothesisData;
  id: Scalars['String']['output'];
};

export type ReportDataHypothesisSectionHypothesisData = {
  hypothesis?: Maybe<Scalars['String']['output']>;
};

export type ReportDataImagesSection = {
  id: Scalars['String']['output'];
  imagesData: ReportDataImagesSectionImagesData;
};

export type ReportDataImagesSectionImagesData = {
  images?: Maybe<Array<ReportDataImagesSectionImagesDataImageData>>;
};

export type ReportDataImagesSectionImagesDataImageData = {
  id: Scalars['String']['output'];
  imageUri?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ReportDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  sections: Array<SectionsOneOfInput>;
};

export type ReportDataInputHypothesisSectionInput = {
  hypothesisData: ReportDataInputHypothesisSectionInputHypothesisDataInput;
  id: Scalars['String']['input'];
};

export type ReportDataInputHypothesisSectionInputHypothesisDataInput = {
  hypothesis?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputImagesSectionInput = {
  id: Scalars['String']['input'];
  imagesData: ReportDataInputImagesSectionInputImagesDataInput;
};

export type ReportDataInputImagesSectionInputImagesDataInput = {
  images?: InputMaybe<
    Array<ReportDataInputImagesSectionInputImagesDataInputImageDataInput>
  >;
};

export type ReportDataInputImagesSectionInputImagesDataInputImageDataInput = {
  id: Scalars['String']['input'];
  imageUri?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputMetricsSectionInput = {
  id: Scalars['String']['input'];
  metricsData: ReportDataInputMetricsSectionInputMetricsDataInput;
};

export type ReportDataInputMetricsSectionInputMetricsDataInput = {
  metrics?: InputMaybe<
    Array<ReportDataInputMetricsSectionInputMetricsDataInputMetricInput>
  >;
};

export type ReportDataInputMetricsSectionInputMetricsDataInputMetricInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  metricName?: InputMaybe<Scalars['String']['input']>;
  treatments?: InputMaybe<
    Array<ReportDataInputMetricsSectionInputMetricsDataInputMetricInputMetricTreatmentConfigInput>
  >;
};

export type ReportDataInputMetricsSectionInputMetricsDataInputMetricInputMetricTreatmentConfigInput =
  {
    hidden?: InputMaybe<Scalars['Boolean']['input']>;
    treatment: Scalars['String']['input'];
  };

export type ReportDataInputNextSectionInput = {
  id: Scalars['String']['input'];
  nextData: ReportDataInputNextSectionInputNextDataInput;
};

export type ReportDataInputNextSectionInputNextDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputOutcomeSectionInput = {
  id: Scalars['String']['input'];
  outcomeData: ReportDataInputOutcomeSectionInputOutcomeDataInput;
};

export type ReportDataInputOutcomeSectionInputOutcomeDataInput = {
  conclusion?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputRecommendationSectionInput = {
  id: Scalars['String']['input'];
  recommendationsData: ReportDataInputRecommendationSectionInputRecommendationsDataInput;
};

export type ReportDataInputRecommendationSectionInputRecommendationsDataInput =
  {
    content?: InputMaybe<
      Array<ReportDataInputRecommendationSectionInputRecommendationsDataInputRecommendationsContentInput>
    >;
  };

export type ReportDataInputRecommendationSectionInputRecommendationsDataInputRecommendationsContentInput =
  {
    id: Scalars['String']['input'];
    shippingRecommendation?: InputMaybe<Scalars['String']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    variant?: InputMaybe<Scalars['String']['input']>;
  };

export type ReportDataInputResultsSectionInput = {
  id: Scalars['String']['input'];
  resultsData: ReportDataInputResultsSectionInputResultsDataInput;
};

export type ReportDataInputResultsSectionInputResultsDataInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataInputSummarySectionInput = {
  id: Scalars['String']['input'];
  summaryData: ReportDataInputSummarySectionInputSummaryDataInput;
};

export type ReportDataInputSummarySectionInputSummaryDataInput = {
  imageUri?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportDataMetricsSection = {
  id: Scalars['String']['output'];
  metricsData: ReportDataMetricsSectionMetricsData;
};

export type ReportDataMetricsSectionMetricsData = {
  metrics?: Maybe<Array<ReportDataMetricsSectionMetricsDataMetric>>;
};

export type ReportDataMetricsSectionMetricsDataMetric = {
  hidden?: Maybe<Scalars['Boolean']['output']>;
  metric?: Maybe<MetricsV1MetricResult>;
  metricName?: Maybe<Scalars['String']['output']>;
  treatments?: Maybe<
    Array<ReportDataMetricsSectionMetricsDataMetricMetricTreatmentConfig>
  >;
};

export type ReportDataMetricsSectionMetricsDataMetricMetricTreatmentConfig = {
  hidden?: Maybe<Scalars['Boolean']['output']>;
  treatment: Scalars['String']['output'];
};

export type ReportDataNextSection = {
  id: Scalars['String']['output'];
  nextData: ReportDataNextSectionNextData;
};

export type ReportDataNextSectionNextData = {
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportDataOutcomeSection = {
  id: Scalars['String']['output'];
  outcomeData: ReportDataOutcomeSectionOutcomeData;
};

export type ReportDataOutcomeSectionOutcomeData = {
  conclusion?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
};

export type ReportDataRecommendationSection = {
  id: Scalars['String']['output'];
  recommendationsData: ReportDataRecommendationSectionRecommendationsData;
};

export type ReportDataRecommendationSectionRecommendationsData = {
  content?: Maybe<
    Array<ReportDataRecommendationSectionRecommendationsDataRecommendationsContent>
  >;
};

export type ReportDataRecommendationSectionRecommendationsDataRecommendationsContent =
  {
    id: Scalars['String']['output'];
    shippingRecommendation?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    variant?: Maybe<Scalars['String']['output']>;
  };

export type ReportDataResultsSection = {
  id: Scalars['String']['output'];
  resultsData: ReportDataResultsSectionResultsData;
};

export type ReportDataResultsSectionResultsData = {
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportDataSectionsUnion =
  | ReportDataHypothesisSection
  | ReportDataImagesSection
  | ReportDataMetricsSection
  | ReportDataNextSection
  | ReportDataOutcomeSection
  | ReportDataRecommendationSection
  | ReportDataResultsSection
  | ReportDataSummarySection;

export type ReportDataSummarySection = {
  id: Scalars['String']['output'];
  summaryData: ReportDataSummarySectionSummaryData;
};

export type ReportDataSummarySectionSummaryData = {
  imageUri?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RepositoriesV1ListRepositoriesResponse = {
  repositories: Array<RepositoriesV1Repository>;
};

export type RepositoriesV1ListRepositoriesResponseResult =
  | Error
  | RepositoriesV1ListRepositoriesResponse;

export type RepositoriesV1Repository = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  defaultBranch?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  fullName?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  private?: Maybe<Scalars['Boolean']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
};

export type RepositoriesV1RepositoryAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepositoriesV1RepositoryCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type RepositoriesV1RepositoryCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepositoriesV1RepositoryExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type RepositoriesV1RepositoryQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoriesV1RepositoryReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoriesV1RepositoryResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoriesV1RepositoryReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type RepositoriesV1RepositoryResult = Error | RepositoriesV1Repository;

export type ReviewsData = {
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  optionalReviews?: Maybe<Array<ReviewsDataSurfaceReviewData>>;
  requiredReviews?: Maybe<Array<ReviewsDataSurfaceReviewData>>;
  reviewId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ReviewsDataStatus>;
};

export type ReviewsDataInput = {
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  optionalReviews?: InputMaybe<Array<ReviewsDataInputSurfaceReviewDataInput>>;
  requiredReviews?: InputMaybe<Array<ReviewsDataInputSurfaceReviewDataInput>>;
  reviewId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReviewsDataInputStatus>;
};

export enum ReviewsDataInputStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export type ReviewsDataInputSurfaceReviewDataInput = {
  responses?: InputMaybe<
    Array<ReviewsDataInputSurfaceReviewDataInputResponseInput>
  >;
  state: ReviewsDataInputSurfaceReviewDataInputState;
  surface?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewsDataInputSurfaceReviewDataInputResponseInput = {
  commentId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  reviewer: Scalars['String']['input'];
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  state: ReviewsDataInputSurfaceReviewDataInputResponseInputState;
};

export enum ReviewsDataInputSurfaceReviewDataInputResponseInputState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export enum ReviewsDataInputSurfaceReviewDataInputState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export enum ReviewsDataStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export type ReviewsDataSurfaceReviewData = {
  responses?: Maybe<Array<ReviewsDataSurfaceReviewDataResponse>>;
  state: ReviewsDataSurfaceReviewDataState;
  surface?: Maybe<WorkflowV1SurfaceResult>;
};

export type ReviewsDataSurfaceReviewDataResponse = {
  commentId?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<IamV1IdentityResult>>;
  id?: Maybe<Scalars['String']['output']>;
  reviewer: IamV1IdentityResult;
  stale?: Maybe<Scalars['Boolean']['output']>;
  state: ReviewsDataSurfaceReviewDataResponseState;
};

export enum ReviewsDataSurfaceReviewDataResponseState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export enum ReviewsDataSurfaceReviewDataState {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  Stale = 'STALE',
}

export type RolloutData = {
  abtest?: Maybe<WorkflowV1WorkflowInstanceResult>;
  controlAssignmentId?: Maybe<Scalars['String']['output']>;
  controlVariant?: Maybe<FlagsAdminV1FlagVariantResult>;
  description?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<FlagsAdminV1FlagResult>;
  initialReach?: Maybe<Scalars['String']['output']>;
  monitoringDisabled: Scalars['Boolean']['output'];
  reach?: Maybe<Scalars['String']['output']>;
  reusableBucketRanges?: Maybe<Array<RolloutDataBucketRange>>;
  schedule?: Maybe<RolloutDataSchedule>;
  treatmentGroupProportion?: Maybe<Scalars['Float']['output']>;
  variant?: Maybe<FlagsAdminV1FlagVariantResult>;
  variantAssignmentId?: Maybe<Scalars['String']['output']>;
  variantImageUri?: Maybe<Scalars['String']['output']>;
};

export type RolloutDataBucketRange = {
  lower: Scalars['Long']['output'];
  upper: Scalars['Long']['output'];
};

export type RolloutDataInput = {
  abtest?: InputMaybe<Scalars['String']['input']>;
  controlAssignmentId?: InputMaybe<Scalars['String']['input']>;
  controlVariant?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  initialReach?: InputMaybe<Scalars['String']['input']>;
  monitoringDisabled: Scalars['Boolean']['input'];
  reach?: InputMaybe<Scalars['String']['input']>;
  reusableBucketRanges?: InputMaybe<Array<RolloutDataInputBucketRangeInput>>;
  schedule?: InputMaybe<RolloutDataInputScheduleInput>;
  treatmentGroupProportion?: InputMaybe<Scalars['Float']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variantAssignmentId?: InputMaybe<Scalars['String']['input']>;
  variantImageUri?: InputMaybe<Scalars['String']['input']>;
};

export type RolloutDataInputBucketRangeInput = {
  lower: Scalars['Long']['input'];
  upper: Scalars['Long']['input'];
};

export type RolloutDataInputScheduleInput = {
  state?: InputMaybe<RolloutDataInputScheduleInputState>;
  stateReason?: InputMaybe<RolloutDataInputScheduleInputScheduleStateReasonInput>;
  steps: Array<RolloutDataInputScheduleInputScheduleStepsInput>;
};

export type RolloutDataInputScheduleInputScheduleStateReasonInput = {
  failed?: InputMaybe<RolloutDataInputScheduleInputScheduleStateReasonInputFailed>;
};

export enum RolloutDataInputScheduleInputScheduleStateReasonInputFailed {
  FailedCheck = 'FAILED_CHECK',
  MissingLaunchTime = 'MISSING_LAUNCH_TIME',
  NoSpace = 'NO_SPACE',
}

export type RolloutDataInputScheduleInputScheduleStepsInput = {
  durationSincePreviousStep: Scalars['String']['input'];
  reach: Scalars['String']['input'];
  status?: InputMaybe<RolloutDataInputScheduleInputScheduleStepsInputStatus>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
};

export enum RolloutDataInputScheduleInputScheduleStepsInputStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum RolloutDataInputScheduleInputState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Ended = 'ENDED',
  Failed = 'FAILED',
}

export type RolloutDataSchedule = {
  state?: Maybe<RolloutDataScheduleState>;
  stateReason?: Maybe<RolloutDataScheduleScheduleStateReason>;
  steps: Array<RolloutDataScheduleScheduleSteps>;
};

export type RolloutDataScheduleScheduleStateReason = {
  failed?: Maybe<RolloutDataScheduleScheduleStateReasonFailed>;
};

export enum RolloutDataScheduleScheduleStateReasonFailed {
  FailedCheck = 'FAILED_CHECK',
  MissingLaunchTime = 'MISSING_LAUNCH_TIME',
  NoSpace = 'NO_SPACE',
}

export type RolloutDataScheduleScheduleSteps = {
  durationSincePreviousStep: Scalars['String']['output'];
  reach: Scalars['String']['output'];
  status?: Maybe<RolloutDataScheduleScheduleStepsStatus>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export enum RolloutDataScheduleScheduleStepsStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum RolloutDataScheduleState {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Ended = 'ENDED',
  Failed = 'FAILED',
}

export type SampleSizeData = {
  assignmentTableData?: Maybe<SampleSizeDataAssignmentTableData>;
  error?: Maybe<Scalars['String']['output']>;
  existingInstanceData?: Maybe<SampleSizeDataExistingInstanceData>;
  exposure?: Maybe<SampleSizeDataExposureUnion>;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  exposureCalculationData?: Maybe<SampleSizeDataExposureCalculationData>;
  exposureCalculationName?: Maybe<MetricsV1ExposureCalculationResult>;
  exposureKind?: Maybe<SampleSizeDataExposureKind>;
  exposureSource?: Maybe<SampleSizeDataExposureSourceUnion>;
  exposureSourceKind?: Maybe<SampleSizeDataExposureSourceKind>;
  hasCustomizedExposureSource?: Maybe<Scalars['Boolean']['output']>;
  metrics?: Maybe<Array<SampleSizeDataSampleSizeMetric>>;
  powerAnalysis?: Maybe<Scalars['JSON']['output']>;
  request?: Maybe<Scalars['JSON']['output']>;
  requiredSampleSize?: Maybe<Scalars['Long']['output']>;
  scheduledExposureCalculationData?: Maybe<SampleSizeDataScheduledExposureCalculationData>;
  state?: Maybe<SampleSizeDataState>;
  statsParameters?: Maybe<SampleSizeDataStatsParameters>;
  statsTestConfiguration?: Maybe<Scalars['JSON']['output']>;
  useScheduledCalculation?: Maybe<Scalars['Boolean']['output']>;
};

export type SampleSizeDataAssignmentTable = {
  assignmentTable?: Maybe<Scalars['String']['output']>;
  customEndTime?: Maybe<Scalars['String']['output']>;
  customStartTime?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<SampleSizeDataAssignmentTableSampleSizeFilter>;
  runtime?: Maybe<Scalars['String']['output']>;
  samplingFactor?: Maybe<Scalars['Float']['output']>;
};

export type SampleSizeDataAssignmentTableData = {
  assignmentTable?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<SampleSizeDataAssignmentTableDataSampleSizeFilter>;
};

export type SampleSizeDataAssignmentTableDataSampleSizeFilter = {
  assignmentFilter?: Maybe<Scalars['JSON']['output']>;
  entityFilter?: Maybe<Scalars['JSON']['output']>;
  exposureFilter?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataAssignmentTableSampleSizeFilter = {
  assignmentFilter?: Maybe<Scalars['JSON']['output']>;
  entityFilter?: Maybe<Scalars['JSON']['output']>;
  exposureFilter?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataExistingInstance = {
  exposureTableSchedule?: Maybe<Scalars['String']['output']>;
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export type SampleSizeDataExistingInstanceData = {
  exposureTableSchedule?: Maybe<Scalars['String']['output']>;
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export type SampleSizeDataExposureCalculation = {
  assignmentTable: SampleSizeDataExposureCalculationAssignmentTable;
  endTime?: Maybe<Scalars['String']['output']>;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  exposureCalculationName?: Maybe<MetricsV1ExposureCalculationResult>;
  scheduledExposureCalculation?: Maybe<Scalars['JSON']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataExposureCalculationAssignmentTable = {
  assignmentTable?: Maybe<Scalars['String']['output']>;
  customEndTime?: Maybe<Scalars['String']['output']>;
  customStartTime?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<SampleSizeDataExposureCalculationAssignmentTableSampleSizeFilter>;
  runtime?: Maybe<Scalars['String']['output']>;
  samplingFactor?: Maybe<Scalars['Float']['output']>;
};

export type SampleSizeDataExposureCalculationAssignmentTableSampleSizeFilter = {
  assignmentFilter?: Maybe<Scalars['JSON']['output']>;
  entityFilter?: Maybe<Scalars['JSON']['output']>;
  exposureFilter?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataExposureCalculationData = {
  assignmentTable: SampleSizeDataExposureCalculationDataAssignmentTable;
  endTime?: Maybe<Scalars['String']['output']>;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataExposureCalculationDataAssignmentTable = {
  assignmentTable?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<SampleSizeDataExposureCalculationDataAssignmentTableSampleSizeFilter>;
};

export type SampleSizeDataExposureCalculationDataAssignmentTableSampleSizeFilter =
  {
    assignmentFilter?: Maybe<Scalars['JSON']['output']>;
    entityFilter?: Maybe<Scalars['JSON']['output']>;
    exposureFilter?: Maybe<Scalars['String']['output']>;
  };

export enum SampleSizeDataExposureKind {
  ExposureCalculation = 'EXPOSURE_CALCULATION',
  ScheduledExposureCalculation = 'SCHEDULED_EXPOSURE_CALCULATION',
}

export enum SampleSizeDataExposureSourceKind {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  ExistingInstance = 'EXISTING_INSTANCE',
}

export type SampleSizeDataExposureSourceUnion =
  | SampleSizeDataAssignmentTable
  | SampleSizeDataExistingInstance;

export type SampleSizeDataExposureUnion =
  | SampleSizeDataExposureCalculation
  | SampleSizeDataScheduledExposureCalculation;

export type SampleSizeDataInput = {
  assignmentTableData?: InputMaybe<SampleSizeDataInputAssignmentTableDataInput>;
  error?: InputMaybe<Scalars['String']['input']>;
  existingInstanceData?: InputMaybe<SampleSizeDataInputExistingInstanceDataInput>;
  exposure?: InputMaybe<ExposureOneOfInput>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  exposureCalculationData?: InputMaybe<SampleSizeDataInputExposureCalculationDataInput>;
  exposureCalculationName?: InputMaybe<Scalars['String']['input']>;
  exposureKind?: InputMaybe<SampleSizeDataInputExposureKind>;
  exposureSource?: InputMaybe<ExposureSourceOneOfInput>;
  exposureSourceKind?: InputMaybe<SampleSizeDataInputExposureSourceKind>;
  hasCustomizedExposureSource?: InputMaybe<Scalars['Boolean']['input']>;
  metrics?: InputMaybe<Array<SampleSizeDataInputSampleSizeMetricInput>>;
  powerAnalysis?: InputMaybe<Scalars['JSON']['input']>;
  request?: InputMaybe<Scalars['JSON']['input']>;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  scheduledExposureCalculationData?: InputMaybe<SampleSizeDataInputScheduledExposureCalculationDataInput>;
  state?: InputMaybe<SampleSizeDataInputState>;
  statsParameters?: InputMaybe<SampleSizeDataInputStatsParametersInput>;
  statsTestConfiguration?: InputMaybe<Scalars['JSON']['input']>;
  useScheduledCalculation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SampleSizeDataInputAssignmentTableDataInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SampleSizeDataInputAssignmentTableDataInputSampleSizeFilterInput>;
};

export type SampleSizeDataInputAssignmentTableDataInputSampleSizeFilterInput = {
  assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
  entityFilter?: InputMaybe<Scalars['JSON']['input']>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputAssignmentTableInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  customEndTime?: InputMaybe<Scalars['String']['input']>;
  customStartTime?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SampleSizeDataInputAssignmentTableInputSampleSizeFilterInput>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  samplingFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type SampleSizeDataInputAssignmentTableInputSampleSizeFilterInput = {
  assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
  entityFilter?: InputMaybe<Scalars['JSON']['input']>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputExistingInstanceDataInput = {
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  workflowInstance: Scalars['String']['input'];
};

export type SampleSizeDataInputExistingInstanceInput = {
  exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
  workflowInstance: Scalars['String']['input'];
};

export type SampleSizeDataInputExposureCalculationDataInput = {
  assignmentTable: SampleSizeDataInputExposureCalculationDataInputAssignmentTableInput;
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputExposureCalculationDataInputAssignmentTableInput =
  {
    assignmentTable?: InputMaybe<Scalars['String']['input']>;
    filters?: InputMaybe<SampleSizeDataInputExposureCalculationDataInputAssignmentTableInputSampleSizeFilterInput>;
  };

export type SampleSizeDataInputExposureCalculationDataInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export type SampleSizeDataInputExposureCalculationInput = {
  assignmentTable: SampleSizeDataInputExposureCalculationInputAssignmentTableInput;
  endTime?: InputMaybe<Scalars['String']['input']>;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  exposureCalculationName?: InputMaybe<Scalars['String']['input']>;
  scheduledExposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputExposureCalculationInputAssignmentTableInput = {
  assignmentTable?: InputMaybe<Scalars['String']['input']>;
  customEndTime?: InputMaybe<Scalars['String']['input']>;
  customStartTime?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SampleSizeDataInputExposureCalculationInputAssignmentTableInputSampleSizeFilterInput>;
  runtime?: InputMaybe<Scalars['String']['input']>;
  samplingFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type SampleSizeDataInputExposureCalculationInputAssignmentTableInputSampleSizeFilterInput =
  {
    assignmentFilter?: InputMaybe<Scalars['JSON']['input']>;
    entityFilter?: InputMaybe<Scalars['JSON']['input']>;
    exposureFilter?: InputMaybe<Scalars['String']['input']>;
  };

export enum SampleSizeDataInputExposureKind {
  ExposureCalculation = 'EXPOSURE_CALCULATION',
  ScheduledExposureCalculation = 'SCHEDULED_EXPOSURE_CALCULATION',
}

export enum SampleSizeDataInputExposureSourceKind {
  AssignmentTable = 'ASSIGNMENT_TABLE',
  ExistingInstance = 'EXISTING_INSTANCE',
}

export type SampleSizeDataInputSampleSizeMetricInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  forecastedData?: InputMaybe<
    Array<SampleSizeDataInputSampleSizeMetricInputForecastedDataPointInput>
  >;
  metric: Scalars['String']['input'];
  metricCalculation?: InputMaybe<Scalars['JSON']['input']>;
  metricCalculationName?: InputMaybe<Scalars['String']['input']>;
  observedData?: InputMaybe<
    Array<SampleSizeDataInputSampleSizeMetricInputObservedDataPointInput>
  >;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  scheduledMetricCalculation?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputState>;
  summaryStats?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputSummaryStatsInput>;
  type?: InputMaybe<SampleSizeDataInputSampleSizeMetricInputType>;
};

export type SampleSizeDataInputSampleSizeMetricInputForecastedDataPointInput = {
  dayIndex: Scalars['Long']['input'];
  expectedSampleSize?: InputMaybe<Scalars['Long']['input']>;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
};

export type SampleSizeDataInputSampleSizeMetricInputObservedDataPointInput = {
  dayIndex: Scalars['Long']['input'];
  expectedSampleSize?: InputMaybe<Scalars['Long']['input']>;
  mean?: InputMaybe<Scalars['Float']['input']>;
  requiredSampleSize?: InputMaybe<Scalars['Long']['input']>;
  variance?: InputMaybe<Scalars['Float']['input']>;
};

export enum SampleSizeDataInputSampleSizeMetricInputState {
  Error = 'ERROR',
  NoPlannedEffectSize = 'NO_PLANNED_EFFECT_SIZE',
  Ok = 'OK',
}

export type SampleSizeDataInputSampleSizeMetricInputSummaryStatsInput = {
  count?: InputMaybe<Scalars['Long']['input']>;
  mean?: InputMaybe<Scalars['Float']['input']>;
  variance?: InputMaybe<Scalars['Float']['input']>;
  varianceReductionRate?: InputMaybe<Scalars['Float']['input']>;
};

export enum SampleSizeDataInputSampleSizeMetricInputType {
  Deterioration = 'DETERIORATION',
  Guardrail = 'GUARDRAIL',
  Monitoring = 'MONITORING',
  Quality = 'QUALITY',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type SampleSizeDataInputScheduledExposureCalculationDataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  existingInstance: SampleSizeDataInputScheduledExposureCalculationDataInputExistingInstanceInput;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputScheduledExposureCalculationDataInputExistingInstanceInput =
  {
    exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
    workflowInstance: Scalars['String']['input'];
  };

export type SampleSizeDataInputScheduledExposureCalculationInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  existingInstance: SampleSizeDataInputScheduledExposureCalculationInputExistingInstanceInput;
  exposureCalculation?: InputMaybe<Scalars['JSON']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type SampleSizeDataInputScheduledExposureCalculationInputExistingInstanceInput =
  {
    exposureTableSchedule?: InputMaybe<Scalars['String']['input']>;
    workflowInstance: Scalars['String']['input'];
  };

export enum SampleSizeDataInputState {
  CalculatingExposure = 'CALCULATING_EXPOSURE',
  CalculatingMetrics = 'CALCULATING_METRICS',
  Canceled = 'CANCELED',
  Done = 'DONE',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Stale = 'STALE',
}

export type SampleSizeDataInputStatsParametersInput = {
  allocationProportion?: InputMaybe<Scalars['String']['input']>;
  alpha: Scalars['Float']['input'];
  power: Scalars['Float']['input'];
  testHorizonStrategy: SampleSizeDataInputStatsParametersInputTestHorizonStrategy;
};

export enum SampleSizeDataInputStatsParametersInputTestHorizonStrategy {
  FixedHorizon = 'FIXED_HORIZON',
  Sequential = 'SEQUENTIAL',
}

export type SampleSizeDataSampleSizeMetric = {
  error?: Maybe<Scalars['String']['output']>;
  forecastedData?: Maybe<
    Array<SampleSizeDataSampleSizeMetricForecastedDataPoint>
  >;
  metric: Scalars['String']['output'];
  metricCalculation?: Maybe<Scalars['JSON']['output']>;
  metricCalculationName?: Maybe<MetricsV1MetricCalculationResult>;
  observedData?: Maybe<Array<SampleSizeDataSampleSizeMetricObservedDataPoint>>;
  requiredSampleSize?: Maybe<Scalars['Long']['output']>;
  scheduledMetricCalculation?: Maybe<Scalars['JSON']['output']>;
  state?: Maybe<SampleSizeDataSampleSizeMetricState>;
  summaryStats?: Maybe<SampleSizeDataSampleSizeMetricSummaryStats>;
  type?: Maybe<SampleSizeDataSampleSizeMetricType>;
};

export type SampleSizeDataSampleSizeMetricForecastedDataPoint = {
  dayIndex: Scalars['Long']['output'];
  expectedSampleSize?: Maybe<Scalars['Long']['output']>;
  requiredSampleSize?: Maybe<Scalars['Long']['output']>;
};

export type SampleSizeDataSampleSizeMetricObservedDataPoint = {
  dayIndex: Scalars['Long']['output'];
  expectedSampleSize?: Maybe<Scalars['Long']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  requiredSampleSize?: Maybe<Scalars['Long']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
};

export enum SampleSizeDataSampleSizeMetricState {
  Error = 'ERROR',
  NoPlannedEffectSize = 'NO_PLANNED_EFFECT_SIZE',
  Ok = 'OK',
}

export type SampleSizeDataSampleSizeMetricSummaryStats = {
  count?: Maybe<Scalars['Long']['output']>;
  mean?: Maybe<Scalars['Float']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
  varianceReductionRate?: Maybe<Scalars['Float']['output']>;
};

export enum SampleSizeDataSampleSizeMetricType {
  Deterioration = 'DETERIORATION',
  Guardrail = 'GUARDRAIL',
  Monitoring = 'MONITORING',
  Quality = 'QUALITY',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
}

export type SampleSizeDataScheduledExposureCalculation = {
  endTime?: Maybe<Scalars['String']['output']>;
  existingInstance: SampleSizeDataScheduledExposureCalculationExistingInstance;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataScheduledExposureCalculationData = {
  endTime?: Maybe<Scalars['String']['output']>;
  existingInstance: SampleSizeDataScheduledExposureCalculationDataExistingInstance;
  exposureCalculation?: Maybe<Scalars['JSON']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type SampleSizeDataScheduledExposureCalculationDataExistingInstance = {
  exposureTableSchedule?: Maybe<Scalars['String']['output']>;
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export type SampleSizeDataScheduledExposureCalculationExistingInstance = {
  exposureTableSchedule?: Maybe<Scalars['String']['output']>;
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export enum SampleSizeDataState {
  CalculatingExposure = 'CALCULATING_EXPOSURE',
  CalculatingMetrics = 'CALCULATING_METRICS',
  Canceled = 'CANCELED',
  Done = 'DONE',
  Empty = 'EMPTY',
  Error = 'ERROR',
  Stale = 'STALE',
}

export type SampleSizeDataStatsParameters = {
  allocationProportion?: Maybe<Scalars['String']['output']>;
  alpha: Scalars['Float']['output'];
  power: Scalars['Float']['output'];
  testHorizonStrategy: SampleSizeDataStatsParametersTestHorizonStrategy;
};

export enum SampleSizeDataStatsParametersTestHorizonStrategy {
  FixedHorizon = 'FIXED_HORIZON',
  Sequential = 'SEQUENTIAL',
}

export type SearchV1ExternalHit = {
  resource?: Maybe<SearchV1ExternalHitResourceUnion>;
  resourceType?: Maybe<SearchV1ExternalResourceType>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type SearchV1ExternalHitResourceUnion =
  | FlagsAdminV1Flag
  | IamV1Client
  | IamV1Identity
  | MetricsV1Entity
  | MetricsV1FactTable
  | MetricsV1Metric
  | RecordingV1Recording
  | WorkflowV1Surface
  | WorkflowV1WorkflowInstance;

export enum SearchV1ExternalResourceType {
  Client = 'CLIENT',
  Entity = 'ENTITY',
  FactTable = 'FACT_TABLE',
  Flag = 'FLAG',
  Identity = 'IDENTITY',
  Metric = 'METRIC',
  Recording = 'RECORDING',
  Surface = 'SURFACE',
  WorkflowInstance = 'WORKFLOW_INSTANCE',
}

export type SearchV1ExternalSearchRequestFiltersIdentityFilterInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  kinds?: InputMaybe<
    Array<SearchV1ExternalSearchRequestFiltersIdentityFilterKind>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum SearchV1ExternalSearchRequestFiltersIdentityFilterKind {
  Agent = 'AGENT',
  ApiClient = 'API_CLIENT',
  Everyone = 'EVERYONE',
  Group = 'GROUP',
  Service = 'SERVICE',
  User = 'USER',
}

export type SearchV1ExternalSearchRequestFiltersInput = {
  identity?: InputMaybe<SearchV1ExternalSearchRequestFiltersIdentityFilterInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type SearchV1ExternalSearchResponse = {
  hits: Array<SearchV1ExternalHit>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  totalSize?: Maybe<Scalars['Int']['output']>;
};

export type SearchV1ExternalSearchResponseResult =
  | Error
  | SearchV1ExternalSearchResponse;

export type SectionsOneOfInput = {
  hypothesisSection?: InputMaybe<ReportDataInputHypothesisSectionInput>;
  imagesSection?: InputMaybe<ReportDataInputImagesSectionInput>;
  metricsSection?: InputMaybe<ReportDataInputMetricsSectionInput>;
  nextSection?: InputMaybe<ReportDataInputNextSectionInput>;
  one_of_input?: InputMaybe<Scalars['Boolean']['input']>;
  outcomeSection?: InputMaybe<ReportDataInputOutcomeSectionInput>;
  recommendationSection?: InputMaybe<ReportDataInputRecommendationSectionInput>;
  resultsSection?: InputMaybe<ReportDataInputResultsSectionInput>;
  summarySection?: InputMaybe<ReportDataInputSummarySectionInput>;
};

export type SpotifyAnalysis = {
  experimentId?: Maybe<Scalars['Long']['output']>;
  mhMetrics: Array<SpotifyAnalysisMhMetric>;
  treatments: Array<SpotifyAnalysisTreatment>;
};

export type SpotifyAnalysisInput = {
  experimentId?: InputMaybe<Scalars['Long']['input']>;
  mhMetrics: Array<SpotifyAnalysisInputMhMetricInput>;
  treatments: Array<SpotifyAnalysisInputTreatmentInput>;
};

export type SpotifyAnalysisInputMhMetricInput = {
  expectedSampleSize?: InputMaybe<Scalars['String']['input']>;
  guardrail?: InputMaybe<SpotifyAnalysisInputMhMetricInputGuardrailInput>;
  metricName: Scalars['String']['input'];
  preferredDirection: Scalars['String']['input'];
  secondary?: InputMaybe<Scalars['JSON']['input']>;
  success?: InputMaybe<SpotifyAnalysisInputMhMetricInputSuccessInput>;
  userCreated: Scalars['Boolean']['input'];
};

export type SpotifyAnalysisInputMhMetricInputGuardrailInput = {
  nonInferiorityMargin?: InputMaybe<Scalars['Float']['input']>;
};

export type SpotifyAnalysisInputMhMetricInputSuccessInput = {
  minimumDetectableEffect?: InputMaybe<Scalars['Float']['input']>;
};

export type SpotifyAnalysisInputTreatmentInput = {
  id: Scalars['Long']['input'];
  name: Scalars['String']['input'];
  weight: Scalars['Long']['input'];
};

export type SpotifyAnalysisMhMetric = {
  expectedSampleSize?: Maybe<Scalars['String']['output']>;
  guardrail?: Maybe<SpotifyAnalysisMhMetricGuardrail>;
  metricName: Scalars['String']['output'];
  preferredDirection: Scalars['String']['output'];
  secondary?: Maybe<Scalars['JSON']['output']>;
  success?: Maybe<SpotifyAnalysisMhMetricSuccess>;
  userCreated: Scalars['Boolean']['output'];
};

export type SpotifyAnalysisMhMetricGuardrail = {
  nonInferiorityMargin?: Maybe<Scalars['Float']['output']>;
};

export type SpotifyAnalysisMhMetricSuccess = {
  minimumDetectableEffect?: Maybe<Scalars['Float']['output']>;
};

export type SpotifyAnalysisTreatment = {
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  weight: Scalars['Long']['output'];
};

export type StaticConfig = {
  description?: Maybe<Scalars['String']['output']>;
  primaryUnit?: Maybe<Scalars['String']['output']>;
  propertyAssignments?: Maybe<Array<StaticConfigPropertyAssignment>>;
  treatmentId?: Maybe<Scalars['Long']['output']>;
};

export type StaticConfigInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  primaryUnit?: InputMaybe<Scalars['String']['input']>;
  propertyAssignments?: InputMaybe<
    Array<StaticConfigInputPropertyAssignmentInput>
  >;
  treatmentId?: InputMaybe<Scalars['Long']['input']>;
};

export type StaticConfigInputPropertyAssignmentInput = {
  name: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StaticConfigPropertyAssignment = {
  name: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type StatsData = {
  alpha?: Maybe<Scalars['Float']['output']>;
  analysisResult?: Maybe<StatsV2AnalysisAnalysisResultResult>;
  analysisResults?: Maybe<Array<StatsDataAnalysisResult>>;
  fallbackSampleSize?: Maybe<Scalars['String']['output']>;
  metricInformation?: Maybe<Array<StatsDataMetricInformation>>;
  metricMethods?: Maybe<Array<StatsDataMethod>>;
  power?: Maybe<Scalars['Float']['output']>;
  testHorizonStrategy?: Maybe<StatsDataTestHorizonStrategy>;
};

export type StatsDataAnalysisResult = {
  analysisResult: StatsV2AnalysisAnalysisResultResult;
  exposureFilterName?: Maybe<Scalars['String']['output']>;
};

export type StatsDataInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  analysisResult?: InputMaybe<Scalars['String']['input']>;
  analysisResults?: InputMaybe<Array<StatsDataInputAnalysisResultInput>>;
  fallbackSampleSize?: InputMaybe<Scalars['String']['input']>;
  metricInformation?: InputMaybe<Array<StatsDataInputMetricInformationInput>>;
  metricMethods?: InputMaybe<Array<StatsDataInputMethodInput>>;
  power?: InputMaybe<Scalars['Float']['input']>;
  testHorizonStrategy?: InputMaybe<StatsDataInputTestHorizonStrategy>;
};

export type StatsDataInputAnalysisResultInput = {
  analysisResult: Scalars['String']['input'];
  exposureFilterName?: InputMaybe<Scalars['String']['input']>;
};

export type StatsDataInputMethodInput = {
  method: StatsDataInputMethodInputMethod;
  metricName: Scalars['String']['input'];
};

export enum StatsDataInputMethodInputMethod {
  AsympCs = 'ASYMP_CS',
  AsympCsQuantile = 'ASYMP_CS_QUANTILE',
  AsympCsRatio = 'ASYMP_CS_RATIO',
  Chi2 = 'CHI2',
  GstQuantile = 'GST_QUANTILE',
  GstRatio = 'GST_RATIO',
  GstZTest = 'GST_Z_TEST',
  Quantile = 'QUANTILE',
  Ratio = 'RATIO',
  Unknown = 'UNKNOWN',
  ZTest = 'Z_TEST',
}

export type StatsDataInputMetricInformationInput = {
  expectedSampleSize?: InputMaybe<Scalars['String']['input']>;
  metricName: Scalars['String']['input'];
};

export enum StatsDataInputTestHorizonStrategy {
  FixedHorizon = 'FIXED_HORIZON',
  Sequential = 'SEQUENTIAL',
}

export type StatsDataMethod = {
  method: StatsDataMethodMethod;
  metricName: Scalars['String']['output'];
};

export enum StatsDataMethodMethod {
  AsympCs = 'ASYMP_CS',
  AsympCsQuantile = 'ASYMP_CS_QUANTILE',
  AsympCsRatio = 'ASYMP_CS_RATIO',
  Chi2 = 'CHI2',
  GstQuantile = 'GST_QUANTILE',
  GstRatio = 'GST_RATIO',
  GstZTest = 'GST_Z_TEST',
  Quantile = 'QUANTILE',
  Ratio = 'RATIO',
  Unknown = 'UNKNOWN',
  ZTest = 'Z_TEST',
}

export type StatsDataMetricInformation = {
  expectedSampleSize?: Maybe<Scalars['String']['output']>;
  metricName: Scalars['String']['output'];
};

export enum StatsDataTestHorizonStrategy {
  FixedHorizon = 'FIXED_HORIZON',
  Sequential = 'SEQUENTIAL',
}

export type StatsV2AnalysisAnalysisResult = {
  annotations: Array<StatsV2AnalysisStatsAnnotation>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  exposureFilter?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<StatsV2AnalysisAnalysisResultLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  results: Array<StatsV2AnalysisStatsHypothesisResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  treatments: Array<StatsV2AnalysisTreatmentInfo>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type StatsV2AnalysisAnalysisResultAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatsV2AnalysisAnalysisResultCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type StatsV2AnalysisAnalysisResultCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StatsV2AnalysisAnalysisResultExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type StatsV2AnalysisAnalysisResultQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultInput = {
  annotations?: InputMaybe<Array<StatsV2AnalysisStatsAnnotationInput>>;
  exposureFilter?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<StatsV2AnalysisAnalysisResultLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  results?: InputMaybe<Array<StatsV2AnalysisStatsHypothesisResultInput>>;
  treatments?: InputMaybe<Array<StatsV2AnalysisTreatmentInfoInput>>;
};

export type StatsV2AnalysisAnalysisResultLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisAnalysisResultLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisAnalysisResultResult =
  | Error
  | StatsV2AnalysisAnalysisResult;

export type StatsV2AnalysisEstimate = {
  estimate?: Maybe<Scalars['Float']['output']>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  lower?: Maybe<Scalars['Float']['output']>;
  powered?: Maybe<Scalars['Float']['output']>;
  upper?: Maybe<Scalars['Float']['output']>;
};

export type StatsV2AnalysisEstimateInput = {
  estimate?: InputMaybe<Scalars['Float']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  lower?: InputMaybe<Scalars['Float']['input']>;
  powered?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['Float']['input']>;
};

export type StatsV2AnalysisEventsAnalysisResultCreated = {
  analysisResult: StatsV2AnalysisAnalysisResult;
};

export type StatsV2AnalysisEventsAnalysisResultDeleted = {
  analysisResult: Scalars['String']['output'];
};

export type StatsV2AnalysisEventsAnalysisResultUpdated = {
  analysisResult: StatsV2AnalysisAnalysisResult;
};

export enum StatsV2AnalysisGuardrailStatus {
  GuardrailStatusAllPoweredAllSignificant = 'GUARDRAIL_STATUS_ALL_POWERED_ALL_SIGNIFICANT',
  GuardrailStatusAllPoweredNoneSignificant = 'GUARDRAIL_STATUS_ALL_POWERED_NONE_SIGNIFICANT',
  GuardrailStatusAllPoweredUnknownSignificance = 'GUARDRAIL_STATUS_ALL_POWERED_UNKNOWN_SIGNIFICANCE',
  GuardrailStatusNoGuardrails = 'GUARDRAIL_STATUS_NO_GUARDRAILS',
  GuardrailStatusSomeMissing = 'GUARDRAIL_STATUS_SOME_MISSING',
  GuardrailStatusSomeNotSignificant = 'GUARDRAIL_STATUS_SOME_NOT_SIGNIFICANT',
  GuardrailStatusSomePoweredNotSignificant = 'GUARDRAIL_STATUS_SOME_POWERED_NOT_SIGNIFICANT',
  GuardrailStatusSomeUnpoweredAllSignificant = 'GUARDRAIL_STATUS_SOME_UNPOWERED_ALL_SIGNIFICANT',
  GuardrailStatusSomeUnpoweredUnknownSignificance = 'GUARDRAIL_STATUS_SOME_UNPOWERED_UNKNOWN_SIGNIFICANCE',
  GuardrailStatusWaitForEnd = 'GUARDRAIL_STATUS_WAIT_FOR_END',
  GuardrailStatusWithoutNimNoneDeteriorated = 'GUARDRAIL_STATUS_WITHOUT_NIM_NONE_DETERIORATED',
  GuardrailStatusWithoutNimSomeDeteriorated = 'GUARDRAIL_STATUS_WITHOUT_NIM_SOME_DETERIORATED',
}

export type StatsV2AnalysisListAnalysisResultsResponse = {
  analysisResults: Array<StatsV2AnalysisAnalysisResult>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisListAnalysisResultsResponseResult =
  | Error
  | StatsV2AnalysisListAnalysisResultsResponse;

export enum StatsV2AnalysisMethod {
  MethodAsympCs = 'METHOD_ASYMP_CS',
  MethodAsympCsQuantile = 'METHOD_ASYMP_CS_QUANTILE',
  MethodAsympCsRatio = 'METHOD_ASYMP_CS_RATIO',
  MethodChi2 = 'METHOD_CHI2',
  MethodGstQuantile = 'METHOD_GST_QUANTILE',
  MethodGstRatio = 'METHOD_GST_RATIO',
  MethodGstZTest = 'METHOD_GST_Z_TEST',
  MethodQuantile = 'METHOD_QUANTILE',
  MethodRatio = 'METHOD_RATIO',
  MethodZTest = 'METHOD_Z_TEST',
}

export type StatsV2AnalysisMetricDetails = {
  direction?: Maybe<StatsV2AnalysisMetricDirection>;
  hasRun?: Maybe<Scalars['Boolean']['output']>;
  metricType?: Maybe<StatsV2AnalysisMetricType>;
  plannedEffectSize?: Maybe<GoogleTypeDecimal>;
};

export type StatsV2AnalysisMetricDetailsInput = {
  direction?: InputMaybe<StatsV2AnalysisMetricDirection>;
  hasRun?: InputMaybe<Scalars['Boolean']['input']>;
  metricType?: InputMaybe<StatsV2AnalysisMetricType>;
  plannedEffectSize?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum StatsV2AnalysisMetricDirection {
  MetricDirectionAny = 'METRIC_DIRECTION_ANY',
  MetricDirectionDecrease = 'METRIC_DIRECTION_DECREASE',
  MetricDirectionIncrease = 'METRIC_DIRECTION_INCREASE',
}

export enum StatsV2AnalysisMetricResultStatus {
  MetricResultStatusDesiredAndUndesiredSignificant = 'METRIC_RESULT_STATUS_DESIRED_AND_UNDESIRED_SIGNIFICANT',
  MetricResultStatusDesiredSignificant = 'METRIC_RESULT_STATUS_DESIRED_SIGNIFICANT',
  MetricResultStatusNotSignificant = 'METRIC_RESULT_STATUS_NOT_SIGNIFICANT',
  MetricResultStatusUndesiredSignificant = 'METRIC_RESULT_STATUS_UNDESIRED_SIGNIFICANT',
  MetricResultStatusWaitForData = 'METRIC_RESULT_STATUS_WAIT_FOR_DATA',
  MetricResultStatusWaitForEnd = 'METRIC_RESULT_STATUS_WAIT_FOR_END',
}

export type StatsV2AnalysisMetricStatus = {
  decisionIsSignificant?: Maybe<Scalars['Boolean']['output']>;
  decisionPowered?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<StatsV2AnalysisMetricType>;
  status?: Maybe<StatsV2AnalysisMetricResultStatus>;
  validationIsSignificant?: Maybe<Scalars['Boolean']['output']>;
};

export type StatsV2AnalysisMetricStatusInput = {
  decisionIsSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  decisionPowered?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metricType?: InputMaybe<StatsV2AnalysisMetricType>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatsV2AnalysisMetricResultStatus>;
  validationIsSignificant?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StatsV2AnalysisMetricType {
  MetricTypeDeterioration = 'METRIC_TYPE_DETERIORATION',
  MetricTypeGuardrail = 'METRIC_TYPE_GUARDRAIL',
  MetricTypeMonitoring = 'METRIC_TYPE_MONITORING',
  MetricTypeQuality = 'METRIC_TYPE_QUALITY',
  MetricTypeSecondary = 'METRIC_TYPE_SECONDARY',
  MetricTypeSuccess = 'METRIC_TYPE_SUCCESS',
}

export enum StatsV2AnalysisQualityStatus {
  QualityStatusAllSucceeded = 'QUALITY_STATUS_ALL_SUCCEEDED',
  QualityStatusSomeFailed = 'QUALITY_STATUS_SOME_FAILED',
  QualityStatusSomePending = 'QUALITY_STATUS_SOME_PENDING',
}

export type StatsV2AnalysisRecommendation = {
  shipping?: Maybe<StatsV2AnalysisShippingRecommendation>;
  status?: Maybe<StatsV2AnalysisRecommendationStatus>;
};

export type StatsV2AnalysisRecommendationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<StatsV2AnalysisShippingRecommendation>;
  status?: InputMaybe<StatsV2AnalysisRecommendationStatusInput>;
};

export type StatsV2AnalysisRecommendationStatus = {
  guardrail?: Maybe<StatsV2AnalysisGuardrailStatus>;
  quality?: Maybe<StatsV2AnalysisQualityStatus>;
  success?: Maybe<StatsV2AnalysisSuccessStatus>;
  tanking?: Maybe<StatsV2AnalysisTankingStatus>;
};

export type StatsV2AnalysisRecommendationStatusInput = {
  guardrail?: InputMaybe<StatsV2AnalysisGuardrailStatus>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<StatsV2AnalysisQualityStatus>;
  success?: InputMaybe<StatsV2AnalysisSuccessStatus>;
  tanking?: InputMaybe<StatsV2AnalysisTankingStatus>;
};

export type StatsV2AnalysisSampleSizeEstimate = {
  current?: Maybe<Scalars['Long']['output']>;
  poweredEffectAbs?: Maybe<Scalars['Float']['output']>;
  poweredEffectRel?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Long']['output']>;
};

export type StatsV2AnalysisSampleSizeEstimateInput = {
  current?: InputMaybe<Scalars['Long']['input']>;
  poweredEffectAbs?: InputMaybe<Scalars['Float']['input']>;
  poweredEffectRel?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Long']['input']>;
};

export enum StatsV2AnalysisShippingRecommendation {
  ShippingRecommendationAbort = 'SHIPPING_RECOMMENDATION_ABORT',
  ShippingRecommendationContinue = 'SHIPPING_RECOMMENDATION_CONTINUE',
  ShippingRecommendationDontShip = 'SHIPPING_RECOMMENDATION_DONT_SHIP',
  ShippingRecommendationEnd = 'SHIPPING_RECOMMENDATION_END',
  ShippingRecommendationEnoughDataCollected = 'SHIPPING_RECOMMENDATION_ENOUGH_DATA_COLLECTED',
  ShippingRecommendationShip = 'SHIPPING_RECOMMENDATION_SHIP',
  ShippingRecommendationShipWithCaution = 'SHIPPING_RECOMMENDATION_SHIP_WITH_CAUTION',
  ShippingRecommendationWaitForData = 'SHIPPING_RECOMMENDATION_WAIT_FOR_DATA',
}

export type StatsV2AnalysisSrmGroupResult = {
  expected?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  observed?: Maybe<Scalars['Float']['output']>;
};

export type StatsV2AnalysisSrmGroupResultInput = {
  expected?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  observed?: InputMaybe<Scalars['Float']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisSrmResult = {
  dimensions: Array<StatsV2AnalysisSrmResultDimensionsEntry>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  result: Array<StatsV2AnalysisSrmGroupResult>;
  segmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatsV2AnalysisMetricStatus>;
};

export type StatsV2AnalysisSrmResultDimensionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisSrmResultDimensionsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisSrmResultInput = {
  dimensions?: InputMaybe<Array<StatsV2AnalysisSrmResultDimensionsEntryInput>>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Array<StatsV2AnalysisSrmGroupResultInput>>;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatsV2AnalysisMetricStatusInput>;
};

export type StatsV2AnalysisStatsAnnotation = {
  context: Array<StatsV2AnalysisStatsAnnotationContextItem>;
  error?: Maybe<StatsV2AnalysisStatsAnnotationError>;
  info?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
};

export enum StatsV2AnalysisStatsAnnotationContext {
  StatsAnnotationContextComparison = 'STATS_ANNOTATION_CONTEXT_COMPARISON',
  StatsAnnotationContextGroup = 'STATS_ANNOTATION_CONTEXT_GROUP',
  StatsAnnotationContextHypothesis = 'STATS_ANNOTATION_CONTEXT_HYPOTHESIS',
  StatsAnnotationContextSegment = 'STATS_ANNOTATION_CONTEXT_SEGMENT',
  StatsAnnotationContextUnknown = 'STATS_ANNOTATION_CONTEXT_UNKNOWN',
}

export type StatsV2AnalysisStatsAnnotationContextItem = {
  key?: Maybe<StatsV2AnalysisStatsAnnotationContext>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisStatsAnnotationContextItemInput = {
  key?: InputMaybe<StatsV2AnalysisStatsAnnotationContext>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsAnnotationError = {
  category?: Maybe<StatsV2AnalysisStatsAnnotationErrorCategory>;
  details?: Maybe<Scalars['String']['output']>;
};

export enum StatsV2AnalysisStatsAnnotationErrorCategory {
  StatsAnnotationErrorCategoryAnalysisError = 'STATS_ANNOTATION_ERROR_CATEGORY_ANALYSIS_ERROR',
  StatsAnnotationErrorCategoryDataValidationError = 'STATS_ANNOTATION_ERROR_CATEGORY_DATA_VALIDATION_ERROR',
  StatsAnnotationErrorCategoryGeneral = 'STATS_ANNOTATION_ERROR_CATEGORY_GENERAL',
  StatsAnnotationErrorCategoryNoData = 'STATS_ANNOTATION_ERROR_CATEGORY_NO_DATA',
}

export type StatsV2AnalysisStatsAnnotationErrorInput = {
  category?: InputMaybe<StatsV2AnalysisStatsAnnotationErrorCategory>;
  details?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsAnnotationInput = {
  context?: InputMaybe<Array<StatsV2AnalysisStatsAnnotationContextItemInput>>;
  error?: InputMaybe<StatsV2AnalysisStatsAnnotationErrorInput>;
  info?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  warning?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsComparisonPair = {
  baseline?: Maybe<Scalars['String']['output']>;
  compared?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisStatsComparisonPairInput = {
  baseline?: InputMaybe<Scalars['String']['input']>;
  compared?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsComparisonResult = {
  comparisonId?: Maybe<Scalars['String']['output']>;
  dimensions: Array<StatsV2AnalysisStatsComparisonResultDimensionsEntry>;
  groupStats: Array<StatsV2AnalysisStatsGroupStats>;
  groups?: Maybe<StatsV2AnalysisStatsComparisonPair>;
  isSignificant?: Maybe<Scalars['Boolean']['output']>;
  lastDeteriorationResult?: Maybe<StatsV2AnalysisStatsResult>;
  lastResult?: Maybe<StatsV2AnalysisStatsResult>;
  result: Array<StatsV2AnalysisStatsResult>;
  sampleSize?: Maybe<StatsV2AnalysisSampleSizeEstimate>;
  segmentId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StatsV2AnalysisMetricStatus>;
  usedDataType?: Maybe<StatsV2AnalysisStatsDataType>;
};

export type StatsV2AnalysisStatsComparisonResultDimensionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StatsV2AnalysisStatsComparisonResultDimensionsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StatsV2AnalysisStatsComparisonResultInput = {
  comparisonId?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<
    Array<StatsV2AnalysisStatsComparisonResultDimensionsEntryInput>
  >;
  groupStats?: InputMaybe<Array<StatsV2AnalysisStatsGroupStatsInput>>;
  groups?: InputMaybe<StatsV2AnalysisStatsComparisonPairInput>;
  isSignificant?: InputMaybe<Scalars['Boolean']['input']>;
  lastDeteriorationResult?: InputMaybe<StatsV2AnalysisStatsResultInput>;
  lastResult?: InputMaybe<StatsV2AnalysisStatsResultInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Array<StatsV2AnalysisStatsResultInput>>;
  sampleSize?: InputMaybe<StatsV2AnalysisSampleSizeEstimateInput>;
  segmentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatsV2AnalysisMetricStatusInput>;
  usedDataType?: InputMaybe<StatsV2AnalysisStatsDataType>;
};

export enum StatsV2AnalysisStatsDataType {
  StatsDataTypeBinary = 'STATS_DATA_TYPE_BINARY',
  StatsDataTypeContinuous = 'STATS_DATA_TYPE_CONTINUOUS',
  StatsDataTypeCount = 'STATS_DATA_TYPE_COUNT',
}

export type StatsV2AnalysisStatsGroupStats = {
  id?: Maybe<Scalars['String']['output']>;
  sampleSize?: Maybe<Scalars['Long']['output']>;
};

export type StatsV2AnalysisStatsGroupStatsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sampleSize?: InputMaybe<Scalars['Long']['input']>;
};

export type StatsV2AnalysisStatsHypothesisResult = {
  annotations: Array<StatsV2AnalysisStatsAnnotation>;
  id?: Maybe<Scalars['String']['output']>;
  metricDetails?: Maybe<StatsV2AnalysisMetricDetails>;
  result: Array<StatsV2AnalysisStatsComparisonResult>;
  srmResult: Array<StatsV2AnalysisSrmResult>;
  statsSettings?: Maybe<StatsV2AnalysisStatsSettings>;
};

export type StatsV2AnalysisStatsHypothesisResultInput = {
  annotations?: InputMaybe<Array<StatsV2AnalysisStatsAnnotationInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  metricDetails?: InputMaybe<StatsV2AnalysisMetricDetailsInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Array<StatsV2AnalysisStatsComparisonResultInput>>;
  srmResult?: InputMaybe<Array<StatsV2AnalysisSrmResultInput>>;
  statsSettings?: InputMaybe<StatsV2AnalysisStatsSettingsInput>;
};

export type StatsV2AnalysisStatsResult = {
  baselineEstimateAbs?: Maybe<Scalars['Float']['output']>;
  baselineEstimateRel?: Maybe<Scalars['Float']['output']>;
  baselineSampleSize?: Maybe<Scalars['Long']['output']>;
  comparedEstimateAbs?: Maybe<Scalars['Float']['output']>;
  comparedEstimateRel?: Maybe<Scalars['Float']['output']>;
  comparedSampleSize?: Maybe<Scalars['Long']['output']>;
  differenceEstimateAbs?: Maybe<StatsV2AnalysisEstimate>;
  differenceEstimateRel?: Maybe<StatsV2AnalysisEstimate>;
  resultTime?: Maybe<Scalars['String']['output']>;
  unadjustedEstimateBaseline?: Maybe<Scalars['Float']['output']>;
  unadjustedEstimateCompared?: Maybe<Scalars['Float']['output']>;
  varianceReductionRate?: Maybe<Scalars['Float']['output']>;
};

export type StatsV2AnalysisStatsResultInput = {
  baselineEstimateAbs?: InputMaybe<Scalars['Float']['input']>;
  baselineEstimateRel?: InputMaybe<Scalars['Float']['input']>;
  baselineSampleSize?: InputMaybe<Scalars['Long']['input']>;
  comparedEstimateAbs?: InputMaybe<Scalars['Float']['input']>;
  comparedEstimateRel?: InputMaybe<Scalars['Float']['input']>;
  comparedSampleSize?: InputMaybe<Scalars['Long']['input']>;
  differenceEstimateAbs?: InputMaybe<StatsV2AnalysisEstimateInput>;
  differenceEstimateRel?: InputMaybe<StatsV2AnalysisEstimateInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  resultTime?: InputMaybe<Scalars['String']['input']>;
  unadjustedEstimateBaseline?: InputMaybe<Scalars['Float']['input']>;
  unadjustedEstimateCompared?: InputMaybe<Scalars['Float']['input']>;
  varianceReductionRate?: InputMaybe<Scalars['Float']['input']>;
};

export type StatsV2AnalysisStatsSettings = {
  adjustedAlpha?: Maybe<Scalars['Float']['output']>;
  adjustedBeta?: Maybe<Scalars['Float']['output']>;
  hasVarianceReduction?: Maybe<Scalars['Boolean']['output']>;
  method?: Maybe<StatsV2AnalysisMethod>;
};

export type StatsV2AnalysisStatsSettingsInput = {
  adjustedAlpha?: InputMaybe<Scalars['Float']['input']>;
  adjustedBeta?: InputMaybe<Scalars['Float']['input']>;
  hasVarianceReduction?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<StatsV2AnalysisMethod>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export enum StatsV2AnalysisSuccessStatus {
  SuccessStatusAllPoweredNoneSignificant = 'SUCCESS_STATUS_ALL_POWERED_NONE_SIGNIFICANT',
  SuccessStatusAllPoweredUnknownSignificance = 'SUCCESS_STATUS_ALL_POWERED_UNKNOWN_SIGNIFICANCE',
  SuccessStatusNoneSignificant = 'SUCCESS_STATUS_NONE_SIGNIFICANT',
  SuccessStatusNoSuccessMetric = 'SUCCESS_STATUS_NO_SUCCESS_METRIC',
  SuccessStatusSomeMissing = 'SUCCESS_STATUS_SOME_MISSING',
  SuccessStatusSomePoweredSignificant = 'SUCCESS_STATUS_SOME_POWERED_SIGNIFICANT',
  SuccessStatusSomeUnpoweredSignificant = 'SUCCESS_STATUS_SOME_UNPOWERED_SIGNIFICANT',
  SuccessStatusSomeUnpoweredUnknownSignificance = 'SUCCESS_STATUS_SOME_UNPOWERED_UNKNOWN_SIGNIFICANCE',
  SuccessStatusWaitForEnd = 'SUCCESS_STATUS_WAIT_FOR_END',
}

export enum StatsV2AnalysisTankingStatus {
  TankingStatusAllSucceeded = 'TANKING_STATUS_ALL_SUCCEEDED',
  TankingStatusNoMetrics = 'TANKING_STATUS_NO_METRICS',
  TankingStatusSomeFailed = 'TANKING_STATUS_SOME_FAILED',
  TankingStatusSomePending = 'TANKING_STATUS_SOME_PENDING',
}

export type StatsV2AnalysisTreatmentInfo = {
  id?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<StatsV2AnalysisRecommendation>;
};

export type StatsV2AnalysisTreatmentInfoInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<StatsV2AnalysisRecommendationInput>;
};

export type Subscription = {
  activityCreated?: Maybe<ActivityV1EventsActivityCreated>;
  agentReviewPreviewCreated?: Maybe<CollaborationV1EventsAgentReviewPreviewCreated>;
  agentReviewPreviewUpdated?: Maybe<CollaborationV1EventsAgentReviewPreviewUpdated>;
  analysisResultCreated?: Maybe<StatsV2AnalysisEventsAnalysisResultCreated>;
  analysisResultDeleted?: Maybe<StatsV2AnalysisEventsAnalysisResultDeleted>;
  analysisResultUpdated?: Maybe<StatsV2AnalysisEventsAnalysisResultUpdated>;
  apiClientCreated?: Maybe<IamV1EventsApiClientCreated>;
  apiClientDeleted?: Maybe<IamV1EventsApiClientDeleted>;
  apiClientUpdated?: Maybe<IamV1EventsApiClientUpdated>;
  assignmentTableCreated?: Maybe<MetricsV1EventsAssignmentTableCreated>;
  assignmentTableUpdated?: Maybe<MetricsV1EventsAssignmentTableUpdated>;
  attachmentCreated?: Maybe<CollaborationV1EventsAttachmentCreated>;
  attachmentDeleted?: Maybe<CollaborationV1EventsAttachmentDeleted>;
  attachmentUpdated?: Maybe<CollaborationV1EventsAttachmentUpdated>;
  authCheckLogCreated?: Maybe<FgaV1EventsAuthCheckLogCreated>;
  chatCreated?: Maybe<ConversationsV2EventsChatCreated>;
  chatEventCreated?: Maybe<ConversationsV2EventsChatEventCreated>;
  chatEventUpdated?: Maybe<ConversationsV2EventsChatEventUpdated>;
  chatUpdated?: Maybe<ConversationsV2EventsChatUpdated>;
  checkCreated?: Maybe<WorkflowV1EventsCheckCreated>;
  checkRemoved?: Maybe<WorkflowV1EventsCheckRemoved>;
  checkUpdated?: Maybe<WorkflowV1EventsCheckUpdated>;
  clientCreated?: Maybe<IamV1EventsClientCreated>;
  clientCredentialCreated?: Maybe<IamV1EventsClientCredentialCreated>;
  clientCredentialDeleted?: Maybe<IamV1EventsClientCredentialDeleted>;
  clientCredentialUpdated?: Maybe<IamV1EventsClientCredentialUpdated>;
  clientDeleted?: Maybe<IamV1EventsClientDeleted>;
  clientUpdated?: Maybe<IamV1EventsClientUpdated>;
  collaborativeDocumentUpdated?: Maybe<CollaborationV1EventsCollaborativeDocumentUpdated>;
  collectionCreated?: Maybe<CollectionsV1EventsCollectionCreated>;
  collectionDeleted?: Maybe<CollectionsV1EventsCollectionDeleted>;
  collectionEntryCreated?: Maybe<CollectionsV1EventsCollectionEntryCreated>;
  collectionEntryDeleted?: Maybe<CollectionsV1EventsCollectionEntryDeleted>;
  collectionUpdated?: Maybe<CollectionsV1EventsCollectionUpdated>;
  commentCreated?: Maybe<CollaborationV1EventsCommentCreated>;
  commentDeleted?: Maybe<CollaborationV1EventsCommentDeleted>;
  commentReplyCreated?: Maybe<CollaborationV1EventsCommentReplyCreated>;
  commentReplyDeleted?: Maybe<CollaborationV1EventsCommentReplyDeleted>;
  commentReplyUpdated?: Maybe<CollaborationV1EventsCommentReplyUpdated>;
  commentUpdated?: Maybe<CollaborationV1EventsCommentUpdated>;
  dataWarehouseCreated?: Maybe<MetricsV1EventsDataWarehouseCreated>;
  dataWarehouseUpdated?: Maybe<MetricsV1EventsDataWarehouseUpdated>;
  dimensionTableCreated?: Maybe<MetricsV1EventsDimensionTableCreated>;
  dimensionTableUpdated?: Maybe<MetricsV1EventsDimensionTableUpdated>;
  entityCreated?: Maybe<MetricsV1EventsEntityCreated>;
  entityDeleted?: Maybe<MetricsV1EventsEntityDeleted>;
  entityIdentityBindingCreated?: Maybe<MetricsV1EventsEntityIdentityBindingCreated>;
  entityIdentityBindingDeleted?: Maybe<MetricsV1EventsEntityIdentityBindingDeleted>;
  entityIdentityBindingUpdated?: Maybe<MetricsV1EventsEntityIdentityBindingUpdated>;
  entityRelationTableCreated?: Maybe<MetricsV1EventsEntityRelationTableCreated>;
  entityRelationTableDeleted?: Maybe<MetricsV1EventsEntityRelationTableDeleted>;
  entityRelationTableUpdated?: Maybe<MetricsV1EventsEntityRelationTableUpdated>;
  entityUpdated?: Maybe<MetricsV1EventsEntityUpdated>;
  environmentCreated?: Maybe<FlagsAdminV1EventsEnvironmentCreated>;
  environmentDeleted?: Maybe<FlagsAdminV1EventsEnvironmentDeleted>;
  environmentUpdated?: Maybe<FlagsAdminV1EventsEnvironmentUpdated>;
  evaluationContextFieldOverrideCreated?: Maybe<FlagsAdminV1EventsEvaluationContextFieldOverrideCreated>;
  evaluationContextFieldOverrideDeleted?: Maybe<FlagsAdminV1EventsEvaluationContextFieldOverrideDeleted>;
  evaluationContextFieldOverrideUpdated?: Maybe<FlagsAdminV1EventsEvaluationContextFieldOverrideUpdated>;
  eventDefinitionCreated?: Maybe<EventsAdminV1EventsEventDefinitionCreated>;
  eventDefinitionDeleted?: Maybe<EventsAdminV1EventsEventDefinitionDeleted>;
  eventDefinitionUpdated?: Maybe<EventsAdminV1EventsEventDefinitionUpdated>;
  exposureCalculationCompleted?: Maybe<MetricsV1EventsExposureCalculationCompleted>;
  exposureCalculationCreated?: Maybe<MetricsV1EventsExposureCalculationCreated>;
  exposureCalculationFailed?: Maybe<MetricsV1EventsExposureCalculationFailed>;
  exposureCalculationUpdated?: Maybe<MetricsV1EventsExposureCalculationUpdated>;
  exposureTableCreated?: Maybe<MetricsV1EventsExposureTableCreated>;
  exposureTableUpdated?: Maybe<MetricsV1EventsExposureTableUpdated>;
  factTableCreated?: Maybe<MetricsV1EventsFactTableCreated>;
  factTableUpdated?: Maybe<MetricsV1EventsFactTableUpdated>;
  flagArchived?: Maybe<FlagsAdminV1EventsFlagArchived>;
  flagCreated?: Maybe<FlagsAdminV1EventsFlagCreated>;
  flagUnarchived?: Maybe<FlagsAdminV1EventsFlagUnarchived>;
  flagUpdated?: Maybe<FlagsAdminV1EventsFlagUpdated>;
  groupCreated?: Maybe<IamV1EventsGroupCreated>;
  groupDeleted?: Maybe<IamV1EventsGroupDeleted>;
  groupUpdated?: Maybe<IamV1EventsGroupUpdated>;
  identityCreated?: Maybe<IamV1EventsIdentityCreated>;
  identityDeleted?: Maybe<IamV1EventsIdentityDeleted>;
  identityUpdated?: Maybe<IamV1EventsIdentityUpdated>;
  initiativeCreated?: Maybe<WorkflowV1EventsInitiativeCreated>;
  initiativeDeleted?: Maybe<WorkflowV1EventsInitiativeDeleted>;
  initiativeUpdated?: Maybe<WorkflowV1EventsInitiativeUpdated>;
  issueCreated?: Maybe<ObservationsV1EventsIssueCreated>;
  issueDeleted?: Maybe<ObservationsV1EventsIssueDeleted>;
  issueUpdated?: Maybe<ObservationsV1EventsIssueUpdated>;
  materializedSegmentCreated?: Maybe<FlagsAdminV1EventsMaterializedSegmentCreated>;
  materializedSegmentDeleted?: Maybe<FlagsAdminV1EventsMaterializedSegmentDeleted>;
  materializedSegmentLoadJobCancelled?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobCancelled>;
  materializedSegmentLoadJobCompleted?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobCompleted>;
  materializedSegmentLoadJobCreated?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobCreated>;
  materializedSegmentLoadJobFailed?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobFailed>;
  materializedSegmentLoadJobUpdated?: Maybe<MaterializerV1EventsMaterializedSegmentLoadJobUpdated>;
  materializedSegmentUpdated?: Maybe<FlagsAdminV1EventsMaterializedSegmentUpdated>;
  measurementCalculationCompleted?: Maybe<MetricsV1EventsMeasurementCalculationCompleted>;
  measurementCalculationCreated?: Maybe<MetricsV1EventsMeasurementCalculationCreated>;
  measurementCalculationFailed?: Maybe<MetricsV1EventsMeasurementCalculationFailed>;
  measurementCalculationUpdated?: Maybe<MetricsV1EventsMeasurementCalculationUpdated>;
  measurementCreated?: Maybe<MetricsV1EventsMeasurementCreated>;
  measurementTableCreated?: Maybe<MetricsV1EventsMeasurementTableCreated>;
  measurementTableUpdated?: Maybe<MetricsV1EventsMeasurementTableUpdated>;
  measurementUpdated?: Maybe<MetricsV1EventsMeasurementUpdated>;
  metricCalculationCompleted?: Maybe<MetricsV1EventsMetricCalculationCompleted>;
  metricCalculationCreated?: Maybe<MetricsV1EventsMetricCalculationCreated>;
  metricCalculationFailed?: Maybe<MetricsV1EventsMetricCalculationFailed>;
  metricCalculationUpdated?: Maybe<MetricsV1EventsMetricCalculationUpdated>;
  metricCreated?: Maybe<MetricsV1EventsMetricCreated>;
  metricUpdated?: Maybe<MetricsV1EventsMetricUpdated>;
  observationCreated?: Maybe<ObservationsV1EventsObservationCreated>;
  observationDeleted?: Maybe<ObservationsV1EventsObservationDeleted>;
  observationUpdated?: Maybe<ObservationsV1EventsObservationUpdated>;
  partitionCreated?: Maybe<MetricsV1EventsPartitionCreated>;
  partitionDeleted?: Maybe<MetricsV1EventsPartitionDeleted>;
  policyCreated?: Maybe<IamV1EventsPolicyCreated>;
  policyDeleted?: Maybe<IamV1EventsPolicyDeleted>;
  policyUpdated?: Maybe<IamV1EventsPolicyUpdated>;
  presenceCreated?: Maybe<CollaborationV1EventsPresenceCreated>;
  presenceDeleted?: Maybe<CollaborationV1EventsPresenceDeleted>;
  presenceUpdated?: Maybe<CollaborationV1EventsPresenceUpdated>;
  processRoundLogVerificationFailed?: Maybe<MetricsV1EventsProcessRoundLogVerificationFailed>;
  projectCreated?: Maybe<CollaborationV1EventsProjectCreated>;
  projectDeleted?: Maybe<CollaborationV1EventsProjectDeleted>;
  projectUpdated?: Maybe<CollaborationV1EventsProjectUpdated>;
  pulseCreated?: Maybe<PulseV1EventsPulseCreated>;
  pulseUpdated?: Maybe<PulseV1EventsPulseUpdated>;
  reactionCreated?: Maybe<CollaborationV1EventsReactionCreated>;
  reactionDeleted?: Maybe<CollaborationV1EventsReactionDeleted>;
  reactionSummaryCreated?: Maybe<CollaborationV1EventsReactionSummaryCreated>;
  reactionSummaryUpdated?: Maybe<CollaborationV1EventsReactionSummaryUpdated>;
  recordingCreated?: Maybe<RecordingV1EventsRecordingCreated>;
  recordingDeleted?: Maybe<RecordingV1EventsRecordingDeleted>;
  recordingUpdated?: Maybe<RecordingV1EventsRecordingUpdated>;
  retriggerCreated?: Maybe<MetricsV1EventsRetriggerCreated>;
  retriggerScheduledExposureCalculationCompleted?: Maybe<MetricsV1EventsRetriggerScheduledExposureCalculationCompleted>;
  retriggerScheduledMeasurementCalculationCompleted?: Maybe<MetricsV1EventsRetriggerScheduledMeasurementCalculationCompleted>;
  retriggerScheduledMetricCalculationCompleted?: Maybe<MetricsV1EventsRetriggerScheduledMetricCalculationCompleted>;
  retriggerUpdated?: Maybe<MetricsV1EventsRetriggerUpdated>;
  reviewCreated?: Maybe<CollaborationV1EventsReviewCreated>;
  reviewDeleted?: Maybe<CollaborationV1EventsReviewDeleted>;
  reviewResponseCreated?: Maybe<CollaborationV1EventsReviewResponseCreated>;
  reviewResponseDeleted?: Maybe<CollaborationV1EventsReviewResponseDeleted>;
  reviewResponseRequested?: Maybe<CollaborationV1EventsReviewResponseRequested>;
  reviewResponseSubmitted?: Maybe<CollaborationV1EventsReviewResponseSubmitted>;
  reviewResponseUpdated?: Maybe<CollaborationV1EventsReviewResponseUpdated>;
  reviewUpdated?: Maybe<CollaborationV1EventsReviewUpdated>;
  scheduledExposureCalculationCreated?: Maybe<MetricsV1EventsScheduledExposureCalculationCreated>;
  scheduledExposureCalculationDeleted?: Maybe<MetricsV1EventsScheduledExposureCalculationDeleted>;
  scheduledExposureCalculationUpdated?: Maybe<MetricsV1EventsScheduledExposureCalculationUpdated>;
  scheduledMeasurementCalculationCreated?: Maybe<MetricsV1EventsScheduledMeasurementCalculationCreated>;
  scheduledMeasurementCalculationDeleted?: Maybe<MetricsV1EventsScheduledMeasurementCalculationDeleted>;
  scheduledMeasurementCalculationUpdated?: Maybe<MetricsV1EventsScheduledMeasurementCalculationUpdated>;
  scheduledMetricCalculationCreated?: Maybe<MetricsV1EventsScheduledMetricCalculationCreated>;
  scheduledMetricCalculationDeleted?: Maybe<MetricsV1EventsScheduledMetricCalculationDeleted>;
  scheduledMetricCalculationUpdated?: Maybe<MetricsV1EventsScheduledMetricCalculationUpdated>;
  segmentAllocated?: Maybe<FlagsAdminV1EventsSegmentAllocated>;
  segmentArchived?: Maybe<FlagsAdminV1EventsSegmentArchived>;
  segmentCreated?: Maybe<FlagsAdminV1EventsSegmentCreated>;
  segmentUpdated?: Maybe<FlagsAdminV1EventsSegmentUpdated>;
  sqlJobCreated?: Maybe<MetricsV1EventsSqlJobCreated>;
  sqlJobUpdated?: Maybe<MetricsV1EventsSqlJobUpdated>;
  stripeCustomerCreated?: Maybe<BillingV1EventsStripeCustomerCreated>;
  stripeCustomerUpdated?: Maybe<BillingV1EventsStripeCustomerUpdated>;
  surfaceCreated?: Maybe<WorkflowV1EventsSurfaceCreated>;
  surfaceDeleted?: Maybe<WorkflowV1EventsSurfaceDeleted>;
  surfaceUpdated?: Maybe<WorkflowV1EventsSurfaceUpdated>;
  taskCreated?: Maybe<ObservationsV1EventsTaskCreated>;
  taskDeleted?: Maybe<ObservationsV1EventsTaskDeleted>;
  taskUpdated?: Maybe<ObservationsV1EventsTaskUpdated>;
  themeCreated?: Maybe<ObservationsV1EventsThemeCreated>;
  themeDeleted?: Maybe<ObservationsV1EventsThemeDeleted>;
  themeUpdated?: Maybe<ObservationsV1EventsThemeUpdated>;
  userCreated?: Maybe<IamV1EventsUserCreated>;
  userUpdated?: Maybe<IamV1EventsUserUpdated>;
  workflowCreated?: Maybe<WorkflowV1EventsWorkflowCreated>;
  workflowInstanceCreated?: Maybe<WorkflowV1EventsWorkflowInstanceCreated>;
  workflowInstanceInitiativesUpdated?: Maybe<WorkflowV1EventsWorkflowInstanceInitiativesUpdated>;
  workflowInstanceSurfacesUpdated?: Maybe<WorkflowV1EventsWorkflowInstanceSurfacesUpdated>;
  workflowInstanceTransitionCompleted?: Maybe<WorkflowV1EventsWorkflowInstanceTransitionCompleted>;
  workflowInstanceUpdated?: Maybe<WorkflowV1EventsWorkflowInstanceUpdated>;
  workflowUpdated?: Maybe<WorkflowV1EventsWorkflowUpdated>;
};

export type SubscriptionActivityCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAgentReviewPreviewCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAgentReviewPreviewUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAnalysisResultCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAnalysisResultDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAnalysisResultUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionApiClientCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionApiClientDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionApiClientUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAssignmentTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAssignmentTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAttachmentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAttachmentDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAttachmentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionAuthCheckLogCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionChatCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionChatEventCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionChatEventUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionChatUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCheckCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCheckRemovedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCheckUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientCredentialCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientCredentialDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientCredentialUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionClientUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollaborativeDocumentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionEntryCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionEntryDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCollectionUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentReplyCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentReplyDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentReplyUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCommentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDataWarehouseCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDataWarehouseUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDimensionTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionDimensionTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityIdentityBindingCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityIdentityBindingDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityIdentityBindingUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityRelationTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityRelationTableDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityRelationTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEntityUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEnvironmentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEnvironmentDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEnvironmentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEvaluationContextFieldOverrideCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEvaluationContextFieldOverrideDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEvaluationContextFieldOverrideUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEventDefinitionCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEventDefinitionDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEventDefinitionUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureCalculationFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionExposureTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFactTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFactTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFlagArchivedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFlagCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFlagUnarchivedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionFlagUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionGroupCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionGroupDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionGroupUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIdentityCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIdentityDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIdentityUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionInitiativeCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionInitiativeDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionInitiativeUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIssueCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIssueDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionIssueUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobCancelledArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentLoadJobUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMaterializedSegmentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCalculationFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementTableCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementTableUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMeasurementUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCalculationFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionMetricUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionObservationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionObservationDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionObservationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPartitionCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPartitionDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPolicyCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPolicyDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPolicyUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPresenceCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPresenceDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPresenceUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProcessRoundLogVerificationFailedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProjectCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProjectDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProjectUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPulseCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPulseUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReactionCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReactionDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReactionSummaryCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReactionSummaryUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRecordingCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRecordingDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRecordingUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRetriggerCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRetriggerScheduledExposureCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRetriggerScheduledMeasurementCalculationCompletedArgs =
  {
    filter?: InputMaybe<Scalars['String']['input']>;
  };

export type SubscriptionRetriggerScheduledMetricCalculationCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRetriggerUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseRequestedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseSubmittedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewResponseUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionReviewUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledExposureCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledExposureCalculationDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledExposureCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMeasurementCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMeasurementCalculationDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMeasurementCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMetricCalculationCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMetricCalculationDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionScheduledMetricCalculationUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSegmentAllocatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSegmentArchivedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSegmentCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSegmentUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSqlJobCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSqlJobUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionStripeCustomerCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionStripeCustomerUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSurfaceCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSurfaceDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionSurfaceUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionTaskCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionTaskDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionTaskUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionThemeCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionThemeDeletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionThemeUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionUserCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionUserUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceCreatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceInitiativesUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceSurfacesUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceTransitionCompletedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowInstanceUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionWorkflowUpdatedArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1CheckPermissionsResponse = {
  actionPermissionCheckResults: Array<WorkflowV1CheckPermissionsResponseActionPermissionCheckResult>;
  functionPermissionCheckResults: Array<WorkflowV1CheckPermissionsResponseFunctionPermissionCheckResult>;
  isAllAllowed?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkflowV1CheckPermissionsResponseActionPermissionCheckResult = {
  action?: Maybe<Scalars['String']['output']>;
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  permissionChecks: Array<WorkflowV1CheckPermissionsResponsePermissionCheck>;
};

export type WorkflowV1CheckPermissionsResponseFunctionPermissionCheckResult = {
  function?: Maybe<Scalars['String']['output']>;
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  permissionChecks: Array<WorkflowV1CheckPermissionsResponsePermissionCheck>;
};

export type WorkflowV1CheckPermissionsResponsePermissionCheck = {
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1CheckPermissionsResponseResult =
  | Error
  | WorkflowV1CheckPermissionsResponse;

export enum WorkflowV1EnforcementLevel {
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export type WorkflowV1EventsCheckCreated = {
  check?: Maybe<WorkflowV1WorkflowInstanceCheck>;
};

export type WorkflowV1EventsCheckRemoved = {
  check?: Maybe<WorkflowV1WorkflowInstanceCheck>;
};

export type WorkflowV1EventsCheckUpdated = {
  check?: Maybe<WorkflowV1WorkflowInstanceCheck>;
};

export type WorkflowV1EventsInitiativeCreated = {
  initiative?: Maybe<WorkflowV1Initiative>;
};

export type WorkflowV1EventsInitiativeDeleted = {
  initiative: Scalars['String']['output'];
};

export type WorkflowV1EventsInitiativeUpdated = {
  initiative?: Maybe<WorkflowV1Initiative>;
};

export type WorkflowV1EventsSurfaceCreated = {
  surface?: Maybe<WorkflowV1Surface>;
};

export type WorkflowV1EventsSurfaceDeleted = {
  surface: Scalars['String']['output'];
};

export type WorkflowV1EventsSurfaceUpdated = {
  surface?: Maybe<WorkflowV1Surface>;
};

export type WorkflowV1EventsWorkflowCreated = {
  workflow?: Maybe<WorkflowV1Workflow>;
};

export type WorkflowV1EventsWorkflowInstanceCreated = {
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1EventsWorkflowInstanceInitiativesUpdated = {
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1EventsWorkflowInstanceSurfacesUpdated = {
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1EventsWorkflowInstanceTransitionCompleted = {
  action: Scalars['String']['output'];
  workflowInstance: WorkflowV1WorkflowInstanceResult;
};

export type WorkflowV1EventsWorkflowInstanceUpdated = {
  oldWorkflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1EventsWorkflowUpdated = {
  workflow?: Maybe<WorkflowV1Workflow>;
};

export type WorkflowV1ExclusivityGroup = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1ExclusivityGroupLabelsEntry>;
  mode?: Maybe<WorkflowV1ExclusivityGroupMode>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1ExclusivityGroupAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1ExclusivityGroupCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1ExclusivityGroupCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1ExclusivityGroupExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1ExclusivityGroupQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<WorkflowV1ExclusivityGroupLabelsEntryInput>>;
  mode?: InputMaybe<WorkflowV1ExclusivityGroupMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ExclusivityGroupLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ExclusivityGroupLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowV1ExclusivityGroupMode {
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export type WorkflowV1ExclusivityGroupResult =
  | Error
  | WorkflowV1ExclusivityGroup;

export type WorkflowV1ExecuteFunctionResponse = {
  instance: WorkflowV1WorkflowInstance;
  response?: Maybe<Scalars['JSON']['output']>;
};

export type WorkflowV1ExecuteFunctionResponseResult =
  | Error
  | WorkflowV1ExecuteFunctionResponse;

export type WorkflowV1Holdback = {
  allocation: GoogleTypeDecimal;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1HoldbackLabelsEntry>;
  mode?: Maybe<WorkflowV1HoldbackMode>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  segment?: Maybe<FlagsAdminV1SegmentResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1HoldbackAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1HoldbackCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1HoldbackCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1HoldbackExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1HoldbackQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackInput = {
  allocation: GoogleTypeDecimalInput;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<WorkflowV1HoldbackLabelsEntryInput>>;
  mode?: InputMaybe<WorkflowV1HoldbackMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1HoldbackLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1HoldbackLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowV1HoldbackMode {
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED',
}

export type WorkflowV1HoldbackResult = Error | WorkflowV1Holdback;

export type WorkflowV1InitiateImageUploadResponse = {
  imageUri?: Maybe<Scalars['String']['output']>;
  signedUri?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1InitiateImageUploadResponseResult =
  | Error
  | WorkflowV1InitiateImageUploadResponse;

export type WorkflowV1InitiateTarUploadResponse = {
  path?: Maybe<Scalars['String']['output']>;
  signedUri?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1InitiateTarUploadResponseResult =
  | Error
  | WorkflowV1InitiateTarUploadResponse;

export type WorkflowV1Initiative = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  automatedActions: Array<ActionsV1TypesAutomatedAction>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1InitiativeLabelsEntry>;
  metricConfig?: Maybe<WorkflowV1InitiativeMetricConfig>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<WorkflowV1InitiativeReviews>;
  stakeholders: Array<WorkflowV1InitiativeStakeholder>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1InitiativeAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1InitiativeCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1InitiativeCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1InitiativeExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1InitiativeQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeAssociatedMetric = {
  guardrailMetric?: Maybe<WorkflowV1InitiativeGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection?: Maybe<WorkflowV1InitiativePreferredDirection>;
  successMetric?: Maybe<WorkflowV1InitiativeSuccessMetric>;
};

export type WorkflowV1InitiativeAssociatedMetricInput = {
  guardrailMetric?: InputMaybe<WorkflowV1InitiativeGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection?: InputMaybe<WorkflowV1InitiativePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1InitiativeSuccessMetricInput>;
};

export type WorkflowV1InitiativeGuardrailMetric = {
  nonInferiorityMargin?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1InitiativeGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeInput = {
  automatedActions?: InputMaybe<Array<ActionsV1TypesAutomatedActionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<WorkflowV1InitiativeLabelsEntryInput>>;
  metricConfig?: InputMaybe<WorkflowV1InitiativeMetricConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<WorkflowV1InitiativeReviewsInput>;
  stakeholders?: InputMaybe<Array<WorkflowV1InitiativeStakeholderInput>>;
};

export type WorkflowV1InitiativeLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1InitiativeLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeMetric = {
  guardrailMetric?: Maybe<WorkflowV1InitiativeGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection: WorkflowV1InitiativePreferredDirection;
  successMetric?: Maybe<WorkflowV1InitiativeSuccessMetric>;
};

export type WorkflowV1InitiativeMetricConfig = {
  /** @deprecated No longer supported */
  associatedMetrics: Array<WorkflowV1InitiativeAssociatedMetric>;
  /** @deprecated No longer supported */
  mandatoryMetrics: Array<WorkflowV1InitiativeMetric>;
  metrics: Array<WorkflowV1LinkedMetric>;
};

export type WorkflowV1InitiativeMetricConfigInput = {
  associatedMetrics?: InputMaybe<
    Array<WorkflowV1InitiativeAssociatedMetricInput>
  >;
  mandatoryMetrics?: InputMaybe<Array<WorkflowV1InitiativeMetricInput>>;
  metrics?: InputMaybe<Array<WorkflowV1LinkedMetricInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1InitiativeMetricInput = {
  guardrailMetric?: InputMaybe<WorkflowV1InitiativeGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection: WorkflowV1InitiativePreferredDirection;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1InitiativeSuccessMetricInput>;
};

export enum WorkflowV1InitiativePreferredDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type WorkflowV1InitiativeResult = Error | WorkflowV1Initiative;

export type WorkflowV1InitiativeReviews = {
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  reviewers: Array<IamV1IdentityResult>;
};

export type WorkflowV1InitiativeReviewsInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkflowV1InitiativeStakeholder = {
  identity: IamV1IdentityResult;
  role: Scalars['String']['output'];
};

export type WorkflowV1InitiativeStakeholderInput = {
  identity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type WorkflowV1InitiativeSuccessMetric = {
  minimumDetectableEffect?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1InitiativeSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1LinkedMetric = {
  enforcementLevel?: Maybe<WorkflowV1EnforcementLevel>;
  guardrailMetric?: Maybe<WorkflowV1LinkedMetricGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection?: Maybe<WorkflowV1LinkedMetricPreferredDirection>;
  successMetric?: Maybe<WorkflowV1LinkedMetricSuccessMetric>;
};

export type WorkflowV1LinkedMetricGuardrailMetric = {
  nonInferiorityMargin?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1LinkedMetricGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1LinkedMetricInput = {
  enforcementLevel?: InputMaybe<WorkflowV1EnforcementLevel>;
  guardrailMetric?: InputMaybe<WorkflowV1LinkedMetricGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection?: InputMaybe<WorkflowV1LinkedMetricPreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1LinkedMetricSuccessMetricInput>;
};

export enum WorkflowV1LinkedMetricPreferredDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type WorkflowV1LinkedMetricSuccessMetric = {
  minimumDetectableEffect?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1LinkedMetricSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1ListChecksResponse = {
  checks: Array<WorkflowV1WorkflowInstanceCheck>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ListChecksResponseResult =
  | Error
  | WorkflowV1ListChecksResponse;

export type WorkflowV1ListExclusivityGroupsResponse = {
  exclusivityGroups: Array<WorkflowV1ExclusivityGroup>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ListExclusivityGroupsResponseResult =
  | Error
  | WorkflowV1ListExclusivityGroupsResponse;

export type WorkflowV1ListHoldbacksResponse = {
  holdbacks: Array<WorkflowV1Holdback>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ListHoldbacksResponseResult =
  | Error
  | WorkflowV1ListHoldbacksResponse;

export type WorkflowV1ListInitiativesResponse = {
  initiatives: Array<WorkflowV1Initiative>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1ListInitiativesResponseResult =
  | Error
  | WorkflowV1ListInitiativesResponse;

export type WorkflowV1ListSurfaceIdentityBindingsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  surfaceIdentityBindings: Array<WorkflowV1SurfaceIdentityBinding>;
};

export type WorkflowV1ListSurfaceIdentityBindingsResponseResult =
  | Error
  | WorkflowV1ListSurfaceIdentityBindingsResponse;

export type WorkflowV1ListSurfacesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  surfaces: Array<WorkflowV1Surface>;
};

export type WorkflowV1ListSurfacesResponseResult =
  | Error
  | WorkflowV1ListSurfacesResponse;

export type WorkflowV1ListWorkflowInstancesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowInstances: Array<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1ListWorkflowInstancesResponseResult =
  | Error
  | WorkflowV1ListWorkflowInstancesResponse;

export type WorkflowV1ListWorkflowLogsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowLogs: Array<WorkflowV1WorkflowLog>;
};

export type WorkflowV1ListWorkflowLogsResponseResult =
  | Error
  | WorkflowV1ListWorkflowLogsResponse;

export type WorkflowV1ListWorkflowSecretsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowSecrets: Array<WorkflowV1WorkflowSecret>;
};

export type WorkflowV1ListWorkflowSecretsResponseResult =
  | Error
  | WorkflowV1ListWorkflowSecretsResponse;

export type WorkflowV1ListWorkflowTemplatesResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowTemplates: Array<WorkflowV1WorkflowTemplate>;
};

export type WorkflowV1ListWorkflowTemplatesResponseResult =
  | Error
  | WorkflowV1ListWorkflowTemplatesResponse;

export type WorkflowV1ListWorkflowVersionsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflowVersions: Array<WorkflowV1WorkflowVersion>;
};

export type WorkflowV1ListWorkflowVersionsResponseResult =
  | Error
  | WorkflowV1ListWorkflowVersionsResponse;

export type WorkflowV1ListWorkflowsResponse = {
  nextPageToken?: Maybe<Scalars['String']['output']>;
  workflows: Array<WorkflowV1Workflow>;
};

export type WorkflowV1ListWorkflowsResponseResult =
  | Error
  | WorkflowV1ListWorkflowsResponse;

export type WorkflowV1QueryWorkflowInstancePermissionsResponse = {
  actionPermissionCheckResults: Array<WorkflowV1QueryWorkflowInstancePermissionsResponseActionPermissionCheckResult>;
  functionPermissionCheckResults: Array<WorkflowV1QueryWorkflowInstancePermissionsResponseFunctionPermissionCheckResult>;
  isAllAllowed?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkflowV1QueryWorkflowInstancePermissionsResponseActionPermissionCheckResult =
  {
    action?: Maybe<Scalars['String']['output']>;
    isAllowed?: Maybe<Scalars['Boolean']['output']>;
    permissionChecks: Array<WorkflowV1QueryWorkflowInstancePermissionsResponsePermissionCheck>;
  };

export type WorkflowV1QueryWorkflowInstancePermissionsResponseFunctionPermissionCheckResult =
  {
    function?: Maybe<Scalars['String']['output']>;
    isAllowed?: Maybe<Scalars['Boolean']['output']>;
    permissionChecks: Array<WorkflowV1QueryWorkflowInstancePermissionsResponsePermissionCheck>;
  };

export type WorkflowV1QueryWorkflowInstancePermissionsResponsePermissionCheck =
  {
    isAllowed?: Maybe<Scalars['Boolean']['output']>;
    relation?: Maybe<Scalars['String']['output']>;
    resource?: Maybe<Scalars['String']['output']>;
  };

export type WorkflowV1QueryWorkflowInstancePermissionsResponseResult =
  | Error
  | WorkflowV1QueryWorkflowInstancePermissionsResponse;

export type WorkflowV1Surface = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  automatedActions: Array<ActionsV1TypesAutomatedAction>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  exclusivityGroups?: Maybe<WorkflowV1ListExclusivityGroupsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  holdbacks?: Maybe<WorkflowV1ListHoldbacksResponseResult>;
  labels: Array<WorkflowV1SurfaceLabelsEntry>;
  metricConfig?: Maybe<WorkflowV1SurfaceMetricConfig>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<WorkflowV1SurfaceReviews>;
  stakeholders: Array<WorkflowV1SurfaceStakeholder>;
  surfaceIdentityBindings?: Maybe<WorkflowV1ListSurfaceIdentityBindingsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1SurfaceAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1SurfaceCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceExclusivityGroupsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowV1SurfaceExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1SurfaceHoldbacksArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowV1SurfaceQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceSurfaceIdentityBindingsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceAssociatedMetric = {
  guardrailMetric?: Maybe<WorkflowV1SurfaceGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection?: Maybe<WorkflowV1SurfacePreferredDirection>;
  successMetric?: Maybe<WorkflowV1SurfaceSuccessMetric>;
};

export type WorkflowV1SurfaceAssociatedMetricInput = {
  guardrailMetric?: InputMaybe<WorkflowV1SurfaceGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection?: InputMaybe<WorkflowV1SurfacePreferredDirection>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1SurfaceSuccessMetricInput>;
};

export type WorkflowV1SurfaceGuardrailMetric = {
  nonInferiorityMargin?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1SurfaceGuardrailMetricInput = {
  nonInferiorityMargin?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBinding = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  enforcementLevel?: Maybe<WorkflowV1EnforcementLevel>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  identity: IamV1IdentityResult;
  labels: Array<WorkflowV1SurfaceIdentityBindingLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1SurfaceIdentityBindingAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1SurfaceIdentityBindingCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1SurfaceIdentityBindingQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingInput = {
  enforcementLevel?: InputMaybe<WorkflowV1EnforcementLevel>;
  identity: Scalars['String']['input'];
  labels?: InputMaybe<Array<WorkflowV1SurfaceIdentityBindingLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1SurfaceIdentityBindingLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceIdentityBindingResult =
  | Error
  | WorkflowV1SurfaceIdentityBinding;

export type WorkflowV1SurfaceInput = {
  automatedActions?: InputMaybe<Array<ActionsV1TypesAutomatedActionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<WorkflowV1SurfaceLabelsEntryInput>>;
  metricConfig?: InputMaybe<WorkflowV1SurfaceMetricConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviews?: InputMaybe<WorkflowV1SurfaceReviewsInput>;
  stakeholders?: InputMaybe<Array<WorkflowV1SurfaceStakeholderInput>>;
};

export type WorkflowV1SurfaceLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1SurfaceLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceMetric = {
  guardrailMetric?: Maybe<WorkflowV1SurfaceGuardrailMetric>;
  metric: MetricsV1MetricResult;
  preferredDirection: WorkflowV1SurfacePreferredDirection;
  successMetric?: Maybe<WorkflowV1SurfaceSuccessMetric>;
};

export type WorkflowV1SurfaceMetricConfig = {
  /** @deprecated No longer supported */
  associatedMetrics: Array<WorkflowV1SurfaceAssociatedMetric>;
  /** @deprecated No longer supported */
  mandatoryMetrics: Array<WorkflowV1SurfaceMetric>;
  metrics: Array<WorkflowV1LinkedMetric>;
};

export type WorkflowV1SurfaceMetricConfigInput = {
  associatedMetrics?: InputMaybe<Array<WorkflowV1SurfaceAssociatedMetricInput>>;
  mandatoryMetrics?: InputMaybe<Array<WorkflowV1SurfaceMetricInput>>;
  metrics?: InputMaybe<Array<WorkflowV1LinkedMetricInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceMetricInput = {
  guardrailMetric?: InputMaybe<WorkflowV1SurfaceGuardrailMetricInput>;
  metric: Scalars['String']['input'];
  preferredDirection: WorkflowV1SurfacePreferredDirection;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  successMetric?: InputMaybe<WorkflowV1SurfaceSuccessMetricInput>;
};

export enum WorkflowV1SurfacePreferredDirection {
  Decrease = 'DECREASE',
  Increase = 'INCREASE',
}

export type WorkflowV1SurfaceRequirement = {
  enforcementLevel?: Maybe<WorkflowV1EnforcementLevel>;
  reason?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<WorkflowV1SurfaceResult>;
};

export type WorkflowV1SurfaceRequirementInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1SurfaceResult = Error | WorkflowV1Surface;

export type WorkflowV1SurfaceReviews = {
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  reviewers: Array<IamV1IdentityResult>;
};

export type WorkflowV1SurfaceReviewsInput = {
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  reviewers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkflowV1SurfaceStakeholder = {
  identity: IamV1IdentityResult;
  role: Scalars['String']['output'];
};

export type WorkflowV1SurfaceStakeholderInput = {
  identity: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type WorkflowV1SurfaceSuccessMetric = {
  minimumDetectableEffect?: Maybe<GoogleTypeDecimal>;
};

export type WorkflowV1SurfaceSuccessMetricInput = {
  minimumDetectableEffect?: InputMaybe<GoogleTypeDecimalInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1TransitionWorkflowInstanceResponse = {
  workflowInstance?: Maybe<WorkflowV1WorkflowInstance>;
};

export type WorkflowV1TransitionWorkflowInstanceResponseResult =
  | Error
  | WorkflowV1TransitionWorkflowInstanceResponse;

export type WorkflowV1UpgradeWorkflowInstancesResponse = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1UpgradeWorkflowInstancesResponseResult =
  | Error
  | WorkflowV1UpgradeWorkflowInstancesResponse;

export type WorkflowV1Workflow = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  builtin?: Maybe<Scalars['Boolean']['output']>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  currentVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1WorkflowLabelsEntry>;
  lowestVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowInfo: WorkflowV1WorkflowWorkflowInfo;
  workflowInstances?: Maybe<WorkflowV1ListWorkflowInstancesResponseResult>;
  workflowLogs?: Maybe<WorkflowV1ListWorkflowLogsResponseResult>;
  workflowVersions?: Maybe<WorkflowV1ListWorkflowVersionsResponseResult>;
};

export type WorkflowV1WorkflowAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInstancesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowV1WorkflowWorkflowLogsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowVersionsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkflowV1WorkflowInput = {
  currentVersion?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  labels?: InputMaybe<Array<WorkflowV1WorkflowLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstance = {
  analysisResults?: Maybe<StatsV2AnalysisListAnalysisResultsResponseResult>;
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  checks: Array<WorkflowV1WorkflowInstanceCheck>;
  cloneSource?: Maybe<WorkflowV1WorkflowInstanceResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  initiatives: Array<WorkflowV1InitiativeResult>;
  jobQueue?: Maybe<WorkflowV1WorkflowInstanceWorkflowJobQueue>;
  labels: Array<WorkflowV1WorkflowInstanceLabelsEntry>;
  lockedDataKeys: Array<Scalars['String']['output']>;
  moduleData: Array<WorkflowV1WorkflowInstanceModuleDataEntry>;
  moduleData2: ModuleData;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  pendingTransition?: Maybe<WorkflowV1WorkflowInstancePendingTransition>;
  possibleTransitions: Array<Scalars['String']['output']>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  queryWorkflowInstancePermissions?: Maybe<WorkflowV1QueryWorkflowInstancePermissionsResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: Scalars['String']['output'];
  stateHistory: Array<WorkflowV1WorkflowInstanceStateHistory>;
  surfaceRequirements: Array<WorkflowV1SurfaceRequirement>;
  surfaces: Array<WorkflowV1SurfaceResult>;
  template?: Maybe<WorkflowV1WorkflowTemplateResult>;
  transitionStatus?: Maybe<WorkflowV1WorkflowInstanceTransitionStatus>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
};

export type WorkflowV1WorkflowInstanceAnalysisResultsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowInstanceCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowInstanceQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheck = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  data?: Maybe<Scalars['JSON']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1WorkflowInstanceCheckLabelsEntry>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<WorkflowV1WorkflowInstanceCheckResult>;
  persist: Scalars['Boolean']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: WorkflowV1WorkflowInstanceCheckState;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1WorkflowInstanceCheckAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowInstanceCheckCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowInstanceCheckQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<WorkflowV1WorkflowInstanceCheckLabelsEntryInput>>;
  message: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['String']['input']>;
  persist: Scalars['Boolean']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  state: WorkflowV1WorkflowInstanceCheckState;
};

export type WorkflowV1WorkflowInstanceCheckLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstanceCheckLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceCheckResult =
  | Error
  | WorkflowV1WorkflowInstanceCheck;

export enum WorkflowV1WorkflowInstanceCheckState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export type WorkflowV1WorkflowInstanceInput = {
  displayName: Scalars['String']['input'];
  initiatives?: InputMaybe<Array<Scalars['String']['input']>>;
  jobQueue?: InputMaybe<WorkflowV1WorkflowInstanceWorkflowJobQueueInput>;
  labels?: InputMaybe<Array<WorkflowV1WorkflowInstanceLabelsEntryInput>>;
  moduleData?: InputMaybe<
    Array<WorkflowV1WorkflowInstanceModuleDataEntryInput>
  >;
  moduleData2?: InputMaybe<ModuleDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
  template?: InputMaybe<Scalars['String']['input']>;
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstanceLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceModuleDataEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type WorkflowV1WorkflowInstanceModuleDataEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type WorkflowV1WorkflowInstancePendingTransition = {
  /** @deprecated No longer supported */
  failedActions: Array<WorkflowV1WorkflowInstancePendingTransitionFailedAction>;
  failedSteps: Array<WorkflowV1WorkflowInstancePendingTransitionFailedActionStep>;
  /** @deprecated No longer supported */
  succeededActions: Array<Scalars['String']['output']>;
  succeededSteps: Array<Scalars['String']['output']>;
  targetState: Scalars['String']['output'];
  transitionAction: Scalars['String']['output'];
  /** @deprecated No longer supported */
  unprocessedActions: Array<Scalars['String']['output']>;
  unprocessedSteps: Array<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionFailedAction = {
  action: Scalars['String']['output'];
  failuresMessages: Array<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionFailedActionInput = {
  action: Scalars['String']['input'];
  failuresMessages?: InputMaybe<Array<Scalars['String']['input']>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionFailedActionStep = {
  actionStep: Scalars['String']['output'];
  failuresMessages: Array<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionFailedActionStepInput = {
  actionStep: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstancePendingTransitionInput = {
  failedActions?: InputMaybe<
    Array<WorkflowV1WorkflowInstancePendingTransitionFailedActionInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  succeededActions?: InputMaybe<Array<Scalars['String']['input']>>;
  targetState: Scalars['String']['input'];
  transitionAction: Scalars['String']['input'];
  unprocessedActions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkflowV1WorkflowInstanceResult =
  | Error
  | WorkflowV1WorkflowInstance;

export type WorkflowV1WorkflowInstanceStateHistory = {
  actualEnteredTime?: Maybe<Scalars['String']['output']>;
  actualExitedTime?: Maybe<Scalars['String']['output']>;
  checks: Array<WorkflowV1WorkflowInstanceCheck>;
  enteredTime?: Maybe<Scalars['String']['output']>;
  exitedTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowInstanceStateHistoryInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowInstanceTransitionStatus = {
  action: Scalars['String']['output'];
  completed?: Maybe<WorkflowV1WorkflowInstanceTransitionStatusCompleted>;
  failed?: Maybe<WorkflowV1WorkflowInstanceTransitionStatusFailed>;
  initiator: IamV1IdentityResult;
  running?: Maybe<WorkflowV1WorkflowInstanceTransitionStatusRunning>;
};

export type WorkflowV1WorkflowInstanceTransitionStatusCompleted = {
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusCompletedInput = {
  endTime: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusFailed = {
  endTime: Scalars['String']['output'];
  error: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusFailedInput = {
  endTime: Scalars['String']['input'];
  error: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusInput = {
  action: Scalars['String']['input'];
  completed?: InputMaybe<WorkflowV1WorkflowInstanceTransitionStatusCompletedInput>;
  failed?: InputMaybe<WorkflowV1WorkflowInstanceTransitionStatusFailedInput>;
  initiator: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  running?: InputMaybe<WorkflowV1WorkflowInstanceTransitionStatusRunningInput>;
};

export type WorkflowV1WorkflowInstanceTransitionStatusRunning = {
  startTime: Scalars['String']['output'];
};

export type WorkflowV1WorkflowInstanceTransitionStatusRunningInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
};

export type WorkflowV1WorkflowInstanceWorkflowJob = {
  func: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
  runTime: Scalars['String']['output'];
};

export type WorkflowV1WorkflowInstanceWorkflowJobInput = {
  func: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  runTime: Scalars['String']['input'];
};

export type WorkflowV1WorkflowInstanceWorkflowJobQueue = {
  isEnabled: Scalars['Boolean']['output'];
  items: Array<WorkflowV1WorkflowInstanceWorkflowJob>;
};

export type WorkflowV1WorkflowInstanceWorkflowJobQueueInput = {
  items?: InputMaybe<Array<WorkflowV1WorkflowInstanceWorkflowJobInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLog = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  level: WorkflowV1WorkflowLogLogLevel;
  logTime: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  workflowInstance?: Maybe<WorkflowV1WorkflowInstanceResult>;
  workflowVersion: WorkflowV1WorkflowVersionResult;
};

export type WorkflowV1WorkflowLogAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowLogCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowLogCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowLogExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowLogQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLogReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLogResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowLogReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkflowV1WorkflowLogLogLevel {
  LogLevelError = 'LOG_LEVEL_ERROR',
  LogLevelInfo = 'LOG_LEVEL_INFO',
  LogLevelWarn = 'LOG_LEVEL_WARN',
}

export type WorkflowV1WorkflowLogResult = Error | WorkflowV1WorkflowLog;

export type WorkflowV1WorkflowResult = Error | WorkflowV1Workflow;

export type WorkflowV1WorkflowSecret = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1WorkflowSecretLabelsEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
};

export type WorkflowV1WorkflowSecretAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowSecretCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowSecretCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowSecretExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowSecretQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretInput = {
  labels?: InputMaybe<Array<WorkflowV1WorkflowSecretLabelsEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
};

export type WorkflowV1WorkflowSecretLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowSecretLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowSecretResult = Error | WorkflowV1WorkflowSecret;

export type WorkflowV1WorkflowTemplate = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  deleteTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  initiatives: Array<WorkflowV1InitiativeResult>;
  labels: Array<WorkflowV1WorkflowTemplateLabelsEntry>;
  moduleData: Array<WorkflowV1WorkflowTemplateModuleDataEntry>;
  name: Scalars['String']['output'];
  owner?: Maybe<IamV1IdentityResult>;
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  sourceInstance: WorkflowV1WorkflowInstanceResult;
  state?: Maybe<Scalars['String']['output']>;
  surfaces: Array<WorkflowV1SurfaceResult>;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowVersion?: Maybe<WorkflowV1WorkflowVersionResult>;
};

export type WorkflowV1WorkflowTemplateAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowTemplateCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowTemplateCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowTemplateExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowTemplateQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  initiatives?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<WorkflowV1WorkflowTemplateLabelsEntryInput>>;
  moduleData?: InputMaybe<
    Array<WorkflowV1WorkflowTemplateModuleDataEntryInput>
  >;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  sourceInstance: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  surfaces?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowVersion?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowTemplateLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowTemplateModuleDataEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type WorkflowV1WorkflowTemplateModuleDataEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type WorkflowV1WorkflowTemplateResult =
  | Error
  | WorkflowV1WorkflowTemplate;

export type WorkflowV1WorkflowVersion = {
  attachments?: Maybe<CollaborationV1ListAttachmentsResponseResult>;
  collaborativeDocuments?: Maybe<CollaborationV1ListCollaborativeDocumentsResponseResult>;
  comments?: Maybe<CollaborationV1ListCommentsResponseResult>;
  createTime: Scalars['String']['output'];
  creator: IamV1IdentityResult;
  externalDocuments?: Maybe<CollaborationV1ListExternalDocumentsResponseResult>;
  labels: Array<WorkflowV1WorkflowVersionLabelsEntry>;
  name: Scalars['String']['output'];
  queryIsFollowingResource?: Maybe<ActivityV1QueryIsFollowingResourceResponseResult>;
  queryReactionSummary?: Maybe<CollaborationV1QueryReactionSummaryResponseResult>;
  reactions?: Maybe<CollaborationV1ListReactionsResponseResult>;
  resourcePermissions?: Maybe<FgaV1ListResourcePermissionsResponseResult>;
  resourceRelations?: Maybe<FgaV1ListResourceRelationsResponseResult>;
  reviews?: Maybe<CollaborationV1ListReviewsResponseResult>;
  state: WorkflowV1WorkflowVersionState;
  updateTime: Scalars['String']['output'];
  updater: IamV1IdentityResult;
  workflowConfig: WorkflowV1WorkflowVersionWorkflowConfig;
  workflowInfo?: Maybe<WorkflowV1WorkflowWorkflowInfo>;
};

export type WorkflowV1WorkflowVersionAttachmentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowVersionCollaborativeDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1CollaborativeDocumentView>;
};

export type WorkflowV1WorkflowVersionCommentsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowVersionExternalDocumentsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<CollaborationV1ExternalDocumentView>;
};

export type WorkflowV1WorkflowVersionQueryIsFollowingResourceArgs = {
  feed?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionReactionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionResourcePermissionsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionReviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionInput = {
  labels?: InputMaybe<Array<WorkflowV1WorkflowVersionLabelsEntryInput>>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  workflowConfig: WorkflowV1WorkflowVersionWorkflowConfigInput;
};

export type WorkflowV1WorkflowVersionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowVersionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionResult = Error | WorkflowV1WorkflowVersion;

export enum WorkflowV1WorkflowVersionState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Creating = 'CREATING',
  Failed = 'FAILED',
}

export type WorkflowV1WorkflowVersionWorkflowConfig = {
  jsConfig?: Maybe<WorkflowV1WorkflowVersionWorkflowConfigJsWorkflowConfig>;
  localDevConfig?: Maybe<WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfig>;
  remoteHttpConfig?: Maybe<WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfig>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigInput = {
  jsConfig?: InputMaybe<WorkflowV1WorkflowVersionWorkflowConfigJsWorkflowConfigInput>;
  localDevConfig?: InputMaybe<WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigInput>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  remoteHttpConfig?: InputMaybe<WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigInput>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigJsWorkflowConfig = {
  jsPackagePath: Scalars['String']['output'];
};

export type WorkflowV1WorkflowVersionWorkflowConfigJsWorkflowConfigInput = {
  jsPackagePath: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfig = {
  describeResponse?: Maybe<Scalars['JSON']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  tunnelInfo?: Maybe<WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigTunnelInfo>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigInput =
  {
    describeResponse?: InputMaybe<Scalars['JSON']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    tunnelInfo?: InputMaybe<WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigTunnelInfoInput>;
  };

export type WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigTunnelInfo =
  {
    url: Scalars['String']['output'];
  };

export type WorkflowV1WorkflowVersionWorkflowConfigLocalDevWorkflowConfigTunnelInfoInput =
  {
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    url: Scalars['String']['input'];
  };

export type WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfig = {
  baseUrls: Array<WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigBaseUrlsEntry>;
  entryPoint: Scalars['String']['output'];
  jsPackagePath?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigBaseUrlsEntry =
  {
    key: Scalars['String']['output'];
    value?: Maybe<Scalars['String']['output']>;
  };

export type WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigBaseUrlsEntryInput =
  {
    key: Scalars['String']['input'];
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
  };

export type WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigInput =
  {
    baseUrls?: InputMaybe<
      Array<WorkflowV1WorkflowVersionWorkflowConfigRemoteHttpWorkflowConfigBaseUrlsEntryInput>
    >;
    entryPoint: Scalars['String']['input'];
    jsPackagePath?: InputMaybe<Scalars['String']['input']>;
    proto_type_url?: InputMaybe<Scalars['String']['input']>;
  };

export type WorkflowV1WorkflowWorkflowInfo = {
  eventHandlers: Array<WorkflowV1WorkflowWorkflowInfoEventHandlersEntry>;
  functions: Array<WorkflowV1WorkflowWorkflowInfoFunctionsEntry>;
  initialState?: Maybe<Scalars['String']['output']>;
  migrations: Array<WorkflowV1WorkflowWorkflowInfoMigrationsEntry>;
  modules: Array<WorkflowV1WorkflowWorkflowInfoModulesEntry>;
  protocolVersion?: Maybe<Scalars['Int']['output']>;
  states: Array<WorkflowV1WorkflowWorkflowInfoStatesEntry>;
  validations: Array<WorkflowV1WorkflowWorkflowInfoValidationsEntry>;
};

export type WorkflowV1WorkflowWorkflowInfoAction = {
  actionSteps: Array<Scalars['String']['output']>;
  labels: Array<WorkflowV1WorkflowWorkflowInfoActionLabelsEntry>;
  nextState?: Maybe<Scalars['String']['output']>;
  requiredPermissions: Array<WorkflowV1WorkflowWorkflowInfoPermissionSpec>;
  softChecks?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoActionInput = {
  actionSteps?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoActionLabelsEntryInput>
  >;
  nextState?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  requiredPermissions?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoPermissionSpecInput>
  >;
  softChecks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoActionLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoActionLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoEventHandler = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoEventHandlerInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoEventHandlersEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoEventHandler>;
};

export type WorkflowV1WorkflowWorkflowInfoEventHandlersEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoEventHandlerInput>;
};

export type WorkflowV1WorkflowWorkflowInfoFunction = {
  description?: Maybe<Scalars['String']['output']>;
  requestSchema?: Maybe<Scalars['JSON']['output']>;
  requiredPermissions: Array<WorkflowV1WorkflowWorkflowInfoPermissionSpec>;
  responseSchema?: Maybe<Scalars['JSON']['output']>;
  visibility?: Maybe<WorkflowV1WorkflowWorkflowInfoFunctionVisibility>;
};

export type WorkflowV1WorkflowWorkflowInfoFunctionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  requestSchema?: InputMaybe<Scalars['JSON']['input']>;
  requiredPermissions?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoPermissionSpecInput>
  >;
  responseSchema?: InputMaybe<Scalars['JSON']['input']>;
  visibility?: InputMaybe<WorkflowV1WorkflowWorkflowInfoFunctionVisibility>;
};

export enum WorkflowV1WorkflowWorkflowInfoFunctionVisibility {
  Internal = 'INTERNAL',
}

export type WorkflowV1WorkflowWorkflowInfoFunctionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoFunction>;
};

export type WorkflowV1WorkflowWorkflowInfoFunctionsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoFunctionInput>;
};

export type WorkflowV1WorkflowWorkflowInfoInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoMigration = {
  dummy?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoMigrationInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoMigrationsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoMigration>;
};

export type WorkflowV1WorkflowWorkflowInfoMigrationsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoMigrationInput>;
};

export type WorkflowV1WorkflowWorkflowInfoModule = {
  payloadSchema?: Maybe<Scalars['JSON']['output']>;
  payloadType?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoModuleInput = {
  payloadSchema?: InputMaybe<Scalars['JSON']['input']>;
  payloadType?: InputMaybe<Scalars['String']['input']>;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoModulesEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoModule>;
};

export type WorkflowV1WorkflowWorkflowInfoModulesEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoModuleInput>;
};

export type WorkflowV1WorkflowWorkflowInfoPermissionSpec = {
  ref?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoPermissionSpecInput = {
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoState = {
  actions: Array<WorkflowV1WorkflowWorkflowInfoStateActionsEntry>;
};

export type WorkflowV1WorkflowWorkflowInfoStateActionsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoAction>;
};

export type WorkflowV1WorkflowWorkflowInfoStateActionsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoActionInput>;
};

export type WorkflowV1WorkflowWorkflowInfoStateInput = {
  actions?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoStateActionsEntryInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoStatesEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoState>;
};

export type WorkflowV1WorkflowWorkflowInfoStatesEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoStateInput>;
};

export type WorkflowV1WorkflowWorkflowInfoValidation = {
  appliedStates: Array<Scalars['String']['output']>;
  labels: Array<WorkflowV1WorkflowWorkflowInfoValidationLabelsEntry>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationInput = {
  appliedStates?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<
    Array<WorkflowV1WorkflowWorkflowInfoValidationLabelsEntryInput>
  >;
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationLabelsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationLabelsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationsEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<WorkflowV1WorkflowWorkflowInfoValidation>;
};

export type WorkflowV1WorkflowWorkflowInfoValidationsEntryInput = {
  key: Scalars['String']['input'];
  proto_type_url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<WorkflowV1WorkflowWorkflowInfoValidationInput>;
};

export type CreateUserInvitationMutationVariables = Exact<{
  userInvitation: IamV1UserInvitationInput;
}>;

export type CreateUserInvitationMutation = {
  createUserInvitation?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1UserInvitation';
        name: string;
        inviter?: string | null;
      }
    | null;
};

export type DefaultErrorFragment = {
  __typename: 'Error';
  message?: string | null;
  code: ErrorCode;
};

export type GetAccountStateQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountStateQuery = {
  existsDataWarehouses?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'MetricsV1ExistsDataWarehousesResponse';
        exists?: boolean | null;
        demoData?: boolean | null;
      }
    | null;
  currentAccount?:
    | {
        __typename: 'AdminV1AccountInfo';
        mode?: AdminV1AccountMode | null;
        totalConfidenceAccountInfo?: {
          state?: AdminV1AccountInfoTotalConfidenceAccountStatusState | null;
        } | null;
      }
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | null;
  flags?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1ListFlagsResponse';
        flags: Array<{
          name: string;
          labels: Array<{ value?: string | null; key: string }>;
        }>;
      }
    | null;
  eventDefinitions?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1ListEventDefinitionsResponse';
        eventDefinitions: Array<{
          name: string;
          usageMetadata: { lastPublishTime?: string | null };
        }>;
      }
    | null;
  currentUser?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1CurrentUser'; identity: { name: string } }
    | null;
};

export type GetEventPublishedQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetEventPublishedQuery = {
  eventDefinition?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'EventsAdminV1EventDefinition';
        name: string;
        usageMetadata: { lastPublishTime?: string | null };
      }
    | null;
};

export type GetFlagResolvedQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetFlagResolvedQuery = {
  flag?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'FlagsAdminV1Flag';
        name: string;
        usageMetadata?: {
          lastApplyTime?: string | null;
          lastResolveTime?: string | null;
        } | null;
      }
    | null;
};

export type GetOwnedInstancesQueryVariables = Exact<{
  tutorialFilter?: InputMaybe<Scalars['String']['input']>;
  instancesFilter?: InputMaybe<Scalars['String']['input']>;
  accountFilter?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOwnedInstancesQuery = {
  tutorialInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          name: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
  accountWorkflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          name: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
  workflowInstances?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'WorkflowV1ListWorkflowInstancesResponse';
        workflowInstances: Array<{
          name: string;
          labels: Array<{ key: string; value?: string | null }>;
        }>;
      }
    | null;
};

export type StoreSlackUserInfoMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type StoreSlackUserInfoMutation = {
  storeSlackUserInfo?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'IamV1StoreSlackUserInfoResponse' }
    | null;
};

export type UserQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type UserQuery = {
  user?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | {
        __typename: 'IamV1User';
        name: string;
        fullName: string;
        pictureUri?: string | null;
      }
    | null;
};

export type WriteDemoDataMutationVariables = Exact<{ [key: string]: never }>;

export type WriteDemoDataMutation = {
  writeDemoData?:
    | { __typename: 'Error'; message?: string | null; code: ErrorCode }
    | { __typename: 'GoogleProtobufEmpty'; dummy?: string | null }
    | null;
};

export const DefaultErrorFragmentDoc = gql`
  fragment DefaultError on Error {
    __typename
    message
    code
  }
`;
export const CreateUserInvitationDocument = gql`
  mutation CreateUserInvitation($userInvitation: IamV1UserInvitationInput!) {
    createUserInvitation(userInvitation: $userInvitation) {
      ... on IamV1UserInvitation {
        __typename
        name
        inviter
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type CreateUserInvitationMutationFn = Apollo.MutationFunction<
  CreateUserInvitationMutation,
  CreateUserInvitationMutationVariables
>;

/**
 * __useCreateUserInvitationMutation__
 *
 * To run a mutation, you first call `useCreateUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserInvitationMutation, { data, loading, error }] = useCreateUserInvitationMutation({
 *   variables: {
 *      userInvitation: // value for 'userInvitation'
 *   },
 * });
 */
export function useCreateUserInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserInvitationMutation,
    CreateUserInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserInvitationMutation,
    CreateUserInvitationMutationVariables
  >(CreateUserInvitationDocument, options);
}
export type CreateUserInvitationMutationHookResult = ReturnType<
  typeof useCreateUserInvitationMutation
>;
export type CreateUserInvitationMutationResult =
  Apollo.MutationResult<CreateUserInvitationMutation>;
export type CreateUserInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateUserInvitationMutation,
  CreateUserInvitationMutationVariables
>;
export const GetAccountStateDocument = gql`
  query GetAccountState {
    existsDataWarehouses {
      ... on MetricsV1ExistsDataWarehousesResponse {
        __typename
        exists
        demoData
      }
      ...DefaultError
    }
    currentAccount {
      ... on AdminV1AccountInfo {
        __typename
        mode
        totalConfidenceAccountInfo {
          state
        }
      }
      ...DefaultError
    }
    flags(pageSize: 1, filter: "_exists_:usageMetadata.lastResolveTime") {
      ... on FlagsAdminV1ListFlagsResponse {
        __typename
        flags {
          name
          labels {
            value
            key
          }
        }
      }
      ...DefaultError
    }
    eventDefinitions(
      pageSize: 1
      filter: "_exists_:usageMetadata.lastPublishTime"
    ) {
      ... on EventsAdminV1ListEventDefinitionsResponse {
        __typename
        eventDefinitions {
          name
          usageMetadata {
            lastPublishTime
          }
        }
      }
      ...DefaultError
    }
    currentUser {
      ... on IamV1CurrentUser {
        __typename
        identity {
          name
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetAccountStateQuery__
 *
 * To run a query within a React component, call `useGetAccountStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountStateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccountStateQuery, GetAccountStateQueryVariables>(
    GetAccountStateDocument,
    options,
  );
}
export function useGetAccountStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >(GetAccountStateDocument, options);
}
// @ts-ignore
export function useGetAccountStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAccountStateQuery,
  GetAccountStateQueryVariables
>;
export function useGetAccountStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccountStateQuery,
        GetAccountStateQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAccountStateQuery | undefined,
  GetAccountStateQueryVariables
>;
export function useGetAccountStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccountStateQuery,
        GetAccountStateQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccountStateQuery,
    GetAccountStateQueryVariables
  >(GetAccountStateDocument, options);
}
export type GetAccountStateQueryHookResult = ReturnType<
  typeof useGetAccountStateQuery
>;
export type GetAccountStateLazyQueryHookResult = ReturnType<
  typeof useGetAccountStateLazyQuery
>;
export type GetAccountStateSuspenseQueryHookResult = ReturnType<
  typeof useGetAccountStateSuspenseQuery
>;
export type GetAccountStateQueryResult = Apollo.QueryResult<
  GetAccountStateQuery,
  GetAccountStateQueryVariables
>;
export const GetEventPublishedDocument = gql`
  query GetEventPublished($name: String!) {
    eventDefinition(name: $name) {
      ... on EventsAdminV1EventDefinition {
        __typename
        name
        usageMetadata {
          lastPublishTime
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetEventPublishedQuery__
 *
 * To run a query within a React component, call `useGetEventPublishedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPublishedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPublishedQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetEventPublishedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  > &
    (
      | { variables: GetEventPublishedQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >(GetEventPublishedDocument, options);
}
export function useGetEventPublishedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >(GetEventPublishedDocument, options);
}
// @ts-ignore
export function useGetEventPublishedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetEventPublishedQuery,
  GetEventPublishedQueryVariables
>;
export function useGetEventPublishedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventPublishedQuery,
        GetEventPublishedQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetEventPublishedQuery | undefined,
  GetEventPublishedQueryVariables
>;
export function useGetEventPublishedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventPublishedQuery,
        GetEventPublishedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventPublishedQuery,
    GetEventPublishedQueryVariables
  >(GetEventPublishedDocument, options);
}
export type GetEventPublishedQueryHookResult = ReturnType<
  typeof useGetEventPublishedQuery
>;
export type GetEventPublishedLazyQueryHookResult = ReturnType<
  typeof useGetEventPublishedLazyQuery
>;
export type GetEventPublishedSuspenseQueryHookResult = ReturnType<
  typeof useGetEventPublishedSuspenseQuery
>;
export type GetEventPublishedQueryResult = Apollo.QueryResult<
  GetEventPublishedQuery,
  GetEventPublishedQueryVariables
>;
export const GetFlagResolvedDocument = gql`
  query GetFlagResolved($name: String!) {
    flag(name: $name) {
      ... on FlagsAdminV1Flag {
        __typename
        name
        usageMetadata {
          lastApplyTime
          lastResolveTime
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetFlagResolvedQuery__
 *
 * To run a query within a React component, call `useGetFlagResolvedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlagResolvedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlagResolvedQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFlagResolvedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  > &
    (
      | { variables: GetFlagResolvedQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFlagResolvedQuery, GetFlagResolvedQueryVariables>(
    GetFlagResolvedDocument,
    options,
  );
}
export function useGetFlagResolvedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  >(GetFlagResolvedDocument, options);
}
// @ts-ignore
export function useGetFlagResolvedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetFlagResolvedQuery,
  GetFlagResolvedQueryVariables
>;
export function useGetFlagResolvedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFlagResolvedQuery,
        GetFlagResolvedQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetFlagResolvedQuery | undefined,
  GetFlagResolvedQueryVariables
>;
export function useGetFlagResolvedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetFlagResolvedQuery,
        GetFlagResolvedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFlagResolvedQuery,
    GetFlagResolvedQueryVariables
  >(GetFlagResolvedDocument, options);
}
export type GetFlagResolvedQueryHookResult = ReturnType<
  typeof useGetFlagResolvedQuery
>;
export type GetFlagResolvedLazyQueryHookResult = ReturnType<
  typeof useGetFlagResolvedLazyQuery
>;
export type GetFlagResolvedSuspenseQueryHookResult = ReturnType<
  typeof useGetFlagResolvedSuspenseQuery
>;
export type GetFlagResolvedQueryResult = Apollo.QueryResult<
  GetFlagResolvedQuery,
  GetFlagResolvedQueryVariables
>;
export const GetOwnedInstancesDocument = gql`
  query GetOwnedInstances(
    $tutorialFilter: String
    $instancesFilter: String
    $accountFilter: String
  ) {
    tutorialInstances: workflowInstances(pageSize: 1, filter: $tutorialFilter) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          name
          labels {
            key
            value
          }
        }
      }
      ...DefaultError
    }
    accountWorkflowInstances: workflowInstances(
      pageSize: 1
      filter: $accountFilter
    ) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          name
          labels {
            key
            value
          }
        }
      }
      ...DefaultError
    }
    workflowInstances(pageSize: 1, filter: $instancesFilter) {
      ... on WorkflowV1ListWorkflowInstancesResponse {
        __typename
        workflowInstances {
          name
          labels {
            key
            value
          }
        }
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useGetOwnedInstancesQuery__
 *
 * To run a query within a React component, call `useGetOwnedInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnedInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnedInstancesQuery({
 *   variables: {
 *      tutorialFilter: // value for 'tutorialFilter'
 *      instancesFilter: // value for 'instancesFilter'
 *      accountFilter: // value for 'accountFilter'
 *   },
 * });
 */
export function useGetOwnedInstancesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >(GetOwnedInstancesDocument, options);
}
export function useGetOwnedInstancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >(GetOwnedInstancesDocument, options);
}
// @ts-ignore
export function useGetOwnedInstancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetOwnedInstancesQuery,
  GetOwnedInstancesQueryVariables
>;
export function useGetOwnedInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOwnedInstancesQuery,
        GetOwnedInstancesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetOwnedInstancesQuery | undefined,
  GetOwnedInstancesQueryVariables
>;
export function useGetOwnedInstancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOwnedInstancesQuery,
        GetOwnedInstancesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOwnedInstancesQuery,
    GetOwnedInstancesQueryVariables
  >(GetOwnedInstancesDocument, options);
}
export type GetOwnedInstancesQueryHookResult = ReturnType<
  typeof useGetOwnedInstancesQuery
>;
export type GetOwnedInstancesLazyQueryHookResult = ReturnType<
  typeof useGetOwnedInstancesLazyQuery
>;
export type GetOwnedInstancesSuspenseQueryHookResult = ReturnType<
  typeof useGetOwnedInstancesSuspenseQuery
>;
export type GetOwnedInstancesQueryResult = Apollo.QueryResult<
  GetOwnedInstancesQuery,
  GetOwnedInstancesQueryVariables
>;
export const StoreSlackUserInfoDocument = gql`
  mutation StoreSlackUserInfo($code: String!) {
    storeSlackUserInfo(code: $code) {
      ... on IamV1StoreSlackUserInfoResponse {
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type StoreSlackUserInfoMutationFn = Apollo.MutationFunction<
  StoreSlackUserInfoMutation,
  StoreSlackUserInfoMutationVariables
>;

/**
 * __useStoreSlackUserInfoMutation__
 *
 * To run a mutation, you first call `useStoreSlackUserInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreSlackUserInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeSlackUserInfoMutation, { data, loading, error }] = useStoreSlackUserInfoMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useStoreSlackUserInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StoreSlackUserInfoMutation,
    StoreSlackUserInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StoreSlackUserInfoMutation,
    StoreSlackUserInfoMutationVariables
  >(StoreSlackUserInfoDocument, options);
}
export type StoreSlackUserInfoMutationHookResult = ReturnType<
  typeof useStoreSlackUserInfoMutation
>;
export type StoreSlackUserInfoMutationResult =
  Apollo.MutationResult<StoreSlackUserInfoMutation>;
export type StoreSlackUserInfoMutationOptions = Apollo.BaseMutationOptions<
  StoreSlackUserInfoMutation,
  StoreSlackUserInfoMutationVariables
>;
export const UserDocument = gql`
  query User($name: String!) {
    user(name: $name) {
      ... on IamV1User {
        __typename
        name
        fullName
        pictureUri
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUserQuery(
  baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> &
    ({ variables: UserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export function useUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  );
}
// @ts-ignore
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  );
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<
  typeof useUserSuspenseQuery
>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const WriteDemoDataDocument = gql`
  mutation WriteDemoData {
    writeDemoData {
      ... on GoogleProtobufEmpty {
        dummy
        __typename
      }
      ...DefaultError
    }
  }
  ${DefaultErrorFragmentDoc}
`;
export type WriteDemoDataMutationFn = Apollo.MutationFunction<
  WriteDemoDataMutation,
  WriteDemoDataMutationVariables
>;

/**
 * __useWriteDemoDataMutation__
 *
 * To run a mutation, you first call `useWriteDemoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteDemoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeDemoDataMutation, { data, loading, error }] = useWriteDemoDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useWriteDemoDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WriteDemoDataMutation,
    WriteDemoDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WriteDemoDataMutation,
    WriteDemoDataMutationVariables
  >(WriteDemoDataDocument, options);
}
export type WriteDemoDataMutationHookResult = ReturnType<
  typeof useWriteDemoDataMutation
>;
export type WriteDemoDataMutationResult =
  Apollo.MutationResult<WriteDemoDataMutation>;
export type WriteDemoDataMutationOptions = Apollo.BaseMutationOptions<
  WriteDemoDataMutation,
  WriteDemoDataMutationVariables
>;
